export default {
  addNewSkill: {
    ans1: "Atrás",
    ans2: "Siguiente",
    ans3: "Enviar",
    data: {
      ed: {
        characteristic: "Es energético/a",
        wdd: "Consigue resultados y alcanza sus objetivos de negocio de forma consistente. Está motivado/a para avanzar en su carrera profesional. Nunca deja trabajo sin terminar incluso cuando surgen problemas o se presentan obstáculos y tiene iniciativa y demuestra una actitud positiva para llevar a cabo las tareas",
        icon: require("@/assets/Iconography/Characteristics/10_Inspirational Motivator.svg"),
        competencies: [
          {
            id: "ed-0",
            icon: require("@/assets/Iconography/Attributes/07-01_Achieving Goals.svg"),
            comp: "Obtiene Resultados",
            wdd: "Consigue resultados y alcanza sus objetivos de negocio de forma consistente",
            progressMeasures: [
              {
                id: "ed-0-0",
                pm: "Defino metas claras para mí y conozco mis objetivo de desempeño",
                pmMap: "Definir metas claras para mí y conocer mis objetivos",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "ed-0-1",
                pm: "Quiero hacer las cosas bien y definir un estándar elevado para mí",
                pmMap:
                  "Esforzarse por hacer las cosas bien y definir un estándar elevado para mí",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "ed-0-2",
                pm: "No permito que los obstáculos que encuentro me desanimen",
                pmMap:
                  "No permitir que los obstáculos encontrados me desanimen",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "ed-0-3",
                pm: "Se cuándo dar un paso atrás y coger fuerzas antes de que parecen insuperables",
                pmMap:
                  "Saber cuándo dar un paso atrás y coger fuerzas antes de abordar tareas que parezcan insuperables",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
            ],
            developmentActions: [
              {
                id: "ed-0:1-a",
                da: "Como regla general, primero haga las cosas que menos le gusta hacer.Tendrá que hacerlas de todos modos. A menudo dedica demasiada energía entratar de evitar esas tareas, lo que le impide trabajar de forma productiva. Escriba cuáles son y pídale a un colega que le ayude a mantenerse en linea.",
              },
              {
                id: "ed-0:1-b",
                da: "Concéntrese en hacer las cosas que son más importantes, de este modo ocupará su tiempo de forma más inteligente. Si el tiempo le supera, por lo menos se habrá ocupado de las cosas que tienen mayor impacto. Sea específico/a en cuanto a cuáles son estas cosas y prepare una lista de prioridades. Confirme con la persona adecuada que su lista de prioridades es correcta.",
              },
              {
                id: "ed-0:1-c",
                da: "Emprenda la tarea en cantidades aceptables. Trabaje en las tareas durante los intervalos que pueda tener entre sus compromisos y citas. Eso asegurará que la cantidad de trabajo es manejable y observará un mayor progreso.",
              },
              {
                id: "ed-0:1-d",
                da: "Anticipe que todo llevará más tiempo de lo que esperaba. Sea cual fuere la fecha límite, réstele tiempo para darse impulso para empezar. Recompénsese cada vez que cumpla con la fecha límite.",
              },
              {
                id: "ed-0:1-e",
                da: "Póngase a trabajar inmediatamente. Limite el tiempo entre recibir la tarea y empezar a trabajar en ella. No tomar acción durante demasiado tiempo puede afectar su motivación",
              },
              {
                id: "ed-0:1-f",
                da: "Si se desempeña mejor o se siente motivado trabajando con otras personas, reclute colegas con los cuales pueda colaborar y que lo ayuden a ponerse en movimiento. Ellos también podrán ayudarlo a mantenerse en la senda, especialmente si su desempeño está vinculado al de otras personas.",
              },
              {
                id: "ed-0:2-a",
                da: "Limite el tiempo que dedica a una tarea en particular. Defina momentos en los cuales se reunirá con su superior para obtener retroalimentación acerca del nivel de detalle al cual debería estar trabajando. Esto le ayudará a mantener sus expectativas acerca de sí mismo/a en un nivel realista",
              },
              {
                id: "ed-0:2-b",
                da: "Redefina sus expectativas. Apunte a completar una tarea o función bien, no a hacerla perfecta.",
              },
              {
                id: "ed-0:3-a",
                da: "Incorpore flexibilidad en su cronograma de modo que pueda abordar un proyecto determinado cada vez, y en el momento en que tenga sentido para usted. Muchas personas bloquean horarios específicos para trabajar en una tarea, pero si está exhausto/a, esto puede resultar contraproducente ya que su inspiración y motivación serán inconstantes — no pueden programarse. Aproveche los momentos en que se siente preparado/a para trabajar en un proyecto, incluso si es sólo por un corto período. Igualmente, pase a otra cosa si no está produciendo nada. Dedicar tiempo a algo sin obtener resultados le producirá frustración y aumentará las asociaciones negativas con la tarea que está realizando.",
              },
              {
                id: "ed-0:3-b",
                da: "Revise y recompense su progreso continuamente. Divida el proyecto en tareas más pequeñas y recompénsese cada vez que avance un paso.",
              },
              {
                id: "ed-0:3-c",
                da: "Sea honesto/a con su superior. Puede brindarle asistencia haciendo algo simple tal como ayudar a delegar parte de su trabajo. A menudo a la gente no le gusta informar a su superior acerca de los problemas porque no quieren que se vea como que no pueden manejar la situación. Inevitablemente, sin embargo, el agotamiento quedará evidente en su desempeño, por lo tanto actúe antes de que eso suceda.",
              },
              {
                id: "ed-0:3-d",
                da: "Genere algunos cambios — si se siente crónicamente exhausto/a puede ser el momento de buscar otra posición dentro de la compañía o intentar algo completamente nuevo. Dedique tiempo a investigar sus opciones y definir su meta.",
              },
              {
                id: "ed-0:4-a",
                da: "Concéntrese en hacer las cosas que son más importantes. Sea específico/a en cuanto a cuáles son estas tareas y prepare una lista de prioridades. Confirme con su superior que su lista de prioridades es correcta.",
              },
              {
                id: "ed-0:4-b",
                da: "¿Qué actividades ocupan la mayor parte de su tiempo? Prepare una lista de sus actividades y asigne los tiempos aproximados que está dedicando a cada categoría. Luego divida las categorías en “esenciales” y “necesitan hacerse”. ¿Cómo es su asignación de tiempos?",
              },
              {
                id: "ed-0:4-c",
                da: "¿Está delegando de forma adecuada? ¿En qué tareas puede involucrar a otras personas?",
              },
              {
                id: "ed-0:5-a",
                da: "Lentamente eleve su nivel de comodidad con respecto al riesgo, aceptando tareas más pequeñas que requieran mayor entrega de su parte.",
              },
              {
                id: "ed-0:5-b",
                da: "Vea los errores como oportunidades para aprender y reflexionar. Cada vez que cometa un error, escriba una lista de los beneficios de haber cometido el error — los detalles específicos de lo que aprendió, a quién conoció en el proceso y así sucesivamente.",
              },
              {
                id: "ed-0:5-c",
                da: "Lea biografías de líderes de empresas o personas públicas que admire. Busque un tema común de toma de riesgos entre ellos.",
              },
              {
                id: "ed-0:5-d",
                da: "Tal vez usted se arriesgó más de lo que pensaba o se creía capaz. Documente sus logros. ¿Qué riesgos involucraron cada uno de esos logros? Escríbalos, independientemente de qué tan pequeño haya sido el riesgo. Pida ayuda a la gente que le conoce bien. El objetivo es demostrar que todas las carreras están basadas en una combinación de desafíos a los cuales constantemente se nos invita a responder. Probablemente usted ya haya asumido más riesgos de los que pensaba.",
              },
              {
                id: "ed-0:6-a",
                da: "Si todavía no tiene un plan de trabajo, reúnase con su superior para desarrollar uno que defina sus metas y objetivos específicos para cada año. Recuerde reevaluar su plan de trabajo ocasionalmente para realizar cualquier ajuste que sea necesario.",
              },
              {
                id: "ed-0:6-b",
                da: "Esté preparado/a para preguntar a su supervisor y a sus colegas acerca de su desempeño y si está cumpliendo sus expectativas",
              },
              {
                id: "ed-0:6-c",
                da: "Acepte consejos de colegas que sean considerados/as personas de alto desempeño. Compare su estándar de trabajo con el de ellos/as — no confíe en su propia percepción. Use la evaluación hecha por ellos/as como parámetro para medir su nivel de logros.",
              },
            ],
          },
          {
            id: "ed-1",
            icon: require("@/assets/Iconography/Attributes/07-02_Advancing My Career.svg"),
            comp: "Ambicioso/a",
            wdd: "Está motivado/a para avanzar en su carrera profesional",
            progressMeasures: [
              {
                id: "ed-1-0",
                pm: "Confío en que puedo tener éxito en un rol o una posición distinta de la mía",
                pmMap:
                  "Confiar en que puedo tener éxito en un rol o en una posición distinta de la mía",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "ed-1-1",
                pm: "Tener claro lo que necesito hacer para promocionar en mi carrera profesional" /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
                pmMap:
                  "Tener claro lo que necesito hacer para promocionar en mi carrera profesional",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "ed-1-2",
                pm: "Estoy tomando las medidas necesarias para lograr un avance en mi carrera profesional",
                pmMap:
                  "Tomar las medidas necesarias para lograr un avance en mi carrera profesiona",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "ed-1-3",
                pm: "He conversado sobre mis planes futuros con mi jefe o mentor",
                pmMap:
                  "Conversar sobre mis planes futuros con mi jefe o mentor",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
            ],
            developmentActions: [
              {
                id: "ed-1:1-a",
                da: " Visualice las cosas que desea en su vida y en su carrera a diario. Existe un movimiento, creciente en los últimos años, que cree en el poder de la visualización para “atraer” lo que necesitamos en nuestras vidas. Lea El Secreto de Rhonda Byrne.",
              },
              {
                id: "ed-1:1-b",
                da: " La afirmación positiva puede ayudarle a reprogramar su pensamiento. Esté alerta de los pensamientos negativos acerca de sí mismo/a e intente reemplazarlos con pensamientos positivos inmediatamente.",
              },
              {
                id: "ed-1:1-c",
                da: " Identifique algunas personas que admira por su confianza en sí mismas y hable con ellas acerca de sus opiniones sobre el mundo. Observe las diferencias en sus estilos de pensamiento.",
              },
              {
                id: "ed-1:1-d",
                da: " No dé a los errores más importancia de la que merecen. Escriba los peores escenarios y analícelos. A menos que su vida o la de otra persona esté en peligro, lo peor nunca es tan malo como usted podría pensar.",
              },
              {
                id: "ed-1:1-e",
                da: " Lea acerca de personas que han cometido errores pero que igualmente tuvieron éxito, tales como Thomas Edison. ¡Le llevó 10,000 fracasos crear la bombilla de luz!",
              },
              {
                id: "ed-1:1-f",
                da: " No necesita tener todas las respuestas. Trabaje en la parte de su plan que pueda y pida ayuda con el resto.",
              },
              {
                id: "ed-1:1-g",
                da: " Extienda su zona de seguridad. Usted está creando confianza cada vez que asume un nuevo desafío o tarea. Lleve la cuenta de los desafíos nuevos que ha superado.",
              },
              {
                id: "ed-1:1-h",
                da: " Comprenda cuáles serán sus desafíos si pasara a una nueva posición o rol. Ennumere las cosas que potencialmente le resultan incómodas. Podría ser manejar gente por primera vez, establecer contactos más de lo acostumbrado o aprender más acerca de un área técnica específica. Trate de que su lista sea lo más detallada posible. ¿Que elementos de su lista son desafíos imaginarios y cuáles son reales? Por ejemplo, puede no haber supervisado gente antes pero trabaja bien con otras personas, es accesible, paciente, maneja bien los conflictos, etc. Todos estos comportamientos apuntan a su posible éxito como gerente de otras personas.",
              },
              {
                id: "ed-1:1-i",
                da: " Aprenda más acerca de la posición en que está interesado/a reuniéndose con el titular o alguien con un rol similar. Averigüe qué consideran ellos como los mayores desafíos de la posición. Cuánto más sepa, mejor equipado/a estará para empezar el trabajo sin verse sorprendido por exigencias inesperadas",
              },
              {
                id: "ed-1:1-j",
                da: " Si cree que realmente carece de las habilidades críticas para obtener una promoción, hable con su supervisor acerca de concebir un plan de desarrollo que involucre tareas y experiencias clave, que le ayuden a crear su conjunto de habilidades. Asegúrese de comunicar tanto su interés como su preocupación acerca de sus insuficiencias.",
              },
              {
                id: "ed-1:1-k",
                da: " No hay una cantidad exacta de preparación que garantice que usted está 100% listo/a para una posición. Si la oportunidad está disponible y usted quiere hacerlo, deje de pensar y tome acción.",
              },
              {
                id: "ed-1:1-l",
                da: " Si piensa que su falta de confianza en sí mismo/a está afectando su capacidad de funcionar y avanzar en su carrera, busque la ayuda de un coach o asesor profesional como parte de su plan de desarrollo. Un/a terapeuta capacitado/a puede ayudarle a desafiar patrones de pensamiento profundamente arraigados.",
              },
              {
                id: "ed-1:2-a",
                da: " Revise sus objetivos de carrera. ¿Sigue bien encaminado/a? ¿Su falta de motivación se debe a su tarea actual, a otra circunstancia temporal, o el problema es su posición en sí misma?",
              },
              {
                id: "ed-1:2-b",
                da: " Identifique las necesidades específicas que no están siendo cubiertas por su posición. Herramientas de evaluación tales como el método Birkman revisan las necesidades menos obvias de las personas que no son cubiertas en su ambiente de trabajo y en sus relaciones profesionales. Otros factores pueden ser más obvios, tales como el sueldo, la relación con su jefe, o la falta de tareas desafiantes. El sistema de gestión de talento de The PeopleTree Group tiene una encuesta de motivación que aborda áreas motivadoras.",
              },
              {
                id: "ed-1:2-c",
                da: " Hable con su supervisor acerca del rol que usted imagina para sí mismo/a y cómo puede crearse la oportunidad. Sea honesto/a — su supervisor puede estar pensando que usted está perfectamente satisfecho con su situación.",
              },
              {
                id: "ed-1:2-d",
                da: " Es importante mantener el empuje cuando uno/a no está motivado/a. Identifique tres acciones a realizar en el próximo mes que podrían ayudarle a recuperar el interés en su carrera.",
              },
              {
                id: "ed-1:2-e",
                da: " Trate de visualizarse haciendo algo nuevo. ¿Cuál sería su posición ideal en la organización? Tiene sentido crear una visión de su futuro y luego concentrarse estratégicamente en cómo llegar allí.",
              },
              {
                id: "ed-1:2-f",
                da: " Continúe buscando oportunidades dentro de la compañía estableciendo contactos y probando nuevos roles hasta que encuentre un proyecto, tarea o trabajo que le motive.",
              },
              {
                id: "ed-1:3-a",
                da: " Implemente un plan para el avance de su carrera. Deje que su supervisor le ayude a identificar las competencias, experiencias y habilidades técnicas que necesitará para obtener una promoción.",
              },
              {
                id: "ed-1:3-b",
                da: " Tome la iniciativa para averiguar acerca de posiciones disponibles en su compañía.",
              },
              {
                id: "ed-1:3-c",
                da: " Manténgase informado/a acerca de las habilidades consideradas escasas en su industria. Las compañías hacen esfuerzos extra para retener empleados con estas habilidades.",
              },
              {
                id: "ed-1:3-d",
                da: " Trate de visualizarse haciendo algo nuevo. ¿Cuál sería su oportunidad soñada en la organización? Tiene sentido crear una visión de futuro y luego concentrarse estratégicamente en cómo llegar allí.",
              },
              {
                id: "ed-1:3-e",
                da: " Tómese tiempo para establecer contactos. Hablar con la gente y tener más exposición aumenta sus posibilidades de descubrir nuevas formas de elevar su visibilidad y avanzar en su carrera.",
              },
              {
                id: "ed-1:3-f",
                da: " Tome el crecimiento en pasos pequeños si no se siente cómodo/a con los cambios drásticos, o realmente no sabe qué paso tomar a continuación. Experimente con tareas nuevas que pongan a prueba habilidades diferentes. Tal vez le sorprenda descubrir otras cosas para las cuales realmente tiene talento. Encontrará que se siente más cómodo/a haciendo tareas diferentes cuanto más diversas se tornen sus experiencias.",
              },
              {
                id: "ed-1:3-g",
                da: " Consulte acerca de oportunidades de corto plazo en su compañía, tal vez en un departamento nuevo, si esto podría servirle de ayuda para avanzar hacia sus metas de largo plazo.",
              },
              {
                id: "ed-1:3-h",
                da: " Lea The Leadership Pipeline de Ram Charan y Stephen Drotter, que describe las competencias necesarias para funcionar con éxito a través de los diferentes niveles organizacionales.",
              },
              {
                id: "ed-1:4-a",
                da: " ¿Puede señalar las razones por las cuales se siente tan exhausto/a? ¿Qué cosas dentro de su control pueden cambiar y cuáles no? Se sorprenderá al ver cómo cambiar uno o dos factores responsables de su agotamiento, puede brindarle el espacio que necesita para re-energizarse. Obtenga retroalimentación de su familia, colegas o un coach acerca de cuáles podrían ser esos factores. A veces nos resulta difícil ver lo que parece obvio para las personas que nos rodean.",
              },
              {
                id: "ed-1:4-b",
                da: " ¿Es su carga de trabajo razonable y realista? Hable con la gente relevante acerca de su distribución de trabajo, si ello contribuye en gran medida a su agotamiento.",
              },
              {
                id: "ed-1:4-c",
                da: " Asegúrese de energizarse diariamente con ejercicio o con un pasatiempo que le ayude a dejar de pensar en su trabajo.",
              },
              {
                id: "ed-1:4-d",
                da: " ¿Qué aspectos de la oportunidad que se le ofrece le gustan y cuáles le desagradan? ¿Qué términos son negociables? Por lo general, hay formas de adaptar una promoción para que se ajuste mejor a sus necesidades.",
              },
              {
                id: "ed-1:4-e",
                da: " Observe a la gente exitosa en su organización que tiene trabajos exigentes pero que mantiene un equilibrio entre sus vidas profesionales y privadas. Aprenda cómo lo hacen.",
              },
              {
                id: "ed-1:4-f",
                da: " Tómese un respiro antes de tomar una decisión. Haga un intervalo en sus actividades para relajarse y pensar claramente. Cualquiera que sea su decisión al volver, estará basada en una mejor perspectiva.",
              },
              {
                id: "ed-1:5-a",
                da: " Escriba los pros y contras de permanecer en la misma posición.",
              },
              {
                id: "ed-1:5-b",
                da: " Identifique una posición que realmente despierte su interés y para la cual estaría dispuesto/a a hacer sacrificios. Siga buscando si no puede identificar algo ahora.",
              },
              {
                id: "ed-1:5-c",
                da: " Incluso si no está listo/a para una promoción, siga conversando las posibilidades con sus colegas y supervisor para demostrar su interés.",
              },
              {
                id: "ed-1:5-d",
                da: " Hable con personas en otras posiciones un nivel o dos por encima de usted. Pregúnteles cuánto les gusta su trabajo y cuáles son los principales beneficios.",
              },
              {
                id: "ed-1:5-e",
                da: " Averigüe lo que más pueda acerca de la posición en cuestión. Es habitual hacer supuestos incorrectos acerca de las responsabilidades que implica una posición. Hable con el titular, si es posible, u otras personas que han desempeñado un rol similar.",
              },
              {
                id: "ed-1:5-f",
                da: " Contrate un coach para examinar en profundidad los motivos por los cuales usted no está interesado/a en asumir más responsabilidad.",
              },
              {
                id: "ed-1:6-a",
                da: " Aborde su auto-promoción como lo haría con cualquier otro esfuerzo comercial y cree un plan de marketing personal. Establezca las acciones a tomar y responsabilícese semanalmente.",
              },
              {
                id: "ed-1:6-b",
                da: " Cree un informe de situación semanal para informar a su jefe acerca de sus logros.",
              },
              {
                id: "ed-1:6-c",
                da: " Comunique sus esfuerzos a todos los interesados/as, no sólo a sus colegas o gerente. Si es adecuado, considere informar a sus clientes, altos directivos y red de negocios.",
              },
              {
                id: "ed-1:6-d",
                da: " Aprenda a crear un documento breve que comunique los puntos destacados de su éxito sin brindar detalles innecesarios.",
              },
              {
                id: "ed-1:6-e",
                da: " Cuidado con ser demasiado modesto/a. ¿Está desviando los elogios con demasiada rapidez? Acepte los elogios bien merecidos gentilmente y con orgullo.",
              },
              {
                id: "ed-1:6-f",
                da: " No acepte la culpa con demasiada rapidez. Usted es responsable de sus acciones, no de los errores de las demás personas. Asumir la culpa cuando no es merecida diluye las percepciones del valor de su aportación.",
              },
              {
                id: "ed-1:6-g",
                da: " Puede sentirse más cómodo/a promocionando el esfuerzo de su grupo, lo que le da la oportunidad de destacar su rol para compartir los elogios.",
              },
              {
                id: "ed-1:6-h",
                da: " Prepárese bien para sus revisiones de desempeño. Debe ser capaz de destacar sus logros y brindar documentación qué apoye las metas menos obvias que ha cumplido.",
              },
            ],
          },
          {
            id: "ed-2",
            icon: require("@/assets/Iconography/Attributes/07-03_Being Determined.svg"),
            comp: "Perseverante",
            wdd: "Nunca deja trabajo sin terminar incluso cuando surgen problemas o se presentan obstáculos",
            progressMeasures: [
              {
                id: "ed-2-0",
                pm: "Rara vez abandono antes de terminar una tarea o proyecto",
                pmMap: "Abandonar antes de terminar una tarea o proyecto",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "ed-2-1",
                pm: "Me recupero rápidamente de impedimentos emocionales durante un proyecto",
                pmMap:
                  "Recuperarme rápidamente de impedimentos emocionales durante un proyecto",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "ed-2-2",
                pm: "He completado proyectos de largo plazo con éxito",
                pmMap: "Completar proyectos de largo plazo con éxito",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "ed-2-3",
                pm: "No me gusta dejar las tareas incompletas",
                pmMap: "No dejar cosas incompletas",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
            ],
            developmentActions: [
              {
                id: "ed-2:1-a",
                da: " Asegúrese de que las nuevas iniciativas son presentadas de forma que generen aceptación por parte de los interesados y que exista infraestructura y recursos para facilitar el seguimiento adecuado.",
              },
              {
                id: "ed-2:1-b",
                da: " Celebre las pequeñas metas o hitos a medida que se producen. Puede llevar un tiempo terminar el proyecto por completo y reconocer los pasos necesarios para llegar allí le mantendrá motivado/a.",
              },
              {
                id: "ed-2:1-c",
                da: " Que el progreso, no la inspiración, sea su principal meta. Esto significa que debe concentrarse en los pasos necesarios para hacer madurar un producto o servicio existente en lugar de tratar de generar nuevos. Prepare un plan detallado de los pasos necesarios para poner la idea en práctica. Una vez que haya identificado estos pasos en su plan, puede aplicar el mismo marco para ideas futuras.",
              },
              {
                id: "ed-2:1-d",
                da: " Asegúrese de monitorear sus procesos de trabajo. Cuando uno está distraído con iniciativas nuevas, es fácil abandonar el seguimiento del avance de los proyectos existentes. ¿Por qué comprometer el trabajo arduo y los recursos que fueron invertidos debido a una falta de supervisión?",
              },
              {
                id: "ed-2:1-e",
                da: " Encuentre un colega de confianza que pueda alentarle cuando las cosas estén complicadas. Una perspectiva externa para recordarle lo cerca que está de su meta, o simplemente alguien que escuche sus sentimientos puede ser el chaleco salvavidas que necesita cuando está menos inspirado/a.",
              },
              {
                id: "ed-2:1-f",
                da: " ¿Ha perdido de vista su sueño? Ocasionalmente, reflexione sobre la visión global y qué es lo que le entusiasmó acerca del trabajo en primer lugar.",
              },
              {
                id: "ed-2:1-g",
                da: " Primero termine las cosas que menos le guste hacer y sáquelas del medio mientras su motivación está en el punto más alto. Será más fácil abordar las tareas menos complejas cuando tenga menos energía.",
              },
              {
                id: "ed-2:1-h",
                da: " Si simplemente no puede entusiasmarse acerca de trabajar en una tarea en particular, puede ser que necesite tiempo para recargarse concentrándose en alguna otra cosa.Tomarse un descanso de la tarea que está realizando la dará la oportunidad de recargarse. ¿Puede pedir ayuda?",
              },
              {
                id: "ed-2:1-i",
                da: " Si no es una persona orientada a los detalles, es probable que pierda interés rápidamente y prefiera pasar a algo nuevo. Asegúrese de que haya gente en su equipo que sea más analítica o que se ocupe más de los detalles y que pueda manejar ese aspecto del proyecto.",
              },
              {
                id: "ed-2:1-j",
                da: " Ciertamente, algunos aspectos de los trabajos de la gente son menos interesantes que otros, pero si nada retiene su interés o se aburre crónicamente, debería considerar si su posición es correcta para usted.",
              },
              {
                id: "ed-2:2-a",
                da: " Mantenga las cosas lo más simple posible concentrando su enfoque en una o dos causas básicas del problema. Exprese cuáles son esas causas.",
              },
              {
                id: "ed-2:2-b",
                da: " Concéntrese en el punto de partida y no en la línea de llegada. ¿Qué es lo más importante como un primer curso de acción? Haga una lista de todas las posibilidades y elija sólo unos pocos caminos en los que concentrarse por ahora. Nunca hay un lugar “perfecto” para empezar. Una vez que haya logrado los pasos iniciales, empiece nuevamente.",
              },
              {
                id: "ed-2:2-c",
                da: " Reúna un equipo sólido que tenga múltiples habilidades y que pueda abordar los diversos ángulos del proyecto. No tiene que ser un experto en todos los aspectos.",
              },
              {
                id: "ed-2:2-d",
                da: " No se demore demasiado en un problema antes de abordarlo. Cuánto más tiempo deje una cuestión sin abordar más abrumadora se torna.",
              },
              {
                id: "ed-2:3-a",
                da: " A menudo, una vez que se obtiene una mejor perspectiva o se tiene mayor información, los obstáculos no son tan difíciles de superar como parecía al principio. Pídale a un colega de confianza o a un experto que le brinde una perspectiva diferente. Alguien más podría ser capaz de ver una solución obvia que usted no puede ver ahora.",
              },
              {
                id: "ed-2:3-b",
                da: " Use los obstáculos como oportunidades para divertirse a la vez de ser creativo/a. Siempre hay múltiples maneras de abordar un tema. ¿Necesita empezar de nuevo o simplemente cambiar su curso de acción? Muchos planes han fracasado no porque no eran buenos, sino porque eran inflexibles.",
              },
              {
                id: "ed-2:3-c",
                da: " Su mayor obstáculo pueden ser sus emociones o actitud. Examine los motivos reales de por qué está contemplando renunciar y asegúrese de que los motivos están basados en la lógica, no en la emoción.",
              },
              {
                id: "ed-2:3-d",
                da: " Reflexione sobre el propósito original que le llevó a embarcarse en este camino y siéntase motivado/a nuevamente. A veces una inyección de energía es todo lo que se necesita para superar un obstáculo.",
              },
              {
                id: "ed-2:4-a",
                da: " Siempre agregue tiempo a sus cronogramas para dejar espacio a contingencias. Es conveniente empezar con un horizonte temporal realista para su concreción y mitigar la frustración innecesaria.",
              },
              {
                id: "ed-2:4-b",
                da: " ¿Tiene otras cosas en marcha? No hay motivo para no pasar a otro proyecto si simplemente no está en condiciones de concentrarse en una tarea específica en este momento, pero asegúrese de volver más adelante para abordar lo que dejó atrás.",
              },
              {
                id: "ed-2:4-c",
                da: " En lugar de abandonar por completo porque las cosas no se están moviendo lo suficientemente rápido, encuentre maneras de mejorar el proceso de modo que pueda completarse más rápidamente. Esto podría implicar obtener ayuda de recursos adicionales.",
              },
              {
                id: "ed-2:4-d",
                da: " ¿Toda la tarea tiene que hacerse del principio al fin de una vez? Divídala en tareas más pequeñas en las cuales pueda trabajar de forma progresiva.",
              },
            ],
          },
          {
            id: "ed-3",
            icon: require("@/assets/Iconography/Attributes/07-04_Taking Initiative.svg"),
            comp: "Toma Iniciativa",
            wdd: "Tiene iniciativa y demuestra una actitud positiva para llevar a cabo las tareas",
            progressMeasures: [
              {
                id: "ed-3-0",
                pm: "Estoy entusiasmado/a con mi trabajo",
                pmMap: "Demostrar entusiasmo con mi trabajo",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "ed-3-1",
                pm: "Soy proactivo/a acerca de asumir tareas que aumentarán mis habilidades y ampliarán mis experiencias",
                pmMap:
                  "Ser proactivo/a acerca de asumir tareas que aumentarán mis habilidades y ampliarán mis experiencias",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "ed-3-2",
                pm: "No espero que me digan qué trabajo hacer",
                pmMap:
                  "No esperar a recibir instrucciones sobre qué trabajo hacer",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "ed-3-3",
                pm: "Tomo la iniciativa incluso si la decisión es arriesgada",
                pmMap:
                  "Tomar la iniciativa incluso si la decisión es arriesgada",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
            ],
            developmentActions: [
              {
                id: "ed-3:1-a",
                da: " ¿Está asumiendo su falta de habilidades necesarias antes de realmente saber qué implica una posición? Si carece de confianza en sus habilidades, es probable que haga juicios rápidos no necesariamente basados en los hechos. Hable con las personas relevantes acerca de lo que realmente se necesita. Asegúrese de que sus expectativas acerca de sí mismo/a se comparen con las que su supervisor tiene de usted. Si por lo general es muy duro/a consigo mismo/a, probablemente está sobreestimando lo que necesita para ponerse en movimiento.",
              },
              {
                id: "ed-3:1-b",
                da: " Si su conjunto de habilidades es insuficiente para la tarea en cuestión, tome la iniciativa reclutando a alguna otra persona para que trabaje con usted. Puede aprender de esta persona y aportar sus fortalezas al mismo tiempo. Use un colega adecuado y con conocimientos como tabla de resonancia para las ideas.",
              },
              {
                id: "ed-3:1-c",
                da: " Ofrézcase como voluntario/a para tareas que desafiarán y extenderán su capacidad. Enumere las cosas que se siente menos cómodo/a haciendo. Resuelva llevar a cabo como mínimo una tarea por mes que le ayudará a desarrollar un área débil.",
              },
              {
                id: "ed-3:1-d",
                da: " Formule un plan de desarrollo individual con su supervisor o coach para abordar áreas en las que particularmente le falta confianza. ¿Por qué esperar para abordar una debilidad cuando puede tener una estrategia de desarrollo constante diseñada para mejorarla?",
              },
              {
                id: "ed-3:1-e",
                da: " Recuerde otros tiempos cuando era temeroso/a de abordar un desafío. ¿Cuál fue el resultado? ¿Desbarató su nivel de habilidad el proyecto?",
              },
              {
                id: "ed-3:1-f",
                da: " Si no sabe dónde empezar, tome la iniciativa siendo ingenioso/a. Averigüe quién puede ayudarle con tareas determinadas; investigue el trabajo realizado en proyectos similares y los materiales de referencia disponibles para estar totalmente informado/a. En lugar de dedicar tiempo a algo sin obtener resultados, empiece a formular las preguntas correctas.",
              },
              {
                id: "ed-3:2-a",
                da: " Sopese la probabilidad del completo fracaso de la situación o decisión y el grado de daño si se materializara el peor escenario. La realidad tiende a ser menos severa que la percepción. Hable con un colega de confianza o mentor que pueda actuar de tabla de resonancia para sus preocupaciones. Pueden ayudarle abrindar perspectiva. ¿Piensan que la situación es tan arriesgada como usted?",
              },
              {
                id: "ed-3:2-b",
                da: " Siéntase cómodo/a tomando decisiones sin los datos completos. Practique confiar en su intuición. En su libro Blink, Malcom Gladwell defiende el poder de usar la intuición en la toma de decisiones. Empiece con pequeñas decisiones y avance hasta aquellas con mayores consecuencias.",
              },
              {
                id: "ed-3:2-c",
                da: " Acostúmbrese a tomar decisiones independientemente de la sabiduría convencional o el nivel de respaldo con que cuenta. Tomar la iniciativa a veces significará preparar el terreno por su cuenta.",
              },
              {
                id: "ed-3:2-d",
                da: " Trabaje junto con alguien que sea más tolerante al riesgo y pueda ayudarle a tomar la iniciativa en proyectos fuera de su zona de comodidad.",
              },
              {
                id: "ed-3:2-e",
                da: " Identifique por adelantado los riesgos asociados con su trabajo, negocio, proyecto,etc. Tener un plan para manejar el riesgo, si se convirtiera en un problema, le dará una mayor sensación de control.",
              },
              {
                id: "ed-3:2-f",
                da: " Haga reflexiones una vez terminados los proyectos, por su cuenta y con su equipo. Revise sus supuestos incorrectos. ¿Qué le preocupó más? ¿Cuál fue la consecuencia de haber hecho esas cosas o haber dejado de hacerlas? ¿Qué podría hacer diferente la próxima vez? ¿Estuvieron justificadas sus preocupaciones?",
              },
              {
                id: "ed-3:3-a",
                da: " Finja hasta que lo crea. Hable acerca de la tarea como si estuviera verdaderamente entusiasmado/a. Identifique todos los resultados posibles que pueden obtenerse emprendiendo acciones. Arremánguese y hágalo. La recompensa por el arduo trabajo está a una iniciativa de distancia.",
              },
              {
                id: "ed-3:3-b",
                da: " El ejercicio regular ayuda a aliviar el estrés, crea resistencia física y mental y eleva los niveles de energía. Incluya el ejercicio como una de sus herramientas para crear más energía en su vida y en su trabajo.",
              },
              {
                id: "ed-3:3-c",
                da: " Asegúrese de equilibrar su vida con las cosas que le traen felicidad. Si no se está recargando fuera del trabajo, su energía se verá debilitada y su desempeño carecerá de brillo.",
              },
              {
                id: "ed-3:3-d",
                da: " Ayude a los demás a entusiasmarse incluso si usted no lo está. Trate de no sonar aburrido/a o quejarse en el lugar de trabajo. Aliente discusiones optimistas acerca del futuro. Pida a la gente que comparta su visión y esperanza por el futuro de ellos/as o de la organización. Integre esto como parte ritual de sus reuniones. Asegúrese de no entorpecer el progreso de los demás por, por ejemplo, no hacer el trabajo con el cual ellos/as habían contado.",
              },
              {
                id: "ed-3:3-e",
                da: " Observe cómo lo hacen los demás. Identifique personas que sean energizantes y generen entusiasmo acerca del trabajo. Pase tiempo con ellos/as y aproveche su energía.",
              },
              {
                id: "ed-3:3-f",
                da: " Si era enérgico/a antes pero perdió su entusiasmo, examine qué cambió acerca de su situación. ¿Es el trabajo o algo mayor? Hable con un mentor o coach que pueda ayudarle a examinar los factores que lo llevaron a su estado de ánimo, y los cambios que podría hacer.",
              },
              {
                id: "ed-3:3-g",
                da: " ¿Se sentiría más enérgico/a si tuviera responsabilidades diferentes? Explore si su posición es adecuada y, si no lo es, cuál sí sería. Considere nuevas posiciones que empezarán un nuevo capítulo en su carrera y le ayudarán a explotar la nueva energía.",
              },
              {
                id: "ed-3:3-h",
                da: " Si su nivel de energía es crónicamente bajo y le resulta difícil tomar la iniciativa en todo, incluyendo las cuestiones personales, considere consultar a un asesor profesional o buscar asesoramiento médico.",
              },
              {
                id: "ed-3:4-a",
                da: " No espere que le digan qué hacer o que se produzca una crisis para forzar una cuestión. Busque tareas que queden incompletas o proyectos que podrían beneficiarse de su participación.",
              },
              {
                id: "ed-3:4-b",
                da: " Hable con su supervisor acerca de sus expectativas. Su supervisor puede sentirse amenazado o tal vez no es consciente de qué le desalienta a tomar la iniciativa. Trate de descubrir los motivos en lugar de hacer supuestos. Usted puede estar desconcentrado/a y el supervisor puede necesitar que usted actúe proactivamente en otras áreas. Dé ejemplos de cuestiones concretas en lugar de generalizaciones.",
              },
              {
                id: "ed-3:4-c",
                da: " Comparta el mérito con otras personas cuando pueda de modo que nadie se sienta amenazado/a por el hecho de que usted tome la iniciativa por su cuenta.",
              },
              {
                id: "ed-3:4-d",
                da: " Si se siente totalmente incapaz de tomar la iniciativa en su posición, considere una reasignación donde sus esfuerzos serán bien reconocidos.",
              },
              {
                id: "ed-3:5-a",
                da: " No asuma que no tendrá éxito. Si carece de recursos, hable con la gente relevante acerca de ponerlos a su disposición. Si es lo suficientemente convincente, obtendrá el respaldo que necesita.",
              },
              {
                id: "ed-3:5-b",
                da: " Si no puede hacerlo por su cuenta, movilice a otras personas para que se interesen y compartan el proyecto con usted.",
              },
              {
                id: "ed-3:5-c",
                da: " Busque inspiración desde adentro más que desde afuera. Otras personas pueden no estar motivados/as para brindar dirección, por lo tanto sea quien sobresale. La cuestión puede no ser una prioridad para los demás, pero puede ver el impacto que tendrá, por lo tanto manténgase resuelto/a y fuerte.",
              },
              {
                id: "ed-3:5-d",
                da: " Defienda los beneficios de seguir el curso de acción que está sugiriendo. Sus esfuerzos pueden no recibir la apreciación que quería, pero al menos hizo lo mejor que pudo. Tal vez su plan de acción será implementado cuando el momento sea mejor.",
              },
              {
                id: "ed-3:6-a",
                da: " No asuma que no puede tomar ciertas decisiones. Averigüe cuál es su nivel de autoridad y dentro de qué parámetros necesita trabajar.",
              },
              {
                id: "ed-3:6-b",
                da: " Sea proactivo/a. Si tiene ideas acerca de abordar un problema, consulte a las personas relevantes y explique cómo propone hacerlo.",
              },
              {
                id: "ed-3:6-c",
                da: " Hágase cargo de la situación primero, luego deténgase en puntos de control a lo largo del camino para asegurarse de que está avanzando en la dirección correcta.",
              },
              {
                id: "ed-3:7-a",
                da: " Pase tiempo familiarizándose con los tipos de herramientas en las que puede confiar para hacer su trabajo. La mayoría de las organizaciones han hecho considerables inversiones en recursos como software, revistas de la industria y material de referencia. Reserve algo de tiempo después del trabajo o durante los fines de semana, si es necesario, para repasar su material de referencia.",
              },
              {
                id: "ed-3:7-b",
                da: " Pregunte a sus colegas qué solían lograr en trabajos similares. Conversaciones como ésta le exponen a recursos que pueden estar disponibles pero que usted no conocía o nunca pensó en utilizar.",
              },
              {
                id: "ed-3:7-c",
                da: " Si no tiene los recursos que necesita a su disposición, arroje la red más lejos. Mire más allá de su grupo o división o incluso su compañía para encontrar lo recursos necesarios.",
              },
              {
                id: "ed-3:7-d",
                da: " Averigüe acerca de la capacitación disponible de su departamento de recursos humanos y programe tiempo para asistir.",
              },
              {
                id: "ed-3:7-e",
                da: " Sugiera reuniones informales, en el almuerzo tal vez, donde usted y sus colegas puedan compartir sus conocimientos y capacitar a otras personas informalmente",
              },
              {
                id: "ed-3:7-f",
                da: " Inmediatamente informe a sus colegas si no puede aprovechar un recurso o ni siquier usarlo. No hay que tener vergüenza de no saber, pero, ¡debería darle vergüenza no preguntar!",
              },
            ],
          },
        ],
      },
      fc: {
        characteristic: "Es flexible",
        wdd: "Se adapta a los diferentes estilos de personalidad y a las necesidades de los demás, está abierto al ",
        feedback: " y es consciente de sus fortalezas y de sus debilidades",
        icon: require("@/assets/Iconography/Characteristics/08_Flexible Character.svg"),
        competencies: [
          {
            id: "fc-0",
            icon: require("@/assets/Iconography/Attributes/08-02_Adapting To Others.svg"),
            comp: "Adaptable",
            wdd: "Se adapta a los diferentes estilos de personalidad y a las necesidades de los demás",
            progressMeasures: [
              {
                id: "fc-0-0",
                pm: "Puedo identificar los estilos adecuados que pueden funcionar mejor con diferentes personas",
                pmMap:
                  "Identificar los estilos adecuados que pueden funcionar mejor con diferentes personas",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "fc-0-1",
                pm: "Puedo identificar el estilo necesario para trabajar en diferentes situaciones",
                pmMap:
                  "Identificar el estilo necesario para trabajar en diferentes situaciones",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "fc-0-2",
                pm: "Comprendo que hay más de una manera de actuar con la gente sin perder mi autenticidad",
                pmMap:
                  "Adaptar la manera de actuar con la gente sin perder la autenticidad",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "fc-0-3",
                pm: "Me adapto a los demás de modo que puedan relacionarse conmigo",
                pmMap:
                  "Adaptarme a los demás de modo que puedan relacionarse conmigo",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "fc-0-4",
                pm: "Me siento cómodo/a entre diversos grupos de gente",
                pmMap: "Sentirme cómodo/a entre diversos grupos de gente",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
            ],
            developmentActions: [
              {
                id: "fc-0:1-a",
                da: "Observe mejor el comportamiento de los demás. Trate de imitar loscomportamientos del grupo o de la otra persona. Por ejemplo, si la persona parece retraída y callada, modere su comportamiento. Baje la voz y sea reservado/a y sereno/a en lugar de enérgico/a y animado/a, hasta que la conozca mejor. La clave es prestar atención a la otra persona también, no solo a sí mismo/a.",
              },
              {
                id: "fc-0:1-b",
                da: "Investigue el grupo con el cual estará interactuando. Conocer la formación de la gente puede brindar mucha información acerca de sus estilos.",
              },
              {
                id: "fc-0:1-c",
                da: "Pregunte a los demás qué necesita hacer diferente para mejorar su relación con ellos.",
              },
              {
                id: "fc-0:1-d",
                da: "Sea honesto/a acerca de no estar seguro/a de si su estilo podría ser ofensivo de alguna manera. Esto se aplica especialmente si está trabajando con grupos de otras nacionalidades. La gente apreciará su preocupación.",
              },
              {
                id: "fc-0:1-e",
                da: "¿Se ajusta su comportamiento a los valores o expectativas de la organización? Trate de definir cuáles son y considere si su comportamiento es adecuado.",
              },
              {
                id: "fc-0:2-a",
                da: "Investigue diferentes estilos interpersonales para reconocer los tipos con los cuales interactúa.",
              },
              {
                id: "fc-0:2-b",
                da: "Considere la formación de la persona así como la disciplina o su campo de trabajo y de qué manera éstos pueden diferir de los suyos. Si está interactuando con contadores, por ejemplo, ellos pueden preferir mantener la conversación bastante estructurada y pueden querer que usted comparta más detalles que otras personas.",
              },
              {
                id: "fc-0:2-c",
                da: "Evalúe el estado emocional de la persona: triste, irritado/a, nervioso/a, etc. Es importante respetar el estado mental de la gente y adaptarse al mismo.",
              },
              {
                id: "fc-0:2-d",
                da: "Considere primero de qué manera la persona podría ser diferente de usted y sólo entonces busque similitudes. Esto le ayudará a evitar proyectarse en los demás.",
              },
              {
                id: "fc-0:2-e",
                da: "Las reacciones y el lenguaje corporal de la gente pueden ayudarle a guiar sucomportamiento. Busque cambios en la expresión facial, el tono de voz, la postura. Puedeadaptarse en consecuencia.",
              },
              {
                id: "fc-0:2-f",
                da: "Algunos/as de nosotros/as tenemos un talento natural para captar indicios acerca de los demás. Si piensa que no puede leer a otras personas, piense nuevamente. La clave esrealmente observarlos/as —- cómo se comunican, su comportamiento, expresiones,lenguaje corporal. Los indicios acerca de la gente y quiénes son realmente son muy evidentes y usted, a su vez, puede usarlos para adaptarse a sus necesidades interpersonales.Simplemente eleve su nivel de consciencia.",
              },
              {
                id: "fc-0:2-g",
                da: "Dedique tiempo a conocer a la gente a nivel personal. No hay mejor manera de comprender a la gente que pasando tiempo con ellos.",
              },
              {
                id: "fc-0:3-a",
                da: "Identifique los objetivos compartidos entre usted y la persona o grupo y use eso como puente hacia un terreno común.",
              },
              {
                id: "fc-0:3-b",
                da: "Dedique tiempo a conocer mejor a la persona para desafiar sus impresiones acerca de ella. Por lo general, las reuniones en entornos sociales, fuera de las presiones del trabajo, le dan una perspectiva nueva acerca de los demás, por lo tanto, trate de organizarlas, si es posible.",
              },
              {
                id: "fc-0:3-c",
                da: "La falta de flexibilidad de su parte podría derivarse de un prejuicio hacia un grupo.Considere los prejuicios ocultos que puede estar albergando y trate de desafiar los supuestos sobre los cuales están basados.",
              },
              {
                id: "fc-0:3-d",
                da: "Reconozca el estilo interpersonal de la otra persona y sus fortalezas y aportes, incluso si es diferente del suyo. Por ejemplo, puede estar tratando con alguien que es audaz y conversador/a, muy diferente de usted. Pero estos rasgos pueden agregar valor real en el rol de ventas con el cual usted se siente incómodo/a.",
              },
              {
                id: "fc-0:4-a",
                da: "Trate de ponerse en el lugar de la otra persona.",
              },
              {
                id: "fc-0:4-b",
                da: "Considere los pros de adaptar su comportamiento para ambos.",
              },
              {
                id: "fc-0:4-c",
                da: "Pregúntese si le gustaría que alguien haga lo mismo por usted. Muy probablemente apreciaría tal esfuerzo",
              },
            ],
          },
          {
            id: "fc-1",
            icon: require("@/assets/Iconography/Attributes/08-01_Being Self-Aware.svg"),
            comp: "Consciente De Sí Mismo/a",
            wdd: 'Está abierto al "feedback" y es consciente de sus fortalezas y de sus debilidades',
            progressMeasures: [
              {
                id: "fc-1-0",
                pm: "Sé cuáles son mis mejores cualidades y mis debilidades",
                pmMap:
                  "Saber cuáles son mis mejores cualidades y mis debilidades",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "fc-1-1",
                pm: "Habitualmente pido retroalimentación",
                pmMap: "Pedir feedback regularmente",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "fc-1-2",
                pm: "No me pongo a la defensiva cuando recibo crítica constructiva",
                pmMap:
                  "No ponerme a la defensiva al recibir crítica constructiva",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "fc-1-3",
                pm: "Habitualmente me cuestiono mis motivos, valores y opiniones",
                pmMap:
                  "Cuestionar mis motivos, valores y opiniones habitualmente",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "fc-1-4",
                pm: "Leo literatura sobre comportamiento humano y psicología",
                pmMap: "Leer sobre comportamiento humano y psicología",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
            ],
            developmentActions: [
              {
                id: "fc-1:1-a",
                da: " Participe en una evaluación de retroalimentación de 360°. Es la forma más efectiva de obtener resultados colectivos de sus colegas. La metodología de 360° de PeopleTree usa un método de clasificación forzado que reduce el prejuicio del calificador y evalúa sus fortalezas y debilidades relativas.",
              },
              {
                id: "fc-1:1-b",
                da: " Si encuentra que se está poniendo a la defensiva u hostil cuando recibe retroalimentación, puede verse tentado/a a dar una respuesta con carga emocional.Practique técnicas de manejo de estrés tales como respiración profunda. Dedique tiempo a dejar que la retroalimentación sea asimilada y repítala en su mente varias veces, cada vez seguida de las palabras “consciente de sí mismo/a”. Esto le da un momento para conscientemente calmar la ira u hostilidad y le ayuda a poner todo en perspectiva.",
              },
              {
                id: "fc-1:1-c",
                da: " No quede atrapado/a en tratar de defenderse. Informe a la persona que tomará en consideración sus sugerencias o retroalimentación. Si no se siente demasiado emotivo/a,pida ejemplos concretos para poder considerar mejor lo que le dijeron.",
              },
              {
                id: "fc-1:1-d",
                da: " Sea accesible. La gente evita dar retroalimentación a aquellos que tienen poco tiempo para ellos o que no escuchan. Usted muestra claramente que está abierto a la retroalimentación a través de su lenguaje corporal y expresiones faciales, y porque la alienta, por supuesto.",
              },
              {
                id: "fc-1:1-e",
                da: " No toda la retroalimentación es 100% precisa, pero, si presta atención, siempre hay algo revelador acerca de sí mismo/a o de la otra persona. No estará en condiciones de detectar estos matices si se pone a la defensiva. Incluso si no está de acuerdo con la retroalimentación, se está dando por algún motivo. ¿Cuál cree que sea el motivo? ¿Qué puede aprender acerca de sí mismo/a y de la otra persona?",
              },
              {
                id: "fc-1:1-f",
                da: " Si más de una persona le está dando la misma retroalimentación, hay posibilidades de que sea bastante cierta. Sería sabio por su parte que prestara atención.",
              },
              {
                id: "fc-1:2-a",
                da: " La meditación describe un estado de atención concentrada en un objeto de pensamiento o consciencia. Por lo general implica volcar la atención hacia adentro a un único punto de referencia. Es una buena técnica para alcanzar nuestros motivos y emociones internas. Elija entre las numerosas técnicas de meditación disponibles y agréguelas a su rutina diaria.",
              },
              {
                id: "fc-1:2-b",
                da: " Identifique a alguien en la compañía que sea exitoso/a y querido/a. ¿Qué habilidades interpersonales le atribuiría a esa persona? Úselo/a como modelo para su comportamiento.",
              },
              {
                id: "fc-1:2-c",
                da: " Conscientemente trate de ser más abierto/a con la gente. Puede ser incómodo y difícil al principio, pero sentirse lo suficientemente cómodo/a como para compartir información personal le ayuda a practicar la comunicación de sus sentimientos.",
              },
              {
                id: "fc-1:2-d",
                da: " Póngase en el lugar de la otra persona cuando se le presenten situaciones problemáticas. ¿Cómo se sentiría en la misma posición? ¿Cómo le gustaría que le trataran?",
              },
              {
                id: "fc-1:3-a",
                da: " Desafíe sus valores. Lea acerca de las prácticas, religiones o filosofías con las cuales no está familiarizado/a y vea si encuentra más valores admirables.",
              },
              {
                id: "fc-1:3-b",
                da: " Si es reacio/a a descubrirse, trate de descubrir el mundo. Expóngase a gente, experiencias y pasatiempos completamente diferentes. Aprenderá mucho acerca de sí mismo/a en el proceso.",
              },
              {
                id: "fc-1:3-c",
                da: " Cree una biblioteca de consciencia de sí mismo/a y programe tiempo por lo menos una vez por semana para auto-desarrollo en una variedad de áreas. Hay una gran cantidad de lecturas interesantes disponibles",
              },
              {
                id: "fc-1:3-d",
                da: " Hay numerosas evaluaciones psicológicas disponibles para evaluar efectivamente a la gente desde diversos ángulos. Intente un ángulo diferente. Pida una recomendación al departamento de recursos humanos.",
              },
              {
                id: "fc-1:3-e",
                da: " El autoanálisis es clave. Siempre formúlese preguntas: ¿Por qué tomó esa decisión? ¿Por qué se está sintiendo realmente de una forma determinada? ¿Cuáles habrían sido las consecuencias de una elección diferente? No se obsesione, simplemente pregunte.",
              },
              {
                id: "fc-1:3-f",
                da: " La meditación es una forma comprobada y efectiva de alcanzar motivos y emociones internas. Las técnicas de meditación incluyen ejercicios de respiración y mantra así como también yoga. Investigue las opciones y haga meditación como parte de su ritual diario.",
              },
              {
                id: "fc-1:3-g",
                da: " Comparta lo que sabe o piensa acerca de sí mismo/a con otras personas. Compare su auto-evaluación con la retroalimentación recibida de ellos/as y encuentre sus puntos ciegos y fortalezas ocultas.",
              },
              {
                id: "fc-1:4-a",
                da: " Acostúmbrese a mantenerse en contacto con su comportamiento pidiendo retroalimentación a las demás personas cuando sea adecuado. Pregunte: ¿Qué estoy haciendo bien? ¿Qué puedo mejorar? ¿Qué necesito cambiar?",
              },
              {
                id: "fc-1:4-b",
                da: " Participe en un proceso de evaluación de 360º formal. Es una excelente manera de medir cómo la gente le percibe realmente.",
              },
              {
                id: "fc-1:4-c",
                da: " Contrate un coach que pueda ayudarle a interpretar los resultados y comprender los beneficios de modificar su comportamiento.",
              },
            ],
          },
        ],
      },
      im: {
        characteristic: "Es creativo/a",
        wdd: "Crea nuevas ideas haciendo conexiones entre conceptos diferentes, muchas veces sin relación entre ellos. Está abierto/a a ideas o conceptos diferentes y a veces contradictorios y está abierto al cambio",
        icon: require("@/assets/Iconography/Characteristics/09_Imaginative Mind.svg"),
        competencies: [
          {
            id: "im-0",
            icon: require("@/assets/Iconography/Attributes/09-01_Keeping An Open Mind.svg"),
            comp: "Abierto/a De Mente",
            wdd: "Está abierto/a a ideas o conceptos diferentes y a veces contradictorios y está abierto al cambio",
            progressMeasures: [
              {
                id: "im-0-0",
                pm: "No me siento incómodo acerca de ideas nuevas o diferentes",
                pmMap: "No sentirme incómodo ante ideas nuevas o diferentes",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "im-0-1",
                pm: "Valoro la importancia de las visiones y creencias que difieren de las mías",
                pmMap:
                  "Valorar la importancia de las visiones y creencias que difieren de las mías",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "im-0-2",
                pm: "Estoy abierto/a a nuevas experiencias",
                pmMap: "Estar abierto/a a nuevas experiencias",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "im-0-3",
                pm: "Previamente he cambiado mi visión acerca de una sólida creencia personal después de haber estado expuesto/a a una perspectiva diferente",
                pmMap:
                  "Estar preparado/a para cambiar mi punto de vista en alguna creencia personal sólida tras exponerme a una persoectiva diferente",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "im-0-4",
                pm: "Pienso que pocas situaciones son simplemente blanco o negro",
                pmMap:
                  'No ver las situaciones en "blanco o negro" y mantener la mente abierta',
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
            ],
            developmentActions: [
              {
                id: "im-0:1-a",
                da: " Cuando se sienta desafiado/a o puesto/a a prueba por alguien, respire profundo y reconozca sus sentimientos, ya sea ponerse a la defensiva, estar enojado/a, cohibido/a o irritado/a. Reconocer sus emociones le permite abordar sus sentimientos, en lugar de arremeter contra la otra persona.",
              },
              {
                id: "im-0:1-b",
                da: " Independientemente de sus sentimientos, recuerde que su meta es encontrar soluciones, no tener razón.",
              },
              {
                id: "im-0:1-c",
                da: " Imagine cómo se sentiría si quisiera compartir sus opiniones y su jefe/a no fuera receptivo/a.",
              },
              {
                id: "im-0:1-d",
                da: " Pregúntele a la gente qué piensan antes de dar sus recomendaciones.",
              },
              {
                id: "im-0:1-e",
                da: " Si sospecha que estableció una cultura de “sí señor”, pregunte a colegas de confianza si realmente parece muy autoritario/a.",
              },
              {
                id: "im-0:1-f",
                da: " Establezca y fomente una cultura de apertura de mente — pida la opinión de los demás de forma regular, tanto informalmente como en reuniones; asigne a la gente el rol de abogado del diablo; brinde incentivos a aquellos que desafían el status quo; sea coherente, colaborador/a y paciente con aquellos que aprenden de usted.",
              },
              {
                id: "im-0:1-g",
                da: " La gente necesitará ver evidencia de que usted es genuinamente abierto/a de mente. Esto significa no sólo alabar de boca para afuera, sino efectivamente actuar en relación con las ideas generadas por los demás.",
              },
              {
                id: "im-0:1-h",
                da: " Sea generoso/o y dé crédito a las buenas sugerencias de los demás, incluso si son diferentes de las suyas.",
              },
              {
                id: "im-0:2-a",
                da: " Esté abierto a la retroalimentación, ideas y formas de pensar de los demás.",
              },
              {
                id: "im-0:2-b",
                da: " Reserve su juicio hasta que pueda evaluar plenamente el valor de una propuesta.",
              },
              {
                id: "im-0:2-c",
                da: ' Formule preguntas exploratorias en lugar de arremeter de forma defensiva.Sinceramente trate de comprender la posición de la otra persona. Use lenguaje inclusivo, por ejemplo, "Veamos cómo podemos mejorar esta idea juntos”, “¿Puede decirme más?” y “Ésta ha sido mi creencia, ¿por lo tanto cómo justifico un cambio?"',
              },
              {
                id: "im-0:2-d",
                da: " ¿Tiene reputación de ser terco/a? Pregunte a los colegas si las creencias a las que se aferra no están sirviendo al equipo o a la organización. Asegúrese de no ponerse a la defensiva cuando los demás le dicen la verdad.",
              },
              {
                id: "im-0:2-e",
                da: " Haga investigación acerca de la evolución de diversos productos y compañías, desde su idea original hasta lo que son ahora. ¿Qué cambios en los sistemas de creencias o culturas permitieron su avance?",
              },
              {
                id: "im-0:2-f",
                da: " Compare cómo sus creencias o valores actuales difieren de aquellos que sostenía cuando era más joven. Es probable que descubra que algunos han cambiado, incluso si no se dio cuenta en el momento.",
              },
              {
                id: "im-0:3-a",
                da: " Sumérjase en cosas diferentes. Pruebe comidas de culturas poco conocidas. Visite galerías de arte con exposiciones que normalmente no querría ver — cambie escultura por fotografía, cerámica por arte abstracto y así sucesivamente. Escuche nuevos tipos de música — clásica en lugar de bluegrass, jazz en lugar de rap, country en lugar de new age. Mire películas de géneros que normalmente ignora — documentales, películas extranjeras con subtítulos, animación, suspenso.",
              },
              {
                id: "im-0:3-b",
                da: " Comprométase a aprender algo nuevo acerca de una cultura o estilo de vida diferente al suyo cada mes. Trate de experimentarlo de primera mano",
              },
              {
                id: "im-0:3-c",
                da: " Tome clases en una universidad pública, asista a seminarios por Internet, escuche transmisiones por Internet o lea artículos y libros sobre diversos temas poco familiares, por ejemplo, nutrición, cultura pop, arte, historia, danza swing, el cuidado y conservación del planeta, buceo, mecánica del automotor, cocina, idiomas extranjeros, jardinería,astronomía, entrenamiento en primeros auxilios y más.",
              },
              {
                id: "im-0:3-d",
                da: " Pida ser asignado a posiciones que le permitan trabajar con gente de diferentes orígenes o en mercados completamente diferentes. Busque similitudes entre su experiencia y la de ellos. Existen diferencias, pero también hay temas en común que unen.",
              },
              {
                id: "im-0:4-a",
                da: " Aproveche los diversos orígenes y puntos de vista de otras personas cuando planee o improvise procesos o resuelve un problema. Considere retroalimentación de varias fuentes, por ejemplo, el personal de la línea,clientes internos y externos, etc.",
              },
              {
                id: "im-0:4-b",
                da: " Establezca una iniciativa de intercambio de tareas durante la cual usted y otros líderes de su grupo de trabajo desempeñen las tareas de los demás durante un día o varias horas como mínimo. Elija un trabajo poco familiar o uno que le brinde una mejor comprensión de las necesidades de los demás. Elija el trabajo de alguno de sus subordinados, por ejemplo. Comparta las lecciones aprendidas y modifique sus percepciones y procesos en consecuencia.",
              },
              {
                id: "im-0:4-c",
                da: " No inicie una conversación con la meta de demostrar su argumento. En cambio,escuche para recibir información que podría mejorar o tal vez incluso derrotar sus ideas.",
              },
              { id: "im-0:4-d", da: " Escuche primero, hable después." },
              {
                id: "im-0:4-e",
                da: " Use grupos especializados o los así llamados “equipos tigre” para desafiar sus ideas y recomendar cambios.",
              },
            ],
          },
          {
            id: "im-1",
            icon: require("@/assets/Iconography/Attributes/09-02_Being Creative.svg"),
            comp: "Creativo/a",
            wdd: "Crea nuevas ideas haciendo conexiones entre conceptos diferentes, muchas veces sin relación entre ellos",
            progressMeasures: [
              {
                id: "im-1-0",
                pm: "Disfruto del intercambio de ideas y tengo muchas propuestas para compartir durante las sesiones",
                pmMap:
                  "Disfrutar del intercambio de ideas y tener muchas propuestas para compartir durante las sesiones",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "im-1-1",
                pm: "Me gusta pensar acerca de maneras novedosas de hacer las cosas",
                pmMap: "Contemplar maneras novedosas de hacer las cosas",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "im-1-2",
                pm: "Habitualmente considero los diferentes escenarios posibles en mi mente",
                pmMap:
                  "Considerar normalmente diferentes escenarios posibles en mi mente",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "im-1-3",
                pm: "Me gusta especular y reflexionar",
                pmMap: "Especular y reflexionar",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "im-1-4",
                pm: "La gente tiende a acercarse a mí para ideas nuevas",
                pmMap:
                  "Animar a la gente a que se acerquen a mí para buscar ideas nuevas",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
            ],
            developmentActions: [
              {
                id: "im-1:1-a",
                da: " Si tiene el impulso de actuar, hágalo sin demasiado pensamiento o juicio.Trate de actuar de forma espontánea al menos una vez por semana. Olvídese de si es práctico o no.",
              },
              {
                id: "im-1:1-b",
                da: " Aplique su creatividad planteándose habitualmente los escenarios posibles.",
              },
              {
                id: "im-1:1-c",
                da: " Desafíe su naturaleza práctica contemplando escenarios simples que involucren su vida personal: “¿Qué pasaría si me tomo vacaciones la semana que viene y voy a ese lugar que siempre quise ir?” Observe la clase de pensamientos negativos u objeciones que aparecen instantáneamente. ¿Qué objeciones son imposibles de superar? Haga lo mismo cuando piense en soluciones en el trabajo. Una idea puede parecer poco práctica al principio, pero mire más de cerca la validez de sus objeciones a la misma",
              },
              {
                id: "im-1:1-d",
                da: " Recoja nuevas ideas; pregunte a otros cuál sería su enfoque.",
              },
              {
                id: "im-1:1-e",
                da: " Recoja nuevas ideas; pregunte a otros cuál sería su enfoque.",
              },
              {
                id: "im-1:1-f",
                da: " Asegúrese de que haya gente creativa en su equipo.",
              },
              {
                id: "im-1:1-g",
                da: " Participe en pasatiempos que alienten el uso de la imaginación y el lado creativo de su cerebro, tales como clases de arte o fotografía.",
              },
              { id: "im-1:1-h", da: " Pase más tiempo con gente creativa." },
              {
                id: "im-1:2-a",
                da: " Permítase tiempo para reconsiderar una idea que no se ha hecho realidad en el pasado. Si es impaciente, no está dando tiempo a que surjan ideas creativas y novedosas.",
              },
              {
                id: "im-1:2-b",
                da: " Haga un pacto consigo mismo/a para no tomar una decisión hasta que haya considerado por lo menos tres enfoques diferentes.",
              },
              {
                id: "im-1:2-c",
                da: " Elija, deliberadamente, usar de vez en cuando una técnica o metodología diferente,poco familiar.",
              },
              {
                id: "im-1:2-d",
                da: " Asóciese con alguien que sea creativo/a y que pueda alentarlo a pensar de forma menos estructurada.",
              },
              {
                id: "im-1:2-e",
                da: " Deje que los demás den ideas antes de ofrecer las suyas.",
              },
              {
                id: "im-1:2-f",
                da: " Opte por cantidad en lugar de calidad. Cuantas más ideas se generen más probabilidades habrá de que surja algo innovador. Es conveniente recoger la mayor cantidad de ideas posibles.",
              },
              {
                id: "im-1:2-g",
                da: " Manténgase en la delantera. Busque capacitación y asista a conferencias que muestren la última tecnología o tendencias en su industria.",
              },
              {
                id: "im-1:2-h",
                da: " Asegúrese de equilibrar su equipo con pensadores creativos e innovadores.",
              },
              {
                id: "im-1:3-a",
                da: " Cree una lista que identifique posibles mejoras para el ítem o tema en cuestión. Le tornará más receptivo/a a la necesidad de cambio.",
              },
              {
                id: "im-1:3-b",
                da: " Desde su perspectiva las cosas pueden estar funcionando bien, pero pregúntele a otras personas (incluso fuera de su equipo) qué perciben como problemático y por qué algo necesita rediseñarse.",
              },
              {
                id: "im-1:3-c",
                da: " Trate de no juzgar, no sólo las ideas de los demás sino también las propias.Absténgase de usar expresiones tales como “Es una buena idea pero ...” o “No pienso que sea realista…” En cambio, no emita comentarios hasta que haya digerido la idea. Le dará tiempo para considerar adecuadamente las posibilidades e implicaciones antes de hacer un juicio.",
              },
              {
                id: "im-1:3-d",
                da: " Deje que alguien más intente plantearle su idea. Cuanto más sólido sea su argumento más probabilidades tendrá usted de ser receptivo/a al mismo. Esto beneficiará a ambos.Recuerde mantenerse imparcial.",
              },
              {
                id: "im-1:4-a",
                da: " Si su entorno grupal prohíbe la creatividad, encuentre formas alternativas de comunicar sus ideas. Comente las ideas individualmente con su mentor o líder de grupo. Compartir sus pensamientos es más productivo que guardárselos.",
              },
              {
                id: "im-1:4-b",
                da: " Trate de sentirse cómodo/a vendiendo o promoviendo sus ideas. Practique con un colega o alguien con quien se sienta cómodo/a. Observe sus objeciones. Cada vez que hable con otra persona, su discurso se tornará más sólido. Simplemente tiene que convencer a la persona adecuada que pueda defender sus ideas.",
              },
              {
                id: "im-1:4-c",
                da: " Tómese la costumbre de conversar las ideas con gente con la que se sienta cómodo/a.No dé ideas por descontadas antes de haberlo hecho. Puede pensar que no valen la pena,pero permita que otros sean su caja de resonancia.",
              },
              {
                id: "im-1:4-d",
                da: " Traslade su creatividad al lenguaje del negocio. Arme un escenario de negocios que detalle la idea lo más claramente posible. Defina el problema que resultó mal previamente,su solución, el rendimiento sobre la inversión, etc. Es más probable que sus ideas sean creíbles si están bien organizadas y presentadas de forma que claramente demuestren un beneficio.",
              },
              {
                id: "im-1:4-e",
                da: " Incluso si otros gerentes no lo alientan, promueva y recompense la creatividad en su equipo.",
              },
            ],
          },
        ],
      },
      cl: {
        characteristic: "Aprende constantemente",
        wdd: "Desarrolla nuevas habilidades continuamente y mejora las habilidades ya existentes. Sabe cómo funcionan los negocios y se mantiene actualizado/a en las tendencias y cambios del mercado. Posee el conocimiento técnico y funcional para llevar a cabo su trabajo",
        icon: require("@/assets/Iconography/Characteristics/05_Constant Learner.svg"),
        competencies: [
          {
            id: "cl-0",
            icon: require("@/assets/Iconography/Attributes/05-03_Being Knowledgeable.svg"),
            comp: "Posee Conocimiento Del Mercado",
            wdd: "Sabe cómo funcionan los negocios y se mantiene actualizado/a en las tendencias y cambios del mercado",
            progressMeasures: [
              {
                id: "cl-0-0",
                pm: "Regularmente leo periódicos y literatura de mi campo de negocios",
                pmMap:
                  "Leer periódicos regularmente y literatura de mi campo de negocios",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "cl-0-1",
                pm: "Me aseguro de asistir a eventos tales como conferencias y establezco contactos para mantenerme al corriente de nuevas ideas",
                pmMap:
                  "Asegurarme la asistencia a eventos tales como conferencias y establecer contactos para mantenerme al corriente de nuevas ideas",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "cl-0-2",
                pm: "Me aseguro de estar incluido/a en reuniones que pueden ayudarme a obtener una mejor comprensión de los participantes y las partes del negocio",
                pmMap:
                  "Asegurarme de estar incluido/a en reuniones que pueden ayudarme a obtener una mejor comprensión de los participantes y las partes del negocio",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "cl-0-3",
                pm: "Puedo hablar cómodamente acerca de muchos aspectos de mi negocio",
                pmMap:
                  "Poder hablar cómodamente acerca de muchos aspectos de mi negocio",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "cl-0-4",
                pm: "Estoy informado/a de las tendencias actuales y futuras de mi negocio",
                pmMap:
                  "Estar informado/a de las tendencias actuales y futuras de mi negocio",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
            ],
            developmentActions: [
              {
                id: "cl-0:1-a",
                da: " Sea proactivo/a y demuestre interés en tareas que podrían exponerle a áreas del negocio distintas de las suyas.",
              },
              {
                id: "cl-0:1-b",
                da: " Inscríbase en cursos después de hora o en fines de semana que aumentarán sus conocimientos acerca de diferentes aspectos del negocio. Asegúrese de estar expuesto a información perteneciente a servicio al cliente, el aspecto financiero del negocio y también marketing y ventas.",
              },
              {
                id: "cl-0:1-c",
                da: " Participe en iniciativas más allá de su ámbito regular, tales como proyectos de gestión de calidad total (TQM por sus siglas en inglés) y de la Organización Internacional de Estandarización (ISO por sus siglas en inglés)",
              },
              {
                id: "cl-0:1-d",
                da: " Lea casos de estudio de negocios y aprenda qué funcionó o fracasó en diferentes compañías. Puede encontrar esta información en la biblioteca y en Internet.",
              },
              {
                id: "cl-0:1-e",
                da: " Lea la memoria anual de su compañía y asegúrese de poder interpretarla. ¿Qué tendencias están afectando el crecimiento de su compañía? ¿Comprende los estados financieros? Pídale a un asesor financiero que señale los factores importantes.",
              },
              {
                id: "cl-0:1-f",
                da: " Familiarícese con el plan estratégico de su compañía. Converse con su jefe/a sobre los motivos del rumbo específico que ha elegido su compañía. ¿Qué impulsa al negocio? ¿Cómo se determinan las prioridades?",
              },
              {
                id: "cl-0:2-a",
                da: " Conozca a sus competidores: sus productos, fortalezas y debilidades, participación en el mercado, cómo llegan a sus clientes.",
              },
              {
                id: "cl-0:2-b",
                da: " Considere su cartera de clientes con cuidado y a fondo. Comprenda exactamente quiénes son sus clientes: su segmento demográfico, necesidades, patrones y preferencias, así como también cómo llega su compañía a ellos/as y las tendencias que pueden afectarlos en el futuro.",
              },
              {
                id: "cl-0:2-c",
                da: " Compare los estados financieros de su compañía con las de otras en el mismo mercado.",
              },
              {
                id: "cl-0:2-d",
                da: " Piense acerca de asociaciones estratégicas que podrían permitirle aprovechar las tendencias con menos riesgo o inversión de su parte, o fortalecer su negocio en un área en la cual su competidor tiene una mayor participación en el mercado.",
              },
              {
                id: "cl-0:3-a",
                da: " Manténgase informado/a. Lea revistas de la industria y libros de negocios. Pida a sus colegas y jefe que le recomienden libros o sitios web para leer.",
              },
              {
                id: "cl-0:3-b",
                da: " Identifique uno o dos temas relevantes por mes e infórmese lo suficiente acerca de ellos como para conversar de forma inteligente. Trate de comprender las causas y consecuencias de un tema.",
              },
              {
                id: "cl-0:3-c",
                da: " Manténgase informado/a. Lea revistas de la industria y libros de negocios. Pida a sus colegas y jefe que le recomienden libros o sitios web para leer.",
              },
              {
                id: "cl-0:3-d",
                da: " Los medios proveen numerosas formas de obtener información. Mire o escuche los numerosos canales y programas de negocios disponibles en televisión o radio. Escuche noticias de negocios camino al trabajo y aproveche así el viaje. Subscríbase a diarios y revistas de negocios bien respetadas tales como The Wall Street Journal, Fortune 500 y Harvard Business Review.",
              },
              {
                id: "cl-0:3-e",
                da: " Regularmente almuerce con personas de la compañía que sean expertos/as en su campo y formúleles preguntas.",
              },
            ],
          },
          {
            id: "cl-1",
            icon: require("@/assets/Iconography/Attributes/05-02_Being Technically Competent.svg"),
            comp: "Posee Conocimientos Técnicos",
            wdd: "Posee el conocimiento técnico y funcional para llevar a cabo su trabajo",
            progressMeasures: [
              {
                id: "cl-1-0",
                pm: "Tengo las habilidades técnicas necesarias para hacer mi trabajo",
                pmMap:
                  "Tener las habilidades técnicas necesarias para hacer mi trabajo",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "cl-1-1",
                pm: "Actualizo mis habilidades cuando es necesario",
                pmMap: "Actualizar mis habilidades cuando es necesario",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "cl-1-3",
                pm: "Habitualmente utilizo oportunidades de capacitación y entrenamiento relevantes",
                pmMap:
                  "Utilizar habitualmente oportunidades de capacitación y entrenamiento relevantes",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "cl-1-4",
                pm: "Leo ampliamente sobre temas relacionados con mi trabajo para aumentar mis conocimientos",
                pmMap:
                  "Leer ampliamente sobre temas relacionados con mi trabajo para aumentar mis conocimientos",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "cl-1-5",
                pm: "Tengo un mentor o coach que guía mi aprendizaje y la mejora continua de mi experiencia",
                pmMap:
                  "Buscar activamente personas que saben más que yo de las cuales poder aprender",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
            ],
            developmentActions: [
              {
                id: "cl-1:1-a",
                da: " Decida en qué campo le gustaría convertirse en un/a experto/a técnico/a. Tome su decisión en base a la demanda del mercado por habilidades específicas, requisitos del trabajo actuales o futuros, sus fortalezas y debilidades personales, etc.",
              },
              {
                id: "cl-1:1-b",
                da: " Edúquese, sea formal o informalmente. Si cuenta con el tiempo o el dinero para asistir a la universidad, hágalo.",
              },
              {
                id: "cl-1:1-c",
                da: " Emprenda tanta capacitación como le sea posible. Mejorará su CV así como también sus habilidades, conocimientos y experiencia. Preste atención a las clases por Internet,aprendizaje a distancia y demás oportunidades de capacitación disponibles a través de su organización o en otros lugares.",
              },
              {
                id: "cl-1:1-d",
                da: " Una de las formas más accesibles de mejorar sus habilidades técnicas es leyendo libros. Visite sitios de libros como www.amazon.com, busque un libro sobre el tema que desea aprender y consulte las críticas y calificaciones.",
              },
              {
                id: "cl-1:1-e",
                da: " Lea seminarios por Internet. Son accesibles, actualizados y sin cargo. Por lo general ofrecen referencias adicionales, comentarios de los usuarios y demostraciones interactivas.",
              },
              {
                id: "cl-1:1-f",
                da: " Subscríbase a revistas técnicas impresas o por Internet.",
              },
              {
                id: "cl-1:2-a",
                da: " Identifique capacitación y cursos disponibles a través de su organización que puedan ayudarlo a obtener conocimientos en áreas específicas",
              },
              {
                id: "cl-1:2-b",
                da: " Pida a su supervisor y colegas que le recomienden literatura para ayudarle a actualizarse.",
              },
              {
                id: "cl-1:2-c",
                da: " Busque un coach o mentor experimentado en su campo de especialización y siga sus instrucciones. Tener un mentor o coach es crítico para convertirse en un experto técnico,porque hay numerosos matices y detalles específicos para diferentes carreras que no se pueden aprender en una clase.",
              },
              {
                id: "cl-1:2-d",
                da: " Pase tiempo en compañía de gurúes técnicos. Si los observa y se relaciona con ellos/as, es probable que pueda contagiarse de algunos de sus conocimientos.",
              },
              {
                id: "cl-1:2-e",
                da: " Aborde sus tareas — en definitiva, la capacitación práctica le dará experiencia que los libros de texto no pueden enseñarle.",
              },
              {
                id: "cl-1:3-a",
                da: " Comente sus ambiciones de carrera y opciones de desarrollo con su supervisor, y muestre su voluntad de aprender nuevas habilidades para maximizar su desempeño.",
              },
              {
                id: "cl-1:3-b",
                da: " Identifique los conocimientos funcionales o técnicos que necesita para manejar a los demás. Asigne prioridad a obtener mejores conocimientos en estas áreas.",
              },
              {
                id: "cl-1:3-c",
                da: " Explote sus experiencias para obtener oportunidades de aprendizaje técnico. Siempre busque posiciones que podrían desarrollar algunas de las habilidades técnicas que necesita.",
              },
              {
                id: "cl-1:3-d",
                da: " Si disfruta al aprender en grupos, busque cursos de extensión universitaria y otras ofertas de clases, talleres o conferencias en su área. La oportunidad de interactuar con gente de variados orígenes es una ventaja clave del aprendizaje en clase.",
              },
              {
                id: "cl-1:4-a",
                da: " Identifique los conocimientos operativos y técnicos que necesita obtener para manejar su negocio de forma adecuada. Priorice obtener conocimientos en las áreas que tendrán el mayor impacto en su capacidad de hacer negocios ahora.",
              },
              {
                id: "cl-1:4-b",
                da: " Con un coach o gerente, formule un plan de desarrollo con acciones específicas que apunten a mejorar sus conocimientos funcionales y experiencia requerida.",
              },
              {
                id: "cl-1:4-c",
                da: " Mejore su visión para los negocios suscribiéndose a publicaciones relevantes en su campo. Úselas para mantenerse informado/a de las tendencias y aumentar sus conocimientos generales.",
              },
              {
                id: "cl-1:4-d",
                da: " Explote su naturaleza social — asista a conferencias y reuniones de asociaciones que le brinden nuevas visiones y perspectivas.",
              },
              {
                id: "cl-1:4-e",
                da: " Pida a sus colegas que compartan literatura o artículos que encuentren y que consideren informativos.",
              },
              {
                id: "cl-1:4-f",
                da: " Considere su motivación, en otras palabras, cuánto desea crecer en áreas desafiantes y alcanzar metas.",
              },
              {
                id: "cl-1:5-a",
                da: " Use blogs, boletines, libros, libros electrónicos, revistas, artículos, cualesquiera recursos para presentarse al mundo.",
              },
              {
                id: "cl-1:5-b",
                da: " Inscríbase como orador o presentador en conferencias o reuniones de asociaciones.",
              },
              {
                id: "cl-1:5-c",
                da: " Si su agenda lo permite, considere una posición de docencia de tiempo parcial en una universidad local.",
              },
              {
                id: "cl-1:5-d",
                da: " Ofrézcase como voluntario/a para actuar como mentor o capacitar a otras personas en su organización y así establecerse como un/a experto/a internamente.",
              },
            ],
          },
          {
            id: "cl-2",
            icon: require("@/assets/Iconography/Attributes/05-01_Developing myself.svg"),
            comp: "Se Desarrolla A Sí Mismo/a",
            wdd: "Desarrolla nuevas habilidades continuamente y mejora las habilidades ya existentes",
            progressMeasures: [
              {
                id: "cl-2-0",
                pm: "Actualmente trabajo en desarrollar una habilidad o competencia",
                pmMap: "Trabajar en desarrollar una habilidad o competencia",
              },
              {
                id: "cl-2-1",
                pm: "Me ofrezco como voluntario para tareas que sé que serán un desafío",
                pmMap:
                  "Ofrecerme como voluntario para tareas que sé que serán un desafío",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "cl-2-2",
                pm: "Soy profundamente consciente de mis fortalezas y debilidades",
                pmMap:
                  "Ser profundamente consciente de mis fortalezas y debilidades",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "cl-2-3",
                pm: "Tengo un plan de desarrollo personal que estoy cumpliendo",
                pmMap:
                  "Tener un plan de desarrollo personal que estoy cumpliendo",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "cl-2-4",
                pm: "Estoy ansioso/a por explorar oportunidades para aprender y desarrollarme",
                pmMap:
                  "Estar ansioso/a por explorar oportunidades para aprender y desarrollarme",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
            ],
            developmentActions: [
              {
                id: "cl-2:1-a",
                da: " Vuelva a asignarle prioridad a su desarrollo personal. Si lo considera como algo de lo que se ocupará más tarde cuando tenga tiempo, no lo hará. Haga un contrato personal consigo mismo/a para tomar acción sobre planes de desarrollo personal de forma semanal.",
              },
              {
                id: "cl-2:1-b",
                da: " Considere formas de mejorar su manejo del tiempo y organícese mejor para dar espacio al desarrollo personal. Trate de enumerar todas las actividades que tiendan a desperdiciar su tiempo, tanto en el trabajo como en su vida privada. ¿Cuáles de estas actividades pueden reemplazarse con actividades de desarrollo personal?",
              },
              {
                id: "cl-2:1-c",
                da: " Agregue iniciativas de desarrollo personal a su agenda diaria. Por ejemplo, lleve consigo una revista o diario relacionado con su actividad para leer mientras está haciendo una fila o durante el almuerzo. Compre libros en CD para escuchar cuando viaje hacia y desde el trabajo o invite a un experto a cenar y converse sobre temas de interés.",
              },
              {
                id: "cl-2:1-d",
                da: " Es difícil reservar mucho tiempo seguido para el desarrollo personal, por lo tanto comprométase a períodos cortos. Simplemente media hora por día, todos los días de la semana, le brindan dos horas y media para avanzar hacia su meta de desarrollo.",
              },
              {
                id: "cl-2:1-e",
                da: " Tendemos a dedicar tiempo a las cosas que consideramos divertidas o interesantes.¡El desarrollo personal puede ser divertido! Por ejemplo, si necesita leer más, hágalo en algún lugar que disfrute, tal como un parque o una cafetería. Si tiene que mejorar su redsocial, invite gente que quiera conocer mejor a un restaurante que siempre quiso probar.Inscríbase en un curso con un/a amigo/a o colega con el/la cual no pasa tiempo suficiente.",
              },
              {
                id: "cl-2:2-a",
                da: " Cuánto más conozca sus fortalezas y debilidades, más objetivos tendrá su foco de desarrollo. Investigue las metodologías de evaluación disponibles,tales como una evaluación de 360°, que podrían brindarle una retroalimentación objetiva de colegas que le conocen bien. Obtenga ayuda de un coach, o de su departamento de recursos humanos, para realizar las pruebas y ayudarle en su interpretación.",
              },
              {
                id: "cl-2:2-b",
                da: " Asegúrese de tener un plan de desarrollo para su posición actual. Identifique los elementos de desarrollo que tendrían el mayor impacto en la mejora de sus habilidades.",
              },
              {
                id: "cl-2:2-c",
                da: " Asegúrese de considerar múltiples ángulos de desarrollo y no únicamente habilidades técnicas. Por ejemplo, ¿Cómo encaja su estilo de liderazgo en su equipo? ¿Qué debe hacer para estar más en línea con la estrategia de la compañía? ¿La relación con su jefe/a necesita mejora?¿Está preparado/a para las diferencias culturales y exigencias de una posición internacional inminente?",
              },
              {
                id: "cl-2:2-d",
                da: " Asegúrese de que su desarrollo respalde sus metas a largo plazo. Escriba una declaración de misión o visión personal que le ayude a definir a dónde quiere llevar su carrera en el futuro. Le ayudará a concentrarse en las opciones de desarrollo más adecuadas.",
              },
              {
                id: "cl-2:2-e",
                da: " Lea revistas profesionales y relacionadas con su actividad para mantenerse al día con los últimos desarrollos en su campo.",
              },
              {
                id: "cl-2:2-f",
                da: " Encuentre un mentor que pueda brindarle respaldo, asesoramiento y ayuda para darle rumbo a su carrera.",
              },
              {
                id: "cl-2:2-g",
                da: " Deje que un coach le ayude con un plan de desarrollo individual, que defina sus necesidades de aprendizaje y metas. Un plan le ayudará a atenerse a sus metas. Asegúrese de que el plan tenga acciones específicas que debe completar y metas medibles. Prepare un plan de seguimiento — ¿Quién seguirá su progreso y cómo? La mayoría de los planes de desarrollo fracasan porque carecen de seguimiento.",
              },
              {
                id: "cl-2:3-a",
                da: " Concéntrese en las tareas que no desempeña del todo bien. Todos tenemos fortalezas y debilidades, por lo tanto apunte a experiencia y posiciones en áreas en las cuales es menos competente que otras personas.",
              },
              {
                id: "cl-2:3-b",
                da: " Pase de bueno/a a excelente. Un atleta sobresaliente no para de tratar de mejorar,incluso si ha batido un récord mundial. Si ya es muy bueno/a en algo, encuentre un coach experto en habilidades para que le ayude a aprovechar sus fortalezas y lograr la excelencia.",
              },
              {
                id: "cl-2:3-c",
                da: " Cuánto más sepa acerca de sí mismo/a mejor. Investigue las metodologías de evaluación disponibles, tales como una evaluación de 360°, que podrían brindarle una retroalimentación objetiva de colegas que le conocen bien. Obtenga ayuda de un coach o de su departamento de recursos humanos para que le ayude a interpretar la evaluación.",
              },
              {
                id: "cl-2:3-d",
                da: " Esté pendiente de abusos, puntos ciegos, factores knock-out y factores de desvío profesional. Estos son los cuatro exponentes del conocimiento de sí mismo, sin embargo la gente por lo general no está al tanto de esto. Para obtener mayor información acerca de estos conceptos, o para comunicarse con un consultor de PeopleTree Group, visite www.peopletreesuite.com . Identifique si encaja en alguno de estos perfiles.",
              } /*The website listed is not correct*/,
              {
                id: "cl-2:3-e",
                da: " Participe en organizaciones profesionales donde pueda aprender de otras personas y establecer contactos con colegas. Es sorprendente ver cuánto hay que aprender cuando se uno expone a los conocimientos de otros expertos.",
              },
              {
                id: "cl-2:4-a",
                da: " Asóciese con alguien que sea sólido/a en el área que usted necesita desarrollar durante todo el proyecto o tarea. Puede aprender de esa persona y contar con gran respaldo a lo largo del camino, en lugar de avanzar por su cuenta.",
              },
              {
                id: "cl-2:4-b",
                da: " Piense en aprender algo nuevo como una forma de juego o exploración. Este pensamiento promueve la creatividad y el entusiasmo.",
              },
              {
                id: "cl-2:4-c",
                da: " Pase más tiempo con gente que sea naturalmente curiosa, que intente cosas nuevas despreocupadamente y sin miedo de parecer tonta o ridícula. ¿Cuál es la diferencia con su enfoque en estas situaciones?",
              },
              {
                id: "cl-2:4-d",
                da: " Ofrezca ayudar a alguien con las tareas en las cuales está capacitado/a o que se siente cómodo/a haciendo. Hágalo a cambio de respaldo de esas personas con tareas que no domina.",
              },
              {
                id: "cl-2:4-e",
                da: " Nútrase de su experiencia de aprender un pasatiempo, deporte o hacer un proyecto en casa. ¿Cómo se sintió de satisfecho/a cuando pudo completarlo? ¿Hubo momentos en los que pensó que no estaba a la altura de las circunstancias? ¿Por qué perseveró?",
              },
              {
                id: "cl-2:4-f",
                da: " Contrate un coach para contar con más respaldo y aliento, especialmente cuando esté siendo demasiado/a duro consigo mismo/a.",
              },
              {
                id: "cl-2:4-g",
                da: " No hay que avergonzarse de que la gente sepa que usted está activamente tratando de mejorar, pero no tiene que publicitar todo. Si se siente incómodo/a con que la gente lo sepa, continúe trabajando privadamente en ciertos ítems con la aprobación de su gerente y la ayuda de un coach.",
              },
              {
                id: "cl-2:5-a",
                da: " Lea revistas de industrias no relacionadas con su disciplina específica.",
              },
              {
                id: "cl-2:5-b",
                da: " Obtenga una comprensión general de cómo funcionan otras divisiones de su compañía. Almuerce con gente de otros departamentos y formule preguntas acerca de su trabajo.",
              },
              {
                id: "cl-2:5-c",
                da: " Desarrolle una red de contactos en una amplia variedad de disciplinas.",
              },
              {
                id: "cl-2:5-d",
                da: " Familiarícese con las herramientas que pueden ayudarle a recolectar información.Herramientas tales como agregadores de noticias, (Topix, Google News, etc) pueden ayudarle a mantenerse informado acerca de diferentes temas.",
              },
              {
                id: "cl-2:5-e",
                da: " Tome nota y haga más investigación cuando alguien hace referencia a un tema o libro con el cual no está familiarizado/a.",
              },
              {
                id: "cl-2:5-f",
                da: " Asista a cursos de educación continua en áreas de negocios generales. Su compañía puede patrocinar alguno de ellos.",
              },
              {
                id: "cl-2:5-g",
                da: " Participe en la mayor cantidad de reuniones interdepartamentales posibles o tareas que involucren muchas disciplinas.",
              },
              {
                id: "cl-2:5-h",
                da: " Escuche transmisiones por Internet disponibles a través del trabajo.",
              },
              {
                id: "cl-2:5-i",
                da: " Encuentre un mentor con amplia visión para los negocios. Organice reuniones periódicas para conversar acerca de temas diversos.",
              },
              {
                id: "cl-2:6-a",
                da: " Tenga una conversación abierta con su gerente y colegas acerca de cuáles piensan que son sus debilidades. Asegúrese de incluir algunos de estos ítems como parte de su plan de desarrollo.",
              },
              {
                id: "cl-2:6-b",
                da: " Sea consciente de sus competencias, habilidades y experiencia técnica que son críticas para su posición actual y cualquier promoción futura.",
              },
              {
                id: "cl-2:6-c",
                da: " Investigue las oportunidades disponibles en la organización para emprender tareas rotativas.",
              },
              {
                id: "cl-2:6-d",
                da: " Inscríbase en cursos disponibles a través de su compañía que ampliarán su conjunto de habilidades.",
              },
              {
                id: "cl-2:6-e",
                da: " Pida ser incluido/a en reuniones interdisciplinarias para aumentar sus conocimientos generales acerca de todas las unidades de negocios.",
              },
              {
                id: "cl-2:6-f",
                da: " Entérese de lo que está pasando fuera de su campo. Lea revistas o artículos con novedades de otros campos de negocios al menos una vez por semana.",
              },
              {
                id: "cl-2:6-g",
                da: " Ponga a prueba y extienda sus fortalezas. Por ejemplo, si estuvo trabajando en contaduría, tome oportunidades de trabajar en proyección financiera. Ambas hacen uso de sus habilidades analíticas y requieren trabajar con números, pero implican diferentes tipos de aplicación. Si es hábil en redacción técnica, trate de escribir un artículo para una revista.Usted hará uso de su capacidad natural de comunicación escrita pero ampliará sus habilidades.",
              },
              {
                id: "cl-2:6-h",
                da: " Trate de empezar un pasatiempo nuevo que no esté en absoluto relacionado con su trabajo o sus habilidades percibidas. Puede verse sorprendido/a de cuánto lo disfruta y le resultará más fácil dedicarse a actividades que no necesariamente hagan uso de sus fortalezas.",
              },
            ],
          },
        ],
      },
      wrt: {
        characteristic: "Toma riesgos",
        wdd: "Se siente cómodo/a trabajando en un contexto de incertidumbre y de cambio continuo. Disfruta probando todo lo que es nuevo y está dispuesto/a a experimentar y a tomar riesgos relativos",
        icon: require("@/assets/Iconography/Characteristics/18_Willing Risk Taker.svg"),
        competencies: [
          {
            id: "wrt-0",
            icon: require("@/assets/Iconography/Attributes/18-02_Being Comfortable With Uncertainty.svg"),
            comp: "Se Siente Cómodo/a Con La Incertidumbre",
            wdd: "Se siente cómodo/a trabajando en un contexto de incertidumbre y de cambio continuo",
            progressMeasures: [
              {
                id: "wrt-0-0",
                pm: "Soy optimista acerca de que las cosas saldrán bien, incluso si el futuro es incierto",
                pmMap:
                  "Ser optimista acerca de que las cosas saldrán bien, incluso si el futuro es incierto",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "wrt-0-1",
                pm: "Estoy preparado/a para poner a prueba nuevos enfoques",
                pmMap: "Estar preparado/a para poner a prueba nuevos enfoques",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "wrt-0-2",
                pm: "Puedo tomar decisiones y tomar acción sin saber todos los detalles",
                pmMap:
                  "Tomar decisiones y tomar acción sin tener todos los detalles",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "wrt-0-3",
                pm: "Puedo cambiar mi curso de acción rápidamente",
                pmMap: "Cambiar mi curso de acción rápidamente",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "wrt-0-4",
                pm: "Trabajar en un entorno no estructurado me motiva",
                pmMap:
                  "Estar motivado en un entorno de trabajo no estructurado ",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
            ],
            developmentActions: [
              {
                id: "wrt-0:1-a",
                da: " Dígale a su jefe y colegas que prefiere un marco específico en el cual operar o hable con ellos cuando necesita más dirección. No pueden leer su mente y pueden estar operando sobre la base de sus propias necesidades.",
              },
              {
                id: "wrt-0:1-b",
                da: " No puede brindar estructura a todo, por lo tanto concéntrese en las áreas en las que sí puede. Haga una lista de las cosas que son estructuradas en su día de trabajo y verá que no todo está fuera de su control.",
              },
              {
                id: "wrt-0:1-c",
                da: " Tenga sistemas implementados que le permitan hacer rápidamente la transición de una tarea a otra sin olvidarse dónde la dejó. Incluso una lista simple puede ayudarle.",
              },
              {
                id: "wrt-0:1-d",
                da: " Asegúrese de que su enfoque hacia la gente y los temas sea adaptable. Un enfoque que sea igual para todos no funciona en un entorno de trabajo multifacético y será agotador tratar de desempeñar las tareas a su manera todo el tiempo.",
              },
              {
                id: "wrt-0:1-e",
                da: " Acepte que tendrá que detenerse y seguir continuamente. Reacomodarse no significa que no desarrollará sus tareas. Simplemente significa que su atención estará compartida entre varias exigencias simultáneas. Siempre puede volver a lo que había empezado antes.",
              },
              {
                id: "wrt-0:1-f",
                da: " No trate de ocuparse de cada aspecto de un tema o lograr soluciones completas antes de pasar a otra cosa. La mayoría de los temas no pueden resolverse inmediatamente. Es aceptable abordar los temas parcialmente y pasar a otra cosa, luego volver y resolverlos debidamente. Recompénsese por tomar el paso lógico siguiente y no simplemente por finalizar toda la tarea.",
              },
              {
                id: "wrt-0:1-g",
                da: " Practique una transición efectiva desarrollando múltiples actividades por un período de tiempo limitado, todo en un mismo día. Seleccione actividades que requieren un cambio de habilidades o estado de ánimo y no trate de finalizar cualquier tarea inmediatamente. Por ejemplo, responda algunos correos electrónicos, luego ayude a alguien que usted supervisa y luego aborde una sección de una propuesta o documento.Después pare y haga algunas llamadas pendientes, y así sucesivamente. Siga practicando esto y observe los diferentes roles que tiene que desempeñar para avanzar. Enorgullézcase por la cantidad de actividades en las cuales pudo participar en lugar de cuántas completó desde el principio hasta el fin. Observe cuánto más rápido puede abordar múltiples tareas.",
              },
              {
                id: "wrt-0:1-h",
                da: " Observe a un colega que maneje la ambigüedad con éxito. ¿Qué es diferente acerca de su actitud y enfoque?",
              },
              {
                id: "wrt-0:1-i",
                da: " Tome descansos para relajarse a lo largo del día, especialmente cuando pasa de un proyecto a otro o de una tarea importante a otra, dedicando unos momentos a ejercicios de respiración profunda o alejándose de su escritorio por un tiempo.",
              },
              {
                id: "wrt-0:1-j",
                da: " Asegúrese de reflexionar acerca de cómo las cosas habrían sido más fáciles en una situación determinada si hubiera podido reacomodarse con mayor rapidez y eficacia.",
              },
              {
                id: "wrt-0:1-k",
                da: " Si está crónicamente estresado/a e infeliz acerca de su entorno, investigue otras oportunidades para trabajar en un entorno más estructurado dentro de la organización.",
              },
              {
                id: "wrt-0:2-a",
                da: " Trate de separar los datos críticos de la información menos importante.¿Cuál es el detalle mínimo necesario para comprender lo suficiente y poder avanzar con el proyecto?",
              },
              {
                id: "wrt-0:2-b",
                da: " Aunque le pueda resultar difícil, concéntrese en mejorar la velocidad con la cual avanza en un proyecto, más que en lo bien que se hace.",
              },
              {
                id: "wrt-0:2-c",
                da: " Trabaje en proyectos o tareas hasta un punto y luego, antes de que estén terminados en un 100%, páseselos a alguien más para que los revise y se haga cargo.",
              },
              {
                id: "wrt-0:2-d",
                da: " Antes de abordar cualquier tarea, determine como de importante es hacerlo perfectamente. Nunca asigne a algo un puntaje de 10 porque nada puede hacerse perfectamente. Obtenga retroalimentación si no está seguro/a, especialmente de su gerente.",
              },
              {
                id: "wrt-0:2-e",
                da: " Defina un límite de tiempo para recolectar información y reunir datos antes de efectivamente abordar la tarea.",
              },
              {
                id: "wrt-0:2-f",
                da: " Reflexione sobre proyectos pasados en los cuales participó. ¿Qué detalles fueron irrelevantes en definitiva?",
              },
              {
                id: "wrt-0:2-g",
                da: " Compare sus expectativas con las de su equipo y gerente. Asegúrese de comprender exactamente cuánto esfuerzo o tiempo esperan que usted dedique al proyecto.",
              },
              {
                id: "wrt-0:2-h",
                da: " Confíe en sus propias decisiones. Tendrá que tomar muchas decisiones a lo largo de su carrera.",
              },
              {
                id: "wrt-0:3-a",
                da: " Considere si las condiciones y supuestos en la situación actual son los mismos que anteriormente. ¿Qué cambió? ¿Justifican las diferencias una forma nueva de proceder que debería examinar?",
              },
              {
                id: "wrt-0:3-b",
                da: " Primero piense cómo podrían hacerse las tareas de forma diferente, luego considere también la forma estándar de hacerlas. Intercambie ideas antes de llegar a una conclusión.",
              },
              {
                id: "wrt-0:3-c",
                da: " Asegúrese de que haya personas inconformistas o progresistas en su equipo. La opinión de ellos contrarrestará la suya y aportará equilibrio.",
              },
              {
                id: "wrt-0:3-d",
                da: " Manténgase abierto/a a todas las opciones. Es fácil ponerse a la defensiva y ser territorial cuando está tratando de defender la forma estándar de hacer las cosas",
              },
              {
                id: "wrt-0:3-e",
                da: " Recuerde tanto lo bueno como lo malo de su procedimiento estándar. Enumere los pros y los contras para crear una visión realista de qué tan bien funcionó.",
              },
              {
                id: "wrt-0:3-f",
                da: " Experimente porque sí. Puede practicar sentirse más cómodo/a con nuevos enfoques fuera del entorno de trabajo. Intente una cosa nueva por semana, desde pedir un ítem desconocido del menú hasta tomar un camino distinto a casa. Satisfaga su curiosidad acerca de un lugar y viaje allí. Explorar debería ser divertido y parte de su enfoque tanto hacia su vida como a su trabajo",
              },
              {
                id: "wrt-0:4-a",
                da: " Admítalo y enfréntelo. Puede tener que mejorar alguna de sus habilidades,pero preocuparse o compararse con otras personas no producirá ningún resultado ni cambiará la situación. Contrate un coach para definir un plan de desarrollo individual que le ayude a trabajar en áreas que necesitan atención.",
              },
              {
                id: "wrt-0:4-b",
                da: " En lugar de concentrarse en todo lo que no sabe, concéntrese en lo que realmente tiene que saber para completar la próxima tarea.",
              },
              {
                id: "wrt-0:4-c",
                da: " Recuerde otras situaciones en las cuales usted fue principiante y se sintió abrumado/a. ¿Cómo atravesó esas experiencias? Piense en lo que aprendió para llegar a donde está ahora.",
              },
              {
                id: "wrt-0:4-d",
                da: " Consulte con un colega o mentor capacitado en el área que necesita desarrollar y obtenga su respaldo cuando sea necesario.",
              },
              {
                id: "wrt-0:4-e",
                da: " Asegúrese de que sus expectativas acerca de sí mismo/a se comparen con las de su jefe o supervisor. Tendemos a ser más duros con nosotros mismos y probablemente usted necesita saber menos de lo que piensa.",
              },
              {
                id: "wrt-0:4-f",
                da: " Sea paciente consigo mismo/a y sus errores. El éxito proviene de la experiencia, que se forma en base a lecciones aprendidas de los errores.",
              },
              {
                id: "wrt-0:4-g",
                da: " Sea ingenioso/a cuando la información no es clara o no sabe cómo proceder.Averigüe quién puede ayudarle con tareas determinadas, examine el trabajo realizado en proyectos similares y obtenga los materiales de referencia y recursos disponibles para estar totalmente informado/a. Conviértase en investigador/a y empiece a formular preguntas.",
              },
              {
                id: "wrt-0:5-a",
                da: " Antes de hablar, siempre considere si sus comentarios podrían desmoralizar a otros. De ser así, absténgase de compartir sus opiniones o trate de transmitir las noticias de una forma más positiva.",
              },
              {
                id: "wrt-0:5-b",
                da: " Examine qué componentes del trabajo disfrutaba antes de que su interés disminuyera, y qué cambió. ¿Son los cambios autoimpuestos? ¿Ayudaría a revivir su interés hablar con la gente relevante acerca de cambiar la situación? ¿Recuperaría su entusiasmo si participara en otras tareas? Trate de encontrar opciones que recarguen su energía de trabajo.",
              },
              {
                id: "wrt-0:5-c",
                da: " Examine su definición de su valor para la organización. Si piensa que el cambio en la organización disminuiría su valor, trate de reinventarse. Identifique las habilidades que necesita mejorar para mantenerse competitivo/a. Considere nuevas tareas que podrían marcar un nuevo capítulo en su carrera.",
              },
              {
                id: "wrt-0:5-d",
                da: " Asegúrese de no comunicar su actitud negativa rehusando respaldo, incentivo o información.",
              },
              {
                id: "wrt-0:5-e",
                da: " Aliente discusiones optimistas acerca del futuro. Permita que la gente comparta su visión y esperanza para el futuro de la organización y absténgase de señalar el lado negativo de lo que compartieron. Haga esto en todas las reuniones.",
              },
              {
                id: "wrt-0:5-f",
                da: " Olvídese de los “viejos tiempos” y de sus glorias. La reflexión es productiva, pero sólo como medio para analizar cómo mejorar en el futuro.",
              },
              {
                id: "wrt-0:5-g",
                da: " Pida a un mentor o coach que le ayude a examinar qué lo ha llevado a su estado de ánimo actual y qué cambios pueden hacerse antes de convertirse en la última persona con la cual la gente quiere trabajar. O lo que es peor, antes de volverse obsoleto/a.",
              },
            ],
          },
          {
            id: "wrt-1",
            icon: require("@/assets/Iconography/Attributes/18-01_Being Experimental.svg"),
            comp: "Experimentador",
            wdd: "Disfruta probando todo lo que es nuevo y está dispuesto/a a experimentar y a tomar riesgos relativos",
            progressMeasures: [
              {
                id: "wrt-1-0",
                pm: "No temo intentar cosas nuevas para obtener experiencias valiosas",
                pmMap:
                  "Temer intentar cosas nuevas para obtener experiencias valiosas",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "wrt-1-1",
                pm: "Estoy abierto/a a explorar nuevas formas de hacer las cosas",
                pmMap:
                  "Estar abierto/a a explorar nuevas formas de hacer las cosas",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "wrt-1-2",
                pm: "A menudo pruebo ideas, productos o servicios nuevos para encontrar las mejores soluciones",
                pmMap:
                  "Probar ideas, productos o servicios nuevos para encontrar las mejores soluciones",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "wrt-1-3",
                pm: "Propongo la innovación y me gusta inventar ideas creativas para mejorar los procesos y el trabajo en general",
                pmMap:
                  "Proponer la innovación e inventar ideas creativas para mejorar los procesos y el trabajo en general",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "wrt-1-4",
                pm: "Pienso que el tiempo invertido en experimentar es tiempo bien empleado",
                pmMap:
                  "Pensar que el tiempo invertido en experimentar es tiempo bien empleado",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
            ],
            developmentActions: [
              {
                id: "wrt-1:1-a",
                da: " Empiece con experimentación de bajo impacto y menor consecuencia y vea cómo incluso los riesgos pequeños pueden dar su fruto.",
              },
              {
                id: "wrt-1:1-b",
                da: " Documente los beneficios de hacer las cosas de forma diferente. ¿Qué es lo que no está funcionando actualmente y cuánto le cuesta a la organización? Use esto como motivación para experimentar.",
              },
              {
                id: "wrt-1:1-c",
                da: " Encuentre un mentor que esté acostumbrado a tomar riesgos. Pídale que evalúe las consecuencias y la recompensa potencial. Pregúntele como se manejó el fracaso ocasional,cuánto se ganó a la larga por arriesgarse y qué les enseñó su experiencia.",
              },
              {
                id: "wrt-1:1-d",
                da: " Reflexione acerca de qué salió mal la última vez que experimentó. La idea puede haber sido digna de consideración y otros factores pueden haber desempeñado un rol mayor en su fracaso. ¿Tiene el equipo adecuado? ¿Se manejaron bien las políticas corporativas? ¿Hubo suficientes recursos disponibles? ¿Estaba listo el mercado? Comprender qué funcionó bien y qué no, le ayudará a reducir su riesgo cuando experimente la próxima vez.",
              },
              {
                id: "wrt-1:1-e",
                da: " Trate los fracasos y los errores como oportunidades para aprender. No se desaliente si su inversión en tiempo y recursos no tiene éxito en el primer intento. Sea fuerte e inténtelo nuevamente.",
              },
              {
                id: "wrt-1:2-a",
                da: " Sea receptivo/a a desafiar el status quo y alentar a otros a hacer lo mismo.",
              },
              {
                id: "wrt-1:2-b",
                da: " Considere las condiciones y el contexto del problema que está tratando de resolver y determine si cambiaron de alguna manera. Si cambiaron, puede ser el momento de considerar que es aconsejable tener un enfoque diferente.",
              },
              {
                id: "wrt-1:2-c",
                da: " Cambie sus grupos o equipos de trabajo a modo de poder introducir nuevas ideas.",
              },
              {
                id: "wrt-1:2-d",
                da: " Trate de experimentar con pequeños cambios en lugar de modernizar o revisar todo un sistema, política o diseño.",
              },
              {
                id: "wrt-1:2-e",
                da: " Los estudios han demostrado que la gente trabaja más arduamente cuando tienen una opción acerca de intentar enfoques nuevos y diferentes. Experimente de una forma que se adecue a su personalidad y que tenga sentido para usted — pero asegúrese de hacerlo.",
              },
              {
                id: "wrt-1:2-f",
                da: " Sea consciente de su actitud general hacia hacer las cosas de forma diferente y trate de mantenerse positivo/a acerca de las ideas de los demás. Rechazar siempre las peticiones para intentar un nuevo enfoque es una forma segura de desalentar una cultura de experimentación.",
              },
              {
                id: "wrt-1:3-a",
                da: " Comunique de forma efectiva cómo el tiempo y esfuerzo dedicado a la experimentación podrían afectar positivamente al resultado final.",
              },
              {
                id: "wrt-1:3-b",
                da: " Anticipe las objeciones y esté preparado/a para el rechazo o la refutación de sus ideas.",
              },
              {
                id: "wrt-1:3-c",
                da: " Apoye la experimentación dentro de su equipo o unidad reconociendo y alabando públicamente los esfuerzos de sus colegas, independientemente de su éxito o fracaso.",
              },
              {
                id: "wrt-1:3-d",
                da: " Incluya la experimentación como parte de las medidas de desempeño de sus subordinados directos.",
              },
              {
                id: "wrt-1:3-e",
                da: " Asigne equipos para trabajar únicamente en proyectos experimentales y enfoques innovadores.",
              },
              {
                id: "wrt-1:3-f",
                da: " Sea políticamente astuto/a. Trate de obtener el respaldo de las personas clave a cargo de la toma de decisiones.",
              },
              {
                id: "wrt-1:3-g",
                da: " Elija sus batallas. La gente puede ser más receptiva a la experimentación en un área que en otra. Empiece donde exista menos resistencia.",
              },
            ],
          },
        ],
      },
      bpt: {
        characteristic: "Piensa estratégicamente",
        wdd: "Es intelectualmente capaz de manejar conceptos complejos. Es capaz de salirse del detalle y de observar una perspectiva más amplia. Puede visualizar posibles escenarios futuros dando sentido a la información obtenida de diversas fuentes",
        icon: require("@/assets/Iconography/Characteristics/01-Big Picture Thinker.svg"),
        competencies: [
          {
            id: "bpt-0",
            icon: require("@/assets/Iconography/Attributes/01-03_Thinking globally.svg"),
            comp: "Pensador Global",
            wdd: "Es capaz de salirse del detalle y de observar una perspectiva más amplia",
            progressMeasures: [
              {
                id: "bpt-0-0",
                pm: "Estoy informado/a acerca de las tendencias actuales y futuras",
                pmMap:
                  "Estar informado/a acerca de las tendencias actuales y futuras",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "bpt-0-1",
                pm: "Tengo perspectiva sobre muchos aspectos del negocio",
                pmMap:
                  "Leer libros y revistas sobre temas fuera de mi campo  de experiencia?????",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "bpt-0-2",
                pm: "Soy bueno/a previendo consecuencias o resultados",
                pmMap: "Ser bueno/a previendo consecuencias o resultados",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "bpt-0-3",
                pm: "Pienso acerca del futuro del negocio cuando tomo decisiones",
                pmMap:
                  "Pensar acerca del futuro del negocio al tomar decisiones",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "bpt-0-4",
                pm: "Puedo decidir y actuar sin tener la visión global",
                pmMap: "Decidir y actuar sin tener la visióbn global",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
            ],
            developmentActions: [
              {
                id: "bpt-0:1-a",
                da: " Investigue otras oportunidades disponibles en su organización que estén relacionadas con su disciplina pero que sean menos técnicas. Su compañía tal vez ofrece cursos o certificados en campos relacionados con la gestión que podrían ayudar a crear un equilibrio con sus habilidades técnicas.",
              },
              {
                id: "bpt-0:1-b",
                da: " Pida ser incluido/a en reuniones interdisciplinarias para incrementar su exposición a otras áreas de negocios.",
              },
              {
                id: "bpt-0:1-c",
                da: " Sea consciente de lo que sucede en el resto del mundo. Lea revistas y artículos nuevos acerca de otras industrias distintas de la suya.",
              },
              {
                id: "bpt-0:1-d",
                da: " Pida actuar como mentor de empleados recién contratados a cambio de tener un mentor en un área fuera de su disciplina.",
              },
              {
                id: "bpt-0:1-e",
                da: " Inicie un “club futurista”. Establezca un grupo integrado por colegas y amigos en su campo de experiencia, que se reúna regularmente para conversar sobre las formas en que su disciplina o tecnología podría afectar al futuro de su organización y, efectivamente, al del mundo.",
              },
              {
                id: "bpt-0:1-f",
                da: " Lea material acerca de cómo evolucionó su disciplina. ¿Qué factores externos han influido en la forma en que se hacen negocios hoy en día?",
              },
              {
                id: "bpt-0:2-a",
                da: " Incluya escenarios futuros y el impacto que podrían tener en su trabajo cuando planee sus tareas o proyectos.",
              },
              {
                id: "bpt-0:2-b",
                da: " Organice equipos que tengan una buena representación de pensadores globales y personas orientadas a los detalles. Se verá expuesto/a a la forma en que los pensadores globales abordan los problemas y logran un resultado más equilibrado.",
              },
              {
                id: "bpt-0:2-c",
                da: " Permítase tiempo para explorar opciones creativas e intercambiar ideas. No acepte su rimera idea. Cree al menos tres opciones antes de emprender la acción. Considere cómo obtener los mismos resultados a través de medios diferentes",
              },
              {
                id: "bpt-0:2-d",
                da: " Pase de un proyecto a otro a menudo para no quedar muy enterrado en los detalles de sólo uno.",
              },
              {
                id: "bpt-0:2-e",
                da: " Delegue parte del trabajo detallado a otras personas y dese tiempo para conversar y contemplar las cuestiones con una visión global.",
              },
              {
                id: "bpt-0:3-a",
                da: " Asista a diversos eventos culturales en su ciudad, tales como películas o exposiciones extranjeras.",
              },
              {
                id: "bpt-0:3-b",
                da: " Aproveche posiciones internacionales cuando sea posible.",
              },
              {
                id: "bpt-0:3-c",
                da: " Pida oportunidades para trabajar con equipos globales. Le ayudará a ampliar su exposición a diferentes estilos de gestión, técnicas de resolución de problemas, etc.",
              },
              {
                id: "bpt-0:3-d",
                da: " Actúe como mentor con personas de su compañía de diversos orígenes culturales,razas y sexo diferente, o busque un mentor que provenga de un origen diferente del suyo.",
              },
              {
                id: "bpt-0:3-e",
                da: " Exponga su cerebro a nuevas formas de estímulo de forma regular, por ejemplo, un género de libros, arte o música diferente. Aprenda otro idioma. Visite museos.",
              },
              {
                id: "bpt-0:3-f",
                da: " Empiece un pasatiempo que lo introduzca a personas y habilidades nuevas que no haya probado, tales como baile, trabajo en madera, cocina o cerámica. Ofrézcase como voluntario/a para trabajar con grupos con los cuales no necesariamente se identifica, tales como la gente mayor o los pobres. Elija pasatiempos que alienten el uso de la imaginación y el lado creativo de su cerebro, tales como clases de arte o fotografía.",
              },
              {
                id: "bpt-0:4-a",
                da: " Escriba los pros y contras de sus diversas opciones y preste mucha atención al impacto global de cada una de ellas— la influencia potencial en la gente, en el dinero, en el tiempo y en los procesos existentes",
              },
              {
                id: "bpt-0:4-b",
                da: " Suponga que siempre hay más de una manera de resolver un problema. No se limite a soluciones cómodas o familiares. Como regla, asegúrese de haber considerado como mínimo tres enfoques diferentes.",
              },
              {
                id: "bpt-0:4-c",
                da: " Obtenga información que desafíe su pensamiento lineal. Consulte con colegas y compañeros de trabajo para encontrar escenarios que pueda haber pasado por alto.",
              },
              {
                id: "bpt-0:4-d",
                da: " Converse con los demás. Se mantendrá en contacto con las cuestiones que les preocupan.",
              },
              {
                id: "bpt-0:4-e",
                da: " Converse con los demás. Se mantendrá en contacto con las cuestiones que les preocupan.",
              },
            ],
          },
          {
            id: "bpt-1",
            icon: require("@/assets/Iconography/Attributes/01-02_Thinking strategically.svg"),
            comp: "Estratega",
            wdd: "Puede visualizar posibles escenarios futuros dando sentido a la información obtenida de diversas fuentes",
            progressMeasures: [
              {
                id: "bpt-1-0",
                pm: "Me mantengo informado/a acerca de las tendencias que afectan a mi negocio",
                pmMap:
                  "Mantenerme informado/a acerca de las tendencias que afectan a mi negocio",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "bpt-1-1",
                pm: "Tengo experiencia en iniciativas estratégicas",
                pmMap: "Tener experiencia en iniciativas estratégicas",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "bpt-1-2",
                pm: "Considero el impacto a largo plazo incluso cuando sigo un enfoque táctico a corto plazo",
                pmMap:
                  "Considerar el imacto a largo plazo incluso al seguir un enfoque táctico a corto plazo",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "bpt-1-3",
                pm: "Considero cómo se interrelacionan las cosas" /*Diferent in spanish */,
                pmMap: "Considerar cómo se interrelacionan las cosas",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "bpt-1-4",
                pm: "A menudo concibo posibilidades y escenarios para el futuro",
                pmMap: "Concebir posibilidades y escenarios para el futuro",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
            ],
            developmentActions: [
              {
                id: "bpt-1:1-a",
                da: " Aprenda a delegar efectivamente: verifique con cuidado exactamente qué le puede pasar a otras personas para disminuir las distracciones en su concentración en la estrategia y “entréguelo”.",
              },
              {
                id: "bpt-1:1-b",
                da: " Desarrolle equipos sólidos y efectivos con autoridad para actuar. Debe confiar en ellos para tomar decisiones y deben estar en condiciones de ayudarle a manejar el negocio de forma efectiva.",
              },
              {
                id: "bpt-1:1-c",
                da: " Asegúrese de asignar el mismo tiempo a asuntos tácticos, a reuniones y a conversaciones estratégicas.",
              },
              {
                id: "bpt-1:1-d",
                da: " Asegúrese de haber incluido metas estratégicas tanto en sus planes de trabajo como en el de los colegas o personal relevante.",
              },
              {
                id: "bpt-1:1-e",
                da: " Debe tener una visión bien definida para usted y su equipo que haya sido claramente explicada a todos. ¿A dónde se dirige en uno, cinco o diez años? Si no considera esta pregunta regularmente, fácilmente volverá al aquí y ahora únicamente",
              },
              {
                id: "bpt-1:1-f",
                da: " Comprenda su propio horizonte temporal: ¿está trabajando en proyectos con un horizonte de un año, cinco o diez años? También debería conocer el horizonte temporal de su supervisor y su jefe.",
              },
              {
                id: "bpt-1:1-g",
                da: " Implemente un plan de negocios o estratégico que responda en detalle dónde está ahora, hacia dónde va y cómo llegará allí.",
              },
              {
                id: "bpt-1:1-h",
                da: " Revise su posición estratégica regularmente. Use un plan de SWOT, que significa fortalezas, debilidades, oportunidades y amenazas. Estos cuatro componentes son necesarios para evaluar la posición estratégica suya y de la compañía: usted necesita explotar las fortalezas, mejorar las debilidades, capitalizar las oportunidades e identificar las amenazas.",
              },
              {
                id: "bpt-1:2-a",
                da: " Conozca la ventaja competitiva que ayuda a mantener su éxito. Debe reconocer qué es lo que le hace sobresalir sobre sus competidores y luego crear una ventaja que se mantenga competitiva a lo largo del tiempo. ¿Qué hace mejor? ¿Qué le hace único/a? ¿Qué puede su organización hacer mejor que cualquier otra ahora y a largo plazo?",
              },
              {
                id: "bpt-1:2-b",
                da: " Mantenga sesiones de previsión regularmente y converse sólo acerca del futuro.Intercambie ideas con su equipo para identificar los principales factores que influirán en su negocio en los próximos cinco a diez años. ¿Cuáles son los escenarios posibles? ¿Cómo se verá el mercado en cinco o diez años?",
              },
              {
                id: "bpt-1:2-c",
                da: " Revise planes de negocios y resultados de proyectos anteriores. ¿Cuáles supuestos acerca del futuro eran defectuosos y por qué? ¿Está haciendo los mismos supuestos ahora? ¿Qué datos se consultaron y resultaron útiles o engañosos?",
              },
              {
                id: "bpt-1:2-d",
                da: " Los/as consultores pueden brindar opiniones invaluables. Busque seminarios disponibles o considere contratar a un/a consultor/a para que trabaje con usted o su equipo.",
              },
              {
                id: "bpt-1:2-e",
                da: " Existen muchos libros disponibles acerca de tendencias futuras y su influencia.Dos fuentes de consulta populares entre los empresarios son Faith Popcorn y John Naisbett.",
              },
              {
                id: "bpt-1:3-a",
                da: " Permítase seguir sus presentimientos e intuición sin editar sus pensamientos o juzgarse.",
              },
              {
                id: "bpt-1:3-b",
                da: " Encuentre gente creativa con quien compartir ideas novedosas y sentirse seguro/a de hacerlo.",
              },
              {
                id: "bpt-1:3-c",
                da: " Sea más travieso/a. Asegúrese de tener actividades y personas fuera del trabajo que le permitan reírse y relajarse.",
              },
              {
                id: "bpt-1:3-d",
                da: " Haga algo completamente poco práctico, simplemente porque puede. Considere las consecuencias después. ¿Fueron tan malas como esperaba?",
              },
              {
                id: "bpt-1:3-e",
                da: " Juegue a abogado del diablo consigo mismo. Desafíese con preguntas tales como “¿Por qué tiene que ser así?” y “¿Por qué no intentar a su manera?”",
              },
              {
                id: "bpt-1:4-a",
                da: " Sea consciente de lo que sucede en el resto del mundo. Lea revistas y artículos nuevos de otras profesiones también.",
              },
              {
                id: "bpt-1:4-b",
                da: " Considere cómo el cambio en el clima político puede afectar la política gubernamental relacionada con su campo.",
              },
              {
                id: "bpt-1:4-c",
                da: " Haga uso de oportunidades de rotación que puedan exponerle a otras funciones de negocios.",
              },
              {
                id: "bpt-1:4-d",
                da: " Tómese tiempo para alejarse de su escritorio y hablar con gente en otros departamentos acerca de su trabajo y los posibles cambios que podrían afectarles.",
              },
              {
                id: "bpt-1:4-e",
                da: " Asista a reuniones interdepartamentales cuando sea posible.",
              },
              {
                id: "bpt-1:4-f",
                da: " Siempre busque conexiones inusuales entre su trabajo y lo que hace la gente en otros campos.",
              },
              {
                id: "bpt-1:4-g",
                da: " Aproveche conferencias que le expondrán a nuevas tendencias y colegas en su campo.",
              },
              {
                id: "bpt-1:5-a",
                da: " Siempre formule preguntas: ¿por qué la alta dirección tomó una decisión,cuál sería la consecuencia futura si eligiera una táctica diferente hoy, qué supuestos se hacen acerca del futuro que rigen la naturaleza de su trabajo hoy?",
              },
              {
                id: "bpt-1:5-b",
                da: " Considere formas de ver las cosas desde la perspectiva de otras personas. Imagínese que usted es el cliente, su proveedor o el competidor.",
              },
              {
                id: "bpt-1:5-c",
                da: " Pregunte a su supervisor si puede asistir a reuniones o participar en llamadas de planeamiento estratégico para tener exposición a las cuestiones conversadas y consideradas.",
              },
              {
                id: "bpt-1:5-d",
                da: " Pida la oportunidad de participar en proyectos multifuncionales. Las iniciativas y el planeamiento estratégicos siempre involucran múltiples departamentos o áreas de negocios.",
              },
              {
                id: "bpt-1:5-e",
                da: " Pregunte al departamento de recursos humanos acerca de cursos o capacitación en técnicas de planeamiento estratégico a las cuales podría asistir.",
              },
              {
                id: "bpt-1:5-f",
                da: " Lea libros o casos de negocios que implican estrategia.",
              },
              {
                id: "bpt-1:5-g",
                da: " Manténgase al corriente de tendencias y nuevos desarrollos que se relacionan con su campo, la política gubernamental, los competidores y los clientes.",
              },
            ],
          },
          {
            id: "bpt-2",
            icon: require("@/assets/Iconography/Attributes/01-01_Understanding complex ideas.svg"),
            comp: "Inteligente",
            wdd: "Es intelectualmente capaz de manejar conceptos complejos",
            progressMeasures: [
              {
                id: "bpt-2-0",
                pm: "Puedo reformular ideas complejas",
                pmMap: "Reformular ideas complejas",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "bpt-2-1",
                pm: "Habitualmente me piden ayuda con problemas difíciles",
                pmMap: "Explicar conceptos complejos de entender",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "bpt-2-2",
                pm: "Estoy en condiciones de idear múltiples formas de resolver problemas" /*Not in the book*/,
                pmMap:
                  "Hablar sobre conceptos abstractos y dar ejemplos que explican cosas",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "bpt-2-3",
                pm: "Los demás me describen como astuto/a o inteligente" /*Not in the book*/,
                pmMap: "Ser astuto/a o inteligente",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "bpt-2-4",
                pm: "Estoy abierto/a a nuevas ideas y formas de pensar",
                pmMap: "Estar abierto/a a nuevas ideas y formas de pensar",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
            ],
            developmentActions: [
              {
                id: "bpt-2:1-a",
                da: " Concéntrese en identificar y mejorar las áreas más desafiantes para usted,especialmente si son relevantes para el avance de su carrera.",
              },
              {
                id: "bpt-2:1-b",
                da: " Si el problema parece demasiado complejo para asimilarlo en su totalidad,divídalo en partes más pequeñas y abórdelas una a una. Deje que una solución lleve a la próxima.Si el problema parece demasiado complejo para asimilarlo en su totalidad, divídalo en partes más pequeñas y abórdelas una a una. Deje que una solución lleve a la próxima.",
              },
              {
                id: "bpt-2:1-c",
                da: " Mantenga su mente aguda incorporando materiales de acertijos mentales en su tiempo libre. Haga crucigramas o juegos como Sudoku de noche antes de ir a dormir o mientras espera en fila. Son divertidos y mantienen su mente ágil.",
              },
              {
                id: "bpt-2:1-d",
                da: " Explore técnicas de resolución de problemas tales como visualización, guión técnico“storyboarding” y desarrollo de los peores escenarios. Tener varias herramientas paraemplear es especialmente útil cuando necesita ver las cosas desde diferentes perspectivas.",
              },
              {
                id: "bpt-2:1-e",
                da: " ¿Están sus pensamientos organizados? Cuanto más complejo sea el problema o la cuestión, más importante es poder organizarlo en componentes manejables y comprensibles. Use técnicas tales como mapas mentales, diagramas de flujo y listas de verificación para aclarar los conceptos en su mente.",
              },
              {
                id: "bpt-2:1-f",
                da: " Asegúrese de definir bien la naturaleza del problema. Muy a menudo, la gente aborda los problemas precipitadamente, sólo para darse cuenta de que han desperdiciado tiempo analizando los síntomas en lugar del problema en sí. ¿Está simplificando el problema en exceso o haciéndolo más complejo de lo que realmente es?",
              },
              {
                id: "bpt-2:1-g",
                da: " Si no comprende algo, asegúrese de informar a los demás. Puede que tengan que explicárselo varias veces de formas diferentes. De otra manera, usted se quedaría aún más rezagado, lo que haría que fuera todavia más difícil o imposible ponerse al día en el futuro",
              },
              {
                id: "bpt-2:1-h",
                da: " Pida una explicación paciente y verbalice cómo comprendería mejor la información.Por ejemplo, usted puede ser más visual y requerir diagramas o puede necesitar información para organizarse de una forma determinada.",
              },
              {
                id: "bpt-2:1-i",
                da: " Sea realista y dese tiempo para volverse más experimentado/a en un trabajo nuevo",
              },
              {
                id: "bpt-2:1-j",
                da: " Si no trabaja en su primer idioma, podría ser difícil comprender a las demás personas o seguir su hilo de pensamiento. Consiga un instructor de idiomas que le ayude. Avise a la gente que tal vez tengan que repetir las cosas o hablar más lentamente. Pida la mayor cantidad de información posible antes de las reuniones para tener ventaja.",
              },
              {
                id: "bpt-2:2-a",
                da: " Pruebe técnicas de relajación que puedan ayudarle a controlar sus emociones, tales como meditación y ejercicios de respiración.",
              },
              {
                id: "bpt-2:2-b",
                da: " Identifique sus disparadores emocionales y asegúrese de ser consciente de cuándo reacciona a ellos en lugar de a los hechos.",
              },
              {
                id: "bpt-2:2-c",
                da: " Pida a un colega de confianza retroalimentación acerca de los problemas. Puede brindarle una perspectiva valiosa e informarle cuándo está reaccionando exageradamente.",
              },
              {
                id: "bpt-2:2-d",
                da: " Aléjese de una situación o pase a otro tema. Darse suficiente tiempo para reconectarse con su lado lógico puede aportar una claridad muy necesaria a una determinada situación.",
              },
              {
                id: "bpt-2:2-e",
                da: " Escriba el problema en un papel. Evaluar los problemas y trazar un posible curso de acción ayuda a conectarse con la lógica, más que con la emoción.",
              },
              {
                id: "bpt-2:3-d",
                da: " Absténgase de interrumpir a los demás y sacar conclusiones antes de que se hayan presentado todos los hechos.",
              },
              {
                id: "bpt-2:3-a",
                da: " Desafíe lo que sabe. Expóngase a ideas y puntos de vista nuevos.Subscríbase a revistas de su industria, lea el periódico, asista a seminarios,hable con expertos de su compañía y aliente debates productivos entre colegas.",
              },
              {
                id: "bpt-2:3-b",
                da: " Busque prejuicios ocultos en su forma de pensar, porque le impiden aceptar otras posibilidades.",
              },
              {
                id: "bpt-2:3-c",
                da: " Desafíe sus creencias desempeñando el papel de abogado del diablo. Respalde a “la otra parte” en una cuestión, aunque sea sólo por el hecho de considerar todas las opciones.Una vez que empiece a defender territorio nuevo, puede encontrarse pensando de forma totalmente diferente.",
              },
              {
                id: "bpt-2:3-e",
                da: " No suponga que sabe más que los demás. Incluso si es un/a experto/a en su campo,puede estar pasando por alto algo de contexto o información que podría cambiar la solución radicalmente.",
              },
              {
                id: "bpt-2:4-a",
                da: " Establezca un sistema que le ayude a recordar cosas. Diferentes métodos funcionan para diferentes personas, pero algo tan simple como llevar un anotador en todo momento para registrar ítems es más que adecuado. Lo importante es tener un metodo y atenerse al mismo.",
              },
              {
                id: "bpt-2:4-b",
                da: " Use herramientas de software tales como Microsoft Outlook que le ayuden a recordar acontecimientos y reuniones. Pida a su departamento de tecnología que le ayude a familiarizarse con todas las herramientas disponibles.",
              },
              {
                id: "bpt-2:4-c",
                da: " Si es notoriamente olvidadizo/a, confíe en un buen asistente para que le notifique acerca de sus compromisos.",
              },
              {
                id: "bpt-2:4-d",
                da: " No espere hasta más tarde para tomar notas o hacer recordatorios. Cuando registra información inmediatamente, no hay posibilidades de olvidarse.",
              },
              {
                id: "bpt-2:4-e",
                da: " Pida a la gente que haga seguimiento con correos electrónicos y recordatorios.",
              },
              {
                id: "bpt-2:4-f",
                da: " Mantenga su memoria nítida con juegos de memoria. Están disponibles en Internet y hay muchos libros sobre el tema también.",
              },
              {
                id: "bpt-2:4-g",
                da: " Asegúrese de descansar lo suficiente y no tratar de abarcar demasiado. El cansancio puede tornarle olvidadizo/a.",
              },
              {
                id: "bpt-2:4-h",
                da: " Examine su carga de trabajo. Si lucha constantemente para desarrollar sus tareas,puede necesitar delegar o buscar recursos adicionales.",
              },
              {
                id: "bpt-2:4-i",
                da: " Vigile su nivel de estrés. El estrés crónico puede afectar su memoria. Asegúrese de incluir tiempo suficiente para relajarse y recargarse.",
              },
              {
                id: "bpt-2:5-a",
                da: " Identifique los conocimientos operativos y técnicos que debería mejorar para manejar su negocio de forma más inteligente. Priorice obtener conocimientos en las áreas que tendrán el mayor impacto en su capacidad de manejar su negocio ahora.",
              },
              {
                id: "bpt-2:5-b",
                da: " Contrate un coach o gerente para prepararle un plan de desarrollo con acciones específicas que apunten a mejorar sus conocimientos funcionales y que le exponga a las experiencias requeridas.",
              },
              {
                id: "bpt-2:5-c",
                da: " Incremente su visión para los negocios suscribiéndose a publicaciones en su campo.Léalas para mantenerse informado de las tendencias de su industria y aumentar así sus conocimientos generales.",
              },
              {
                id: "bpt-2:5-e",
                da: " Durante las conversaciones, concéntrese menos en los sentimientos propios y de otras personas y más en solucionar los problemas.",
              },
              {
                id: "bpt-2:5-f",
                da: " Durante las conversaciones, concéntrese menos en los sentimientos propios y de otras personas y más en solucionar los problemas.",
              },
              {
                id: "bpt-2:5-g",
                da: " Trabaje en sus habilidades motivacionales, es decir, como se siente de fuerte para crecer en áreas que le son desafiantes y que le ayuden a alcanzar sus metas.",
              },
            ],
          },
        ],
      },
      cc: {
        characteristic: "Confronta el conflicto",
        wdd: "Lo cuestiona todo y está dispuesto/a a dar la cara por un asunto incluso si supone un riesgo personal importante. Reconoce, enfrenta y resuelve los conflictos a tiempo. Confronta el bajo rendimiento de las personas y lo corrige a tiempo.",
        icon: require("@/assets/Iconography/Characteristics/03_Conflict Confronter.svg"),
        competencies: [
          {
            id: "cc-0",
            icon: require("@/assets/Iconography/Attributes/03-03_Acting  courageously.svg"),
            comp: "Tiene Coraje",
            wdd: "Lo cuestiona todo y está dispuesto/a a dar la cara por un asunto incluso si supone un riesgo personal importante",
            progressMeasures: [
              {
                id: "cc-0-0",
                pm: "Me siento cómodo al ofrecer una opinión discrepante",
                pmMap: "Sentirme cómodo al ofrecer una opinión discrepante",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "cc-0-1",
                pm: "Hablo cuando algo debe decirse; no espero hasta el último minuto",
                pmMap:
                  "Hablar cuando algo debe decirse; no esperar hasta el último minuto",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "cc-0-2",
                pm: "No me lo tomo de forma personal cuando la gente no está de acuerdo conmigo",
                pmMap:
                  "Cuando la gente no está de acuerdo conmigo, no tomármelo de forma personal ",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "cc-0-3",
                pm: "No sigo la corriente cuando creo lo contrario",
                pmMap: "No seguir la corriente cuando pienso lo contrario",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "cc-0-4",
                pm: "He defendido mi posición anteriormente por algo en lo que creo",
                pmMap: "Defender mi posición por algo en lo que creo",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
            ],
            developmentActions: [
              {
                id: "cc-0:1-a",
                da: " Espere y prepárese para experimentar resistencia de la gente con más experiencia o autoridad. Escriba respuestas a las objeciones que anticipa. La preparación le dará confianza para manejar la oposición. Ensaye el debate con colegas de confianza — puede haber posiciones que no ha considerado para las cuales debería estar preparado.",
              } /*Very dfferent from English to spanish */,
              {
                id: "cc-0:1-b",
                da: " Exponga bien sus motivos. Si la persona se pone a la defensiva acerca de ser desafiado/a, continúe redireccionando la conversación hacia la meta que desea alcanzar.",
              },
              {
                id: "cc-0:1-c",
                da: " Conozca mejor a las figuras con autoridad que le hacen sentirse inquieto/a. Conocer mejor a la gente ayuda a disipar ansiedades. Asista a fiestas de la compañía donde pueda interactuar con ellos o preguntar a otras personas que los conozcan",
              },
              {
                id: "cc-0:1-d",
                da: " If you must voice extremely sensitive information or have concerns about unethical behavior but do not feel comfortable doing so on your own, consult the human resources department for the best course of action.",
              },
              {
                id: "cc-0:2-a",
                da: " Después de haber presentado su caso, puede necesitar abordar el tema nuevamente.Tiene derecho a hacer seguimiento más de una vez si siente que no le están escuchando o que el tema queda sin resolver.",
              },
              {
                id: "cc-0:2-b",
                da: " Trate lo que tiene que decir como algo importante y dé a la gente la oportunidad de escucharle.",
              },
              {
                id: "cc-0:2-c",
                da: " Prepárese bien y conozca su tema. La gente puede no estar de acuerdo con usted, pero respetarán una opinión informada.",
              },
              {
                id: "cc-0:2-d",
                da: " Comparta sus pensamientos con un colega o mentor. Esto puede ayudarle a tener más confianza en sus opiniones y decisiones.",
              },
              {
                id: "cc-0:3-a",
                da: " En lugar de tratar de afrontar todo lo que necesita atención, elija lo que más necesita mejora. ¿Qué tendría el mayor impacto? Concentrarse en estos temas le proporcionará una mayor determinación cuando los demás demuestren desinterés o resistencia.",
              },
              {
                id: "cc-0:3-b",
                da: " Si el tema representa un desafío demasiado grande, divídalo en partes más pequeñas y manténganse concentrado/a en afrontar un solo aspecto cada vez.",
              },
              {
                id: "cc-0:3-c",
                da: " ¿Alguien más está luchando para hacer frente al status quo? Bríndeles respaldo y descubra la fuerza en la acción conjunta. Trate de motivar a otras personas a participar con usted en expresar sus objeciones.",
              },
              {
                id: "cc-0:3-d",
                da: " Puede estar desperdiciando energía si no comprende la política de un determinado tema. Vuélvase más astuto políticamente. Pedir ayuda a la persona adecuada para facilitar el cambio le llevará más lejos con menos esfuerzo. Si su postura no es bien recibida, ¿quién más está allí para escuchar su opinión? ¿Ha comprometido a las personas clave a cargo de la toma de decisiones? Piense estratégicamente acerca de a quién dirigirse para plantear objeciones o preocupaciones.",
              },
              {
                id: "cc-0:4-a",
                da: " Espere y prepárese para experimentar resistencia de la gente con más experiencia o autoridad. Escriba respuestas a las objeciones que anticipa. La preparación le dará confianza para manejar la oposición. Ensaye el debate con colegas de confianza — puede haber posiciones que no ha considerado para las cuales debería estar preparado.",
              },
              {
                id: "cc-0:4-b",
                da: " Exponga bien sus motivos. Si la persona se pone a la defensiva acerca de ser desafiado/a, continúe redireccionando la conversación hacia la meta que desea alcanzar",
              },
              {
                id: "cc-0:4-c",
                da: " Conozca mejor a las figuras con autoridad que le hacen sentirse inquieto/a. Conocer mejor a la gente ayuda a disipar ansiedades. Asista a fiestas de la compañía donde pueda interactuar con ellos o preguntar a otras personas que los conozcan.",
              },
              {
                id: "cc-0:4-d",
                da: " Después de haber presentado su caso, puede necesitar abordar el tema nuevamente. Tiene derecho a hacer seguimiento más de una vez si siente que no le están escuchando o que el tema queda sin resolver.",
              },
              {
                id: "cc-0:4-e",
                da: " Programe su desafío cuidadosamente. Por lo general, las figuras con autoridad están extremadamente ocupadas y el momento inadecuado puede dañar la forma en que se recibe su opinión. Trate de encontrar un momento en que la persona esté menos ocupada y programe una reunión, si es posible, para asegurarse de recibir plena atención.",
              },
              {
                id: "cc-0:5-a",
                da: " La diplomacia es clave para no ofender a otros cuando uno se mantiene firme en su opinión. Sea honesto/a pero diplomático/a. Reconozca la situación actual y haga referencia a lo que está funcionando bien.",
              },
              {
                id: "cc-0:5-b",
                da: " Hable en un tono calmado, no polémico. Alentará a su público a ser más receptivo y abierto a considerar su posición. Discúlpese si ha levantado la voz.",
              },
              {
                id: "cc-0:5-c",
                da: " Es bueno ser apasionado/a acerca de sus creencias, pero es más importante ser capaz de expresarlas bien. Asegúrese de estar enteramente preparado/a para una discusión lógica cuando desafía a otros. Prepare un caso de negocios si es adecuado y explique las razones por las cuales su posición tiene sentido.",
              },
              {
                id: "cc-0:5-d",
                da: " Ofrezca soluciones cuando haga frente al status quo. Ofrecer alternativas agrega valor real a la conversación y demuestra sus habilidades para la resolución de problemas.",
              },
              {
                id: "cc-0:5-e",
                da: " Al igual que usted, es probable que la mayoría de la gente quiera defender su terreno.Anticipe que los demás quieran discutir y tome consciencia de que son tan apasionados como usted acerca del tema. Manténgase paciente y agradable y escuche a la gente. Les resultará más difícil ser agresivos/as con alguien que es sereno/a.",
              },
            ],
          },
          {
            id: "cc-1",
            icon: require("@/assets/Iconography/Attributes/03-02_Managing conflict.svg"),
            comp: "Gestiona El Conflicto",
            wdd: "Reconoce, enfrenta y resuelve los conflictos a tiempo",
            progressMeasures: [
              {
                id: "cc-1-0",
                pm: "Puedo mediar con éxito en una situación de conflicto",
                pmMap: "Mediar con éxito en una situación de conflicto",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "cc-1-1",
                pm: "Me mantengo sereno/a durante el conflicto",
                pmMap: "Mantenerme sereno/a durante el conflicto",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "cc-1-2",
                pm: "Puedo conversar diplomáticamente acerca de temas que la gente podría no querer escuchar",
                pmMap:
                  "Conversar diplomáticamente acerca de temas que la gente podría no querer escuchar",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "cc-1-3",
                pm: "Veo el resultado positivo del conflicto una vez resuelto",
                pmMap:
                  "Ver el resultado positico del conflicto una vez resuelto",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "cc-1-4",
                pm: "No instigo el conflicto, ni siquiera accidentalmente",
                pmMap: "No instigar el conflicto, ni siquiera accidentalemente",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
            ],
            developmentActions: [
              {
                id: "cc-1:1-a",
                da: " Si se le pide que ayude a otras personas a resolver un conflicto entre ellos/as, facilite una conversación honesta durante la cual todas las partes tengan la oportunidad de ser escuchadas. Concentre la conversación en hechos y no permita que haya insultos o falta de respeto.",
              },
              {
                id: "cc-1:1-b",
                da: " Lograr un consenso puede ser una meta demasiado noble al principio. Mida el éxito por su capacidad de facilitar un acuerdo respetuoso entre las partes.",
              },
              {
                id: "cc-1:1-c",
                da: " A menudo se evita el conflicto, o al menos se gestiona mejor, explicando proactivamente a los empleados por qué se tomaron las decisiones, especialmente cuando no participaron en el proceso de toma de las mismas. Brindar claridad impide que la gente saque sus propias conclusiones o confíe en los rumores más que en la dirección.",
              },
              {
                id: "cc-1:1-d",
                da: " Si el conflicto es acerca de los recursos, por ejemplo, desacuerdo acerca de quién hace qué o estrés acerca de trabajar con recursos inadecuados, aclare su asignación.",
              },
              {
                id: "cc-1:1-e",
                da: " Recuerde qué es lo que se abordará mediante la gestión del conflicto — problemas de liderazgo, desempeño deficiente del equipo, información no compartida, etc.",
              },
              {
                id: "cc-1:1-f",
                da: " Asegúrese de no ceder demasiado rápido sólo para mantener la paz. Cuando trata con gente excesivamente competitiva o agresiva, tendrá que tener una fuerte convicción en su posición.",
              },
              {
                id: "cc-1:1-g",
                da: " Si cede para estar de acuerdo con otras personas, piense porqué lo hace. Ceder es aceptable cuando se hace por el bien de todos/as, incluyendo el suyo, o como una estrategia para promocionar sus intereses en el futuro, por ejemplo, para mejorar su poder de negociación más adelante.",
              },
              {
                id: "cc-1:2-a",
                da: " Maneje el conflicto con una persona determinada iniciando una conversación racional, no emocional. Es la mejor manera de aclarar las cuestiones.",
              },
              {
                id: "cc-1:2-b",
                da: " Sea paciente y asigne valor al proceso, no sólo al resultado.",
              },
              {
                id: "cc-1:2-c",
                da: " En lugar de usar la intimidación para lograr ganancias, propóngase como meta tranquilizar a la otra persona.",
              },
              {
                id: "cc-1:2-d",
                da: " Mantenga la voz serena y use un tono normal para conversar sobre el tema.",
              },
              {
                id: "cc-1:2-e",
                da: " Sea consciente de su lenguaje corporal — a menudo dice más que las palabras.Inclinarse sobre el espacio de la gente y señalarles repetidamente en la cara, por ejemplo,son señales de agresión. Su lenguaje corporal debe permanecer abierto y afable.",
              },
              {
                id: "cc-1:2-f",
                da: " Sea consciente del rol que la química personal desempeña en el conflicto. La cuestión real puede ser menos fuerte que la química polémica entre la gente. Por ejemplo, es probable que dos personas con visiones fuertemente opuestas acerca de una cuestión estén en desacuerdo. A menudo nos desagrada en los demás lo que nos desagrada en nosotros mismos. ¿Qué características de su personalidad encuentra menos favorables?",
              },
              {
                id: "cc-1:2-g",
                da: " Escriba cinco rasgos de otras personas que disparan su agresividad. Vienen en todas las formas y tamaños: la gente que habla constantemente y nunca escucha, que siempr tiene que tener la última palabra, que nunca se compromete, que critica cualquier cosa que no crearon, que le da una puñalada por la espalda o que es chismoso/a todo el tiempo. Sea consciente de que estos rasgos pueden sacar lo peor en usted mientras maneja el conflicto.",
              },
              {
                id: "cc-1:2-h",
                da: " Pida a un colega de confianza que le avise cuando usted pisotea a los demás. Puede resultarle difícil reconocer su comportamiento, especialmente porque es improbable que piense que está haciendo algo mal.",
              },
              {
                id: "cc-1:2-i",
                da: " Tome un curso de manejo de la agresividad si su mal humor es un problema o si pierde los estribos fácilmente.",
              },
              {
                id: "cc-1:3-a",
                da: " Maneje el conflicto inmediatamente. No permita que la situación empeore o que aumenten las tensiones innecesariamente. Cuanto más tiempo queden los asuntos sin resolver, más difícil será calmar las emociones de la gente y más complicado será convencerse de abordarlos.",
              },
              {
                id: "cc-1:3-b",
                da: " Inicie cualquier conversación acerca del tema con una definición clara de sus objetivos y resultados positivos probables. Concentrarse en los resultados positivos valida la necesidad de confrontación.",
              },
              {
                id: "cc-1:3-c",
                da: " La acción conjunta es poderosa. Si es adecuado, obtenga respaldo de otras personas para enfrentar al otro bando.",
              },
              {
                id: "cc-1:3-d",
                da: " Recuerde que está trabajando hacia una meta positiva, y que el hecho de que usted u otras personas se sientan temporalmente incómodos/as justifica el esfuerzo.",
              },
              {
                id: "cc-1:3-e",
                da: " Considere formas creativas de resolver el conflicto. Pida a un colega de confianza o mentor que brinde sugerencias. Practique con una cuestión acerca de la cual tiene convicciones arraigadas.",
              },
              {
                id: "cc-1:3-f",
                da: " Siga practicando. Sentirse confiado/a para enfrentarse a otras personas puede requerir hacerlo las suficientes veces como para darse cuenta de que sus ansiedades son injustificadas.",
              },
              {
                id: "cc-1:4-a",
                da: " Comunique y mantenga informada a la gente. A menudo una falta de comunicación es la raíz del conflicto. La gente se disgusta cuando continuamente se enfrenta a sorpresas o no es informada de nuevas decisiones, programas, etc.",
              },
              {
                id: "cc-1:4-b",
                da: " Si los humores se caldean cuando se enfrenta a otras personas, concéntrese en su propio comportamiento, no en el de ellos/as. Hablar con las personas como si no estuvieran disgustadas es una estrategia efectiva para permanecer sereno/a.",
              },
              {
                id: "cc-1:4-c",
                da: " Sea consciente de usar lenguaje que no ponga a la gente a la defensiva. Por ejemplo, es mejor decir “Parece que hay un malentendido” que “Usted no entiende”. También evite generalizaciones amplias cuando exponga su argumento, tales como “Usted y su equipo siempre hacen lo que quieren”.",
              },
              {
                id: "cc-1:4-d",
                da: " Sea consciente de su comunicación no verbal, por ejemplo, mantenga contacto visual y asienta con la cabeza mientras escucha.",
              },
              {
                id: "cc-1:4-e",
                da: " Concéntrese en los hechos, no en la persona involucrada.",
              },
              {
                id: "cc-1:4-f",
                da: " Escuche activamente. Quiere lograr un resultado mutuamente beneficioso, y eso no puede hacerse sin comprender la posición de la otra parte. Si cree que sabe todas las respuestas antes de que empiece la conversación, no manejará bien el conflicto. Permita que la otra persona tome tiempo para descargarse y déjela explicar sin interrumpir o juzgar lo que dice. Verifique que realmente se escuchan mutuamente. Repita y reformule lo que escuchó decir a la otra persona y confirme la exactitud. Deje que confirme que usted escuchó bien.",
              },
              {
                id: "cc-1:4-g",
                da: " Si es posible, tenga siempre conversaciones relacionadas con el conflicto en privado.No hay necesidad de incluir oidos innecesarios o pedir opiniones no deseadas.",
              },
              {
                id: "cc-1:4-h",
                da: " Muchas veces, es mejor ser abierto/a y honesto/a acerca de sus sentimientos. La gente apreciará su sinceridad y será más comprensiva con su posición.",
              },
              {
                id: "cc-1:4-i",
                da: " Cierre su conversación con ítems de acción de los cuales todas las partes involucradas sean responsables. Asegúrese de que haya acuerdo y respaldo de ambas partes acerca de estos ítems. Si no puede llegar a un acuerdo en ese momento, considere tomar un tiempo para reflexionar y calmarse y vuelva a convocar una conversación más tarde.",
              },
              {
                id: "cc-1:4-j",
                da: " Acuerde discrepar, o busque un tercero para mediar cuando las cuestiones simplemente no pueden resolverse.",
              },
              {
                id: "cc-1:4-k",
                da: " Hay muchos libros disponibles para aprender más acerca de la gestión de conflicto.",
              },
              {
                id: "cc-1:4-l",
                da: " Consulte acerca de posibles cursos de gestión de conflicto que podría tomar a través de la compañía. El departamento de recursos humanos podría ayudarle.",
              },
              {
                id: "cc-1:4-m",
                da: " Pregunte a su jefe acerca de oportunidades para asistir a reuniones que le brindarían una exposición de primera mano a prácticas de gestión de conflicto.",
              },
              {
                id: "cc-1:4-n",
                da: " Aproveche las herramientas de evaluación para que le ayuden a identificar y mitigar el riesgo de conflicto en su equipo. El sistema de Talent Management™ de PeopleTree le permite evaluar diferentes estilos de equipos y cómo las personas probablemente se percibirán entre sí en base a estos estilos.",
              },
              {
                id: "cc-1:5-a",
                da: " Reconozca la tensión abiertamente en lugar de negarla — es el primer paso a la acción.",
              },
              {
                id: "cc-1:5-b",
                da: " Redefina su perspectiva acerca de la confrontación. Aliente la honestidad y promueva el debate creativo y constructivo dentro de su equipo y en toda la organización.",
              },
              {
                id: "cc-1:5-c",
                da: " Si es un/a líder dentro de la organización, marcará un ejemplo para todos los demás.Asegúrese de estar abierto/a a ser desafiado/a.",
              },
              {
                id: "cc-1:5-d",
                da: " Si una situación no puede resolverse mediante una conversación y el comportamiento de la otra parte está en conflicto con las políticas y procedimientos, pida apoyo al departamento de recursos humanos.",
              },
              {
                id: "cc-1:5-e",
                da: " Si está en conflicto con su jefe, tendrá que aprender cómo llevarse bien a pesar de su comportamiento arrogante o controlador. Trate de aprender lo más posible acerca de la personalidad y expectativas de su jefe. Hable con otras personas que trabajen bien con su jefe y pídales consejo.",
              },
            ],
          },
          {
            id: "cc-2",
            icon: require("@/assets/Iconography/Attributes/03-01_Managing under performance.svg"),
            comp: "Gestiona El Bajo Rendimiento",
            wdd: "Confronta el bajo rendimiento de las personas y lo corrige a tiempo",
            progressMeasures: [
              {
                id: "cc-2-0",
                pm: "Me siento cómodo/a dando retroalimentación correctiva cuando es necesaria",
                pmMap:
                  "Estar cómodo/a dando retrtoalimentación correctiva cuando es necesaria",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "cc-2-1",
                pm: "Manejo las cuestiones de bajo rendimiento de forma oportuna",
                pmMap:
                  "Manejar las cuestiones de bajo rendimiento de forma oportuna",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "cc-2-2",
                pm: "Comprendo los comportamientos subyacentes relacionados con el bajo rendimiento",
                pmMap:
                  "Comprender los comportamientos subyacentes relacionados con el bajo rendimiento",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "cc-2-3",
                pm: "Puedo detectar rápidamente cuestiones de bajo rendimiento",
                pmMap: "Detectar rápidamente casos de bajo rendimiento",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "cc-2-4",
                pm: "Adapto mi estilo de retroalimentación a las necesidades de la persona a la cual me estoy dirigiendo",
                pmMap:
                  "Adaptar mi estilo de retroalimentación a las necesidades de la persona a la cual me estoy dirigiendo",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
            ],
            developmentActions: [
              {
                id: "cc-2:1-a",
                da: " Empiece su conversación señalando algunos aspectos positivos del desempeño del empleado.",
              },
              {
                id: "cc-2:1-b",
                da: " Siempre trate al empleado con profesionalismo, dignidad y respeto, incluso si su desempeño tuvo un efecto negativo en usted y su equipo.",
              },
              {
                id: "cc-2:1-c",
                da: " Verifique el nivel de comprensión de la persona acerca de la descripción de su trabajo para asegurarse de que ambos/as tengan las mismas expectativas con respecto a su rol.",
              },
              {
                id: "cc-2:1-d",
                da: " Prepare sugerencias correctivas antes de reunirse con el/la empleado/a, pero permítale expresarse. Puede haber muchos factores que no conozca o que no haya considerado que afectarán la acción recomendada. La gente también debe tener la oportunidad de sentir que fueron escuchados/as.",
              },
              {
                id: "cc-2:1-e",
                da: " La gente tiende a adoptar técnicas de resolución de problemas inadecuadas — culpar,acusar, defenderse, etc. Asegúrese de reconocer y manejar tal comportamiento, de lo contrario podría distraerle de alcanzar una solución.",
              },
              {
                id: "cc-2:1-f",
                da: " Aliente al empleado a sugerir soluciones para su bajo rendimiento. Es más probable que los/as empleados/as acepten y respalden la necesidad de cambio si pueden solucionar sus propios problemas.",
              },
              {
                id: "cc-2:1-g",
                da: " No se distraiga con otros ítems relacionados con el trabajo que también necesiten atención durante una conversación sobre desempeño; guárdelos para otra conversación.Mezclar diferentes cuestiones reduce el impacto de la conversación.",
              },
              {
                id: "cc-2:1-h",
                da: " Sea lo más especifico/a posible acerca de una cuestión. Evite las generalizaciones,opiniones y comparaciones y brinde evidencia que respalde su punto de vista.",
              },
              {
                id: "cc-2:1-i",
                da: " Enfatice las consecuencias del bajo rendimiento del empleado. Destaque el impacto que tiene su desempeño en el resto del equipo o de la organización y las consecuencias si el desempeño del/de la empleado/a no mejorara, por ejemplo, las oportunidades de crecer en la compañía se verán limitadas.",
              },
              {
                id: "cc-2:1-j",
                da: " Asegúrese de que la persona realmente ha comprendido el impacto del problema. Las señales de que no comprendió podrían incluir que continúe usando excusas, le acuse de ser injusto/a y así sucesivamente. Si esto sucede, redirija la conversación diciendo: “Me gustaría hablar de eso después; ahora, me gustaría concentrarme en lo que usted puede hacer”. En este punto podría necesitar decirle al/a la empleado/a cuál piensa que es la mejor solución.",
              },
              {
                id: "cc-2:1-k",
                da: " Recuerde al/ la empleado/a que un desempeño sólido no es negociable.",
              },
              {
                id: "cc-2:2-a",
                da: " Aborde el bajo rendimiento inmediatamente. No espere hasta la revisión de fin de año u otras evaluaciones formales si ve un cambio para peor o se siente preocupado/a acerca del desempeño de una persona. Incluso si el/la empleado/a tiene un buen desempeño uniforme, una breve conversación acerca de susdesafíos y de cómo usted puede ayudar pueden evitar que se deteriore su rendimiento.",
              },
              {
                id: "cc-2:2-b",
                da: " Trate de ver si los talentos de un/a empleado/a se ajustan a los requisitos de su trabajo. Determine las competencias requeridas para la posición y qué vacíos existen. Si es posible, use un sistema de gestión de talento como el Talent Manager™ de PeopleTree para analizar las deficiencias entre el talento de una persona, la posición y el contexto de esa posición. Le permitirá medir las deficiencias existentes y priorizar ítems de desarrollo que maximizarán el desempeño.",
              },
              {
                id: "cc-2:2-c",
                da: " Programe una reunión con el/la empleado/a para discutir cómo se puede mejorar su rol de una manera que le beneficie a él/ella, a su jefe y al negocio. Explique qué parte del desempeño debe mejorarse — sea específico/a y cite ejemplos. Sea claro acerca del nivel de expectativas que tiene y la necesidad de desempeñarse a este nivel de forma consistente.Identifique el respaldo y los recursos que brindará para ayudar a la persona a ser exitosa.Determine las mediciones que usará para evaluar el avance. Cuando termine su reunión, resuma la solución y exprese confianza en la capacidad del/de la empleado/a de implementarla. Finalmente, documente la reunión.",
              },
              {
                id: "cc-2:2-d",
                da: " Involucre al/a la empleado/a en la definición de sus propias metas de modo que cuente con el mayor respaldo.",
              },
              {
                id: "cc-2:2-e",
                da: " Establezca metas de mejora a corto plazo para una persona. Un período de 90 días es ideal, porque da amplia oportunidad de observar el avance y experimentar el éxito de forma regular.",
              },
              {
                id: "cc-2:2-f",
                da: " Decida al principio cómo la persona comunicará su avance — ¿será una vez por semana, una vez por mes? Los intervalos deben ser frecuentes pero no molestos.",
              },
              {
                id: "cc-2:2-g",
                da: " Evalúe si la persona estará en condiciones de mejorar su desempeño sin ayuda adicional de, por ejemplo, un mentor, otro miembro del equipo, un coach o experto técnico.",
              },
              {
                id: "cc-2:2-h",
                da: " Asegúrese de que la capacidad del/de la empleado/a de mejorar su desempeño no esté entorpecida por factores fuera de su control, tales como barreras políticas, burocracia o un/a cliente/a interno/a poco colaborador/a que retenga información. Sea proactivo/a en preparar el terreno para su éxito.",
              },
              {
                id: "cc-2:2-i",
                da: " Investigue si los problemas de bajo rendimiento se deben a cuestiones de motivación y no a una falta de habilidad. Comprender estas cuestiones y crear algunos incentivos puede ser todo lo que se necesita para gestionar el bajo rendimiento.",
              },
              {
                id: "cc-2:3-a",
                da: " Monitoree regularmente el desempeño laboral de los/as empleados/as y los desafíos que enfrentan.",
              },
              {
                id: "cc-2:3-b",
                da: " Establezca una cultura de conversación abierta poniéndose a disposición de sus empleados/as — reserve un horario específico, si es posible todas las semanas, para que la gente hable con usted.",
              },
              {
                id: "cc-2:3-c",
                da: " Solicite información al departamento de recursos humanos acerca del costo de contratar nuevos talentos. La cifra le dará la perspectiva de si justifica invertir su tiempo para ocuparse de cuestiones de bajo rendimiento.",
              },
              {
                id: "cc-2:3-d",
                da: " Trate de mostrar empatía. Recuerde algún momento en que luchaba en su carrera.",
              },
              {
                id: "cc-2:3-e",
                da: " Visualícese como mentor más que como jefe. ¿Qué haría un buen maestro con un alumno problemático? ¿Qué tan bien puede desempeñarse en poner al/a la alumno/a de nuevo en la senda?",
              },
              {
                id: "cc-2:4-a",
                da: " Analice si la persona tiene la experiencia necesaria para sus responsabilidades o para un proyecto. Si no, esto puede ser la causa de su bajo rendimiento. Luego puede reasignar a la persona del todo para aumentar su nivel de experiencia pero primero, manténgale en el proyecto dándole tareas con menos responsabilidad o manténgale en el proyecto trabajando en estrecha colaboración con alguien que tenga más experiencia y pueda supervisarle.",
              },
              {
                id: "cc-2:4-b",
                da: " ¿Qué nivel de experiencia técnica o funcional tiene el individuo? Identifique los ítems que deben mejorarse y cree un plan de desarrollo. Diseñe un plan de capacitación técnica para mejorar el conjunto de habilidades de la persona. Esto puede ser una capacitación formal o a través de mentores.",
              },
              {
                id: "cc-2:4-c",
                da: " Las competencias conductuales deficientes se abordan mejor a través de conversaciones de retroalimentación y entrenamiento. Un proceso de retroalimentación de 360° basado en competencias conductuales es efectivo para definir la cuestión de desempeño.",
              },
              {
                id: "cc-2:4-d",
                da: " La motivación es a menudo culpable de la disminución en el desempeño. Explore si la persona está satisfecha con su situación de trabajo y aborde incentivos que ayudarían a comprometer a la persona nuevamente. Un/a empleado/a puede no sentirse cómodo/a de conversar honestamente sus cuestiones con usted, por lo tanto ofrezca que puede hablar con un/a representante de recursos humanos.",
              },
              {
                id: "cc-2:4-e",
                da: " Los/as empleados/as pueden tener problemas personales que interfieren con su trabajo, tales como enfermedades en la familia, muerte o divorcio. Trate de brindar soluciones para ayudarles en estos tiempos difíciles y aliénteles a usar apoyo profesional disponible a través de la compañía.",
              },
              {
                id: "cc-2:4-f",
                da: " Use un sistema de gestión de talento como Talent Manager™ de PeopleTree para evaluar de forma precisa si un/a empleado/a es adecuado/a para una posición. ¿Está la persona en la posición equivocada dados sus intereses y habilidades? ¿Tiene la persona un problema con su gerente o con los diferentes estilos de trabajo entre los miembros del equipo? Las respuestas a estas preguntas brindarán información valiosa para determinar la  raíz del bajo rendimiento.",
              },
              {
                id: "cc-2:5-a",
                da: " Concéntrese en el comportamiento problemático, no en el/la empleado/a problemático/a. Está buscando una solución para un desempeño débil, no para una personalidad débil.",
              },
              {
                id: "cc-2:5-b",
                da: " Evite tomar desprevenida a una persona con retroalimentación — es probable que se ponga a la defensiva. Avise a la persona que quiere tener una conversación acerca de ciertos puntos y agende la misma rápidamente para evitar aumentar sus niveles de ansiedad.",
              },
              {
                id: "cc-2:5-c",
                da: " Permita que el/la empleado/a reaccione y no responda defensivamente — sólo agregará emoción a la situación. Compórtese de la manera que espera que ellos/as lo hagan.",
              },
              {
                id: "cc-2:5-d",
                da: " Comunique a la persona que comprende por qué está disgustado/a, pero que no puede llegar a una solución a menos que esté sereno/a.",
              },
              {
                id: "cc-2:5-e",
                da: " Anticipe que la persona tratará de desviar la conversación culpando, negando,actuando enojado/a, etc. Manténgase objetivo/a en todo momento.",
              },
              {
                id: "cc-2:5-f",
                da: " Si la persona no se calma a pesar de sus intentos, dígale que le dará tiempo para poner sus ideas en orden y que retomarán la reunión cuando esté listo/a para escuchar.Programe otra cita antes de despedirse.",
              },
              {
                id: "cc-2:5-g",
                da: " Pida a un mediador de recursos humanos que facilite la conversación si es demasiado difícil dialogar con la persona.",
              },
            ],
          },
        ],
      },
      mo: {
        characteristic: "Es organizado/a",
        wdd: "Es organizado/a y metódico/a y pone atención al detalle. Demuestra un alto nivel de productividad y emplea su tiempo de manera eficaz al realizar su trabajo. Identifica el alcance del proyecto, estableciendo fases y acciones claras para llegar a los objetivos definidos.",
        icon: require("@/assets/Iconography/Characteristics/11_Methodical Organiser.svg"),
        competencies: [
          {
            id: "mo-0",
            icon: require("@/assets/Iconography/Attributes/11-03_Being Detail-Oriented.svg"),
            comp: "Orientado/a Al Detalle",
            wdd: "Es organizado/a y metódico/a y pone atención al detalle",
            progressMeasures: [
              {
                id: "mo-0-0",
                pm: "Tengo un sistema implementado que me mantiene organizado/a",
                pmMap:
                  "Tener implementado un sistema que me mantenga organizado/a",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "mo-0-1",
                pm: "Considero las cosas cuidadosamente antes de precipitarme",
                pmMap:
                  "Considerar las cosas cuidadosamente antes de precipitarme",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "mo-0-2",
                pm: "Tomo buenas notas y registro las cuestiones que requieren seguimiento",
                pmMap:
                  "Tomar buenas notas y registrar las cuestiones que requieren seguimiento",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "mo-0-3",
                pm: "Rápidamente puedo acceder a información que almacené sin pasar tiempo innecesario buscándola",
                pmMap:
                  "Acceder rápidamente a la información que almacené sin pasar tiempo innecesario buscándola",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "mo-0-4",
                pm: "Rara vez cometo errores por haber pasado por alto detalles importantes",
                pmMap:
                  "No pasar por alto detalles importantes que pueden llevar a errores",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
            ],
            developmentActions: [
              {
                id: "mo-0:1-a",
                da: " Prepárese para concentrarse en el aquí y ahora, aunque sea por cortos períodos de tiempo a la vez. Asigne una cantidad específica de tiempo cada día para repasar los detalles de un plan, quiera o no. Considere esto como el “tiempo de construcción” que requiere cualquier proyecto.",
              },
              {
                id: "mo-0:1-b",
                da: " Intente un enfoque de pequeños pasos a la vez. Empiece siendo metódico/a acerca de las pequeñas cosas, tales como su Rolodex o sistema de archivo, que no llevan mucho tiempo y luego pase a desafíos más grandes. Esto le ayudará a ver los beneficios que una pequeña inversión de su tiempo puede generar.",
              },
              {
                id: "mo-0:1-c",
                da: " Cultive un interés activo en lo que hace. Cuando hay algo que no quiere hacer pero que simplemente debe hacer, encuentre una manera de hacerlo interesante o reconózcalo como un paso necesario entre donde está y donde quiere estar — y hágalo.",
              },
              {
                id: "mo-0:1-d",
                da: " Cree un sistema que le recuerde concentrarse en los detalles. Escriba una nota en el dorso de la mano, ponga un recordatorio colorido en la pantalla de su computadora, pídale a un colega que le haga acordar o agréguelo a su calendario electrónico de modo que le recuerde una vez por día.",
              },
              {
                id: "mo-0:1-e",
                da: " Asóciese con otras personas que tengan fortalezas opuestas, por ejemplo, si obtiene la posición gerencial, designe una persona orientada a los detalles como su asistente.",
              },
              {
                id: "mo-0:1-f",
                da: " Pida a un colega de confianza que sea metódico/a que le ayude a considerar algunos de los detalles que es probable que usted pase por alto. Compare su lista de detalles con la de la otra persona. ¿Qué ángulos omitió?",
              },
              {
                id: "mo-0:2-a",
                da: " Deje de buscar la salida más fácil. La mayoría de las metas se alcanzan con trabajo arduo y dedicación. Es importante trabajar con inteligencia y rapidez, pero sea cuidadoso/a de no poner excusas acerca de los detalles porque requieren trabajo extra. Identifique los atajos que puede estar tomando, incluyendo hacer supuestos acerca de las instrucciones, la gente, etc.",
              },
              {
                id: "mo-0:2-b",
                da: " Divida su meta en tareas más pequeñas, detalladas — cada pequeña tarea completada trae una recompensa.",
              },
              {
                id: "mo-0:2-c",
                da: " Prepare un cronograma detallado del proyecto que determine puntos realistas en los cuales espera alcanzar hitos. No trate de apurar el proceso indebidamente.",
              },
              {
                id: "mo-0:2-d",
                da: " Reconozca si un enfoque de equipo sería mejor y asigne amplios recursos para trabajar en los detalles de un plan.",
              },
              {
                id: "mo-0:2-e",
                da: " Implemente prácticas de garantía de calidad para protegerse contra cualquier fallo u omisión importante en sus procesos.",
              },
              {
                id: "mo-0:2-f",
                da: " La meditación es una forma efectiva de traer calma y quietud a la mente. Incorpórela en su rutina diaria.",
              },
              {
                id: "mo-0:3-a",
                da: " Mantenga informada a la gente correspondiente acerca de su carga de trabajo si empieza a afectar la precisión del mismo. Es responsabilidad de esa persona delegar adecuadamente.",
              },
              {
                id: "mo-0:3-b",
                da: " Almacene toda la información para diferentes proyectos o tareas de forma separada de manera organizada, ya sea electrónicamente o en archivos en papel y asegúrese de tener fácil acceso a ella.",
              },
              {
                id: "mo-0:3-c",
                da: " Reacomodar la mente constantemente lleva mucho tiempo. Para aumentar su eficiencia, combine actividades similares. Por ejemplo, haga todas las llamadas a los diferentes clientes de una vez y envíe todos los correos electrónicos en otro momento",
              },
              {
                id: "mo-0:3-d",
                da: " ¿Tiene sistemas implementados que le ayudan a mantenerse organizado/a? De ser así, asegúrese de ponerlos en práctica efectivamente. ¿Puede enumerar y describir sus sistemas a otras personas? No tienen que ser complejos — apuntar notas en un anotador determinado es un sistema.",
              },
              {
                id: "mo-0:3-e",
                da: " Pregunte a sus colegas meticulosos acerca de los sistemas que usan para mantenerse organizados/as. Tal vez uno funcionará para usted.",
              },
              {
                id: "mo-0:3-f",
                da: " Aproveche toda la tecnología de organización que tiene en su escritorio, tales como calendarios, herramientas para generar su agenda y software de gestión de proyectos. Se sorprenderá de encontrar muchas herramientas a su disposición; ahora sólo tiene que usarlas.",
              },
              {
                id: "mo-0:3-g",
                da: " Mantenga las cosas ordenadas. Organice su escritorio y su entorno tanto como pueda.",
              },
              {
                id: "mo-0:3-h",
                da: " Resista la tentación de postergar hacer algo que lo ayudará a ser organizado/a sólo porque puede hacerlo “después”. Eso es lo que contribuye a pilas de papeles, notas perdidas, llamadas y correos electrónicos no respondidos, o archivos perdidos en su computadora.",
              },
              {
                id: "mo-0:3-i",
                da: " ¿Está constantemente creando listas, pasando más tiempo tratando de organizarse que efectivamente siendo organizado/a? No establezca sistemas que no puede seguir o incorporar en una rutina diaria.",
              },
              {
                id: "mo-0:3-j",
                da: " Los hábitos y las rutinas ayudan a hacer el seguimiento de los detalles, porque son confiables.",
              },
              {
                id: "mo-0:4-a",
                da: " Para asegurar la responsabilidad, anuncie a los demás su compromiso de abordar una cuestión de forma metódica.",
              },
              {
                id: "mo-0:4-b",
                da: " Asegúrese de conocer la cultura de su compañía y las reglas de juego.Puede que tenga que adaptarse a mayores expectativas o a una nueva cultura. Si es necesario y esperado, tendrá que esforzarse más.",
              },
              {
                id: "mo-0:4-c",
                da: " Recuerde que algunos clientes esperarán más atención al detalle que otros. Suponga que así será.",
              },
              {
                id: "mo-0:4-d",
                da: " Asóciese con alguien que lo considerará responsable y que exigirá una cuidadosa consideración de los detalles de sus procesos y decisiones.",
              },
            ],
          },
          {
            id: "mo-1",
            icon: require("@/assets/Iconography/Attributes/11-02_Managing Time.svg"),
            comp: "Gestiona El Tiempo",
            wdd: "Demuestra un alto nivel de productividad y emplea su tiempo de manera eficaz al realizar su trabajo",
            progressMeasures: [
              {
                id: "mo-1-0",
                pm: "Hago las cosas lo más rápido posible y no las dejo para más tarde",
                pmMap:
                  "Hacer las cosas lo más rápido posible y no dejarlas para más tarde",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "mo-1-1",
                pm: "Puedo ocuparme de múltiples proyectos o tareas",
                pmMap: "Ocuparme de múltiples proyectos o tareas",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "mo-1-2",
                pm: "Soy realista acerca de cuánto trabajo puedo hacer",
                pmMap: "Ser realista acerca de cuánto trabajo puedo hacer",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "mo-1-3",
                pm: "Uso herramientas de generación de agenda para hacer el mejor uso de mi tiempo",
                pmMap:
                  "Usar herramientas de generación de agenda para hacer el mejor uso de mi tiempo",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "mo-1-4",
                pm: "Trato de hacer todo lo que puedo pero no trato de hacer todo perfectamente",
                pmMap:
                  "Tratar de hacer lo mejor que puedo y no intentar hacerlo todo perfectamente",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
            ],
            developmentActions: [
              {
                id: "mo-1:1-a",
                da: " Familiarícese con las señales de “procrastinación” y haga una lista de ellas. Agregue cualquier síntoma que haya advertido en sí mismo/a o en otras personas. Consulte la lista al principio y al final del día para que le sirva como recordatorio. Algunos ejemplos comunes incluyen llenar el día con tareas de baja prioridad, sentarse a empezar una tarea de alta prioridad y casi inmediatamente tomarse un descanso, hacerse una taza de café o mirar los correos electrónicos mientras deja pasar demasiado tiempo, dejar una prioridad en la lista de pendientes durante mucho tiempo sin abordarla y comprometerse a ayudar a otras personas en lugar de ocuparse de su propio trabajo.",
              },
              {
                id: "mo-1:1-b",
                da: " Si una tarea o proyecto es abrumador, establezca pequeños hitos que pueda lograr ada día o semana, y recompénsese.",
              },
              {
                id: "mo-1:1-c",
                da: " Desarrolle su lista de acción en base a actividades específicas, bien definidas, más que en base a resultados. Lento pero seguro alcanzará su meta.",
              },
              {
                id: "mo-1:1-d",
                da: " Pídale a alguien que se acerque y mida el trabajo que usted hace en una tarea específica. Ayuda saber que será considerado/a responsable.",
              },
              {
                id: "mo-1:1-e",
                da: " Calcule el costo de su tiempo para su empleador. ¿Cuánto le pagan por día o por hora? Si usted “procrastina” y no se concentra en las tareas adecuadas, no entrega valor por dinero.",
              },
              {
                id: "mo-1:1-f",
                da: " Concéntrese en los resultados, no en el trabajo ocupado. Controle cuánto tiempo dedica cada día a tareas poco importantes que realmente no contribuyen a su éxito. ¿Sabe cuánto tiempo pasa leyendo correo basura, hablando con colegas, haciendo café o navegando por Internet? ¿Es consciente de cuánto tiempo al día mira su correo electrónico, escribe artículos importante o hace su planificación a largo plazo?",
              },
              {
                id: "mo-1:2-a",
                da: " La delegación es una técnica de gestión de tiempo comprobada. Asegúrese de delegar efectivamente en su equipo. ¿Qué tareas está desarrollando que otros podrían hacer también? Si delega mal, siempre estará presionado/a de tiempo.",
              },
              {
                id: "mo-1:2-b",
                da: " ¿Cómo de organizado/a es? La gente organizada crea sistemas y rutinas que le ayudan a manejar información. No desperdician tiempo buscando archivos perdidos en sus computadoras o información que definitivamente estaba en sus escritorios en alguna parte.",
              },
              {
                id: "mo-1:2-c",
                da: " Trate de minimizar la cantidad de veces por día en que alterna entre diferentes tipos de tareas. Eso desperdicia tiempo. Por ejemplo, lea y conteste correos electrónicos una vez en la mañana y una vez en la tarde. Realice las otras tareas entremedias.",
              },
              {
                id: "mo-1:2-d",
                da: " Use un calendario para programar actividades de trabajo y personales con una o dos semanas de anticipación. Le obligará a considerar y priorizar qué ocupará las próximas dos semanas y siempre estará al tanto del tiempo disponible para usted y sus actividades personales. También le dará control sobre su cronograma, en lugar de ponerlo en manos de los demás.",
              },
              {
                id: "mo-1:2-e",
                da: " Aproveche cualquier tecnología disponible para automatizar procesos que ocupan su tiempo innecesariamente. Por ejemplo, el software para organizar la agenda por Internet le permite manejar reuniones de forma eficiente sin enviar correos electrónicos, porque puede evaluar la disponibilidad de la gente inmediatamente.",
              },
              {
                id: "mo-1:2-f",
                da: " De cuando en cuando tendrá que ocuparse de cuestiones personales durante horas de trabajo. Asegúrese de limitar estas actividades y hacerlas durante el almuerzo o entrar más temprano para manejarlas.",
              },
              {
                id: "mo-1:2-g",
                da: " Mantenga al mínimo los correos electrónicos no relacionados con el trabajo. Pueden ir y venir y antes de darse cuenta pasó una hora sin hacer trabajo alguno.",
              },
              {
                id: "mo-1:2-h",
                da: " Cuánto más bajo es su nivel de energía, más fácil es perder el tiempo trabajando de forma ineficiente. Los niveles de energía de la mayoría de la gente fluctúan durante el día.Pueden estar relacionados con la cantidad de azúcar en sangre, la cantidad de tiempo desde que tomó un descanso, estrés, aburrimiento, etc. Mantenga un registro durante una semana para analizar cuándo está siendo más productivo/a. Sea consciente del tipo de actividades que programa durante momentos en que tiende a sentirse cansado/a versus enérgico/a. Si es posible, programe sus actividades en consecuencia. Por ejemplo, si está más alerta en la mañana, programe actividades que requieren mayor enfoque entonces. La mañana la rendirá más. Deje las llamadas para media tarde cuando sus niveles de energía estén más bajos.",
              },
              {
                id: "mo-1:2-i",
                da: " Internet es un gran recurso pero también puede desperdiciar mucho el tiempo de la gente. Tenga cuidado de no irse por tangentes cibernéticas que desperdician tiempo. Use Internet para fines relacionados con el trabajo únicamente.",
              },
              {
                id: "mo-1:2-j",
                da: " Asegúrese de no abusar de la cantidad de tiempo que dedica a actividades como hacer café o usar la fotocopiadora o máquina de fax.",
              },
              {
                id: "mo-1:2-k",
                da: " Hay muchos recursos para ayudarle a mejorar sus habilidades de gestión de tiempo.Lea libros como Los 7 Hábitos de la Gente Altamente Efectiva de Stephen Covey.",
              },
              {
                id: "mo-1:2-l",
                da: " La mayoría de las organizaciones ofrecen algún curso de gestión de tiempo. Pregunte a su departamento de recursos humanos acerca de las opciones",
              },
              {
                id: "mo-1:2-m",
                da: " Pida consejos a colegas que manejen bien su tiempo.",
              },
              {
                id: "mo-1:3-a",
                da: " Pida ayuda o delegue. Tener colaboración en un proyecto puede ayudarle a mantenerse concentrado/a. Puede dedicar más tiempo a revisar trabajo y asegurarse de que está dentro del estándar.",
              },
              {
                id: "mo-1:3-b",
                da: " Considere invertir dinero en hacer uso de terceros para tareas clave.",
              },
              {
                id: "mo-1:3-c",
                da: " Mantenga sus expectativas bajo control. Reemplace pensamientos buenos para nada con pensamientos realistas, por ejemplo: “Puede no ser perfecto pero no tiene que serlo y terminaré a tiempo”.",
              },
              {
                id: "mo-1:3-d",
                da: " Pida a otras personas, especialmente a su gerente, retroalimentación acerca de la calidad de su trabajo hasta el momento. Pueden ayudarle a medir si dedicó un esfuerzo desmedido a una tarea.",
              },
              {
                id: "mo-1:3-e",
                da: " Trate de adaptar sus expectativas a las circunstancias. Muchos factores que pueden estar fuera de su control determinarán el resultado de una tarea: la cantidad de recursos asignados, la fecha límite, la complejidad de la tarea, la experiencia previa que tuvo en proyectos similares, etc.",
              },
              {
                id: "mo-1:3-f",
                da: " Concéntrese en otros beneficios que obtiene de trabajar en un proyecto y no sólo en hacerlo perfectamente, como el aprendizaje involucrado, divertirse y la satisfacción de completar algo.",
              },
              {
                id: "mo-1:3-g",
                da: " Defina límites de tiempo estrictos para cada uno de sus proyectos. Pase a otro tema cuando se termine el tiempo y ocúpese de algo más.",
              },
              {
                id: "mo-1:3-h",
                da: " Aprenda cómo manejar la crítica. Los/as perfeccionistas a menudo ven la crítica como un ataque personal y responden defensivamente. Concéntrese en ser más objetivo/a cerca de la crítica y de sí mismo/a.",
              },
              {
                id: "mo-1:3-i",
                da: " Obtenga la ayuda de un coach profesional.",
              },
              {
                id: "mo-1:4-a",
                da: " Use más lógica y menos emoción para tomar decisiones, luego actúe.",
              },
              {
                id: "mo-1:4-b",
                da: " Antes de actuar, siempre cuestione si las tareas son absolutamente necesarias y si podrían delegarse o recortarse para que lleven menos tiempo.",
              },
              {
                id: "mo-1:4-c",
                da: " Asista a un programa de capacitación sobre gestión de tiempo que le familiarice con los principios de la planificación y el software correspondiente.",
              },
              {
                id: "mo-1:4-d",
                da: " Planifique un programa tentativo para la semana entrante. Siempre puede ajustarse si es necesario y le da la oportunidad de considerar sus prioridades por adelantado. Asegúrese de abordar ítems urgentes de alta prioridad así como también tareas de mantenimiento que no pueden delegarse ni evitarse.",
              },
              {
                id: "mo-1:4-e",
                da: " Planifique tiempo para las contingencias. Cuanto más impredecible sea su trabajo, más tiempo necesitará para tales eventualidades. La interrupción constante es una realidad del trabajo de los gerentes. Los estudios demuestran que, en promedio, algunos gerentes trabajan de forma ininterrumpida durante tan poco como seis minutos por vez.",
              },
              {
                id: "mo-1:4-f",
                da: " Reserve tiempo para las responsabilidades por las cuales será evaluado, por ejemplo, si maneja gente, programe tiempo para entrenamiento, supervisión y planificación. Del mismo modo, debe dedicar tiempo a comunicarse con su jefe y la gente clave a su alrededor.",
              },
              {
                id: "mo-1:5-a",
                da: " Nunca acepte asumir más responsabilidad si tiene que ocuparse de ítems críticos que no han sido abordados.",
              },
              {
                id: "mo-1:5-b",
                da: " Asegúrese de saber en qué se está involucrando. La tarea puede parecer fácil, pero siempre lleva más tiempo de lo esperado.",
              },
              {
                id: "mo-1:5-c",
                da: " Antes de aceptar ayudar a alguien, consulte con su supervisor acerca de si es realista y factible hacerse cargo de la tarea. Si su supervisor desaprueba, le da un motivo legítimo para decir que no.",
              },
              {
                id: "mo-1:5-d",
                da: " Puede resultarle difícil manejar los pedidos de su supervisor. Claramente comuníquele cuando el tener trabajo adicional tendrá un impacto en otras prioridades. Por ejemplo, si su jefe quiere su ayuda en una crisis, puede tener que poner los planes en espera. Sin embargo, negocie los ítems que serán puestos en espera.",
              },
              {
                id: "mo-1:6-a",
                da: " Mantenga cerrada la puerta de su oficina si la gente habitualmente se acerca sólo para charlar. Ábrala cuando pueda o quiera interactuar. Si la gente todavía no capta el mensaje, es perfectamente aceptable informarles amablemente que no es el mejor momento para usted. Si quieren hablar de trabajo pero no es urgente, programe un horario más tarde que funcione para ambos. Si es personal,ofrézcase a mantener la conversación mientras toman café o durante un descanso.",
              },
              {
                id: "mo-1:6-b",
                da: " Si está haciendo o recibiendo una llamada, sea directo acerca de mantenerla corta y concreta. Recuérdeselo a la persona si es necesario.",
              },
              {
                id: "mo-1:6-c",
                da: " Conteste llamadas telefónicas y correos electrónicos en los momentos que le resulte conveniente en lugar de tratar de responder inmediatamente.",
              },
              {
                id: "mo-1:6-d",
                da: " Sea selectivo/a acerca de las reuniones a las que asiste. No asista a reuniones sólo porque le invitaron — ¿son realmente necesarias? ¿Puede alguien ir en su lugar,representarle e informarle? Es una excelente manera de ampliar la experiencia del personal.",
              },
              {
                id: "mo-1:6-e",
                da: " Informe a los organizadores de las reuniones que sólo puede quedarse un cierto período de tiempo y que se retirará en cuanto termine. Le ayuda a gestionar su tiempo y obliga a los demás a cumplir con el horario",
              },
            ],
          },
          {
            id: "mo-2",
            icon: require("@/assets/Iconography/Attributes/11-01_Planning Work.svg"),
            comp: "Planifica El Trabajo",
            wdd: "Identifica el alcance del proyecto, estableciendo fases y acciones claras para llegar a los objetivos definidos",
            progressMeasures: [
              {
                d: "mo-2-0",
                pm: "Evalúo la cantidad de tiempo y recursos que necesito para los procesos",
                pmMap:
                  "Evaluar la cantidad de tiempo y recursos que necesito para los procesos",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "mo-2-1",
                pm: "Me aseguro de que los recursos que necesito estén disponibles",
                pmMap:
                  "Asegurarme de que los recursos que necesito estén disponibles",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "mo-2-2",
                pm: "Documento los planes del proceso en términos de etapas, calendario, requisitos de recursos y estándares de calidad",
                pmMap:
                  "Documentar los planes del proceso en términos de etapas, calendario, requisitos de recursos y estándares de calidad",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "mo-2-3",
                pm: "Anticipo los riesgos y peligros del proceso para crear planes de contingencia",
                pmMap:
                  "Anticipar los riesgos y peligros del peoceso para crear planes de contingencia",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "mo-2-4",
                pm: "Comparo los resultados reales con los pronosticados para evaluar el desempeño del proceso y registrar las lecciones aprendidas",
                pmMap:
                  "Comparar los resultados reales con los pronosticados para evaluar el desempeño del proceso y registrar las lecciones aprendidas",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
            ],
            developmentActions: [
              {
                id: "mo-2:1-a",
                da: " Puede no tener tiempo para diseñar un plan completo en detalle, pero no tiene que hacerlo de esa manera. Delegue diferentes porciones y luego use su tiempo para combinar la información. La clave es abordar los detalles.Además de ahorrarle tiempo, la participación de los miembros del equipo puede crear un mayor respaldo para el plan.",
              },
              {
                id: "mo-2:1-b",
                da: " No reinvente la rueda cuando planifica. Familiarícese con las herramientas de planificación a su disposición que le brindan un modelo para abordar los detalles. También mire proyectos similares que hayan sido lanzados en la compañía.",
              },
              {
                id: "mo-2:1-c",
                da: " Maneje el alcance del plan de forma creciente. Prepárese en detalle para una o dos partes críticas del proceso y concentre sus esfuerzos de planificación en estas actividades primero. Cree el plan para las porciones restantes más adelante.",
              },
              {
                id: "mo-2:1-d",
                da: " Asegúrese de que haya algunas personas orientadas a los detalles en su equipo que formularán las preguntas adecuadas y le ayudarán a mantenerse concentrado/a..",
              },
              {
                id: "mo-2:1-e",
                da: " Asegúrese de tener un plan de negocios a corto plazo y a largo plazo. Tener un plan le obligará a considerar los detalles cuidadosamente..",
              },
              {
                id: "mo-2:2-a",
                da: " Al comienzo de cada proyecto, reserve tiempo para documentar su plan,incluso si es un borrador que posiblemente cambie a medida que evoluciona el proyecto..",
              },
              {
                id: "mo-2:2-b",
                da: " La documentación puede ser tan básica como un hoja de papel manuscrita, sin embargo un plan documentado en formato electrónico como un procesador de texto,planillas o software de gestión de proyectos es fácil de modificar y acceder a través de correo electrónico, carpetas compartidas, etc.",
              },
              {
                id: "mo-2:2-c",
                da: " Durante el intercambio de ideas y desarrollo inicial de su plan, pida a alguna persona que tome notas y registre detalles que luego puedan transcribirse..",
              },
              {
                id: "mo-2:2-d",
                da: " Siempre envíe correspondencia de seguimiento después de una reunión inicial para resumir el rol y las responsabilidades de cada miembro del equipo y los primeros ítems de acción. La documentación en la etapa inicial de un proceso es crítica para brindar claridad.",
              },
              {
                id: "mo-2:2-e",
                da: " Asegúrese de enviar correspondencia escrita detallando cualquier cambio en los planes a todas las partes involucradas. Hacerlo asegura que todos tengan instrucciones por escrito y que nadie quede sin informar inadvertidamente..",
              },
              {
                id: "mo-2:3-a",
                da: " Desarrolle varios métodos de planificación investigando mejores prácticas.",
              },
              {
                id: "mo-2:3-b",
                da: " Pida opiniones sobre el plan al inicio del proceso, no después de que haya sido formalizado o se hayan comprometido recursos.",
              },
              {
                id: "mo-2:3-c",
                da: " Identifique personas clave en el proceso que tengan interés en el éxito del plan e invítelos/as a formar parte de su equipo de planificación.",
              },
              {
                id: "mo-2:3-d",
                da: " Defina la meta del proceso y luego prepare una lista de todas las tareas que deben completarse, seguidas de quién debería completar cada tarea.",
              },
              {
                id: "mo-2:3-e",
                da: " Identifique tareas que pueden desempeñarse simultáneamente, y aquellas que no pueden empezarse hasta que se hayan completado una o más tareas.",
              },
              {
                id: "mo-2:3-f",
                da: " Determine los recursos requeridos, por ejemplo, tiempo del personal, fondos,equipamiento, materiales, software y espacio, así como la persona que puede autorizar el uso de cada recurso en el proceso. ¿Puede obtener todos los recursos necesarios, incluyendo el tiempo de cada miembro del personal? ¿Están estas personas y demás recursos disponibles en los intervalos requeridos por el plan?",
              },
              {
                id: "mo-2:3-g",
                da: " Identifique los riesgos, por ejemplo, cuellos de botella, proyectos en conflicto,cuestiones de programación y recursos escasos y planifique para las contingencias.",
              },
              {
                id: "mo-2:3-h",
                da: " Determine etapas y defina cómo medirá el éxito del proceso.",
              },
              {
                id: "mo-2:3-i",
                da: " Evalúe sus resultados reales frente a sus metas, por ejemplo, cumplir el calendario y el presupuesto, controles de calidad, asignación de recursos, etc.",
              },
              {
                id: "mo-2:3-j",
                da: " Converse, documente y comparta las lecciones aprendidas con su equipo y otras personas que podrían beneficiarse. Las experiencias suyas y de su equipo pueden ayudar a ahorrar tiempo de planificación, mejorar las estimaciones de los recursos y hacer predicciones más precisas de los riesgos potenciales futuros de su organización",
              },
              {
                id: "mo-2:3-k",
                da: " Celebre los logros con su equipo y brinde elogios si corresponde.",
              },
              {
                id: "mo-2:3-l",
                da: " Encuentre una persona en la organización que respete y que comparta lecciones de experiencias de trabajo y de planificación exitosas y no exitosas. Es invalorable escuchar lo que han experimentado los demás.",
              },
              {
                id: "mo-2:4-a",
                da: " Si está en una posición de liderazgo, recompense y aliente a las personas con buenas habilidades de planificación.",
              },
              {
                id: "mo-2:4-b",
                da: " Invertir tiempo en planificación marcará el ejemplo y enviará un fuerte mensaje a los demás de que es algo valorado en la organización..",
              },
              {
                id: "mo-2:4-c",
                da: " Apoye la capacitación en gestión de proyectos para sus empleados.",
              },
              {
                id: "mo-2:4-d",
                da: " Converse con su jefe y otros miembros del equipo sobre los beneficios logrados por haber planificado adecuadamente.",
              },
              {
                id: "mo-2:4-e",
                da: " Hable con su jefe acerca de su necesidad de un plan. Todas las personas tienen estilos de trabajo diferentes y algunos gerentes asumirán que usted se siente cómodo/a de operar sin un plan si no dice nada al respecto.",
              },
              {
                id: "mo-2:4-f",
                da: " Sea persistente en las conversaciones y reuniones acerca de los detalles que deben considerarse. Preséntelos de forma que constituyan un buen caso de negocios. Incluso si son pasados por alto, habrá usado su intuición para brindar información valiosa.",
              },
              {
                id: "mo-2:4-g",
                da: " Lleve un registro de las lecciones aprendidas a lo largo del proceso y pídale a su equipo que haga lo mismo. Esta práctica puede comunicarse durante una reunión inicial o través de correo electrónico y respaldarse con recordatorios por correo electrónico a su equipo.",
              },
              {
                id: "mo-2:4-h",
                da: " Formalice sesiones informativas, si es posible, y comparta las lecciones aprendidas con otras personas en la compañía para que sean consideradas antes de que otros sigan adelante con sus proyectos. Compare las metas de su plan contra los resultados reales, por ejemplo, presupuesto, calendario, objetivos por etapa, asignación de recursos, calidad, etc.",
              },
            ],
          },
        ],
      },
      sd: {
        characteristic: "Toma buenas decisiones",
        wdd: "Toma decisiones rápidas, incluso sin tener toda la información necesaria. Su buen juicio le permite tomar decisiones teniendo en cuenta tanto los hechos como la intuición. Diferencia las prioridades críticas de las tareas de menor importancia, sabe distinguir entre lo urgente y lo importante. Identifica rápidamente las fortalezas y debilidades de las personas sin necesidad de interactuar con ellas durante un largo periodo de tiempo.",
        icon: require("@/assets/Iconography/Characteristics/17_Sound Decision Maker.svg"),
        competencies: [
          {
            id: "sd-0",
            icon: require("@/assets/Iconography/Attributes/17-04_Demonstrating Good Judgement.svg"),
            comp: "Juicioso/a",
            wdd: "Su buen juicio le permite tomar decisiones teniendo en cuenta tanto los hechos como la intuición",
            progressMeasures: [
              {
                id: "sd-0-0",
                pm: "La gente me consulta acerca de desafíos y problemas",
                pmMap: "Dar buenos consejos cuando se me requieren",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "sd-0-1",
                pm: "I trust my intuition" /*not in the book*/,
                pmMap: "Confiar en mi intuición ",
              },
              {
                id: "sd-0-2",
                pm: "No me dejo influenciar indebidamente por lo que piensan los demás",
                pmMap:
                  "No dejarme influenciar indebidamente por lo que piensan los demás",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "sd-0-3",
                pm: "Considero las consecuencias cuidadosamente cuando tomo una decisión",
                pmMap:
                  "Considerar las consecuencias cuidadosamente cuando tomo una decisión",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
            ],
            developmentActions: [
              {
                id: "sd-0:1-a",
                da: " No actúe en base a su primer impulso. Es sensato salir para tomarse un descanso, ir a caminar o meditarlo con la almohada. Haga lo que tenga sentido para usted para darse tiempo para tomar una decisión juiciosa.",
              },
              {
                id: "sd-0:1-b",
                da: " Considere los múltiples escenarios potenciales y no sólo los obvios. Plantee varios escenarios posibles.",
              },
              {
                id: "sd-0:1-c",
                da: " Considere cuidadosamente cuáles serán las consecuencias de su decisión para todas las partes involucradas — usted mismo, el cliente, los miembros del equipo y su organización.",
              },
              {
                id: "sd-0:1-d",
                da: " ¿Cuáles son las consecuencias de su decisión en el corto y en el largo plazo?",
              },
              {
                id: "sd-0:1-e",
                da: " Reúna un equipo de personas para obtener perspectivas alternativas y que le ayuden a abordar el problema desglosándolo minuciosamente y desde diferentes ángulos. Conversar sobre diferentes ideas le puede ayudar a precisar las complejidades del problema.",
              } /*So we want to include questions on the actions section ? */,
              {
                id: "sd-0:1-f",
                da: " Reúna un equipo de personas para obtener perspectivas alternativas y que le ayuden a abordar el problema desglosándolo minuciosamente y desde diferentes ángulos. Conversar sobre diferentes ideas le puede ayudar a precisar las complejidades del problema.",
              },
              {
                id: "sd-0:1-g",
                da: " Busque modelos de casos con cuestiones similares y observe los paralelismos y diferencias para con su decisión.",
              },
              {
                id: "sd-0:2-a",
                da: ' Represente sus opciones visualmente, empleando herramientas tales como un diagrama de flujo o un software como Mindjet"s MindManager".',
              },
              {
                id: "sd-0:2-b",
                da: " Considere tanto las ganancias inmediatas como potenciales cuando se toma una decisión..",
              },
              {
                id: "sd-0:2-c",
                da: " Preste atención a las advertencias o banderas rojas señaladas por los demás.Regístrelas si no puede investigarlas inmediatamente, pero asegúrese de volver y considerarlas cuidadosamente.",
              },
              {
                id: "sd-0:2-d",
                da: " Pida a un colega de confianza que le ayude a recuperar el enfoque si considera que se está concentrando en información o cuestiones irrelevantes.",
              },
              {
                id: "sd-0:2-e",
                da: " Aprenda de la experiencia de otras personas. Pida a colegas o expertos que compartan experiencias que puedan tener sobre una situación similar y en qué hubieran cambiado sus decisiones de poder hacerlo.",
              },
              {
                id: "sd-0:2-f",
                da: " Sopese las opiniones de colegas de confianza. En definitiva, es su decisión, pero múltiples perspectivas pueden arrojar luz sobre cuestiones que ni siquiera ha considerado.",
              },
              {
                id: "sd-0:2-g",
                da: " No se concentre sólo en un aspecto de una situación, por ejemplo, las cuestiones técnicas. Reúna información de tantas fuentes diversas como sea posible.",
              },
              {
                id: "sd-0:2-h",
                da: " Aprenda de sus experiencias dedicando tiempo a reflexionar sobre ellas, antes,durante y después de sus tareas. Lleve un diario. ¿Qué aprendió que no había observado antes? ¿Qué le sorprendió? ¿Qué decisiones buenas se tomaron y cuáles fueron ineficaces?",
              },
              {
                id: "sd-0:2-i",
                da: " Aplique sentido común en su juicio. Quedar enredado/a en demasiados detalles o invertir tiempo yendo sólo en una dirección puede nublar su perspectiva y hacerle perder de vista una solución obvia y simple.",
              },
              {
                id: "sd-0:3-a",
                da: " Confíe en su intuición. Si ha completado las diligencias debidas y una fuerte corazonada le está guiando,su juicio es tan válido como el de otras personas.",
              },
              {
                id: "sd-0:3-b",
                da: " Limite la cantidad de personas a las cuales pide opinión a unos pocos de confianza.",
              },
              {
                id: "sd-0:3-c",
                da: " Trate de anticipar la resistencia de la gente y prepare respuestas para defender su juicio. Haber examinado cuidadosamente las objeciones posibles le permite defender su decisión con confianza.",
              },
              {
                id: "sd-0:3-d",
                da: " Cuando tome una decisión, dé un paso atrás y pregúntese si tiene sentido. Es fácil verse influenciado/a por soluciones de libro clásicas, pero pueden ser irrelevantes en el contexto de su situación.",
              },
              {
                id: "sd-0:3-e",
                da: " No pase por alto la ética de su juicio. Si siente que sus valores están comprometidos, debe explorar más la cuestión hasta que se sienta cómodo/a.",
              },
              {
                id: "sd-0:3-f",
                da: " Sea consciente de los motivos de las demás personas. Puede estar apoyando sus agendas personales sin darse cuenta.",
              },
              {
                id: "sd-0:3-g",
                da: " Una vez que haya considerado toda la información y tomado una decisión, no pida nuevamente la opinión de las demás personas. Ya lo hizo antes de tomar su decisión.",
              },
              {
                id: "sd-0:4-a",
                da: " Sea honesto/o con los demás y consigo mismo/a acerca de sus motivos personales. Eso da a los demás la oportunidad de encontrar creativamente una solución de beneficio mutuo con usted.",
              },
              {
                id: "sd-0:4-b",
                da: " Sopese cuidadosamente el valor de que sus necesidades sean satisfechas versus las consecuencias de su decisión.",
              },
              {
                id: "sd-0:4-c",
                da: " Base su juicio de una situación en la lógica en lugar de en las emociones.Independientemente de lo sólidos que sean sus motivos personales, ¿es su decisión sensata?",
              },
              {
                id: "sd-0:4-d",
                da: " Pregunte a un mentor o alguien que le conozca bien si piensa que su decisión está indebidamente influenciada por sus motivos personales.",
              },
              {
                id: "sd-0:4-e",
                da: " Pregúntese si su decisión tendrá sentido para todos los demás también. Si no es así,necesita examinar más de cerca cómo llegó a su decisión.",
              },
            ],
          },
          {
            id: "sd-1",
            icon: require("@/assets/Iconography/Attributes/17-03_Focusing on Priorities.svg"),
            comp: "Establece Prioridades",
            wdd: "Diferencia las prioridades críticas de las tareas de menor importancia, sabe distinguir entre lo urgente y lo importante",
            progressMeasures: [
              {
                id: "sd-1-0",
                pm: "Todos los días tengo una visión clara de lo que necesito lograr",
                pmMap:
                  "Tener una visión clara de lo que necesito lograr cada día",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "sd-1-1",
                pm: "Doy prioridad a actividades que son críticas para la misión y organizo mi tiempo en consecuencia",
                pmMap:
                  "Dar prioridad a actividades que son críticas para la misión y organizar mi tiempo consecuentemente",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "sd-1-2",
                pm: "No me distraigo fácilmente de mis prioridades",
                pmMap: "No distraerme de mis prioridades",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "sd-1-3",
                pm: "Puedo revisar información rápidamente para llegar al núcleo" /*not in the book*/,
                pmMap: "Revisar información rápidamente para llevar al núcleo",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
            ],
            developmentActions: [
              {
                id: "sd-1:1-a",
                da: " Realice una evaluación al fin del día durante una semana. Anote las tareas a las cuales dedica su tiempo. ¿Cuántas de estas tareas estuvieron realmente relacionadas con sus metas? ¿Qué distracciones le impidieron estar más concentrado/a? Adopte una solución para sus principales distracciones. Por ejemplo, muchas personas se distraen leyendo sus correos electrónicos. Si éste es su talón de Aquiles, permítase leer los mensajes dos veces por día únicamente y responderlos sólo cuando haya dedicado el tiempo adecuado a sus metas críticas..",
              },
              {
                id: "sd-1:1-b",
                da: " Sea creativo/a en cuanto a asegurarse de tener un espacio sin interrupciones, todos los días, para considerar cuestiones complejas y reflexionar sobre lo que se ha conversado.Por ejemplo, flexibilice su agenda y vaya a trabajar temprano o retírese tarde, mantenga su puerta cerrada para desalentar interrupciones y, en lo posible, trabaje fuera de la oficina por unas pocas horas.",
              },
              {
                id: "sd-1:1-c",
                da: " Asegúrese de no estar dedicando la mayoría de su tiempo a actividades que encuentra divertidas o fáciles. Trate de hacer primero las tareas que le resultan difíciles.",
              },
              {
                id: "sd-1:1-d",
                da: " Distinga lo que es realmente urgente. ¿Es la tarea importante para alcanzar su meta o debe hacerse para alcanzar la meta de otra persona? Delegue las tareas que deben completarse inmediatamente pero que pueden ser realizadas por otra persona.",
              },
              {
                id: "sd-1:1-e",
                da: " Amablemente retírese de conversaciones prolongadas que no conducen a ningún lado y que no están directamente relacionadas con su meta. Su tiempo y sus prioridades son tan importantes como las de la otra persona.",
              },
              {
                id: "sd-1:2-a",
                da: " Cuando examine un tema, siempre formúlese sus preguntas primero y trate de sacar sus propias conclusiones independientemente de los demás. Una vez que lo haya hecho, puede contribuir y mantenerse abierto/a a las opiniones de un grupo.",
              },
              {
                id: "sd-1:2-b",
                da: " Si se siente muy convencido/a acerca de un curso de acción pero anticipa resistencia,asegúrese de crear el respaldo adecuado para su caso. Obtenga retroalimentación de los expertos en el tema que respalden sus hallazgos o sugerencias y presente un caso bien documentado con la mayor cantidad de detalles posible.",
              },
              {
                id: "sd-1:2-c",
                da: " Defienda su posición si es necesario, incluso si le resulta incómodo a los demás. No ofrecer su aportación significa que no puede criticar los resultados si el grupo adopta un curso de acción equivocado.",
              },
              {
                id: "sd-1:2-d",
                da: " Asuma el rol de abogado del diablo. Esto le da la oportunidad de considerar y brindar una opinión discrepante y, al hacerlo, desempeñar una función clave en ayudar al grupo a considerar las alternativas.",
              },
              {
                id: "sd-1:2-e",
                da: " Acepte ayudar a alguien únicamente si puede agregarlo, razonablemente, a su carga de trabajo..",
              },
              {
                id: "sd-1:2-f",
                da: " Practique decir que no amablemente. Cuanto más lo haga más cómodo/a se sentirá poniendo límites.",
              },
              {
                id: "sd-1:3-a",
                da: " Revise su estrategia varias veces a lo largo de un proyecto para evaluar si hay cambios en los supuestos, recursos o circunstancias que requieran un ajuste en su enfoque. Esté abierto/a a la retroalimentación.",
              },
              {
                id: "sd-1:3-b",
                da: " Un rol importante de la persona que le supervisa es ayudarle a guiar los temas en los cuales usted necesita concentrarse. Periódicamente, obtenga retroalimentación acerca de si debería ajustar sus prioridades.",
              },
              {
                id: "sd-1:3-c",
                da: " No dedique todo su tiempo a un proyecto o tarea. Tome un descanso de ese proyecto o tarea y trabaje en otro tema por un rato. Alejarse de los detalles le ayuda a tener perspectiva acerca de lo que es realmente importante.",
              },
              {
                id: "sd-1:4-a",
                da: " Busque claridad y dirección antes de entrar en los detalles de cualquier proyecto. ¿Saben usted y su equipo realmente qué se supone que deben hacer? ¿Cuenta con suficientes instrucciones como para proceder por su cuenta? Defina su meta.",
              },
              {
                id: "sd-1:4-b",
                da: " Si todavía no tiene un plan de trabajo anual, reúnase con su superior para desarrollar un plan con metas y objetivos específicos. Acepte revisar su plan de trabajo ocasionalmente para realizar cualquier cambio que sea necesario.",
              },
              {
                id: "sd-1:4-c",
                da: " Si está confundido/a acerca de su progreso, pida ayuda a tiempo. Es más productivo ser honesto/a acerca de necesitar ayuda que dedicar tiempo a algo sin obtener resultados y desperdiciar tiempo y recursos yendo en la dirección equivocada",
              },
              {
                id: "sd-1:4-d",
                da: " Mantenga informado/a y actualizado/a a su superior y a los miembros de su equipo acerca de su progreso. Sin retroalimentación, puede no darse cuenta de que va en la dirección equivocada. Podría hacer esto con un correo electrónico semanal, por ejemplo.",
              },
              {
                id: "sd-1:4-e",
                da: " Resista la tentación de terminar completamente su tarea antes de conversar acerca de su progreso con alguien. Puede desperdiciar mucha energía perfeccionando algo que debe ser hecho nuevamente.",
              },
              {
                id: "sd-1:5-a",
                da: " Practique sus habilidades de delegación. Sea selectivo/a acerca de lo que realmente necesita su atención y delegue el resto a los demás. Evalúe lo importante que es una tarea. Puede que sea imposible delegar una presentación a la dirección pero ciertamente puede delegar el investigar datos para esa presentación.",
              },
              {
                id: "sd-1:5-b",
                da: " Manténgase bien informado/a acerca de la carga de trabajo de sus subordinados/as. No debería estar en una posición donde se sienta abrumado/a y los miembros del equipo o subordinados están desocupados/as.",
              },
              {
                id: "sd-1:5-c",
                da: " Evalúe y sea realista acerca de si puede realizar la tarea con su carga de trabajo actual o si debería asignarla a otra persona.",
              },
              {
                id: "sd-1:5-d",
                da: " Trabaje como un miembro del equipo en lugar de un triunfador independiente.Siempre se puede hacer más trabajo administrando, o siendo parte de un equipo colaborador.",
              },
            ],
          },
          {
            id: "sd-2",
            icon: require("@/assets/Iconography/Attributes/17-02_Recognizing Talent and Potential.svg"),
            comp: "Reconoce El Talento Y El Potencial En Las Personas",
            wdd: "Identifica rápidamente las fortalezas y debilidades de las personas sin necesidad de interactuar con ellas durante un largo periodo de tiempo",
            progressMeasures: [
              {
                id: "sd-2-0",
                pm: "Juzgar de manera correcta las fortalezas y debilidades de las demas personas",
                pmMap:
                  "Juzgar de manera correcta las fortalezas y debilidades de las demas personas",
              },
              {
                id: "sd-2-1",
                pm: "Recocer el potencial en los demás antes que ellos vean ese pontencial en si mismos/as",
                pmMap:
                  "Recocer el potencial en los demás antes que ellos vean ese pontencial en si mismos/as",
              },
              {
                id: "sd-2-2",
                pm: "Por lo general puedo obtener una lectura precisa de la gente en un corto tiempo",
                pmMap: "Hacer una lectura acertada de la gente en poco tiempo",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
              {
                id: "sd-2-3",
                pm: "Uso toda la información disponible para hacer juicios acerca de la gente",
                pmMap:
                  "Usar toda la información disponible para hacerme juicios sobre las personas",
              } /*En tu opinión, ¿cómo de grande es la brecha que hay a día de hoy entre cómo hago lo siguiente y lo bien que crees que podría llegar a hacerlo*/,
            ],
            developmentActions: [
              {
                id: "sd-2:1-a",
                da: " Consulte con el departamento de recursos humanos para asegurarse de que las competencias conductuales, las habilidades técnicas y la experiencia necesaria para el trabajo hayan sido definidas con claridad y precisión..",
              },
              {
                id: "sd-2:1-b",
                da: " Amplíe su perspectiva de cómo se ajustará una persona a una posición considerando cómo se desempeñará dentro de su contexto..",
              },
              {
                id: "sd-2:1-c",
                da: " Examine los resultados de evaluaciones tales como la retroalimentación de 360°, que puede brindar información nueva acerca de la gente. Le ofrecerá una comprensión de las fortalezas y debilidades de la persona. Hable con el departamento de recursos humanos acerca de las herramientas que puede utilizar..",
              },
              {
                id: "sd-2:1-d",
                da: " La investigación muestra que las entrevistas conductuales son las más efectivas.Aprenda acerca de este método de entrevistar y hable con alguien del departamento de Recursos Humanos si aún no se utiliza en su compañía. Lea acerca de las habilidades efectivas para entrevistar.",
              },
              {
                id: "sd-2:1-e",
                da: " Asegúrese de que su equipo esté equilibrado reclutando gente con talentos diversos.",
              },
              {
                id: "sd-2:1-f",
                da: " Participe en el proceso de contratación mismo. Le ayudará a obtener valiosa experiencia en agudizar su intuición acerca de la gente y comprender cómo formular preguntas efectivas que revelen fortalezas y debilidades.",
              },
              {
                id: "sd-2:1-g",
                da: " Asegúrese de que se apliquen rigurosos procesos, técnicas y estructuras estandarizadas durante la contratación.",
              },
              {
                id: "sd-2:2-a",
                da: " Brinde a las personas que son nuevas en sus posiciones tiempo suficiente para adaptarse dentro de su nuevo contexto antes de hacer juicios.",
              },
              {
                id: "sd-2:2-b",
                da: " Descubra el conocimiento de otras personas acerca de un empleado mediante una retroalimentación de 360° u otras herramientas de evaluación de múltiples fuentes. Es especialmente útil si alguien está recién contratado/a o fue recientemente asignado a usted.",
              },
              {
                id: "sd-2:2-c",
                da: " Hable con el departamento de recursos humanos o un consultor de PeopleTree Group acerca de la Matriz de 9 Celdas, que ayuda a predecir el desempeño. Este proceso brinda indicios acerca de cómo es probable que se desempeñe la gente en una organización.",
              },
              {
                id: "sd-2:2-d",
                da: " Aliente a los subordinados a ser honestos/as con usted. La gente a quienes se les da la oportunidad y un entorno seguro para hacerlo, compartirán información que puede ayudarle a comprender mejor sus intereses y fortalezas. Pregunte acerca de proyectos en los que han trabajado previamente y por qué fueron exitosos o no. Consulte acerca de experiencias y habilidades que puedan tener que usted no conoce. Formule preguntas abiertas acerca de lo que encuentran más desafiante o gratificante.",
              },
              {
                id: "sd-2:2-e",
                da: " Una forma efectiva de conocer las fortalezas y debilidades de alguien es asignarles posiciones que le resulten desafiantes en una variedad de áreas. Rote a la gente entre diferentes posiciones hasta que comprenda sus talentos y defectos. Evite usar repetidamente a la misma persona para llevar a cabo un conjunto determinado de tareas.",
              },
              {
                id: "sd-2:2-f",
                da: " Recolecte retroalimentación de otros gerentes con los cuales el empleado haya trabajado en el pasado. ¿Cuál es su perspectiva de las fortalezas y debilidades de lapersona? Puede darle alguna idea del desempeño de la persona en contextos diferentes.",
              },
              {
                id: "sd-2:3-a",
                da: " Aliente una cultura abierta en la cual la gente se sienta cómoda de ser honesta durante las evaluaciones.",
              },
              {
                id: "sd-2:3-b",
                da: " Recompense la consciencia de sí mismo/a y los esfuerzos de desarrollo en aquellas personas que supervisa de modo que sean más comunicativos/as acerca de sus defectos y que estén dispuestos/as a trabajar en ellos.",
              },
              {
                id: "sd-2:3-c",
                da: " Mantenga registros precisos del desempeño y comportamiento de una persona de modo que pueda respaldar una evaluación impopular con hechos, más que con opinión",
              },
              {
                id: "sd-2:3-d",
                da: " Consulte con su gerente o departamento de recursos humanos para obtener respaldo y asesoramiento si está preocupado/a acerca de una evaluación determinada que tiene que realizar.",
              },
              {
                id: "sd-2:3-e",
                da: " Asegúrese de haber establecido metas y objetivos claros para sus subordinados. Podrá usarlos como referencia para conversar si han sido alcanzados.",
              },
              {
                id: "sd-2:4-a",
                da: " No se quede en su escritorio o en la oficina todo el día. Dedique tiempo a lo largo de su día de trabajo, incluso si es sólo unos pocos minutos, a interactuar individualmente con sus subordinados o colegas.",
              },
              {
                id: "sd-2:4-b",
                da: " No se quede en su escritorio o en la oficina todo el día. Dedique tiempo a lo largo de su día de trabajo, incluso si es sólo unos pocos minutos, a interactuar individualmente con sus subordinados o colegas.",
              },
              {
                id: "sd-2:4-c",
                da: " Cuestione su comprensión de sus colegas o las personas que supervisa. Trate de describir el rol que juega cada persona en su vida laboral, por ejemplo, coordinador/a,seguidor/a, líder. Escriba exactamente lo que sabe acerca de cada persona. Seis meses después, revise la descripción para ver si difiere, considerando que les ha observado más.¿Advirtió algo que confirmó su opinión o cambió su percepción?",
              },
              {
                id: "sd-2:4-d",
                da: " Cuando sea posible, pase tiempo con colegas en entornos informales y sociales. La gente a menudo es cautelosa en el trabajo, lo que hace difícil llegar a conocerlos.",
              },
              {
                id: "sd-2:4-e",
                da: " Ofrézcase como voluntario/a para trabajar en un proyecto de equipo que le permita interactuar con otras personas regularmente.",
              },
              {
                id: "sd-2:4-f",
                da: " Almuerce con colegas. Levántese de su escritorio.",
              },
              {
                id: "sd-2:4-g",
                da: " Conviértase en un observador activo de la gente — haga algo de “avistamiento de personas”. Los humanos tienen matices que las evaluaciones no pueden detectar. Pase suficiente tiempo con colegas para poder percibir las sutilezas que les hacen únicos/as. De ser posible, dedique tiempo a conocerlos fuera del trabajo. Tomen café o asistan a eventos de la compañía juntos, por ejemplo.",
              },
              {
                id: "sd-2:5-a",
                da: " Dé una oportunidad a la gente. Reúnase con ellos/as varias veces antes de juzgar.",
              },
              {
                id: "sd-2:5-b",
                da: " Mida su impresión de alguien preguntando a los demás lo que piensan. Se verá sorprendido de escuchar opiniones bastante diferentes.",
              },
              {
                id: "sd-2:5-c",
                da: " Dedique tiempo a conocer a la gente que le cuesta más entender. ¿Qué hace que le resulten un desafío especialmente difícil? Si no hablan mucho, por ejemplo, invítelos a un ambiente donde se sientan más cómodos/as para expresarse, digamos un almuerzo o un partido de golf.",
              },
              {
                id: "sd-2:5-d",
                da: " Realice un ejercicio para comparar a la gente que conoce bien ahora con su primera impresión de ellos/as. ¿Qué es diferente? ¿Qué sabe acerca de ellos/as ahora, que no observó al principio? ¿Les interpretó bien la primera vez? ¿Si no es así, por qué no?",
              },
              {
                id: "sd-2:5-e",
                da: " Exprese por escrito cómo le interpretaría otra persona. Pregunte a los colegas su primera impresión de usted y cómo cambió.",
              },
              {
                id: "sd-2:5-f",
                da: " Si le resulta difícil descartar una primera impresión de alguien, haga una lista de todos los atributos positivos que tiene esa persona, tales como habilidades y experiencias que aportan a su equipo.",
              },
            ],
          },
          {
            id: "sd-3",
            icon: require("@/assets/Iconography/Attributes/17-01_Acting Decisively.svg"),
            comp: "Decisivo/a",
            wdd: "Toma decisiones rápidas, incluso sin tener toda la información necesaria",
            progressMeasures: [
              {
                id: "sd-3-0",
                pm: "No necesito una extensa cantidad de información para tomar una decisión",
                pmMap:
                  "No necesitar una gran cantidad de información para tomar una decisión",
              },
              {
                id: "sd-3-1",
                pm: "No postergo decisiones desagradables",
                pmMap: "No postergar decisiones desagradables",
              },
              {
                id: "sd-3-2",
                pm: "No necesito la participación de mucha gente para tomar una decisión",
                pmMap:
                  "No necesitar la participación de mucha gente para tomar una decisión",
              },
              {
                id: "sd-3-3",
                pm: "No me preocupo excesivamente acerca de las consecuencias de mi decisión",
                pmMap:
                  "No preocuparme excesivamente sobre las consecuencias de mi decisión",
              },
            ],
            developmentActions: [
              {
                id: "sd-3:1-a",
                da: " Trabaje de forma inteligente. Asigne prioridad a la información que es absolutamente necesaria y que sería bueno tener, y dedique su valioso tiempo a recolectarla.",
              },
              {
                id: "sd-3:1-b",
                da: " Divida una decisión grande en varias pequeñas. En lugar de concentrarse en obtener toda la información antes de empezar un proyecto, concéntrese en la información necesaria para tomar decisiones más pequeñas. Trate cada pequeña decisión como otra pieza de información que ha recolectado.",
              },
              {
                id: "sd-3:1-c",
                da: " Fíjese una fecha límite para la investigación y comprométase a tomar una decisión para entonces, basada en los hechos de los que dispone.",
              },
              {
                id: "sd-3:1-d",
                da: " Agudice y confíe en su intuición. En su libro Blink, Malcolm Gladwell presenta un sólido razonamiento acerca de los beneficios y la precisión involucrada en la toma de decisiones que están basadas en la intuición. Encuentre un taller que pueda ayudarle a ponerse en contacto con su intuición.",
              },
              {
                id: "sd-3:1-e",
                da: " Pregúntele a un/a colega de confianza acerca de la última decisión que tomó guiado/a por su intuición. Empezará a ver qué tan a menudo la gente de negocios confía con éxito en su intuición cuando toma decisiones.",
              },
              {
                id: "sd-3:1-f",
                da: " Practique tomar decisiones rápidas acerca de cuestiones pequeñas que tengan poca relevancia..",
              },
              {
                id: "sd-3:2-a",
                da: " Comparta su decisión con un colega de confianza para obtener confirmación. Use a la persona como una caja de resonancia o para respaldar su decisión.",
              },
              {
                id: "sd-3:2-b",
                da: " Dibuje un esquema de decisión con todos los pros y contras. Esto le ayudará a mapear sus opciones y abordar un enfoque lógico y no emocional.",
              },
              {
                id: "sd-3:2-c",
                da: " Si está retrasando una decisión, está sufriendo innecesariamente. Tarde o temprano la decisión deberá tomarse, por lo tanto, ¿por qué no hacerlo temprano? Hágalo de una vez.Comprométase a un marco de tiempo para tomar la decisión e informe a las otras personas de modo que se sienta responsable.",
              },
              {
                id: "sd-3:2-d",
                da: " Al no tomar una decisión, ya está tomando una (no hacer nada). A veces, cualquier decisión es mejor que no tomar ninguna decisión. Si está completamente confuso/a, confíe en su instinto y sígalo.",
              },
              {
                id: "sd-3:2-e",
                da: " Si está deliberando de forma irrazonable acerca de una decisión, pregúntese:“¿Tendrá esta decisión un efecto duradero en mi vida, las vidas de otros o el mundo en general?” Si la respuesta es no, puede vivir con las consecuencias de la decisión.",
              },
              {
                id: "sd-3:2-f",
                da: " Si su decisión tiene grandes consecuencias, no la aborde solo. Haga participar a otros/as interesados/as en el proceso de toma de decisiones.",
              },
              {
                id: "sd-3:2-g",
                da: " Los efectos a largo plazo de la preocupación crónica han sido bien investigados y se ha demostrado que tienen efectos negativos en su salud. Pregúntese a sí mismo/a si deliberar tanto acerca de la decisión está dañando su salud.",
              },
              {
                id: "sd-3:3-a",
                da: " Si sólo puede concentrarse en un área específica, tómese tiempo de antemano para delegar trabajo que otros podrían estar haciendo mientras tanto. La delegación permite que su proyecto avance incluso si hay contratiempos en un área.",
              },
              {
                id: "sd-3:3-b",
                da: " Aprenda a ser competente para desarrollar múltiples tareas simultáneamente. Ser bien organizado/a es clave. ¿Tiene un sistema ordenado que mantiene todas sus responsabilidades documentadas y accesibles para revisarlas diariamente? Asigne prioridades a modo de saber qué necesita su atención inmediata y qué puede esperar.Continúe asignando prioridades a medida que surgen nuevas exigencias.",
              },
              {
                id: "sd-3:3-c",
                da: " Siempre tenga en cuenta la visión global. En tanto la dirección general sea hacia adelante, es de esperar que algunos ítems tengan que suspenderse por un tiempo.",
              },
              {
                id: "sd-3:3-d",
                da: " En lugar de recompensarse una vez que haya completado un proyecto, espere hasta que haya abordado una serie de tareas dentro de marco de tiempo predefinido.",
              },
              { id: "sd-3:3-e", da: " Trabaje en equipo cuando sea posible." },
              {
                id: "sd-3:4-a",
                da: " Sea honesto/a consigo mismo/a. Pregúntese si desea involucrar a otras personas para obtener reafirmación o porque cree que agregarán valor a la  decisión.",
              },
              {
                id: "sd-3:4-b",
                da: " Si está tratando de lograr consenso, asegúrese de que únicamente los interesados correspondientes estén involucrados en las conversaciones para reducir “ruido” que produzca distracciones. Escriba una lista que especifique el valor que aportará cada persona.",
              },
              {
                id: "sd-3:4-c",
                da: " Pida opinión a otros. Dé fechas límite específicas para retroalimentación y anuncie una fecha límite final en la cual tomará su decisión. Y por supuesto, cumpla dicha fecha límite.",
              },
            ],
          },
        ],
      },
      pm: {
        characteristic: "Gestiona a otras personas",
        wdd: "Proporciona objetivos e instrucciones claras. Delega tareas y responsabilidades importantes y relevantes y otorga la autoridad necesaria para actuar. Establece medidas prácticas y relevantes para supervisar los procesos de trabajo.",
        icon: require("@/assets/Iconography/Characteristics/12_People Manager.svg"),
        competencies: [
          {
            id: "pm-0",
            icon: require("@/assets/Iconography/Attributes/12-03_Empowering People.svg"),
            comp: "Sabe Delegar",
            wdd: "Delega tareas y responsabilidades importantes y relevantes y otorga la autoridad necesaria para actuar",
            progressMeasures: [
              {
                id: "pm-0-0",
                pm: "Le doy a la gente la facultad de tomar decisiones sin mi aprobación",
                pmMap:
                  "Dar a la gente la facultad de tomar decisiones sin mi aprobación",
              },
              {
                id: "pm-0-1",
                pm: "Respaldo las decisiones tomadas por los demás",
                pmMap: "Respaldar las decisiones tomadas por los demás",
              },
              {
                id: "pm-0-2",
                pm: "Me mantengo sereno/a y tranquilizo a la gente cuando cometen errores",
                pmMap:
                  "Mantenerme sereno/a y tranquilizo a la gente cuando cometen errores",
              },
              {
                id: "pm-0-3",
                pm: "Considero cuidadosamente el tipo de recursos y respaldo que una persona puede necesitar para terminar una tarea con éxito",
                pmMap:
                  "Considerar cuidadosamente el tipo de recursos y respaldo que una persona puede necesitar para terminar una tarea con éxito",
              },
              {
                id: "pm-0-4",
                pm: "Delego responsabilidades significativas a los demás, no tareas para simplemente mantenerlos ocupados",
                pmMap:
                  "Delegar responsabilidades significativas a los demás, no tareas para simplemente mantenerlos ocupados",
              },
            ],
            developmentActions: [
              {
                id: "pm-0:1-a",
                da: " Concéntrese en el proceso y no sólo en la gente. Fije sus controles planeando bien los procesos de trabajo. Invierta tiempo de antemano en trazar horizontes temporales, metas e instrucciones claras. Una vez que haya impartido directivas, deje que la gente las siga y ponga a prueba sus controles.",
              },
              {
                id: "pm-0:1-b",
                da: " Asigne tareas que sean significativas, no sólo actividades para mantener ocupada a la gente. Asegúrese de asignar a las personas la clase de responsabilidad que marcaría una diferencia en sus carreras.",
              },
              {
                id: "pm-0:1-c",
                da: " Use herramientas de evaluación para comprender mejor el talento y las fortalezas de las personas de su equipo y delegue en consecuencia. Por ejemplo, a una persona con sólidas habilidades de persuasión se le puede asignar el liderar la fase de negociación de un proyecto.",
              },
              {
                id: "pm-0:1-d",
                da: " Pregunte a la gente que les gustaría hacer y bríndeles oportunidades para explorar ese interés.",
              },
              {
                id: "pm-0:1-e",
                da: " Delegue en forma equitativa. Examine a quién delega por lo general y por qué. Los gerentes tienden a delegar en aquellas personas que se han desempeñado bien previamente, a costa de otros que pueden desempeñarse igual de bien con algo más de guía.",
              },
              {
                id: "pm-0:1-f",
                da: " Considere el nivel de experiencia, el tiempo y los recursos disponibles cuando delegue una tarea. Asegúrese de que sus expectativas sean realistas, sobre la base de todo lo precedente, a modo de no llevar a alguien al fracaso. Las tareas imposibles no otorgan autoridad a la gente.",
              },
              {
                id: "pm-0:2-a",
                da: " Informe claramente a sus subordinados directos que usted les da potestad para tomar decisiones por su cuenta. Tener responsabilidades no otorga autoridad si uno tiene que consultar cada decisión con su gerente. Por naturaleza, la gente es prudente acerca de tomar decisiones incorrectas, por lo tanto si tienen dudas probablemente pedirán su aprobación.",
              },
              {
                id: "pm-0:2-b",
                da: " Establezca una cultura de confianza. Comunique claramente que se espera que la gente maneje su propio trabajo y que usted está disponible cuando necesiten ayuda.",
              },
              {
                id: "pm-0:2-c",
                da: " Acuerde momentos durante el proceso en los cuales revisará el trabajo de una persona. Entre tanto, absténgase de atosigarla.",
              },
              {
                id: "pm-0:2-d",
                da: " Independientemente de cuánto le gustaría que una tarea se hiciera de una determinada manera, recuerde que hay muchos enfoques. Puede aprender algo nuevo si le da libertad a alguien.",
              },
              {
                id: "pm-0:2-e",
                da: " Si no se siente cómodo/a asignándole responsabilidad a una persona, póngala en el mismo equipo con otra persona de alto desempeño. Ayúdeles a evaluar la experiencia una vez finalizado el proyecto.",
              },
              {
                id: "pm-0:2-f",
                da: " Asuma que se necesitará tiempo extra cuando alguien es nuevo/a en una tarea o está poniendo a prueba nuevas habilidades. Esto le brindará a la persona espacio para tener éxito en su tarea y aprender al mismo tiempo.",
              },
              {
                id: "pm-0:2-g",
                da: " Delegue responsabilidades significativas que tengan un impacto sustancial. Recibir tareas poco importantes constantemente es desmoralizante y contribuye poco a otorgar autoridad a la gente.",
              },
              {
                id: "pm-0:2-h",
                da: " Durante la delegación puede descubrir a alguien que no desempeña bien sus tareas en un área. Use esto como una oportunidad para descubrir sus fortalezas o encontrar las intervenciones necesarias. Si una persona desempeña el trabajo por debajo del promedio de forma constante, a pesar de sus mejores intentos, puede optar por capacitación,reasignación o despido de esa persona.",
              },
              {
                id: "pm-0:3-a",
                da: " Tome la delantera en su equipo cuando sea sensato hacerlo. No siempre es necesario esperar a que su supervisor delegue. Coordine con sus colegas qué tareas desempeñará cada uno y aliente a los demás a cultivar nuevas habilidades.",
              },
              {
                id: "pm-0:3-b",
                da: " Si es especialmente habilidoso/a en un área, invite a otros miembros del equipo a trabajar con usted en ese aspecto.",
              },
              {
                id: "pm-0:3-c",
                da: " Comparta de buena gana información o conocimientos nuevos e interesantes que haya adquirido recientemente.",
              },
              {
                id: "pm-0:3-d",
                da: " Observe a otros gerentes que sean buenos otorgando autoridad a su equipo. Observe qué hace bien la persona. Pregunte por qué a la gente le gusta trabajar con esa persona.",
              },
              {
                id: "pm-0:3-e",
                da: " Dígale a su gerente que le gustaría adquirir experiencia en manejar a otras personas y converse las oportunidades para hacerlo. Puede ser asignado/a como líder de equipo para un proyecto determinado o tal vez formar parte de un comité especial. Pida mayor autoridad en la toma de decisiones y en la delegación.",
              },
              {
                id: "pm-0:3-f",
                da: " Hay muchas oportunidades para otorgar autoridad a los demás fuera del trabajo.Practique sus habilidades para hacerlo con los miembros de su familia y a través de cualquier grupo o asociación a la que pertenezca.",
              },
            ],
          },
          {
            id: "pm-1",
            icon: require("@/assets/Iconography/Attributes/12-02_Monitoring Work.svg"),
            comp: "Gestiona El Trabajo",
            wdd: "Establece medidas prácticas y relevantes para supervisar los procesos de trabajo",
            progressMeasures: [
              {
                id: "pm-1-0",
                pm: "Defino etapas para cada objetivo significativo de un proceso",
                pmMap:
                  "Definir etapas para cada objetivo significativo de un proceso",
              },
              {
                id: "pm-1-1",
                pm: "Consulto con los miembros de mi equipo sus opiniones y percepciones acerca de cómo está avanzando el flujo de trabajo",
                pmMap:
                  "Consultar con los miembros de mi equipo sus opiniones y percepciones acerca de cómo está avanzando el flujo de trabajo",
              },
              {
                id: "pm-1-2",
                pm: "Doy retroalimentación regular a todos los miembros del equipo para que se puedan hacer ajustes a lo largo del proceso",
                pmMap:
                  "Dar retroalimentación regular a todos los miembros del equipo para que se puedan hacer ajustes a lo largo del proceso",
              },
              {
                id: "pm-1-3",
                pm: "Cuando es necesario, recalculo programaciones y redefino etapas conforme a los resultados",
                pmMap:
                  "Recalcular programaciones y redefinir etapas conforme a los resultados",
              },
              {
                id: "pm-1-4",
                pm: "Creo que es tan importante supervisar el avance del trabajo como tener un plan",
                pmMap:
                  "Supervisar el avance del trabajo respecto a lo planificado",
              },
            ],
            developmentActions: [
              {
                id: "pm-1:1-a",
                da: " Desarrolle un plan de comunicación para establecer un diálogo regular con su equipo acerca del estado del proceso y las modificaciones necesarias. Esto puede tomar la forma de correos electrónicos de actualización semanales, reuniones formales o conversaciones informales, legajos compartidos para documentos pertinentes, etc. La retroalimentación regular asegura que la gente tenga dirección a lo largo del camino.",
              },
              {
                id: "pm-1:1-b",
                da: " Busque señales menos obvias de problemas en el proceso. Por ejemplo, la gente puede estar cumpliendo los plazos pero sentir un estrés excesivo, o carecer de los recursos esenciales, lo que puede ser desmoralizante y causar agotamiento.",
              },
              {
                id: "pm-1:1-c",
                da: " Publique y distribuya un informe de avance, usando un diagrama de Gantt, una técnica de evaluación y revisión de gestión de proyectos (PERT por sus siglas en inglés) o el método del camino crítico (CPM por sus siglas en inglés) para definir hitos. Una representación visual le brinda a su equipo una forma rápida y medible de supervisar el avance.",
              },
              {
                id: "pm-1:1-d",
                da: " Asegúrese de supervisar los procesos más de cerca al principio del proyecto, hasta que se sienta cómodo/a de que todos/as comprendan sus roles y tengan una guía clara.",
              },
              {
                id: "pm-1:1-e",
                da: " Verifique que se alcancen los objetivos por etapa y que las tareas se ajusten al programa y al presupuesto.",
              },
              {
                id: "pm-1:1-f",
                da: " Asegúrese de que la gente sea honesta acerca del estado de sus tareas —pídales que le muestren el trabajo que han completado hasta el momento. La gente puede ser reacia a decirle el estado de su trabajo si están atrasados/as. Confíe en sus instintos. Puede descubrir que su equipo necesita más recursos o una mejor aclaración de las tareas",
              },
              {
                id: "pm-1:1-g",
                da: " Organice una reunión informativa para conversar sobre las lecciones aprendidas para que la gente sepa cómo trabajar de forma más efectiva en el futuro. Comparta estas lecciones con otras personas de su organización también.",
              },
              {
                id: "pm-1:2-a",
                da: " Fomente un ambiente en el cual reciba informes regularmente. Comunique a la gente que es importante que le mantengan actualizado acerca de su estado sin tener que pedir la información. Por ejemplo, pida a la gente que habitualmente le envíe breves correos electrónicos informando del estado de situación.",
              },
              {
                id: "pm-1:2-b",
                da: " Establezca sistemas que faciliten un control rápido, utilice herramientas de gestión de proyectos compartidas para revisar rápidamente en línea el estado de los hitos y presupuestos.",
              },
              {
                id: "pm-1:2-c",
                da: " Si el seguimiento es difícil de manejar por su cuenta, delegue diferentes aspectos del proceso al equipo y celebre reuniones informativas regularmente.",
              },
              {
                id: "pm-1:2-d",
                da: " Invierta más tiempo al principio del proceso, cuando se necesita más dirección, de modo que se requiera menos de su tiempo más adelante..",
              },
              {
                id: "pm-1:2-e",
                da: " Limite la cantidad de tiempo que pasa con gente que le está dando una actualización de estado. No les deje divagar o hablar acerca de cuestiones irrelevantes.",
              },
              {
                id: "pm-1:3-a",
                da: " Involúcrese en una tarea que implique planificación y ofrézcase para trabajar con su jefe u otro miembro del equipo para establecer objetivos por etapa y medidas de avance.",
              },
              {
                id: "pm-1:3-b",
                da: " Haga investigación y evalúe las mejores prácticas para controlar procesos y su mejora.",
              },
              {
                id: "pm-1:3-c",
                da: " Familiarícese con herramientas disponibles para usted, como informes de avance o gráficos (Gantt, PERT o CPM). Una vez que está familiarizado/a con las opciones,presénteselas a otras personas de modo que puedan ver el valor de utilizarlas.",
              },
              {
                id: "pm-1:3-d",
                da: " Utilice métodos no amenazadores de control al principio, como reuniones informativas, y luego introduzca prácticas más estructuradas que la gente aceptará con mayor facilidad.",
              },
              {
                id: "pm-1:3-e",
                da: " Encuentre una persona respetada en la organización que comparta sus lecciones acerca de control de flujos de trabajo exitosos y no exitosos con usted. Aunque no es sustituto de la experiencia personal, es útil escuchar lo que han experimentado otras personas.",
              },
              {
                id: "pm-1:3-f",
                da: " Documente las lecciones aprendidas de sus experiencias para su uso en el control de  procesos futuros: qué debería haber pasado, que podría haberse evitado o hecho de forma diferente.",
              },
            ],
          },
          {
            id: "pm-2",
            icon: require("@/assets/Iconography/Attributes/12-01_Directing People.svg"),
            comp: "Dirige A Las Personas",
            wdd: "Proporciona objetivos e instrucciones claras",
            progressMeasures: [
              {
                id: "pm-2-0",
                pm: "La gente es capaz de seguir mis instrucciones",
                pmMap:
                  "Proveer de instrucciones claras que resulten fáciles de seguir",
              },
              {
                id: "pm-2-1",
                pm: "Rara vez las personas comprenden mal lo que quiero o necesito de ellas",
                pmMap:
                  "Me explico bien, de manera que rara vez las personas no entienden lo que quiero o necesito de ellas",
              },
              {
                id: "pm-2-2",
                pm: "Cuando doy instrucciones, formulo preguntas para asegurarme de que fueron comprendidas",
                pmMap:
                  "Formular preguntas para asegurarme de que mis instrucciones han quedado claras",
              },
              {
                id: "pm-2-3",
                pm: "Me siento cómodo/a interviniendo para dar indicaciones",
                pmMap: "Sentirme cómodo/a interviniendo para dar indicaciones",
              },
              {
                id: "pm-2-4",
                pm: "No espero hasta que la gente esté teniendo dificultades para darles indicaciones",
                pmMap:
                  "No esperar hasta que la gente esté teniendo dificultades para darles indicaciones",
              },
            ],
            developmentActions: [
              {
                id: "pm-2:1-a",
                da: " Trate de motivar a la gente mientras les da instrucciones. Dé indicaciones de forma entusiasta y señale la ventaja de hacer las cosas de una manera determinada..",
              },
              {
                id: "pm-2:1-b",
                da: " Sea lo más inclusivo/a posible cuando dé indicaciones, especialmente cuando haya personas involucradas que sean antagonistas. Acepte sus sugerencias y comuníqueles que su aportación es valiosa.",
              },
              {
                id: "pm-2:1-c",
                da: " Observe su tono de voz y gestos para asegurarse de no parecer autoritario/a. Esto es especialmente importante si está incómodo/a o tenso/a. Una persona estresada a menudo trasmite el mensaje incorrecto de forma inadvertida.",
              },
              {
                id: "pm-2:1-d",
                da: " Por su propia naturaleza, algunas personas son intimidantes. Si tiene que dar indicaciones, dedique tiempo a conocer a las personas a nivel individual. Le ayudará a establecer una conexión con ellos/as que posiblemente disipe algunas de sus ideas preconcebidas.",
              },
              {
                id: "pm-2:1-e",
                da: " Si la gente se pone a la defensiva mientras recibe instrucciones, manténgase sereno/a y no se tome las cosas de forma personal. La meta es hacerlos avanzar de forma productiva y con un estado de ánimo adecuado. Trate de descubrir qué los pone a la defensiva hablando en privado con cada persona. Ignorar su actitud no la hará desaparecer y le resultará cada vez más difícil brindar indicaciones sin encontrar resistencia. Demuéstrele a la gente que le importa el hecho de que algo los está molestando.",
              },
              {
                id: "pm-2:2-a",
                da: " Programe tiempo para acercarse a cada persona periódicamente, incluso si no le piden ayuda.",
              },
              {
                id: "pm-2:2-b",
                da: " Nunca suponga que todos trabajan bien de forma independiente. Algunas personas simplemente requieren más indicaciones que otras y cuando las obtienen se desempeñan bien.",
              },
              {
                id: "pm-2:2-c",
                da: " Dedique tiempo a conocer a su equipo. La gente tiene diferentes estilos y necesidades y cuanto más los conozca mejor comprenderá su posición.",
              },
              {
                id: "pm-2:2-d",
                da: " Sea realista acerca de las personas que supervisa. Tenga en cuenta no sólo sus personalidades sino también sus experiencias, habilidades y nivel de madurez. Por ejemplo, es probable que una persona nueva en una posición requiera más indicaciones que un empleado experimentado.",
              },
              {
                id: "pm-2:2-e",
                da: " Reúna personas más experimentadas con los empleados nuevos para maximizar la cantidad de indicaciones que reciben.",
              },
              {
                id: "pm-2:2-f",
                da: " Aproveche los instrumentos de evaluación tales como retroalimentación de 360° o la evaluación de personalidad de Birkman para obtener una mejor comprensión de la gente con la que trabaja o supervisa.",
              },
              {
                id: "pm-2:2-g",
                da: " Sea accesible. Cuando la gente pide ayuda, asegúrese de brindarles el tiempo adecuado y sea paciente con sus preguntas.",
              },
              {
                id: "pm-2:3-a",
                da: " Primero delegue aquellas tareas que necesiten la menor cantidad de instrucciones y respaldo de su parte. Califique las tareas de acuerdo con una escala de menor a mayor dirección requerida por su parte y resuélvalas en ese orden.",
              },
              {
                id: "pm-2:3-b",
                da: " Evite dedicar tiempo a repetir instrucciones. Confirme que sus instrucciones fueron comprendidas — pida a la persona que resuma lo que tiene que hacer.",
              },
              {
                id: "pm-2:3-c",
                da: " Dé indicaciones y preserve el tiempo simultáneamente. Por ejemplo, deje que un subordinado lo observe y dé instrucciones a otras personas a medida que desempeña la tarea.",
              },
              {
                id: "pm-2:3-d",
                da: " Esté preparado para recibir preguntas y retroalimentación y no se ponga a la defensiva o agresivo/a. La gente se abstendrá de formular preguntas que podrían aclarar la confusión.",
              },
              {
                id: "pm-2:3-e",
                da: " Incluya dirigir a otras personas como una de sus medidas de desempeño. Le ayudará a priorizar el tiempo para hacerlo.",
              },
              {
                id: "pm-2:3-f",
                da: " Include directing others as one of your performance measures. It will help you to prioritize time to do it.",
              },
              {
                id: "pm-2:4-a",
                da: " Nunca suponga que sus instrucciones son perfectamente claras. Pregunte si la gente le comprendió. Obtenga retroalimentación acerca de la calidad de sus instrucciones.",
              },
              {
                id: "pm-2:4-b",
                da: " Asegúrese de destacar y enfatizar los puntos clave.",
              },
              {
                id: "pm-2:4-c",
                da: " Adapte su estilo de dirección a la persona o audiencia. Un enfoque que sea igual para todos no es una táctica adecuada. Considere los estilos de trabajo, el nivel de experiencia y las habilidades de la gente. Las personas captan los conceptos de forma diferente, por lo tanto considere cómo los explica. Una conversación puede resultar mejor para una persona elocuente, pero una planilla puede funcionar mejor para una persona metódica. Un ingeniero experimentado, por ejemplo, puede sólo tener que comprender el objetivo general, mientras que un empleado recién contratado necesitaría instrucciones detalladas.Además, considere las competencias de la gente. Algunas personas se sienten más cómodas con la ambigüedad o son más ingeniosos que los demás y requieren menos instrucciones.",
              },
              {
                id: "pm-2:4-d",
                da: " Comunique el plan maestro — explíquelo. Prepare un plan del proyecto con tareas y fechas límites para brindar dirección al equipo. Le permite dar un marco a las conversaciones acerca del progreso y puede dirigir a los colegas de una forma estructurada.",
              },
              {
                id: "pm-2:4-e",
                da: " Comprenda el problema o tarea y sus objetivos. Dedique tiempo a organizar sus pensamientos e instrucciones.",
              },
              {
                id: "pm-2:4-f",
                da: " Asegúrese de atenerse a lo planeado y no apartarse. Demasiada información y muchas tangentes confundirán a la gente y enturbiarán las aguas.",
              },
              {
                id: "pm-2:4-g",
                da: " Controle hacia dónde va su atención. Si está preocupado/a con múltiples temas a la vez, la dirección que está brindando puede verse comprometida. Repita lo que la persona e preguntó. Apague su celular y use un espacio privado para minimizar las distracciones.Debe concentrarse en dar instrucciones relevantes y significativas.",
              },
              {
                id: "pm-2:4-h",
                da: " Comunique instrucciones tanto verbalmente como por escrito. Las instrucciones impresas aseguran que la gente sepa lo que usted quiere y limita los ítems desatendidos. En lo posible, redacte sus instrucciones a la gente en un correo electrónico o memo, o pídales que tomen nota.",
              },
            ],
          },
        ],
      },
      sn: {
        characteristic: "Crea conexiones sociales",
        wdd: "Es una persona cooperadora y adopta una actitud de colaboración cuando trabaja con más gente. Se relaciona con los clientes asegurándose de que se cubran sus necesidades y de que se cumplan o se excedan sus expectativas. Establece y maneja activamente contactos importantes dentro y fuera de la organización. Comparte la cantidad apropiada de informacion personal con los demás para permitir que le conozcan. Tiene una buena relación de trabajo con la persona a la que reporta.",
        icon: require("@/assets/Iconography/Characteristics/16_Social Networker.svg"),
        competencies: [
          {
            id: "sn-0",
            icon: require("@/assets/Iconography/Attributes/16-05_Collaborating With Others.svg"),
            comp: "Trabaja Bien En Equipo",
            wdd: "Es una persona cooperadora y adopta una actitud de colaboración cuando trabaja con más gente",
            progressMeasures: [
              {
                id: "sn-0-0",
                pm: "Busco metas comunes entre las mías y las de los demás",
                pmMap: "Buscar metas comunes entre las mías y las de los demás",
              },
              {
                id: "sn-0-1",
                pm: "Me gusta compartir lo que sé",
                pmMap: "Compartir lo que sé",
              },
              {
                id: "sn-0-2",
                pm: "No retengo recursos o información para ganar ventaja sobre los miembros de mi equipo",
                pmMap:
                  "No retener recursos o información para ganar ventaja sobre los miembros de mi equipo",
              },
            ],
            developmentActions: [
              {
                id: "sn-0:1-a",
                da: " Propóngase brindar reconocimiento a los demás. Reconozca cada vez que el grupo u otra persona ha hecho algo bien..",
              },
              {
                id: "sn-0:1-b",
                da: " Comparta información libremente. Considere qué ha retenido o sobre qué se ha sentido posesivo/a previamente y por qué. ¿Cómo se sentiría si no le brindaran información importante necesaria para hacer su trabajo?",
              },
              {
                id: "sn-0:1-c",
                da: " Delegue o comparta trabajo de modo que los demás también puedan recibir reconocimiento por sus esfuerzos.",
              },
              {
                id: "sn-0:1-d",
                da: " Mida su comportamiento competitivo preguntándose si sus acciones principalmente le sirven a usted o a la organización.",
              },
              {
                id: "sn-0:2-a",
                da: " Explore cualquier prejuicio oculto que pueda tener. Indique qué le incómoda al colaborar con esta persona o grupo. ¿Es persona, algo que él/ella ha hecho personalmente, o algo que usted asocia con la persona? ¿Basa sus sentimientos negativos en hechos o en opiniones?",
              },
              {
                id: "sn-0:2-b",
                da: " Empiece obteniendo consenso acerca de la meta común. Es una forma poderosa de crear unidad a pesar de las diferencias.",
              },
              {
                id: "sn-0:2-c",
                da: " Concéntrese en las similitudes más que en las diferencias entre las partes involucradas.",
              },
              {
                id: "sn-0:2-d",
                da: " Haga una lista de las fortalezas y los recursos que se pondrán de manifiesto trabajando con este grupo en particular. Le ayudará a ver el valor agregado.",
              },
              {
                id: "sn-0:2-e",
                da: " No suponga que la gente siempre es la misma y dé a una persona o grupo nuevo el beneficio de la duda. Puede haber tenido una mala experiencia antes con gente de un grupo específico — tal vez alguien cometió un error o sus estilos de trabajo eran incompatibles — pero empiece con la mente abierta.",
              },
              {
                id: "sn-0:2-f",
                da: " Si se presenta la oportunidad, trate de conocer a la gente con la cual trabaja a nivel personal.",
              },
              {
                id: "sn-0:3-a",
                da: " Practique sus habilidades de colaboración trabajando con pequeños grupos al principio. Aborde los proyectos con una o dos personas y luego pase a grupos de trabajo o comités más grandes.",
              },
              {
                id: "sn-0:3-b",
                da: " Trabajar con los demás puede llevar más tiempo, pero considere la calidad del resultado y lo que puede aprender debido a su colaboración.",
              },
              {
                id: "sn-0:3-c",
                da: " Cuando un esfuerzo de grupo está terminado, dedique tiempo a pensar acerca de lo que no podría haber logrado por sí solo/a.",
              },
              {
                id: "sn-0:3-d",
                da: " Ofrezca su ayuda a los demás. Ayudar a otras personas beneficia al conjunto e nvariablemente, en algún momento descubrirá que necesita la ayuda de otras personas.",
              },
              {
                id: "sn-0:3-e",
                da: " Intente ser accesible a los demás. Un estilo interpersonal cálido puede hacer mucho por aliviar la tensión de la gente y apaciguar las emociones. Si parece demasiado independiente y desinteresado/a en los demás, tendrá que combatir esa percepción cuando llegue el momento de colaborar con ellos.",
              },
              {
                id: "sn-0:3-f",
                da: " Practique pedirle a los demás sus opiniones en lugar de decirles cómo deben hacerse las cosas. Sea el/la primero/a en escuchar y el/la último/a en comentar.",
              },
              {
                id: "sn-0:3-g",
                da: " Aproveche la oportunidad de actuar como mentor o trabajar con alguien que se esfuerza y es menos experimentado/a que usted.",
              },
            ],
          },
          {
            id: "sn-1",
            icon: require("@/assets/Iconography/Attributes/16-04_Focusing On Customers.svg"),
            comp: "Orientado/a Al Cliente",
            wdd: "Se relaciona con los clientes asegurándose de que se cubran sus necesidades y de que se cumplan o se excedan sus expectativas",
            progressMeasures: [
              {
                id: "sn-1-0",
                pm: "Tengo a mis clientes en mente cuando tomo mis decisiones",
                pmMap: "Tener a mis clientes en mente cuando tomo decisiones",
              },
              {
                id: "sn-1-1",
                pm: "Satisfacer a mis clientes es una prioridad",
                pmMap:
                  "Pensar en la satisfación de mis clientes como un prioridad",
              },
              {
                id: "sn-1-2",
                pm: "Solicito información de mis clientes que me ayuda a mejorar mi servicio",
                pmMap:
                  "Solicitar información de mis clientes que me ayude a mejorar mi servicio",
              },
            ],
            developmentActions: [
              {
                id: "sn-1:1-a",
                da: " Tal vez deba examinar emociones e información irrelevante antes de poder brindar una solución deseable a su cliente. Escuche cuidadosamente y reformule el pedido del cliente para asegurarse de haber comprendido el problema correctamente. Esto podría llevar un tiempo porque el cliente incluso podría no saber lo que necesita.",
              },
              {
                id: "sn-1:1-b",
                da: " Manténgase paciente y calmado/a, aún más allá de lo que podría considerarse razonable. Su primera respuesta definirá el tono del resto de la conversación. La paciencia le permite escuchar al cliente de forma adecuada y evitar conclusiones incorrectas.",
              },
              {
                id: "sn-1:1-c",
                da: " Póngase en el lugar del cliente y trate de identificarse con los motivos por los cuales está disgustado/a. Reformule su problema para informarles que comprendió. Tal vez se ponga a la defensiva al principio, pero si puede comprender por qué el cliente se está sintiendo de cierta manera, le ayudará a manejar sus emociones de forma más efectiva.",
              },
              {
                id: "sn-1:1-d",
                da: " Sea creativo con sus soluciones. Puede haber políticas y procedimientos estrictos para ayudar al cliente, pero las alternativas creativas a menudo pueden satisfacer sus necesidades. La gente apreciará y recordará que usted se haya esforzado en satisfacerles.",
              },
              {
                id: "sn-1:1-e",
                da: " Tal vez sus procesos o productos necesitan mejora y no la actitud de su cliente. Haga seguimiento de pedidos repetidos de clientes y use la información para mejorar cuando sea necesario.",
              },
              {
                id: "sn-1:1-f",
                da: " Si la relación con su cliente está costando más que el beneficio que crea, considere los pros y contras de continuar esa relación. A veces continuar no justifica los recursos empleados.",
              },
              {
                id: "sn-1:2-a",
                da: " Esté bien atento/a a la información que puede ayudarle a anticipar necesidades futuras. Genere a menudo conversaciones con sus clientes acerca de los cambios que experimenta su mercado y el impacto que tendrán sobre ellos. Estas conversaciones pueden llevar a ideas para nuevos productos o servicios en las que no hubiera pensado sin escuchar sus necesidades.",
              },
              {
                id: "sn-1:2-b",
                da: " Programe en su calendario visitas a clientes como parte de sus responsabilidades.Ocúpese de sus clientes habitualmente.",
              },
              {
                id: "sn-1:2-c",
                da: " Si es conveniente, use técnicas de retroalimentación formales tales como cuestionarios para recolectar información acerca de las necesidades de sus clientes.",
              },
              {
                id: "sn-1:2-d",
                da: " Utilice grupos concentrados en los clientes y retroalimentación para poner a prueba las ideas antes de invertir demasiado tiempo y recursos.",
              },
              {
                id: "sn-1:2-e",
                da: " Pregunte a sus clientes acerca de los aspectos que les gustan y que no les gustan acerca de sus productos o servicios y sus procesos.",
              },
              {
                id: "sn-1:3-a",
                da: " Familiarícese con la cartera de clientes de la compañía y los cambios en las tendencias que afectarán a los perfiles de los clientes, así como también los nuevos clientes a los cuales la compañía puede estar apuntando en el futuro.",
              },
              {
                id: "sn-1:3-b",
                da: " Trate de identificar y mejorar cualquier proceso que tenga un impacto en el cliente.",
              },
              {
                id: "sn-1:3-c",
                da: " Usted tiene clientes externos e internos. Examine la calidad de su relación con la gente en otros departamentos que cuentan con usted para obtener información o para hacer su trabajo.",
              },
              {
                id: "sn-1:4-a",
                da: " Investigue cómo puede reorganizar su trabajo para tener tiempo de atender a sus clientes.",
              },
              {
                id: "sn-1:4-b",
                da: " Asegúrese de que los clientes puedan comunicarse con usted. Brinde suficientes medios para que puedan ponerse en contacto con usted en todo momento y deles alternativas si está fuera de la oficina a menudo.",
              },
              {
                id: "sn-1:4-c",
                da: " Establezca una política para tiempos de respuesta aceptables y controle en qué medida usted y su equipo los cumplen.",
              },
              {
                id: "sn-1:4-d",
                da: " Si absolutamente no hay tiempo disponible para manejar las relaciones con sus clientes, hable con la persona adecuada para que le ayude a redefinir las prioridades y le asista con su carga de trabajo.",
              },
              {
                id: "sn-1:5-a",
                da: " Aplique el mismo conjunto de estándares a los clientes nuevos y los `existentes.",
              },
              {
                id: "sn-1:5-b",
                da: " ¿Cuáles son los valores de la compañía? ¿Su comportamiento es compatible con los valores de la compañía?",
              },
              {
                id: "sn-1:5-c",
                da: " Forme equipo con otras personas que puedan ayudarlo a manejar las necesidades constantes de los clientes si, por ejemplo, usted debe concentrarse en aumentar la cartera de clientes. Incluso si le retiran de las responsabilidades de seguimiento, ocasionalmente revise la situación del cliente. Si cerró el negocio, su nombre y su reputación siempre estarán vinculados a ese cliente.",
              },
              {
                id: "sn-1:5-d",
                da: " Sopese las consecuencias de ampliar versus simplemente brindar los servicios prometidos a su cartera de clientes existentes y nuevos. ¿Qué tipo de recursos e inversiones adicionales serán necesarias para respaldar el crecimiento? ¿Es la satisfacción del cliente una prioridad tanto como la ganancia? Ambas son interdependientes.",
              },
              {
                id: "sn-1:5-e",
                da: " Trate de dedicar el mismo o mayor interés y orgullo no sólo a ganarse al cliente sino también a mantenerlo satisfecho en el largo plazo. Lo último probablemente sea un desafío más grande.",
              },
            ],
          },
          {
            id: "sn-2",
            icon: require("@/assets/Iconography/Attributes/16-03_Building A Personal Network.svg"),
            comp: "Tiene Facilidad Para Establecer Relaciones",
            wdd: "Establece y maneja activamente contactos importantes dentro y fuera de la organización",
            progressMeasures: [
              {
                id: "sn-2-0",
                pm: "Me mantengo en contacto regular con las personas clave",
                pmMap:
                  "Mantenerme en contacto con personas clave en dentro y fuera de la organización",
              },
              {
                id: "sn-2-1",
                pm: "Activamente busco oportunidades para hacer asociaciones",
                pmMap:
                  "Busca activamente oportunidades para generar nuevos contactos",
              },
              {
                id: "sn-2-2",
                pm: "Aprovecho las herramientas para establecer contactos disponibles en la comunidad de internet",
                pmMap:
                  "Aprovechar las herramientas en internet como las redes sociales para establecer nuevos contactos ",
              },
            ],
            developmentActions: [
              {
                id: "sn-2:1-a",
                da: " Prepare una lista de algunas personas a las que le gustaría conocer y piense acerca de lo que estaría en condiciones de ofrecerles. Comuníquese con ellos para ofrecer su ayuda.",
              },
              {
                id: "sn-2:1-b",
                da: " Establezca contactos con los amigos cercanos y la familia primero. Puede sentirse más cómodo/a haciendo esto en primer lugar con gente que conoce.",
              },
              {
                id: "sn-2:1-c",
                da: " Concéntrese en su meta. No estaría pidiendo ayuda si no fuera importante para usted.Comparta su propósito con la persona y hágalos entusiasmarse con su causa.",
              },
              {
                id: "sn-2:2-a",
                da: " Utilice su horario de almuerzo para establecer contactos. La gente pierde excelentes oportunidades de hablar con los demás porque están casados con sus escritorios. Todos tienen que comer y es mejor hacerlo donde tenga la oportunidad de encontrarse con otras personas.",
              },
              {
                id: "sn-2:2-b",
                da: " Asegúrese de tratar de hablar con la mayor cantidad de gente posible durante reuniones sociales o eventos. Tendemos a acercarnos a aquellas personas que ya conocemos. Tiene tiempo suficiente para hablar con sus colegas y amigos, por lo tanto en cambio diríjase a personas que nunca conoció.",
              },
              {
                id: "sn-2:2-c",
                da: " Comprométase a conocer una persona nueva por mes en su organización.Familiarícese con su función o rol en la compañía.",
              },
              {
                id: "sn-2:2-d",
                da: " Asista a asociaciones profesionales que le permitan conocer a otras personas de su industria.",
              },
              {
                id: "sn-2:2-e",
                da: " Aproveche las herramientas para establecer contactos basadas en Internet tales como LinkedIn o incluso Facebook.",
              },
              {
                id: "sn-2:3-a",
                da: " Hable con colegas de confianza o con las personas relevantes acerca de la estructura de su compañía y trate de obtener un conocimiento de primera mano acerca de las percepciones que tiene la gente de aquellos que usted identifica como importantes.",
              },
              {
                id: "sn-2:3-b",
                da: " Cree una lista de personas tanto dentro como fuera de su organización que considera que es importante conocer. Piense acerca de la gente en la compañía con influencia acerca de cómo y por qué se toman las decisiones. ¿Quién, a su vez, tiene influencia en ellos? Identifique formas de ponerse en contacto con ellos, o si es adecuado, con gente cercana a ellos. Fíjese como meta recorrer toda su lista en un período determinado.",
              },
              {
                id: "sn-2:3-c",
                da: " Seleccione unas pocas asociaciones profesionales claves en las cuales inscribirse que le darán acceso a expertos y personas influyentes en su campo.",
              },
              {
                id: "sn-2:3-d",
                da: " Dedique tiempo a conocer las habilidades y capacidades de la gente — ¿Quién sabe qué? Averigüe quiénes son los expertos en diversos campos en su compañía. Sabrá a quien llamar acerca de diferentes temas y puede pedir ayuda, si fuera necesario. Un experto puede ahorrarle mucho tiempo identificando el núcleo del problema y ofreciendo soluciones que han funcionado bien previamente.",
              },
              {
                id: "sn-2:3-e",
                da: " Identifique personas en su compañía con recursos que puedan compartir cuando usted necesita ayuda con más gente o restricciones de tiempo. Habiendo hecho el esfuerzo de establecer buenas relaciones con las personas, estará en una mejor posición de pedir un favor cuando lo necesite.",
              },
              {
                id: "sn-2:3-f",
                da: " Las asociaciones estratégicas son una forma efectiva de obtener ventaja a través de recursos. Establecer contactos le permite conocer a quién más podría considerar usted que se beneficiaría con sus recursos, ahora o en el futuro. Esté atento/a a dónde podrían existir esas asociaciones.",
              },
              {
                id: "sn-2:3-g",
                da: " No pase por alto su círculo interno de colegas, familiares y amigos.",
              },
            ],
          },
          {
            id: "sn-3",
            icon: require("@/assets/Iconography/Attributes/16-02_Being Open.svg"),
            comp: "Comparte Información Personal",
            wdd: "Comparte la cantidad apropiada de informacion personal con los demás para permitir que le conozcan",
            progressMeasures: [
              {
                id: "sn-3-0",
                pm: "Me siento cómodo/a compartiendo información personal en el lugar de trabajo",
                pmMap:
                  "Sentirme cómodo/a compartiendo información personal con otras personas",
              },
              {
                id: "sn-3-1",
                pm: "Dedico tiempo a interactuar socialmente con la gente del trabajo",
                pmMap:
                  "Dedicar tiempo a interactuar socialmente con la gente del trabajo",
              },
              {
                id: "sn-3-2",
                pm: "Aliento a las personas a ser abiertas conmigo",
                pmMap: "Alentar a las personas a ser abiertas conmigo",
              },
            ],
            developmentActions: [
              {
                id: "sn-3:1-a",
                da: " Usar el humor es una forma segura de ser abierto/a ademas puede hablar de algunas de sus debilidades. La gente por lo general participará con sus propias historias.",
              },
              {
                id: "sn-3:1-b",
                da: " Concéntrese en compartir las cosas positivas de su vida en lugar de las negativas.",
              },
              {
                id: "sn-3:1-c",
                da: " Use su apertura para ayudar a los demás a aprender. Comparta su intuición personal acerca de las decisiones buenas y menos positivas que ha tomado en su carrera.",
              },
              {
                id: "sn-3:1-d",
                da: " Piense acerca de la gente que es abierta con usted. ¿La respeta menos por eso?",
              },
              {
                id: "sn-3:2-a",
                da: " Tome un descanso o dos cada día simplemente para charlar con la gente y decirles algo no relacionado con el trabajo. Póngase como meta hacer sentir cómodos/as a los demás. Formule preguntas personales o comparta una historia personal o una sonrisa.",
              },
              {
                id: "sn-3:2-b",
                da: " Programe tiempo en su calendario para asistir a eventos, funciones, almuerzos, etc.para compartir un tiempo personal con la gente.",
              },
              {
                id: "sn-3:2-c",
                da: " Use su apertura para ayudar a los demás a aprender en el lugar de trabajo. Comparta su intuición acerca de las decisiones buenas y menos positivas que ha tomado en su carrera.",
              },
              {
                id: "sn-3:3-a",
                da: " Si usted está incómodo con la apertura, empiece compartiendo información acerca de temas neutros tales como sus pasatiempos.",
              },
              {
                id: "sn-3:3-b",
                da: " ¿Qué le gustaría saber acerca de otras personas? Si inicia la conversación y permite que la otra persona comparta primero, puede sentirse menos cauteloso/a.",
              },
              {
                id: "sn-3:3-c",
                da: " Trate de compartir algo acerca de sí mismo/a con alguna persona en el trabajo una vez por semana.",
              },
              {
                id: "sn-3:3-d",
                da: " ¿Cómo de abierto/a es usted en su vida privada? Pida opinión a su pareja. A menudo es más fácil practicar el ser más abierto/a con su familia primero y luego con sus colegas.",
              },
              {
                id: "sn-3:4-a",
                da: " Empiece tratando de entablar conversación con la otra persona con preguntas casuales, por ejemplo, “¿Qué tal le pareció ese restaurante donde fuimos a almorzar todos?” o “¿Sale a comer a menudo?” Si la persona es receptiva, continúe la conversación.",
              },
              {
                id: "sn-3:4-b",
                da: " Asegúrese de no estar compartiendo información que puede poner incómoda a la persona. Observe la reacción a lo que dijo. ¿Hay un cambio en un tono de voz? ¿Inmediatamente se queda callado/a o cambia su comportamiento o el tema?",
              },
              {
                id: "sn-3:4-c",
                da: " Observe a un colega respetado que sea querido/a por todos y con quien la gente se abra fácilmente. ¿Qué tipo de información comparte esa persona?",
              },
              {
                id: "sn-3:4-d",
                da: " Pregunte a un colega de confianza si sus comentarios son adecuados.",
              },
              {
                id: "sn-3:4-e",
                da: " Sea consciente del tiempo de la gente y sus agendas ocupadas. Puede ser que quieran escuchar, pero tal vez no por tanto tiempo.",
              },
              {
                id: "sn-3:4-f",
                da: " Nunca comparta información acerca de sí mismo/a que siente que luego puede lamentar. La apertura no es una confesión.",
              },
              {
                id: "sn-3:4-g",
                da: " A menos que sea un colega de confianza, no comparta información acerca de sí mismo/a que quiere que la gente mantenga confidencial. Les da una responsabilidad injusta proteger lo que les contó. También es probable que los ponga incómodos/as.",
              },
              {
                id: "sn-3:4-h",
                da: " La comunicación no verbal es clave cuando se comparte información. Asegúrese de ser sincero acerca de compartir una historia y de dar esa impresión. Haga contacto visual directo, no conteste el teléfono durante la conversación, etc.",
              },
            ],
          },
          {
            id: "sn-4",
            icon: require("@/assets/Iconography/Attributes/16-01_Working Well With Authority.svg"),
            comp: "Tiene Una Buena Relación Con Su Jefe",
            wdd: "Tiene una buena relación de trabajo con la persona a la que reporta",
            progressMeasures: [
              {
                id: "sn-4-0",
                pm: "Soy honesto/a con mi jefe/a acerca de los problemas",
                pmMap:
                  "Ser honesto/a y abierto/a con las personas con más autoridad que yo sobre cuestiones delicadas o problemas ",
              },
              {
                id: "sn-4-1",
                pm: "No me pongo a la defensiva cuando mi jefe/a me da retroalimentación negativa",
                pmMap:
                  "No ponerme a la defensiva cuando alguien con más autoridad que yo me da retroalimentación negativa",
              },
              {
                id: "sn-4-2",
                pm: "Trato a mi jefe/a con respeto",
                pmMap:
                  "Respetar a las personas que tienen más autoridad que yo",
              },
            ],
            developmentActions: [
              {
                id: "sn-4:1-a",
                da: " Juzgue a su jefe/a por el desempeño general, no por la profundidad de sus conocimientos técnicos.",
              },
              {
                id: "sn-4:1-b",
                da: " Sea realista acerca de comparar a su jefe/a con otras personas. Usted puede haber trabajado arduamente en especializarse en un área y desarrollado experiencia en ella, o previamente haber tenido un jefe/a que era un experto técnico, pero puede no ser necesario ahora para su jefe/a hacer ese trabajo bien.",
              },
              {
                id: "sn-4:1-c",
                da: " En lugar de criticar o juzgar, encuentre maneras de usar sus conocimientos técnicos para que su jefe/a y el equipo sean más exitosos.",
              },
              {
                id: "sn-4:1-d",
                da: " Comparta literatura o experiencias que ha encontrado útiles para ampliar sus conocimientos técnicos con su jefe/a.",
              },
              {
                id: "sn-4:1-e",
                da: " Pida a su jefe/a que identifique a expertos técnicos en la compañía de quienes usted y su equipo puedan obtener una guía si él o ella no pueden responder sus preguntas.",
              },
              {
                id: "sn-4:1-f",
                da: " Mejore su propia experiencia técnica para no tener que depender de su jefe/a.",
              },
              {
                id: "sn-4:1-g",
                da: " Aprenda lo más posible de las fortalezas de su jefe/a en lugar de concentrarse en las debilidades.",
              },
              {
                id: "sn-4:2-a",
                da: " Mantenga una conversación honesta con su jefe/a acerca de su estilo de trabajo preferido y la guía que necesita para lograr el mejor desempeño. Este tipo de retroalimentación ayudará a su jefe/a a comprender el enfoque con el cual usted se siente más cómodo. Sea lo más específico/a posible y cite ejemplos de cuándo el estilo de su jefe/a hizo las cosas desafiantes para usted. El objetivo es comprender la mejor manera de trabajar juntos.",
              },
              {
                id: "sn-4:2-b",
                da: " Refuerce el comportamiento comunicando a su jefe/a lo que él/ella está haciendo bien. Agradezca a su jefe/a por darle espacio para llevar a cabo un proyecto o, en cambio, por dedicar tiempo a ayudarle a estructurar una tarea de la forma adecuada.",
              },
              {
                id: "sn-4:2-c",
                da: " Pregunte a su jefe/a qué se requiere de usted. ¿Qué puede cambiar usted acerca de su estilo de trabajo para mejorar su relación? Por ejemplo, si su jefe/a está constantemente ocupándose de todos los detalles, tal vez es porque tiene la necesidad de estar informado y usted no está brindando información suficiente.",
              },
              {
                id: "sn-4:2-d",
                da: " Sugiera a su jefe/a que su grupo o equipo participe en evaluaciones que investiguen más a fondo los diferentes estilos de trabajo representados en el grupo. Evaluaciones tales como el método Birkman y los Estilos de Equipo de PeopleTree Team exploran las diferencias entre las personas y los grupos",
              },
              {
                id: "sn-4:2-e",
                da: " Dedique tiempo a conocer mejor a la persona detrás del estilo de trabajo. De serposible, trate de compartir tiempo en un entorno social — almuercen juntos o asistan a un evento social donde tenga la oportunidad de conversar con su jefe/a.",
              },
              {
                id: "sn-4:3-a",
                da: " Concéntrese en aspectos de su jefe/a que respeta — tenacidad, nivel de visión para los negocios, capacidad de tomar decisiones. No considere sólo el comportamiento de su jefe/a, sino también sus logros.",
              },
              {
                id: "sn-4:3-b",
                da: " Observe el contexto o las situaciones que le hacen más difícil trabajar con su jefe/a. ¿Sucede siempre, o sólo en ciertas circunstancias? Si es lo último, ¿qué puede hacer para ayudar a su jefe/a en esas oportunidades?",
              },
              {
                id: "sn-4:3-c",
                da: " Prepárese emocionalmente para los altibajos que están asociados con una personalidad difícil. Es difícil trabajar con una persona cuyos estados de ánimo son irregulares, por lo tanto asegúrese de no tomarse un mal humor de forma personal.",
              },
              {
                id: "sn-4:3-d",
                da: " Sea lo más abierto/a posible con su jefe/a. Él puede no ser consciente del impacto de su comportamiento y sin retroalimentación es improbable que cambie.",
              },
              {
                id: "sn-4:3-e",
                da: " Familiarícese con el lenguaje de las competencias conductuales. Le ayudará a definir y comunicar qué elementos del comportamiento de una persona la torna difícil, por ejemplo, alguien no es abierto/a, no escucha, no es accesible, paciente o justo/a.",
              },
              {
                id: "sn-4:3-f",
                da: " Dedique tiempo a conocer a su jefe/a en entornos sociales. Asista a eventos donde pueda interactuar u organice un almuerzo con su jefe/a, si es posible. Puede llegar a conocer a una persona muy diferente.",
              },
              {
                id: "sn-4:3-g",
                da: " Mantenga informado a su jefe/a. A menudo, no compartimos información con la gente que no respetamos. Mantener bien informado a su jefe/a asegura que las líneas de comunicación se mantengan abiertas y alienta el diálogo entre ambos/as.",
              },
              {
                id: "sn-4:3-h",
                da: " Las relaciones son una calle de doble sentido — ¿pensó en qué podría estar aportando usted a la situación? Sea honesto/a consigo mismo/a. Puede tener poco control sobre el comportamiento de su jefe/a, pero tiene control sobre el suyo. Anote las cosas que usted podría estar haciendo que dificultan la relación. ¿Es demasiado competitivo/a? ¿Se pone a la defensiva cuando su jefe/a le da retroalimentación negativa? ¿Guarda rencor acerca de algo que sucedió en el pasado? ¿Habla a espaldas de su jefe/a?",
              },
              {
                id: "sn-4:3-i",
                da: " Aunque una sólida relación con su jefe/a es ideal, una persona a veces simplemente no está dispuesta a cambiar. Concéntrese en construir una buena relación a través de su desempeño y no de su relación. Lo mejor que puede hacer es concentrarse en desarrollar sus habilidades para prepararse para una nueva posición.",
              },
              {
                id: "sn-4:3-j",
                da: " Si la relación con su jefe/a es verbal o mentalmente abusiva, hable confidencialmente con su representante de recursos humanos acerca de sus opciones.",
              },
              {
                id: "sn-4:3-k",
                da: " Maneje sus expectativas. No le tiene que gustar todo sobre su jefe/a. ¿Está comparando a su jefe/a con alguien más con quien trabajó en el pasado? ¿Espera que su jefe/a se comporte de una manera determinada todo el tiempo?",
              },
              {
                id: "sn-4:3-l",
                da: " Gestione sus expectativas. No le tiene que agradar todo sobre su jefe. Lo/la está comparando con alguien más?",
              },
            ],
          },
        ],
      },
      imr: {
        characteristic: "Inspira y motiva",
        wdd: "Dedica tiempo al desarrollo de otras personas y les brinda oportunidades para practicar habilidades nuevas o mejorar las existentes. Sabe vender la visión de futuro y hace que los demás se sientan inspirados por ella. Da fuerza y energía a los demás y sabe qué motiva a los diferentes tipos de personas. Reconoce el valor del trabajo en conjunto y es capaz de formar un equipo de gente para trabajar en un proyecto común.",
        icon: require("@/assets/Iconography/Characteristics/07_Energetic Driver.svg"),
        competencies: [
          {
            id: "imr-0",
            icon: require("@/assets/Iconography/Attributes/10-04_Developing people.svg"),
            comp: "Desarrolla A Otras Personas",
            wdd: "Dedica tiempo al desarrollo de otras personas y les brinda oportunidades para practicar habilidades nuevas o mejorar las existentes",
            progressMeasures: [
              {
                id: "imr-0-0",
                pm: "Incluyo al personal en reuniones y proyectos relevantes para exponerlos/as a oportunidades de desarrollo",
                pmMap:
                  "Incluir a mis colaboradores en reuniones y proyectos relevantes para exponerlos/as a oportunidades de desarrollo",
              },
              {
                id: "imr-0-1",
                pm: "Regularmente pregunto a mis colaboradores en que estarían interesados en trabajar",
                pmMap:
                  "Preguntar regularmente a mis colaboradores en que estarían interesados en trabajar",
              },
              {
                id: "imr-0-2",
                pm: "Activamente considero oportunidades de desarrollo para mi personal",
                pmMap:
                  "Ayudar activamente a las personas que quieren desarrollarse",
              },
              {
                id: "imr-0-3",
                pm: "Comprendo los estilos de aprendizaje preferidos de mi personal",
                pmMap:
                  "Ayudar a las personas con diferentes estilos de aprendizaje y adecuar sus diferencias",
              },
            ],
            developmentActions: [
              {
                id: "imr-0:1-a",
                da: " ¿Alienta usted una cultura de desarrollo personal? Convérselo abiertamente y ofrezca a la gente oportunidades de desarrollarse. Comuníqueles que es una de sus prioridades y que les alienta a ser proactivos/as acerca de sugerir oportunidades.",
              },
              {
                id: "imr-0:1-b",
                da: " Considere todos las solicitudes de actividades de desarrollo. Asegúrese de no desmoralizar a la gente rechazando sugerencias de eventos a los cuales les gustaría asistir o proyectos por los cuales muestran entusiasmo. Dé a la gente el beneficio de la duda y recompénselos/as por haber mostrado iniciativa. Aprenderán cómo medir los tipos de actividades que dan frutos.",
              },
              {
                id: "imr-0:1-c",
                da: " Elogie a la gente abiertamente cuando completen un punto de su plan de desarrollo.El elogio es contagioso y ayudará a motivar a otros miembros del equipo. También envía el mensaje de que el desarrollo personal es valorado.",
              },
              {
                id: "imr-0:1-d",
                da: " No se guarde sus conocimientos. No requiere gran esfuerzo motivar a los demás a desarrollarse leyendo artículos, revistas o libros de negocios que ha encontrado particularmente informativos y recomendarlos. Formalice ese proceso enviando regularmente una recopilación de sugerencias que a la gente le interese recibir.",
              },
              {
                id: "imr-0:2-a",
                da: " Exponga a la gente al desarrollo incluyéndolos/as en reuniones con grupos con los cuales típicamente no se encuentran: clientes, alta dirección, otros departamentos, etc. No tienen que desempeñar un rol activo pero podrían aprender de la experiencia, y eso no implica una carga de tiempo para usted.",
              },
              {
                id: "imr-0:2-b",
                da: " Identifique tareas que puede delegar a los subordinados para ayudarles a mejorar habilidades débiles.",
              },
              {
                id: "imr-0:2-c",
                da: " Establezca expectativas de desempeño adecuadas que consideren la experiencia, el conjunto de habilidades de la persona y el contexto de la posición.",
              },
              {
                id: "imr-0:2-d",
                da: " Brinde al personal el espacio y tiempo adecuado para trabajar en los problemas y probar su valía.",
              },
              {
                id: "imr-0:2-e",
                da: " Aliente a la gente a tomar la iniciativa. No reaccione de forma exagerada cuando se comete un error, en cambio úselo como una oportunidad para la reflexión y desarrollo.",
              },
              {
                id: "imr-0:3-a",
                da: " Pida a un asesor o al departamento de recursos humanos que lo entrenen para ser coach. Mejorar sus habilidades como coach, le permitirá brindar retroalimentación al personal con más facilidad.",
              },
              {
                id: "imr-0:3-b",
                da: " Use herramientas tales como evaluaciones de 360° para informarse de las fortalezas y necesidades de desarrollo de una persona. La visión colectiva de las habilidades que una persona debiera mejorar es muy importante, ya que es más difícil de objetar que si proviene de una fuente solamente.",
              },
              {
                id: "imr-0:3-c",
                da: " Algunos subordinados estarán mejor preparados/as para seguir su guía que otros/as.No se ponga a la defensiva o lo tome de forma personal. La mayoría de la gente teme la retroalimentación y la consciencia de un problema, a menudo es precedida por la negación del mismo. Puede tener que conversar el tema varias veces antes de que una persona pueda asimilar la retroalimentación y esté preparada para actuar.",
              },
              {
                id: "imr-0:3-d",
                da: " Asegúrese de que el empleado comprende la relevancia de la retroalimentación para lograr el éxito en una posición. La persona debe comprender plenamente cómo una deficiencia, que ha sido identificada, afecta a su capacidad de desempeñarse bien.",
              },
              {
                id: "imr-0:4-a",
                da: " Aproveche herramientas de evaluación como la retroalimentación de 360° de PeopleTree Group que le informa acerca de las fortalezas y oportunidades de desarrollo de una persona.",
              },
              {
                id: "imr-0:4-b",
                da: " Priorice la mejora de “factores knockout” y “factores de desvío profesional” que hayan sido identificados en el perfil de una persona. Los factores knockout son ciertos atributos conductuales que causarán un problema en todos los contextos,independientemente del trabajo de una persona, tales como tener malas relaciones con los jefes. Los factores de desvío profesional son el resultado de una combinación especial de fortalezas y debilidades. Puede empezar como una fortaleza pero puede crear problemas a lo largo de la evolución de una carrera, como cuando alguien se convierte en un/a solitario/a demasiado independiente. Estos factores necesitan atención temprana.",
              },
              {
                id: "imr-0:4-c",
                da: " Identifique los elementos de desarrollo que tendrán el mayor impacto en la posición actual de un empleado.",
              },
              {
                id: "imr-0:4-d",
                da: " Considere el contexto de la posición actual de alguien o el trabajo futuro al cual la persona está apuntando. Por ejemplo, si alguien está siendo preparado/a para una posición de reorganización, asegúrese de que sus competencias conductuales sean una buena combinación para ese tipo de posición.",
              },
              {
                id: "imr-0:4-e",
                da: " Comuníquese con el departamento de recursos humanos, o un consultor de PeopleTree Group en www.peopletreesuite.com, para obtener la Matriz de 9 Celdas. Se usa para identificar a la gente con elevado potencial en la compañía y examinar las mejores estrategias de desarrollo para ellos/as, en base a pronosticadores de desempeño y agilidad de aprendizaje.",
              },
              {
                id: "imr-0:4-f",
                da: " Exponga a la gente a una variedad de posiciones. Es una manera práctica de descubrir sus fortalezas y debilidades.",
              },
              {
                id: "imr-0:4-g",
                da: " El interés debería desempeñar un rol clave en la senda de desarrollo de una persona.Pregunte a la gente qué posiciones encuentran satisfactorias y qué desafíos les gustaría abordar.",
              },
              {
                id: "imr-0:4-h",
                da: " Los colegas pueden aprender mucho uno del otro. Aliente grupos de discusión o almuerzos informales durante los cuales pueden compartir información u opiniones acerca de sus proyectos.",
              },
              {
                id: "imr-0:4-i",
                da: " Tenga en cuenta que la gente aprende de forma diferente. Algunos aprenden mejor por su cuenta, otros disfrutan el aprendizaje en grupo; algunos aprenden de libros y otros requieren experiencia práctica.",
              },
              {
                id: "imr-0:5-a",
                da: " Identifique sucesores para posiciones críticas en su negocio y asegúrese de que haya un plan de sucesión implementado. El sistema de gestión de talentos de PeopleTree es una herramienta integral de la gestión de sucesión.",
              },
              {
                id: "imr-0:5-b",
                da: " Adopte una filosofía de desarrollo a largo plazo que le permita crear el talento necesario en los demás, paso a paso.",
              },
              {
                id: "imr-0:5-c",
                da: " Lleve a la gente a reuniones y compromisos clave donde puedan aprender observando, con poco riesgo para usted o la organización.",
              },
              {
                id: "imr-0:5-d",
                da: " Identifique cuál de sus responsabilidades puede delegar en otras personas como parte de su desarrollo. Convérselo y consiga la aprobación de su supervisor — su respaldo le hará más fácil tomar el riesgo.",
              },
              {
                id: "imr-0:5-e",
                da: " Asigne mentores a la gente para que puedan obtener conocimientos y perspectivas valiosas de otra persona que no sea usted.",
              },
              {
                id: "imr-0:5-f",
                da: " Escriba las consecuencias que se producirían si alguien que usted está desarrollando da un paso en falso. ¿Son las consecuencias tan serias como usted imagina?",
              },
              {
                id: "imr-0:6-a",
                da: " Asegúrese de comprender qué motiva a los empleados y ofrezca incentivos que reconozcan su talento y aseguren su lealtad.",
              },
              {
                id: "imr-0:6-b",
                da: " Pregunte a las personas acerca de las oportunidades que encontrarían interesantes y asegúrese de que tengan posiciones que exploten esos intereses.",
              },
              {
                id: "imr-0:6-c",
                da: " Asigne a una persona que esté desarrollando para que sea mentor de otros/as.Reforzará su confianza en la persona y recompensará su habilidad.",
              },
              {
                id: "imr-0:6-d",
                da: " Eleve la visibilidad de las personas ante la alta dirección comunicando y fomentando sus éxitos y arduo trabajo.",
              },
            ],
          },
          {
            id: "imr-1",
            icon: require("@/assets/Iconography/Attributes/10-03_Inspiring A Future.svg"),
            comp: "Inspira Un Futuro",
            wdd: "Sabe vender la visión de futuro y hace que los demás se sientan inspirados por ella",
            progressMeasures: [
              {
                id: "imr-1-0",
                pm: "De cuando en cuando le recuerdo a la gente la parte que desempeña su trabajo en la visión global",
                pmMap:
                  "Recordar a la gente la parte que su trabajo aporta dentro de la visión global",
              },
              {
                id: "imr-1-1",
                pm: "Habitualmente hablo acerca de nuestra causa común y creo un consenso centrado en la visión de la compañía",
                pmMap:
                  "Hablar habitualmente acerca de nuestra causa común y crear un consenso centrado en la visión de la compañía",
              },
              {
                id: "imr-1-2",
                pm: "Busco indicios de que los niveles de energía de la gente están bajos y trato de inspirarlos una vez más",
                pmMap:
                  "Inspirar cuando los índices de energía de los colaboradores son bajos y hablarles sobre el futuro",
              },
              {
                id: "imr-1-3",
                pm: "Soy un/a orador/a motivador/a y efectivo/a",
                pmMap: "Ser un/a orador/a motivador/a y efectivo/a",
              },
            ],
            developmentActions: [
              {
                id: "imr-1:1-a",
                da: " Revise la misión y visión de la compañía.",
              },
              {
                id: "imr-1:1-b",
                da: " Si son vagas, convérselas con otros/as líderes de la organización y aclárelas. Asegúrese de comprender por qué se tomaron las decisiones para moverse en esta dirección. Comprender los motivos detrás del cambio le ayuda a crear un argumento convincente para aquellas personas que usted supervisa.",
              },
              {
                id: "imr-1:1-c",
                da: " Anticipe que las personas se sientan temerosos/as y dudosos/as acerca del cambio.",
              },
              {
                id: "imr-1:1-d",
                da: " Anticipe que habrá muchas preguntas e inquietudes, por lo tanto prepárese para responder. Puede obtener una lista de preguntas comunes pidiéndole a los/as representantes de varias divisiones que provean sus inquietudes clave.",
              },
              {
                id: "imr-1:1-e",
                da: " Presente la visión como un trabajo en proceso más que como algo que está grabado en piedra. Esto comunica a todas las personas que el camino por delante implicará prueba y error, así como también ajustes.",
              },
              {
                id: "imr-1:1-f",
                da: " Asegúrese de destacar qué permanecerá igual, por ej., los valores de la compañía, el compromiso con la excelencia, los productos básicos, etc. Alentará a los empleados.",
              },
              {
                id: "imr-1:1-g",
                da: " Hable con los/as líderes que han implementado con éxito estrategias de reorganización. ¿Qué desafíos enfrentaron al tratar de inspirar a los demás?",
              },
              {
                id: "imr-1:1-h",
                da: " Recuerde el humor cuando converse acerca de las dificultadas que podrían enfrentarse al conducir la compañía en un rumbo diferente. El humor es una herramienta de unión y le humaniza, lo que puede ayudar a los empleados a ver su posición y abordar el cambio con menos temor.",
              },
              {
                id: "imr-1:1-i",
                da: " Aliente una cultura en la cual la gente tolere, e incluso se sienta motivada en tiempos de ambigüedad. Apoye la experimentación y enfoques innovadores gratificantes para nutrir esa cultura.",
              },
              { id: "imr-1:2-a", da: " No exprese su desacuerdo." },
              {
                id: "imr-1:2-b",
                da: " Si se siente tentado/a a compartir sus opiniones personales, pregúntese si sus comentarios cambiarán las cosas o si simplemente estará descargándose.",
              },
              {
                id: "imr-1:2-c",
                da: " Sea consciente del impacto que sus palabras pueden tener en la moral, especialmente si usted abiertamente expresara las inquietudes acerca del proceso de toma de decisiones, o liderazgo.",
              },
              {
                id: "imr-1:2-d",
                da: " Vigile su lenguaje corporal, por ejemplo, no ponga los ojos en blanco o niegue con la cabeza durante conversaciones acerca de las metas de la compañía o cruce los brazos con fuerza y hable desinteresadamente con voz monótona cuando haga comentarios acerca de su futuro.",
              },
              {
                id: "imr-1:2-e",
                da: " Sea como sea que lo finja, cree algo de motivación para aceptar la visión o rumbo de la compañía. Le resultará más fácil transmitir entusiasmo y motivar a los demás. Si no cree en ello de alguna manera, no le percibirán como auténtico/a. Escriba los motivos de su escepticismo para identificar exactamente qué le pone incómodo/a.",
              },
              {
                id: "imr-1:2-f",
                da: " Desafíe su lógica — obtenga una perspectiva nueva de la situación de un mentor o colega respetado.",
              },
              {
                id: "imr-1:2-g",
                da: " Si no está convencido/a con el curso que la compañía ha fijado, asegúrese de encontrar formas de cambiarlo en el futuro, participando más en el proceso de toma de decisiones. Si es conveniente, hable con las personas que tomaron la decisión para enterarse de su fundamento. Participe en un comité o grupo de tareas, u ofrézcase como voluntario/a para ser parte del proyecto que genera las decisiones que se toman. Si realmente es apasionado/a por el cambio, trate de influenciar a otras personas presionando desde detrás de escena.",
              },
              {
                id: "imr-1:3-a",
                da: " Programe reuniones regulares con el personal para hacerles participar en el rumbo de la compañía y crear entusiasmo entre ellos/as.",
              },
              {
                id: "imr-1:3-b",
                da: " Asegúrese de ser accesible a sus subordinados. Deberían estar en condiciones de conversar abiertamente acerca de sus ambiciones para su futuro dentro de la compañía.",
              },
              {
                id: "imr-1:3-c",
                da: " Aumente su nivel de energía para que su entusiasmo sea evidente. Los/as líderes a menudo cometen el error de transmitir su mensaje como si fuera una tarea desagradable.Sea optimista y transmita entusiasmo cuando hable acerca del futuro de la compañía. Muéstrese animado/a. Eleve el interés de la gente alentado preguntas constructivas.",
              },
              {
                id: "imr-1:3-d",
                da: " Asegúrese de poder expresar claramente los beneficios del rumbo que está tomando la compañía.",
              },
              {
                id: "imr-1:3-e",
                da: " No permita que los detractores le desalienten. Algunas personas pueden estar desinteresadas, otras escépticas o incluso totalmente resistentes. Si puede aislar a estas personas, hable con ellas en privado acerca de su negatividad y trate de abordar sus inquietudes. Simular que no importan, presenta el riesgo de que influyan en la actitud de todo el grupo. Además, esté preparado/a para responder las preguntas clave de los/as detractores/as. No responda de forma defensiva — encuentre paciencia en el conocimiento de que su posición es más sólida cuando se acepta el cambio, no cuando se fuerza.",
              },
              {
                id: "imr-1:3-f",
                da: " Su mensaje a menudo tendrá que transmitirse a través de presentaciones formales. Si los recursos lo permiten, contrate un/a redactor/a de discursos profesional que pueda traducir sus ideas a palabras motivadoras. Se necesita un/a redactor/a altamente especializado/a, por lo tanto obtenga ayuda si es necesario. Si quiere inspirar a una audiencia, la inversión será amortizada generosamente.",
              },
              {
                id: "imr-1:3-g",
                da: " Practique su discurso frente al espejo, su familia o un/a colega. ¿Se sentiría inspirado/a? ¿Se sintieron inspirados ellos/as? Asegúrese de confiar en su mensaje, o su presentación no será creíble.",
              },
              {
                id: "imr-1:3-h",
                da: " Los motivos de inspiración de la gente son tan diversos como la gente misma. El enfoque no será igual para todos cuando trate de inculcar una visión para el futuro. Sea consciente de las diferentes audiencias antes las cuales tendrá que hacer presentaciones. Su mensaje a la dirección diferirá de su mensaje a los/as trabajadores/as de línea o miembros de la prensa.",
              },
              {
                id: "imr-1:3-i",
                da: " Agregue un toque realista a su mensaje usando el humor y metáforas o analogías con las cuales su audiencia pueda relacionarse.",
              },
              {
                id: "imr-1:3-j",
                da: " Aprenda a convertirse en un/a futurista consumado/a. Para inspirar a los demás, tiene que saber cómo hacerles usar su imaginación y creer en las posibilidades de algo que ellos/as no están en condiciones de ver ahora.",
              },
              {
                id: "imr-1:4-a",
                da: " Vender una idea a los demás no tiene que ser solamente a través de una `gran presentación. Cada persona con quien habla es un/a cliente/a, por lo tanto use la oportunidad para charlar informalmente y mostrar su entusiasmo por el rumbo que está tomando la compañía.",
              },
              {
                id: "imr-1:4-b",
                da: " Pida a otras personas que le ayuden a correr la voz. Pida a otros gerentes que lo conviertan en una prioridad y aliénteles o recompénseles por inspirar una visión del futuro en los demás.",
              },
              {
                id: "imr-1:4-c",
                da: " Encabece una campaña de comunicación formal, que esté respaldada por el equipo ejecutivo. Podría adoptar muchas formas, como correos electrónicos, transmisiones por Internet o presentaciones en toda la compañía, dependiendo de los recursos. Consulte a su equipo de gestión del cambio o de comunicación para diseñar un plan de marketing efectivo.",
              },
              {
                id: "imr-1:4-d",
                da: " Asegúrese de que la visión y misión de la compañía están claramente comunicadas en la memoria anual.",
              },
              {
                id: "imr-1:4-e",
                da: " Recuerde, las acciones a menudo tienen un mayor impacto que las palabras en lo que se refiere a inspirar a los demás. Asegúrese de actuar conforme a la misión y visión que está vendiendo.",
              },
              {
                id: "imr-1:5-a",
                da: " Concéntrese menos en cómo alcanzará el objetivo y más en cómo es realmente dicho objetivo.",
              },
              {
                id: "imr-1:5-b",
                da: " No eluda fijar metas y objetivos ambiciosos para usted y su equipo. Si tiene éxito, habrá elevado los estándares más allá del promedio. Si el resultado no alcanza,probablemente habrá logrado lo que se esperaba de todos modos",
              },
              {
                id: "imr-1:5-c",
                da: " Inspírese acerca de la grandeza aprendiendo de líderes inspiradores/as. Lea biografías o escuche discursos inspiradores famosos.",
              },
              {
                id: "imr-1:5-d",
                da: " Si le hace sentirse más cómodo/a, infórmele a la gente que está apuntando a las estrellas y que cómo llegará allí es un trabajo en proceso con toda la prueba y error que ello implica.",
              },
            ],
          },
          {
            id: "imr-2",
            icon: require("@/assets/Iconography/Attributes/10-02_Motivating People.svg"),
            comp: "Motiva A Las Personas",
            wdd: "Da fuerza y energía a los demás y sabe qué motiva a los diferentes tipos de personas",
            progressMeasures: [
              {
                id: "imr-2-0",
                pm: "Soy consciente de que todos necesitan motivación de vez en cuando",
                pmMap:
                  "Ser consciente de que todos necesitan motivación de vez en cuando",
              },
              {
                id: "imr-2-1",
                pm: "He hablado con cada una de las personas que me reportan directamente acerca de qué los motiva",
                pmMap:
                  "Hablar con cada una de las personas que me reportan directamente sobre qué les motiva",
              },
              {
                id: "imr-2-2",
                pm: "Me mantengo enérgico/a y motivo a otras personas incluso cuando estoy pasando por momentos difíciles",
                pmMap:
                  "Mantenerme enérgico/a y motivar a otras personas incluso cuando estoy pasando por momentos difíciles",
              },
              {
                id: "imr-2-3",
                pm: "Considero el impacto de mis afirmaciones sobre la moral de otras personas antes de hacerlas",
                pmMap:
                  "Considerar el impacto de mis afirmaciones en la motivación de otras personas antes de hacerlas",
              },
            ],
            developmentActions: [
              {
                id: "imr-2:1-a",
                da: " Participe en un proceso de retroalimentación de 360° que le brinde una opinión honesta de sus colegas, clientes e incluso de su gerente acerca de su comportamiento. Recuerde que la retroalimentación no es útil a menos que esté dispuesto a aceptarla y hacer los cambios necesarios.",
              },
              {
                id: "imr-2:1-b",
                da: " Contrate un coach para que le ayude a señalar los aspectos de su personalidad que afectan a su capacidad de motivar a otras personas. Por ejemplo, mostrar empatía, escuchar bien, tener paciencia, otorgar autoridad a otras personas, poseer habilidades de delegación,informar a los demás y ser abierto/a.",
              },
              {
                id: "imr-2:1-c",
                da: " Observe a la gente en la organización que es buena motivando a otras personas. ¿Qué rasgos de personalidad le permiten hacerlo?",
              },
              {
                id: "imr-2:1-d",
                da: " Tenga en cuenta que su motivación proviene de un lugar diferente de la de los demás.Está basada en tipos de personalidad. A alguien puede gustarle trabajar por su cuenta y necesitar un entorno de trabajo estructurado. Otra persona sin embargo, puede disfrutar trabajando en equipo, compartiendo ideas y sentirse motivado por un entorno flexible.",
              },
              {
                id: "imr-2:2-a",
                da: " Dedique el tiempo necesario para motivar a la gente acerca de un proyecto. La gente se mantiene inspirada cuando forman una conexión con una visión mayor, más que una tarea.",
              },
              {
                id: "imr-2:2-b",
                da: " Equilibre su necesidad de acción con halagos por lo que se ha logrado hasta el omento.",
              },
              {
                id: "imr-2:2-c",
                da: " Cuando señale errores o un área que necesita mejora, siempre mencione las cosas que se hicieron correctamente también.",
              },
              {
                id: "imr-2:2-d",
                da: " Acérquese a la gente periódicamente para controlar tanto el progreso como sus sentimientos y preocupaciones.",
              },
              {
                id: "imr-2:2-e",
                da: " Considere cuidadosamente qué resultados realmente necesitan ser perfectos, cuán agresivas tienen que ser las fechas límite y cuán realistas son sus estándares. Puede aplicar presión innecesaria en la gente con tareas que realmente requieren menos precisión o que podrían terminarse dentro de un período de tiempo más tolerante.",
              },
              {
                id: "imr-2:2-f",
                da: " No use un enfoque que sea igual para todos. Asegúrese de comprender los diferentes incentivos que necesitan las personas y úselos para obtener sus resultados.",
              },
              {
                id: "imr-2:3-a",
                da: " Busque indicios que señalen una menor motivación — comentarios negativos, retirarse del grupo, cambio drástico en el estilo de trabajo,retrasarse en el trabajo, no cumplir con las fechas límite constantemente,rango de atención inusualmente corto, irritabilidad o comportamiento conflictivo.",
              },
              {
                id: "imr-2:3-b",
                da: " Observe qué hace que la persona se sienta más animada. La gente tiende a estar más comprometida y entusiasmada cuando hablan acerca de tareas o trabajan en tareas que los motivan. No deje pasar la oportunidad de preguntar a la gente acerca de la experiencia,tema, etc. que le atrae. Use la retroalimentación cuando considere formas de motivarlos en el futuro.",
              },
              {
                id: "imr-2:3-c",
                da: " Si sospecha que algo está mal, ¡pregunte! Confíe en su intuición. Puede ser muy motivador simplemente saber que a usted le interesa lo suficiente como para darse cuenta.",
              },
              {
                id: "imr-2:3-d",
                da: " Escuche cuidadosamente lo que la gente dice y lo que no dice. En ocasiones, la gente que está tratando de resolver sus temas todavía no descubrió exactamente qué es lo que los hace infelices.",
              },
              {
                id: "imr-2:3-e",
                da: " Interpretar a la gente no es necesariamente fácil, por lo tanto empiece cuanto antes.Numerosas herramientas de evaluación pueden darle mucha información acerca de la gente, por ejemplo, el Método Birkman se concentra en las necesidades ocultas de la gente.Dichas herramientas de evaluación pueden brindar información invalorable acerca de la motivación de la gente. Pregunte a sus asesores de recursos humanos acerca de las herramientas disponibles que pueden usar.",
              },
              {
                id: "imr-2:4-a",
                da: " Sea elogioso — es la forma mas simple de motivar a la gente. Comunique a la gente el valor de su trabajo, sea generoso/a con su agradecimiento, señale abiertamente cuando alguien esté haciendo bien sus tareas. ¿Cuándo fue la última vez que expresó gratitud a la gente que supervisa?",
              },
              {
                id: "imr-2:4-b",
                da: " No deje que alguien luche demasiado tiempo con una tarea si obviamente necesita ayuda. Controle su progreso habitualmente, pregunte si necesitan ayuda y asegúrese de movilizar recursos para ayudar si es necesario. Pedir ayuda y no obtenerla puede ser altamente dañino para la moral.",
              },
              {
                id: "imr-2:4-c",
                da: " Dedique tiempo a conocer mejor a la gente que trabaja para usted. Cree oportunidades para compartir información entre sí en un entorno informal. Almuerce con ellos o asista a eventos después de las horas de trabajo donde puede ver a la gente interactuar fuera del entorno laboral.",
              },
              {
                id: "imr-2:4-d",
                da: " Las acciones hablan más que las palabras. Herb Keller, presidente de Southwest Airlines en EE.UU. ocasionalmente ha participado en la carga de equipaje o en recibir los pasajes en la puerta de embarque. Mostrar a sus colegas que usted realmente forma parte del equipo y sabe lo que implica su trabajo es un mensaje muy poderoso.",
              },
              {
                id: "imr-2:5-a",
                da: " Consulte con recursos humanos y su supervisor para enterarse acerca de las prácticas y políticas relacionadas con incentivos a los empleados.",
              },
              {
                id: "imr-2:5-b",
                da: " Cuando la moral está baja o el entorno de trabajo ha sido especialmente difícil, brinde incentivos que alienten a la gente a alcanzar metas, objetivos o fechas límite específicas. Todo el mundo necesita un empujón a veces.",
              },
              {
                id: "imr-2:5-c",
                da: " Las tareas interesantes ayudan a mantener motivada a la gente. Asegúrese de que sus subordinados tengan metas realistas pero desafiantes y tareas con las cuales puedan entusiasmarse. Comprenda la naturaleza del trabajo al cual la gente dedica la mayoría de su tiempo. Rote las tareas para evitar el agotamiento. Pregunte si a una persona le gustaría trabajar en una tarea o proyecto específico. Sorprendentemente, a los empleados rara vez se les formula esa pregunta.",
              },
              {
                id: "imr-2:5-d",
                da: " Ayude a la gente a mantenerse entusiasmada con su trabajo informándoles acerca de la visión global y las oportunidades que tienen — no sólo hoy, sino en el futuro.",
              },
              {
                id: "imr-2:5-e",
                da: " Cuando sea posible, eleve el perfil de la gente entre los altos directivos comunicando sus éxitos.",
              },
              {
                id: "imr-2:5-f",
                da: " No suponga que la gente está contenta porque no se ha quejado. Deje que sus subordinados participen en una encuesta de motivación. Los resultados podrían ser instructivos.",
              },
              {
                id: "imr-2:5-g",
                da: " Cuando pueda, asegúrese de que se realicen e implementen cambios en la política a modo de reflejar la retroalimentación de tales encuestas. Si se pidió opinión pero luego no se toman acciones al respecto, los empleados se sentirán desmoralizados/as.",
              },
              {
                id: "imr-2:5-h",
                da: " Asegúrese de tener planes para retener a sus empleados/as de mejor desempeño y a aquellos/as con elevado potencial.",
              },
              {
                id: "imr-2:6-a",
                da: " Siempre empiece con una respuesta positiva a la petición de una persona y actúe de forma alentadora, incluso si tiene dudas.",
              },
              {
                id: "imr-2:6-b",
                da: " Cuando converse las metas de una persona, exponga tanto los obstáculos para el éxito como los motivos por los cuales la meta puede alcanzarse.",
              },
              {
                id: "imr-2:6-c",
                da: " Aborde cada situación como si fuera nueva. Previamente, otras personas pueden no haber tenido éxito, pero eso no significa que la persona frente a usted no lo logrará.",
              },
              {
                id: "imr-2:6-d",
                da: " No suponga que las cosas tienen que permanecer como están. Hable con las personas adecuadas acerca de las opciones y exponga los argumentos a favor de la persona que está defendiendo.",
              },
              {
                id: "imr-2:6-e",
                da: " Pídale que le dé un plan de cómo espera alcanzar la meta antes de juzgar si puede tener éxito o no.",
              },
              {
                id: "imr-2:6-f",
                da: " Si su equipo trabajó con diligencia en un proyecto y el resultado no fue tan bueno como se esperaba, no se detenga innecesariamente en los resultados. Aliente al equipo a aplicar lo que aprendieron al próximo proyecto.",
              },
              {
                id: "imr-2:7-a",
                da: " Considere cuidadosamente qué podría estar afectando a su panorama positivo, no sólo en el trabajo sino también en su vida personal.",
              },
              {
                id: "imr-2:7-b",
                da: " Haga una lista e identifique los aspectos de su trabajo o de su vida que puede cambiar inmediatamente, en el corto y en el largo plazo.",
              },
              {
                id: "imr-2:7-c",
                da: " Cree un plan de acción para abordar estos cambios. Por ejemplo, si está descontento con su calendario de trabajo, márquelo como un ítem de corto plazo que podría abordarse trabajando desde casa dos días por semana. La infelicidad con su posición es un ítem a largo plazo que puede abordar desarrollando habilidades para otra posición en la organización.",
              },
              {
                id: "imr-2:7-d",
                da: " Lea literatura inspiradora. Pida a sus colegas que le recomienden libros motivadores.",
              },
              {
                id: "imr-2:7-e",
                da: " No descargue sus frustraciones frente a sus subordinados y sea consciente de la charla negativa. No estarán en condiciones de cambiar la situación y se arriesga a desmoralizarlos. En cambio, hable acerca de sus quejas con la persona adecuada — su jefe,un representante de recursos humanos, su coach.",
              },
              {
                id: "imr-2:7-f",
                da: " Incluso cuando no está motivado acerca de su situación, igualmente puede ser positivo/a y alentador/a acerca de los demás.",
              },
              {
                id: "imr-2:7-g",
                da: " Considere ver a un asesor si su negatividad es crónica o se vuelve conflictiva en el trabajo.",
              },
              {
                id: "imr-2:7-h",
                da: " En ocasiones, puede tener que fingir sentirse motivado por un rato hasta que realmente se sienta así.",
              },
            ],
          },
          {
            id: "imr-3",
            icon: require("@/assets/Iconography/Attributes/10-01_Unifying People.svg"),
            comp: "Unifica A Las Personas",
            wdd: "Reconoce el valor del trabajo en conjunto y es capaz de formar un equipo de gente para trabajar en un proyecto común",
            progressMeasures: [
              {
                id: "imr-3-0",
                pm: "Claramente defino las metas del equipo e inspiro una sensación de propósito común",
                pmMap:
                  "Definir claramente las metas del equipo e inspirar una sensación de propósito común",
              },
              {
                id: "imr-3-1",
                pm: "Tengo una buena comprensión de los diferentes estilos de trabajo de los miembros del equipo",
                pmMap:
                  "Reconocer los diferentes estilos de trabajo de los miembros del equipo y adaptarlos",
              },
              {
                id: "imr-3-2",
                pm: "Regularmente reúno al equipo para conversar sobre el avance",
                pmMap:
                  "Reunir al equipo regularmente para conversar sobre el avance y construir espíritu de equipo",
              },
              {
                id: "imr-3-3",
                pm: "Recompenso el esfuerzo del equipo, no sólo el de los individuos",
                pmMap:
                  "Recompensar el esfuerzo del equipo, no sólo el de los individuos",
              },
            ],
            developmentActions: [
              {
                id: "imr-3:1-a",
                da: " Establezca una cultura que valore la participación del equipo. Comparta los logros del equipo con sus subordinados y los altos directivos para obtener reconocimiento por sus esfuerzos. Es una forma efectiva de recompensar a la gente por su trabajo colectivo.",
              },
              {
                id: "imr-3:1-b",
                da: " Recompense y celebre las metas del equipo alcanzadas, no solamente las metas individuales.",
              },
              {
                id: "imr-3:1-c",
                da: " Considere cuidadosamente el alcance del proyecto y si su calidad se beneficiaría del trabajo en equipo o de la participación de una persona.",
              },
              {
                id: "imr-3:1-d",
                da: " Encuentre formas de optimizar la participación de la gente creando equipos con conjuntos de habilidades diversas para abordar los proyectos.",
              },
              {
                id: "imr-3:1-e",
                da: " Claramente defina el rol de cada participante del equipo. Esto significa destacar y promover lo que cada miembro aporta al equipo.",
              },
              {
                id: "imr-3:1-f",
                da: " En sus reuniones de equipo iniciales, establezca el procedimiento necesario que debe seguir cada persona: cómo se comunicarán, el proceso de toma de decisiones, detalles acerca de cómo se hará el trabajo y formas de resolver los conflictos.",
              },
              {
                id: "imr-3:2-a",
                da: " Asegúrese de crear y mantener una declaración de misión bien definida y relevante.",
              },
              {
                id: "imr-3:2-b",
                da: " Permita que los miembros del equipo participen lo más posible en crear su visión y metas. Aumentará su sentido de propiedad del proyecto.",
              },
              {
                id: "imr-3:2-c",
                da: " Cree hitos y medidas de éxito concretas para ayudar a los miembros del equipo a mantenerse motivados a lo largo del camino. Vincule las mediciones con las metas alcanzadas, por ejemplo, el número de nuevos clientes obtenidos.",
              },
              {
                id: "imr-3:2-d",
                da: " Cree una sensación de camaradería celebrando los logros del equipo.",
              },
              {
                id: "imr-3:2-e",
                da: " Periódicamente, dedique tiempo para comunicarle a las personas exactamente qué rol desempeñan en el éxito del equipo así como también en la meta definitiva y qué significa esa meta para la compañía.",
              },
              {
                id: "imr-3:3-a",
                da: " Reúna a todos los miembros del equipo para una reunión inicial cara a cara. Es importante establecer la identidad del equipo, generar confianza entre sus miembros y crear una sensación de unidad.",
              },
              {
                id: "imr-3:3-b",
                da: " Evalúe a su equipo para detectar diferentes estilos y facilite un taller guiado para ayudar a que los miembros se entiendan mejor entre sí. El método Birkman® es una herramienta efectiva para evaluar cómo las necesidades individuales afectan la dinámica de un equipo. Los informes sobre estilos de equipos y análisis de talento individual de PeopleTree Group, disponibles a través de un/a consultor/a en www.peopletreegroup.com,pueden brindar a los gerentes percepciones clave acerca de las personas de su equipo.",
              },
              {
                id: "imr-3:3-c",
                da: " Ask your human resources department about team-building exercises your team can attend.",
              },
              {
                id: "imr-3:3-d",
                da: " Ayude a la gente a crear la conexión vital entre el avance en la carrera y trabajar bien con otras personas. Las habilidades interpersonales efectivas son críticas para el avance en cualquier organización. Aprenda a desarrollarlas y enséñele a su equipo.",
              },
              {
                id: "imr-3:3-e",
                da: " Asegúrese de intervenir rápidamente cuando un miembro del equipo está siendo conflictivo/a. Hable con la persona en privado para evaluar los desafíos que está experimentando. Se puede necesitar un mediador externo si surge un intenso conflicto entre miembros del equipo. Los malentendidos deben abordarse antes de que tomen un significado mayor del que deberían.",
              },
              {
                id: "imr-3:3-f",
                da: " No suponga que los problemas del equipo pueden resolverse de inmediato — puede tener que abordar las cuestiones nuevamente. Esté siempre consciente de las necesidades del grupo.",
              },
              {
                id: "imr-3:4-a",
                da: " Si su posición no incluye manejar a un equipo, trate de adoptar el rol de motivador/a en su grupo de trabajo. Ayude a sus colegas a mantenerse concentrados en el avance y en el aspecto positivo de las cosas cuando el ánimo está bajo.",
              },
              {
                id: "imr-3:4-b",
                da: " Si no están programadas, trate de organizar reuniones de equipo periódicas para revisar el estado del trabajo. Ofrézcase a facilitar la reunión y posiblemente la conversación.",
              },
              {
                id: "imr-3:4-c",
                da: " Hable con su jefe/a acerca de las oportunidades de tomar un rol de liderazgo en un proyecto de equipo.",
              },
              {
                id: "imr-3:4-d",
                da: " Incorpórese a comisiones especiales, en el trabajo o en forma privada, que le expongan a la dinámica de grupo.",
              },
              {
                id: "imr-3:4-e",
                da: " Familiarícese con las competencias requeridas para manejar otras personas. Hable con un/a consultor/a de PeopleTree Group acerca del proceso de evaluación de 360° y el análisis de talentos individuales de la compañía que brindan una visión profunda de las reas a desarrollar.",
              },
              {
                id: "imr-3:4-f",
                da: " Lea The Leadership Pipeline de Charan, Drotter y Noel.",
              },
            ],
          },
        ],
      },
      en: {
        characteristic: "Es diplomático/a",
        wdd: "Posee confianza en sí mismo/a cuando interactúa con los demás, especialmente en situaciones que pueden crear cierta ansiedad. Tiene tacto y sabe comunicarse de manera educada y sin generar enfrentamientos. Llega a resultados positivos para ambas partes incluso cuando hay conflicto de intereses y recursos limitados.Entiende cómo funciona la política de una corporación y sabe manejar la dinámica del poder en el ambiente corporativo.  ",
        icon: require("@/assets/Iconography/Characteristics/06_Effective Negotiator.svg"),
        competencies: [
          {
            id: "en-0",
            icon: require("@/assets/Iconography/Attributes/06-04_Acting Confidently.svg"),
            comp: "Posee Confianza En Sí Mismo/a",
            wdd: "Posee confianza en sí mismo/a cuando interactúa con los demás, especialmente en situaciones que pueden crear cierta ansiedad",
            progressMeasures: [
              {
                id: "en-0-0",
                pm: "Me siento cómodo/a expresándome frente a otras personas",
                pmMap: "Estar cómodo/a expresándome frente a otras personas",
              },
              {
                id: "en-0-1",
                pm: "Creo que soy competente en lo que hago",
                pmMap: "Creer que soy competente en lo que hago",
              },
              {
                id: "en-0-2",
                pm: "La mayoría de las veces, tengo una actitud de “puedo hacerlo”",
                pmMap: "Tener la actitud de “puedo hacerlo”",
              },
              {
                id: "en-0-3",
                pm: "No me avergüenzo fácilmente",
                pmMap: "No avergonzarme fácilmente",
              },
            ],
            developmentActions: [
              {
                id: "en-0:1-a",
                da: " Ciertas personas pueden saber más que usted en algunas áreas, pero cada uno/a aporta tanto fortalezas como debilidades a sus trabajos. Promueva sus fortalezas identificando las partes de un proyecto a las cuales puede agregar mayor valor. Si es bueno/a resolviendo problemas, por ejemplo, pero no está muy familiarizado/a con el tema, igualmente puede ayudar al equipo a organizar las ideas de forma lógica y agregar valor formulando preguntas desde una perspectiva más externa.¿Qué fortalezas aporta, independientemente de su tarea?",
              },
              {
                id: "en-0:1-b",
                da: " Arremánguese y participe. Nada la dará más confianza que dominar lo que no sabía. Involúcrese en proyectos y tareas que le ayuden a obtener conocimientos en las áreas en las cuales se siente menos confiado/a. Muchas compañías brindan oportunidades de rotación para que los empleados trabajen en diferentes áreas de la organización. Solicite tareas que sean diferentes de las que domina.",
              },
              {
                id: "en-0:1-c",
                da: " Reúnase con gente que sepa más que usted o que sean expertos/as en un campo determinado. En lugar de compararse con ellos/as, elija aprender de ellos/as.",
              },
              {
                id: "en-0:1-d",
                da: " No simule saber lo que no sabe. Es perfectamente aceptable no ser experto/a en todo.Derive preguntas que no puede responder a alguien que sí pueda, o haga su investigación y luego vuelva a comunicarse con la persona. La gente valora la honestidad y tendrá más respeto por usted si no los engaña.",
              },
              {
                id: "en-0:1-e",
                da: " Sea un/a estudiante. Acepte el rol de formular muchas preguntas.",
              },
              {
                id: "en-0:1-f",
                da: " No se dé por vencido/a en el momento en que las cosas se tornan particularmente difíciles o confusas. Es parte del proceso de aprendizaje y la etapa en la cual la mayoría de la gente pierde la confianza.",
              },
              {
                id: "en-0:1-g",
                da: " Pida ser incluido/a en reuniones y conferencias telefónicas incluso cuando no va a participar. La exposición es invalorable para sentirse cómodo/a con diferentes entornos y para obtener confianza.",
              },
              {
                id: "en-0:2-a",
                da: " La afirmación positiva puede ayudarle a reprogramar su pensamiento. Esté atento/a a los pensamientos negativos y practique reemplazarlos con pensamiento positivo.",
              },
              {
                id: "en-0:2-b",
                da: " Identifique a alguien que admira por su confianza en sí mismo/a y converse acerca de cómo esa persona ve el mundo. Observe las diferencias entre sus visiones y las suyas.",
              },
              {
                id: "en-0:2-c",
                da: " No asigne a los errores más importancia de la que merecen. Escriba el peor escenario posible. A menos que la vida de alguien esté amenazada, las consecuencias realmente no son tan malas como uno piensa.",
              },
              {
                id: "en-0:2-d",
                da: " No puede predecir todo 100% correctamente o controlar las cosas en su totalidad.Haga una lista de las cosas sobre las cuales tiene control versus aquellas que no controla.Acepte un equilibrio entre las dos y concéntrese únicamente en las cosas que puede controlar. Por ejemplo, haga su tarea sobre el tema, ensaye su discurso, familiarícese con el entorno en el cual estará haciendo la presentación, conozca mejor a las personas que participarán en la reunión antes del gran día, y así sucesivamente. Entonces habrá hecho su parte. El resto está fuera de su control.",
              },
              {
                id: "en-0:2-e",
                da: " Deje de pensar demasiado acerca de cómo se harán las cosas y en cambio concéntrese en empezar. Confíe en que el proceso se resolverá por sí mismo. Elija algo que haya estado postergando y encárelo hoy.",
              },
              {
                id: "en-0:2-f",
                da: " Forme equipo con alguien que esté orientado/a a la acción que le ayude a ponerse en movimiento y le brinde apoyo.",
              },
              {
                id: "en-0:2-g",
                da: " Recuerde que la mayoría de los proyectos tienen fechas límite estrictas y siempre llevan más tiempo de lo esperado, por lo tanto considere eso cuando defina los cronogramas.",
              },
              {
                id: "en-0:2-h",
                da: " Priorice su tiempo. Algunas cosas requieren mucha atención y detalle y otras no. Por ejemplo, dedicar tiempo a perfeccionar un correo electrónico para un colega es innecesario, pero hacerlo para examinar un contrato cuidadosamente es tiempo bien invertido.",
              },
              {
                id: "en-0:2-i",
                da: " Priorice su tiempo. Algunas cosas requieren mucha atención y detalle y otras no. Por jemplo, dedicar tiempo a perfeccionar un correo electrónico para un colega es innecesario, pero hacerlo para examinar un contrato cuidadosamente es tiempo bien invertido.",
              },
              {
                id: "en-0:3-a",
                da: " Exponerse a las situaciones o personas que le tornan temeroso/a es la mejor manera de abordar su ansiedad y obtener confianza. Cuánto más exposición tenga a estas situaciones, más se elevará su nivel de confianza.Encuentre maneras de participar, aunque sólo mínimamente al principio, en este tipo de entornos.",
              },
              {
                id: "en-0:3-b",
                da: " Comparta su ansiedad. Encuentre alguien que pueda darle apoyo en momentos en que esté muy ansioso/a. Por ejemplo, si no le gusta estar en grupos grandes pero necesita asistir a una reunión para establecer contactos, busque a un/a compañero/a de trabajo que disfrute socializar para que le acompañe.",
              },
              {
                id: "en-0:3-c",
                da: " Si se siente incómodo/a con aquellas personas que tienen más autoridad, haga un esfuerzo consciente de tratar de conocerlos a un nivel más personal. Le ayudará a desafiar sus supuestos acerca de ellos/as y a verles como individuos en lugar de figuras de autoridad. Hable con las personas mientras está esperando que empiece una reunión; asista a reuniones sociales que le permitan interactuar de forma relajada; averigüe más acerca de la gente preguntando a otras personas qué piensan de ellos/as.",
              },
              {
                id: "en-0:3-d",
                da: " Pídale a un asesor profesional técnicas para relajarse y reducir la ansiedad. Los ejercicios de respiración, bio-retroalimentación, visualización e hipnosis son sólo algunas de las herramientas a su disposición.",
              },
              {
                id: "en-0:4-a",
                da: " La afirmación positiva puede ayudarle a reprogramar su pensamiento. Esté atento/a a los pensamientos negativos y practique reemplazarlos con pensamiento positivo.",
              },
              {
                id: "en-0:4-b",
                da: " Considere cómo reaccionaría si alguien más cometiera un error frente a usted. No lo crucificaría. Tendemos a ser más duros con nosotros/as mismos/as. Cuando mire alrededor de la sala, recuerde que la gente deja lugar para los errores y muestra más empatía de lo que usted piensa.",
              },
              {
                id: "en-0:4-c",
                da: " Obtenga retroalimentación acerca de cómo fue su presentación o qué tan bueno resultó su trabajo. Debido a que usted es su peor crítico/a, los demás pueden brindar una perspectiva más realista.",
              },
              {
                id: "en-0:4-d",
                da: " Use su sentido del humor y practique burlarse de sí mismo/a, incluso en público. Es una manera fácil de conectarse con los demás y sacarse la presión. ¿Cuántas veces observó situaciones y descubrió sus aspectos graciosos en retrospectiva? Trate de usar esa perspectiva en el presente.",
              },
              {
                id: "en-0:4-e",
                da: " Concéntrese en los temas o el problema en cuestión, en lugar de en sí mismo/a.",
              },
            ],
          },
          {
            id: "en-1",
            icon: require("@/assets/Iconography/Attributes/06-03_Acting Diplomatically.svg"),
            comp: "Diplomático/a",
            wdd: "Tiene tacto y sabe comunicarse de manera educada y sin generar enfrentamientos",
            progressMeasures: [
              {
                id: "en-1-0",
                pm: "Soy capaz de apaciguar situaciones tensas",
                pmMap: "Apacigüo situaciones tensas",
              },
              {
                id: "en-1-1",
                pm: "Me relaciono bien con la gente incluso si son diferentes a mí",
                pmMap:
                  "Relacionarme bien con la gente incluso si son diferentes a mí",
              },
              {
                id: "en-1-2",
                pm: "Comunico información delicada de forma diplomática",
                pmMap: "Comunicar información delicada de forma diplomática",
              },
              {
                id: "en-1-3",
                pm: "Puedo ser honesto/a sin ser irrespetuoso/a",
                pmMap: "Ser honesto/a sin ser irrespetuoso/a",
              },
            ],
            developmentActions: [
              {
                id: "en-1:1-a",
                da: " Despersonalice la interacción. Piense en sí mismo/a como que actúa en un rol, por ejemplo, como gerente tratando con el personal, como representante de servicio al cliente tratando con un cliente, etc. No está siendo atacado por las otras personas; están interactuando con su rol.",
              },
              {
                id: "en-1:1-b",
                da: " Piense antes de hablar. Una vez que dice algo, no puede retractarse. La gente recordará expresiones que provocaron una fuerte respuesta emocional. Decir algo que ofende, humilla o critica dañará una relación.",
              },
              {
                id: "en-1:1-c",
                da: " Maneje sus emociones. Ser consciente de sus propios disparadores emocionales le ayudará a prevenir arrebatos que pueden dañar una relación. Piense en cómo identificar sus “botones rojos”, por ejemplo, alguien que hace un comentario racista o implica que usted carece de inteligencia puede provocar una reacción de su parte más fuerte de lo normal.",
              },
              {
                id: "en-1:1-d",
                da: " Escuche más y hable menos. La diplomacia requiere una comprensión de la gente,sus agendas, sistemas de creencias y valores. Estos aspectos pueden identificarse si escucha también lo que no se está diciendo. La mayor parte del tiempo usted obtiene información importante no sólo a través del mensaje, sino también a través de la forma en que éste se transmite. Sea consciente del momento y del tono",
              },
              {
                id: "en-1:2-a",
                da: " Considere los motivos por los cuales quiere comunicar cierta información a alguien. ¿Es el mensaje crítico para las partes involucradas, o está usted cubriendo una necesidad personal y emocional compartiéndolo?",
              },
              {
                id: "en-1:2-b",
                da: " La elección de un buen momento es esencial. Puede tener más éxito compartiendo sus pensamientos más adelante, por lo tanto sea paciente y apártese si cree que la gente será más receptiva en otra oportunidad.",
              },
              {
                id: "en-1:2-c",
                da: " Póngase en el lugar de la otra persona. Probablemente haya algunas cosas acerca de las cuales usted es sensible que lo ofenderían si alguien las compartiera con usted. Haga el esfuerzo de comprender el impacto que tendrá en la persona lo que tiene que decirle.Considere si es lo suficientemente importante para decirlo. De ser así, ¿cómo le hubiera gustado que se lo dijeran a usted?",
              },
              {
                id: "en-1:2-d",
                da: " Manténgase sereno/a todo el tiempo. Le coloca en una mejor posición para manejar conflictos o situaciones tensas. No se tome las cosas de forma personal. En circunstancias tensas, es posible que las emociones estén caldeadas y la gente sea más propensa a lanzar ataques injustos. Si se está sintiendo demasiado emotivo/a, absténgase de responder y tómese tiempo para poner sus ideas en orden. Puede pedir tiempo para pensar las cosas, si es necesario. Mantenga su tono de voz uniforme y tranquilo, porque elevarlo sólo alentará a los demás a hacer lo mismo.",
              },
              {
                id: "en-1:2-e",
                da: " Haga una buena lectura de su público y ajuste su estrategia en consecuencia.Invariablemente, algunas personas necesitarán un manejo más delicado que otras.",
              },
              {
                id: "en-1:3-a",
                da: " Es difícil establecer una relación mutuamente respetuosa si no escucha genuinamente lo que la gente tiene que decir. Esté de acuerdo o no, reconozca el punto de vista de otras personas. Concéntrese en ser atento/a en lugar de decir “así son las cosas”.",
              },
              {
                id: "en-1:3-b",
                da: " Pida opiniones a la gente y no haga juicios rápidos o hable de forma despectiva,indicando que ya tiene todas las respuestas.",
              },
              {
                id: "en-1:3-c",
                da: " Evite lenguaje corporal o comportamientos agresivos que otras personas podrían percibir como demasiado autoritarios o arrogantes, por ejemplo, levantar la voz,interrumpir a la gente o hacerles callar, cruzar los brazos o dar golpecitos con el pie de forma impaciente.",
              },
              {
                id: "en-1:4-a",
                da: " Evite prejuicios ocultos. Puede ser muy diplomático/a con la mayoría de la gente, excepto con aquellos/as de un grupo determinado. Considere tomar la prueba de asociación implícita, que está disponible en www.understandingprejudice.org/iat/. Le ayudará a identificar prejuicios subconscientes.",
              },
              {
                id: "en-1:4-b",
                da: " Si le cuesta comprender la perspectiva de otra persona, concéntrese en los aspectos que tienen en común. Tienden a ser universales, por ejemplo, la apreciación de un buen servicio, el deseo de avanzar en la carrera profesional, el reconocimiento de la importancia de la calidad del tiempo con la familia — cualquier cosa que le vincule a usted con la persona.",
              },
              {
                id: "en-1:4-c",
                da: " Lea biografías o mire documentales acerca de grandes políticos. Observe cómo interactúan con diferentes grupos de interés, cómo transmiten su mensaje o expresan su opinión sin ofender o alienar a la gente que tiene opiniones diferentes.",
              },
            ],
          },
          {
            id: "en-2",
            icon: require("@/assets/Iconography/Attributes/06-02_Managing Negotiations.svg"),
            comp: "Buen Negociador/a",
            wdd: "Llega a resultados positivos para ambas partes incluso cuando hay conflicto de intereses y recursos limitados",
            progressMeasures: [
              {
                id: "en-2-0",
                pm: "Puedo llegar a una solución intermedia cuando negocio",
                pmMap: "Llegar a un acuerdo cuando negocio",
              },
              {
                id: "en-2-1",
                pm: "Durante las negociaciones por lo general alcanzo resultados que benefician a más partes",
                pmMap:
                  "En las negociaciones, alcanzar resultados que benefician a ambas partes",
              },
              {
                id: "en-2-2",
                pm: "Cuando la negociación termina, por lo general ambas partes se sienten satisfechas",
                pmMap:
                  "Cuando una negociación termina, asegurarme de que ambas partes quedan satisfechas",
              },
              {
                id: "en-2-3",
                pm: "No me molesta pedir lo que quiero",
                pmMap: "Pedir lo que quiero",
              },
            ],
            developmentActions: [
              {
                id: "en-2:1-a",
                da: " Trabaje en su estilo y enfoque: manténgase sereno/a, no levante la voz,reformule lo que la otra persona dijo y acepte su punto de vista. Tal enfoque es crítico para mantener una conversación productiva — los despliegues o exabruptos exagerados siempre trabajarán en su contra.",
              },
              {
                id: "en-2:1-b",
                da: " Si hablar de las emociones de la gente es importante para despejar el ambiente, hágalo pero maneje la conversación con cuidado. La meta es abordar los sentimientos pero ocúpese de conversar sobre los hechos lo más rápido posible.",
              },
              {
                id: "en-2:1-c",
                da: " Permita que la otra parte descargue sus frustraciones de modo que sientan que fueron escuchados/as. Probablemente reducirá la volatilidad durante las conversaciones.",
              },
              {
                id: "en-2:1-d",
                da: " Si las conversaciones entre usted y otras personas se caldean, hable con ellos/as como si no estuvieran disgustados/as, independientemente de su reacción. Concéntrese en su respuesta, no en su reacción.",
              },
              {
                id: "en-2:1-e",
                da: " Trate de mostrar empatía cuando una situación está cargada emocionalmente. ¿Porqué la otra parte está tan convencida acerca de una posición?",
              },
              {
                id: "en-2:1-f",
                da: " Quédese callado/a en los momentos adecuados. Cuando la gente se pone ansiosa, una reacción humana natural es tratar de llenar el silencio con ruido sin sentido, especialmente durante el conflicto. Durante las negociaciones, la gente ansiosa tiende a decir cosas que erosionan sus posiciones. Espere el momento oportuno formulando preguntas.",
              },
              {
                id: "en-2:1-g",
                da: " ¿Está revelando sus emociones inadvertidamente? — ¿pone los ojos en blanco,desvía la mirada con impaciencia, se mueve innecesariamente? Sea consciente de las señales que envía.",
              },
              {
                id: "en-2:1-h",
                da: " No se deje atraer por las amenazas, culpa o juegos de los demás. Recuerde, estas tácticas pueden hacerle perder la calma, por lo tanto no lo permita",
              },
              {
                id: "en-2:2-a",
                da: " Sólo considere una negociación en que una parte gana y la otra pierde si no necesita una relación duradera con la otra parte. Una parte que no obtiene beneficios de una negociación será reacia a mantener una relación con usted.",
              },
              {
                id: "en-2:2-b",
                da: " Considere la honestidad y la apertura antes de la manipulación y deje que los principios comunes de la ética y la imparcialidad le guíen cuando negocia",
              },
              {
                id: "en-2:2-c",
                da: " Evite llegar a la mesa con posiciones inflexibles blanco o negro. Siempre hay espacio para considerar otras opciones si realmente escucha lo que la otra parte tiene para decir.",
              },
              {
                id: "en-2:2-d",
                da: " Absténgase de usar amenazas para lograr su cometido. Las amenazas son improductivas y sólo sirven para poner a la otra parte a la defensiva.",
              },
              {
                id: "en-2:2-e",
                da: " Antes de negociar, piense cuidadosamente en los puntos que podría conceder y guárdelos para tener ventaja. Incluso si tiene la ventaja, conceder algunos puntos establece buena voluntad y permite a la otra parte irse con alguna sensación de beneficio.",
              },
              {
                id: "en-2:3-a",
                da: " Empiece las negociaciones estableciendo un ambiente de colaboración.Permita que la gente tenga unos momentos para conversar informalmente,disponga los asientos para no diferenciar lados, programe intervalos y aliente a las personas a hablar entre sí.",
              },
              {
                id: "en-2:3-b",
                da: " Permita que las partes expresen sus metas para la reunión.",
              },
              {
                id: "en-2:3-c",
                da: " Siempre escuche las cuestiones e intereses subyacentes de las partes involucradas y trate de comprenderlas. Es sorprendente cuántas negociaciones fracasan debido a los malentendidos. Formule la mayor cantidad de preguntas posibles para aclarar los motivos y las preocupaciones clave de la gente.",
              },
              {
                id: "en-2:3-d",
                da: " Tome medidas para asegurarse de que todas las partes efectivamente se escuchan entre sí. Reformule lo que una persona dice durante una conversación si hay alguna duda.Resuma los argumentos principales expresados a medida que la conversación avanza.",
              },
              {
                id: "en-2:3-e",
                da: " Use un lenguaje que claramente indique su voluntad de resolver un problema de una forma mutuamente beneficiosa y trabajar juntos. Use frases como “¿Qué les parece si intentamos esto?” o “¿Qué piensan acerca de que ambos tomemos este enfoque?”",
              },
              {
                id: "en-2:3-f",
                da: " Use comunicación no verbal para comunicarle a la otra parte que está escuchando y abierto a la conversación — mantenga contacto visual y asienta con la cabeza cuando comprenda. Evite una postura que muestre que se siente a la defensiva o amenazado/a,como cruzar los brazos, fruncir el ceño, sacudir la cabeza o reclinarse en la silla como si se hubiera desconectado.",
              },
              {
                id: "en-2:3-g",
                da: " Piense acerca del estilo personal de la otra parte. ¿Tienden a ser diplomáticos/as, o son más sinceros/as y ponen todo sobre la mesa de entrada? Adáptese en consecuencia a medida que negocia.",
              },
              {
                id: "en-2:3-h",
                da: " Considere los puntos de negociación que son de poco valor para usted y altamente valorados por la otra parte. Si tiene que ceder, es importante saber cuáles son esos puntos por adelantado.",
              },
              {
                id: "en-2:3-i",
                da: " Procure que cualquier avance y acuerdo sean lo más visibles posible. Documente el éxito obtenido a lo largo de las conversaciones escribiendo los puntos acordados en un “rotafolio” o pizarrón. Cuando la frustración sea alta, remítase al avance que se ha logrado.",
              },
              {
                id: "en-2:3-j",
                da: " Utilice transacciones comparables o que hayan sentando precedentes como marco de referencia para las negociaciones. La información puede ayudarle a medir el tipo de resultado que podría esperar y comprender los puntos que la otra parte probablemente estaría dispuesta a aceptar.",
              },
              {
                id: "en-2:4-a",
                da: " Considere todos sus intereses antes de que empiecen las negociaciones.Puede tener que conceder algunos puntos, pero sea claro/a acerca de los que absolutamente no puede conceder. Si no puede negociar una solución ganadora para ambas partes, ¿cuál es el escenario menos aceptable? Saber eso le ayudará a mantenerse en sus trece.",
              },
              {
                id: "en-2:4-b",
                da: " Si la otra parte ha adoptado el rol de negociador/a duro/a, encuentre formas durante el proceso de elogiarlos/as por su dureza y reconocer que son excelentes negociadores/as.",
              },
              {
                id: "en-2:4-c",
                da: " Si no puede ponerse de acuerdo en todo, trabaje en los puntos que son críticos y concéntrese en ellos por ahora. Acuerde abordar los otros puntos más tarde, pero trate de sentar un precedente para una experiencia de negociación exitosa.",
              },
              {
                id: "en-2:4-d",
                da: " Si ha llegado a un punto muerto, considere contratar un árbitro aceptable para ambas partes en lugar de ceder.",
              },
              {
                id: "en-2:4-e",
                da: " Esté preparado para retirarse en lugar de rendirse. Éste puede no ser el mejor momento para negociar y puede haber otra forma de obtener lo que necesita. Retirarse cuando no puede ganar nada es perfectamente aceptable.",
              },
              {
                id: "en-2:5-a",
                da: " Considere las metas de la negociación. ¿Qué pretende de ella? ¿Qué piensa que quiere la otra persona?",
              },
              {
                id: "en-2:5-b",
                da: " Considere posibles soluciones y alternativas. Si no llega a un acuerdo con la otra parte, ¿cuáles son sus alternativas? ¿Son buenas o malas? ¿Cuánto importa si no puede estar de acuerdo?¿ El hecho de no poder llegar a un acuerdo elimina futuras oportunidades? ¿Qué alternativas podría tener la otra persona?",
              },
              {
                id: "en-2:5-c",
                da: " Considere las relaciones. ¿Cuál es la historia de la relación; podría o debería tener un impacto en la negociación? ¿Hay alguna cuestión oculta que podría influenciar la negociación? ¿Cómo la manejará?",
              },
              {
                id: "en-2:5-d",
                da: " Considere las consecuencias de ganar o perder esta negociación. ¿Cuáles son para la otra persona?",
              },
              {
                id: "en-2:5-e",
                da: " ¿Quién tiene esa clase de poder en la relación? ¿Quién controla los recursos? ¿Quién puede perder más si no se produce un acuerdo? ¿Qué poder tiene la otra persona de satisfacer sus necesidades?",
              },
              {
                id: "en-2:5-f",
                da: " Nunca haga una afirmación o aseveración falsa y recolecte la mayor cantidad de información precisa posible antes de cualquier negociación.",
              },
            ],
          },
          {
            id: "en-3",
            icon: require("@/assets/Iconography/Attributes/06-01_Being Politically Astute.svg"),
            comp: "Políticamente Hábil",
            wdd: "Entiende cómo funciona la política de una corporación y sabe manejar la dinámica del poder en el ambiente corporativo",
            progressMeasures: [
              {
                id: "en-3-0",
                pm: "Adapto mis tácticas en base a una situación o persona determinada",
                pmMap:
                  "Adaptar mis tácticas en base a una situación o persona determinada",
              },
              {
                id: "en-3-1",
                pm: "Comprendo la dinámica entre los altos directivos",
                pmMap:
                  "Comprender cómo la dinámica de poder influye en la gente y en las decisiones que toman",
              },
              {
                id: "en-3-2",
                pm: "Rara vez, o nunca, creo problemas para otras personas por lo que digo",
                pmMap:
                  "Rara vez, o nunca, crear problemas a otras personas por lo que digo",
              },
              {
                id: "en-3-3",
                pm: "Sé qué información compartir con quién",
                pmMap:
                  "Saber qué información es importante compartir y con quién",
              },
            ],
            developmentActions: [
              {
                id: "en-3:1-a",
                da: " Observe qué permite a un líder respetado en su organización usar la política para presentar una propuesta. Puede ayudar a disipar un estereotipo que usted tenga acerca de la naturaleza de hacer política.",
              },
              {
                id: "en-3:1-b",
                da: " Lea acerca de líderes políticamente hábiles, tales como Mahatma Gandhi y Nelson Mandela, que son ampliamente respetados y superaron obstáculos tremendos manejando de alguna manera la política de sus tiempos. Le brindará una perspectiva diferente de la política.",
              },
              {
                id: "en-3:1-c",
                da: " Manténgase genuino/a y sincero/a. Si sus acciones están guiadas por lo que es mejor para la organización, más que por lo que es mejor para usted, se sentirá más cómodo/a",
              },
              {
                id: "en-3:1-d",
                da: " Comprenda claramente por qué es necesario poner la política en práctica para la meta que está tratando de alcanzar. Recopile una lista de maneras en las cuales las personas “adecuadas” pueden ayudarle a alcanzar su meta de forma más efectiva. ¿Tiene sentido hacerlo por su cuenta? ¿Cree lo suficiente en su posición como para defenderla? ¿Qué ética o valores realmente tiene que violar para alcanzar su meta?",
              },
              {
                id: "en-3:1-e",
                da: " A veces, por ser escépticos, deshumanizamos a las personas con poder político. Asista a eventos de la organización que le den la oportunidad de hablar con las personas clave a cargo de la toma de decisiones a un nivel más personal. Encuentre sus intereses comunes,pasiones y humanidad. Encontrará mucha gente respetable y honesta como usted.",
              },
              {
                id: "en-3:2-a",
                da: " Encuentre a un colega de confianza o mentor dentro de su organización con quien pueda conversar acerca de la política interna de la misma. Aprenda a comprender quién tiene el poder, para tomar decisiones en diferentes áreas,tanto en la teoría como en la realidad.",
              },
              {
                id: "en-3:2-b",
                da: " Familiarícese con el organigrama de la compañía y sus posiciones críticas. Póngase como meta presentarse cómo mínimo una vez a todas las personas en posiciones clave.",
              },
              {
                id: "en-3:2-c",
                da: " Maximice sus oportunidades de establecer contactos. Asista a recepciones, eventos y conferencias de la compañía para establecer relaciones con la mayor cantidad de gente posible, no sólo en su compañía sino también en su campo.",
              },
              {
                id: "en-3:2-d",
                da: " Esté preparado/a para comunicar brevemente la forma en que su trabajo, proyecto o idea puede marcar la diferencia. Usted a menudo no tiene la oportunidad de conversar sobre sus ideas extensamente, por lo tanto un discurso bien transmitido y convincente es importante.",
              },
              {
                id: "en-3:2-e",
                da: " Haga aliados con la gente relevante. Manténgales informados/as de los obstáculos que encuentra, incluyendo la resistencia de la gente o los departamentos. Juntos pueden desarrollar una estrategia para superar estos obstáculos y compartir la tarea de influenciar a otras personas.",
              },
              {
                id: "en-3:2-f",
                da: " Trate de desarrollar coaliciones para una máxima influencia. El poder a menudo radica en los números y algunas cuestiones necesitan una coalición para presentar una propuesta.",
              },
              {
                id: "en-3:2-g",
                da: " ¿Hay grupos específicos con los cuales tiene problemas políticamente la mayor parte del tiempo? Busque prejuicios determinados que pudiera albergar. Pueden pensar que son invisibles, pero la gente rápidamente capta las sutilezas en el comportamiento o el lenguaje que les torna defensivos/as y resistentes a su influencia.",
              },
              {
                id: "en-3:2-h",
                da: " La elección del momento puede marcar toda la diferencia cuando se necesita obtener respaldo. A veces simplemente no es el momento correcto para continuar presionando. Sea sensible acerca de los momentos en que necesita dejar de insistir para dejar la puerta abierta para más adelante. Enumere las condiciones que hacen que éste no sea el momento adecuado para presentar su propuesta.",
              },
              {
                id: "en-3:2-i",
                da: " A menudo, no es que se haya comunicado con la gente equivocada, sino que su presentación no fue bien recibida. Las habilidades de comunicación o interpersonales deficientes son una forma segura de perder influencia. Una evaluación de 360° es efectiva para obtener retroalimentación acerca de sus fortalezas y debilidades, así como también sobre las cuestiones que puede trabajar con un coach.",
              },
              {
                id: "en-3:2-j",
                da: " Lea acerca de gente común tal como Erin Brockovich que, con poca experiencia política, fue capaz de navegar a través de políticas complejas y ejercer una gran influencia.",
              },
              {
                id: "en-3:3-a",
                da: " Reenvíe correos electrónicos de halagos de clientes u otros miembros del equipo a la gente relevante.",
              },
              {
                id: "en-3:3-b",
                da: " Mantenga una lista de logros importantes para su referencia durante evaluaciones de desempeño. La persona que hace su evaluación puede no recordar todos sus logros a lo largo del año.",
              },
              {
                id: "en-3:3-c",
                da: " Pida a expertos y colegas respetados sus opiniones profesionales y consejo acerca de un proyecto. Le brinda la oportunidad de conocer gente influyente y hacer visible su trabajo.",
              },
              {
                id: "en-3:3-d",
                da: " Involúcrese en proyectos más allá de su ámbito inmediato que le expongan a las personas que toman las decisiones. Por ejemplo, ofrézcase como voluntario/a para un quipo de trabajo o comité.",
              },
              {
                id: "en-3:3-e",
                da: " Si, al principio, se siente incómodo con promocionar sus talentos, hable acerca de los logros de su equipo. Destacará sus logros en forma indirecta..",
              },
              {
                id: "en-3:3-f",
                da: " Invite a las personas clave que toman las decisiones de otras divisiones o grupos para que agreguen valor a sus reuniones y se familiaricen con sus proyectos.",
              },
              {
                id: "en-3:3-g",
                da: " Sus logros pueden hablar por sí mismos en el presente, pero un líder anterior de su organización puede no haber tenido la misma experiencia con usted. No pase por alto relaciones anteriores que puedan requerir una atención extra o incluso reparación.",
              },
            ],
          },
        ],
      },
      sc: {
        characteristic: "Se comunica bien",
        wdd: "Es capaz de expresar un punto de vista y su razonamiento claramente tanto a una sola persona como a grandes audiencias. Escribe de manera profesional en múltiples formatos y con la cantidad de información precisa y relevante. Mantiene a las personas informadas con datos relevantes y oportunos.",
        icon: require("@/assets/Iconography/Characteristics/15_Skilled Communicator.svg"),
        competencies: [
          {
            id: "sc-0",
            icon: require("@/assets/Iconography/Attributes/15-03_Communicating Well (Verbally).svg"),
            comp: "Se Comunica Bien (Verbalmente)",
            wdd: "Es capaz de expresar un punto de vista y su razonamiento claramente tanto a una sola persona como a grandes audiencias",
            progressMeasures: [
              {
                id: "sc-0-0",
                pm: "Me siento seguro de mí mismo/a cuando hablo con otras personas",
                pmMap:
                  "Sentirme seguro de mí mismo/a cuando hablo con otras personas",
              },
              {
                id: "sc-0-1",
                pm: "Mis pensamientos están bien organizados cuando hablo",
                pmMap: "Organizar bien mis pensamientos cuando hablo",
              },
              {
                id: "sc-0-2",
                pm: "Adapto cómo me comunico dependiendo de la situación",
                pmMap:
                  "Adaptar la manera de comunicarme dependiendo de cada situación",
              },
              {
                id: "sc-0-3",
                pm: "Por lo general, soy capaz de agregar valor a una conversación",
                pmMap: "Añadir valor a la conversación",
              },
              {
                id: "sc-0-4",
                pm: "Brindo suficiente contexto (me aseguro de que los demás están en la misma sintonía) cuando inicio una conversación",
                pmMap:
                  "Brindar suficiente contexto (me aseguro de que los demás están en la misma sintonía) cuando inicio una conversación",
              },
            ],
            developmentActions: [
              {
                id: "sc-0:1-a",
                da: " Hay muchas estrategias que puede practicar diariamente que le ayudarán a relajarse y a tener un mejor control de la reacción física de su cuerpo al estrés.Explore, por ejemplo, técnicas de relajación tales como respiración profunda y meditación. La práctica diaria hace que el control de sus respuestas sea más automático y se convertirá en algo como cualquier otra cosa en la cual se invierte tiempo y práctica diligente — usted mejorará.",
              },
              {
                id: "sc-0:1-b",
                da: " Su respuesta de alarma en situaciones de presentación está basada en un temor irracional y desproporcionado ante la situación en cuestión. Su cuerpo no sabe esto, por lo tanto su mente debe brindar perspectiva. Use autoafirmación positiva para abordar pensamientos negativos irracionales. Por ejemplo, reemplace “¿Qué pasa si no se cómo  responder una pregunta?” con “Es imposible que sepa todo”. Luego, encuentre una solución equilibrada, tal como “Responderé la pregunta de esa persona más tarde”. Preste atención y sea consciente de la afirmación negativa.",
              },
              {
                id: "sc-0:1-c",
                da: " Use la técnica de visualización para sentirse más cómodo/a con la presentación inminente. En otras palabras, imagínese teniendo una presentación exitosa. Trate de revisar los detalles en su mente. Haga que la experiencia sea lo más real posible. Haga esto repetidamente hasta que empiece a creer lo que visualiza.",
              },
              {
                id: "sc-0:1-d",
                da: " Manténgase objetivo/a acerca de su propósito: comunicar y hacer participar a la gente en la conversación. Si durante el proceso, la gente está de acuerdo con usted y le aprecian y usted está en condiciones de responder todas las preguntas, eso es simplemente una ventaja adicional, no su objetivo. Hasta que se sienta más cómodo/a con las presentaciones, elimine las presiones innecesarias y simplemente apunte a transmitir la información en forma efectiva.",
              },
              {
                id: "sc-0:1-e",
                da: " Afíliese a organizaciones tales como Toastmasters, que le ayudan a practicar tener mayor confianza para hablar y hacer presentaciones efectivas en público brindándole oportunidades para practicar en un ambiente no amenazador.",
              },
              {
                id: "sc-0:1-f",
                da: " Lea alguno de los cientos de libros sobre cómo hablar en público en forma efectiva,tales como Public Speaking for Success (Cómo hablar bien en público) de Dale Carnegie.",
              },
              {
                id: "sc-0:1-g",
                da: " Become intimate and comfortable with the subject matter. The more you know the more self-confident you will feel. You may need to do supplementary reading or talk to experts to help you.",
              },
              {
                id: "sc-0:1-h",
                da: " Use apuntes tales como tarjetas y presentaciones en PowerPoint, pero sólo como guías. Leer las notas textualmente durante una presentación la torna aburrida y no será percibido/a como un valor agregado. Además, no le permite relajarse y no deja que su personalidad sobresalga.",
              },
              {
                id: "sc-0:1-i",
                da: " Desempeñe el rol hasta que se lo crea. Hable con confianza, incluso si no se siente confiado/a. Nadie sabe que usted está incómodo/a a menos que lo demuestre. Mire al público directamente y hable de modo que todos puedan escucharle. Evite justificarse o disculparse por todo lo que dice, o moverse innecesariamente, porque mostrará que está nervioso/a y que le falta confianza.",
              },
              {
                id: "sc-0:1-j",
                da: " Consulte a un asesor profesional acerca de técnicas de relajación y reducción de ansiedad. Los ejercicios de respiración, bio-retroalimentación y visualización son sólo algunas de las herramientas que puede usar.",
              },
              {
                id: "sc-0:2-a",
                da: " No necesita tener un guión para hacer una buena presentación o mantener una conversación de forma elocuente, pero si tiende a perder el hilo fácilmente, dedique algo de tiempo a organizar sus pensamientos de antemano. Cree un flujo lógico para comunicar sus ideas y asegúrese de que sus ideas tengan un orden. Comparta el resumen con un colega para ver si tiene sentido. Trate de usar software como MindJet Manager para organizar las ideas de antemano o a medida que se conversan.",
              },
              {
                id: "sc-0:2-b",
                da: " Use apuntes para mantenerse enfocado/a. Redacte una agenda y asegúrese de no desviarse de ella. Asegúrese de que la agenda plantee las metas de la reunión o presentación. Incluso las conversaciones menos formales pueden beneficiarse de una agenda. Prepare ayudas visuales tales como una presentación en PowerPoint o simples tarjetas con los puntos clave que debe abordar al final de la conversación. Su tendencia podría ser a “improvisar”, pero la preparación necesaria redundará en su beneficio.",
              },
              {
                id: "sc-0:2-c",
                da: " Maneje la cantidad de detalle que brinda cuando habla o presenta. Si hay demasiado detalle, a la gente le resulta difícil mantenerse concentrada en su argumento. Siempre pregúntese cuando habla si el detalle que está brindando es crítico para la conversación, o si es simplemente información agregada.",
              },
              {
                id: "sc-0:2-d",
                da: " Limite la cantidad de conversación tangencial y anécdotas personales que introduce en una conversación. Estos desvíos del tema pueden desperdiciar mucho tiempo y distraer a su audiencia. Pídale a un colega de confianza que le avise cuando se esté apartando del tema. Ser consciente de con qué frecuencia hace esto puede servirle de ayuda para ajustar su estilo de conversación.",
              },
              {
                id: "sc-0:2-e",
                da: " ¡Sepa de lo que está hablando! Aunque no puede ser un/a experto/a en todo, cuánto más sepa de un tema más probabilidades habrá de que brinde información relevante.",
              },
              {
                id: "sc-0:2-f",
                da: " No suponga que todos son como usted. Algunas personas necesitan que usted vaya directamente al punto y otros quieren todos los detalles. ¿Le piden muy a menudo que acorte? ¿La gente tiende a evitar formularle preguntas? Trate de leer las reacciones de las personas o pregúnteles si está brindando demasiada información.",
              },
              {
                id: "sc-0:2-g",
                da: " ¿Se distrae fácilmente? Siempre anticipe que será interrumpido/a o que le formularán preguntas cuando está tratando de transmitir un concepto. Si la pregunta no es relevante, pospóngala y, por muy tentador que sea, evite las distracciones innecesarias.",
              },
              {
                id: "sc-0:2-h",
                da: " En la medida que pueda, haga un esfuerzo consciente para minimizar las distracciones en el ambiente de antemano. Programe las reuniones en lugares tranquilos lejos de la actividad, pida a la gente que apague sus teléfonos y sea consciente de minimizar las distracciones, y haga participar al número adecuado de gente en las reuniones — el número debería maximizar el aporte pero limite las distracciones que interrumpirán su concentración.",
              },
              {
                id: "sc-0:2-i",
                da: " Trate de no saltar de un tema a otro sin cerrarlo o sin suficiente introducción para un tema nuevo. Algunas personas pueden ser capaces de seguir su comunicación, pero otras piensan linealmente y necesitan que la conversación sea más organizada.",
              },
              {
                id: "sc-0:2-j",
                da: " No olvide brindar suficiente contexto a la gente cuando inicia una conversación.Resuma brevemente el estado de la presentación y asegúrese de que la gente sabe de qué está hablando antes de pasar a los detalles.",
              },
              {
                id: "sc-0:3-a",
                da: " Al hacer una presentación, es fácil quedar atrapado/a en el mensaje y olvidar a la audiencia. Manténganse en contacto con la misma. Por ejemplo,regularmente pregunte si están siguiendo el argumento, si le escuchan bien o si es necesario que hable más despacio. Siga evaluando su respuesta y si es necesario ajuste su estilo de comunicación. Asegúrese de obtener retroalimentación al final de la presentación para identificar si hay áreas de mejora posible.",
              },
              {
                id: "sc-0:3-b",
                da: " ¿Qué necesita escuchar o ver su audiencia para mantenerse interesada? ¿Detalles,imágenes, casos de negocios? Tal vez debería cubrir más temas si tiene una audiencia diversa.",
              },
              {
                id: "sc-0:3-c",
                da: " Si está haciendo una presentación ante personas de un grupo cultural específico,infórmese acerca de sus sensibilidades y normas. Hable con un consultor, lea acerca de la cultura y pregunte a otras personas que hayan tenido experiencia con ese grupo.",
              },
              {
                id: "sc-0:3-d",
                da: " Cuando tenga una conversación individual, considere la personalidad de su interlocutor. ¿Es la persona más orientada a la gente, analítica o reservada? Diseñe su mensaje con la personalidad del interlocutor en mente.",
              },
              {
                id: "sc-0:3-e",
                da: " Considere la complejidad de su mensaje. El nivel de comprensión del tema por parte de la audiencia determinará la información que usted brinda, en otras palabras, como de complejo o simple debe ser el mensaje. Si las personas a las cuales se está dirigiendo no son expertas en el tema, trate de evitar jerga técnica o información innecesaria que los dejará confundidos o frustrados.",
              },
              {
                id: "sc-0:4-a",
                da: " Reconozca las cosas que le hacen reaccionar cuando suceden. Respire profundo y dese tiempo para calmarse antes de responder. Recuérdese su propósito — que su mensaje sea escuchado y comprendido. Puede requerir una gran cantidad de paciencia.",
              },
              {
                id: "sc-0:4-b",
                da: " Pida tiempo para poner sus ideas en orden. Puede necesitar retirarse de la sala, lo cual es preferible antes de perder el foco totalmente.",
              },
              {
                id: "sc-0:4-c",
                da: " Trate de mantenerse objetivo/a y paciente. No puede controlar los estados de ánimo de las otras personas o su falta de respeto. ¿De qué manera ponerse emotivo/a va a mejorar la situación?",
              },
              {
                id: "sc-0:5-a",
                da: " Lea más sobre el tema relevante antes de asistir a una reunión o agrupación de personas.",
              },
              {
                id: "sc-0:5-b",
                da: " Lea el periódico tan a menudo como sea posible para mantenerse informado/a acerca de los acontecimientos actuales.",
              },
              {
                id: "sc-0:5-c",
                da: " Expóngase a diferentes métodos de expresión. Trate de leer diversos tipos de literatura, por ejemplo; ficción, revistas comerciales, poesía e informes gubernamentales.Tome nota del uso de vocabulario, metáforas y analogías que pueda incorporar en su comunicación.",
              },
              {
                id: "sc-0:5-d",
                da: " Asista a un taller de narración de cuentos para comprender cómo expresarse y captar a su audiencia de forma óptima.",
              },
              {
                id: "sc-0:5-e",
                da: " Comparta tiempo con colegas que sean comunicadores efectivos. ¿Qué temas abordan? ¿Cómo manejan la conversación trivial?",
              },
              {
                id: "sc-0:6-a",
                da: " En lugar de ignorar su condición, abórdela de frente de modo que los demás sepan que no es un tema tabú y que pueden pasar a los temas en cuestión.",
              },
              {
                id: "sc-0:6-b",
                da: " Si se siente cómodo haciéndolo, use el humor para romper el hielo acerca de sus circunstancias particulares.",
              },
              {
                id: "sc-0:6-c",
                da: " Concéntrese en las cosas que puede controlar — qué tan bien conoce el tema y qué tan preparado/a, agradable y accesible es.",
              },
              {
                id: "sc-0:6-d",
                da: " Busque un entrenador vocal, terapeuta o clínica para tratar temas de la voz donde pueda encontrar apoyo y aprender técnicas para manejar problemas en el habla.",
              },
              {
                id: "sc-0:6-e",
                da: " Contrate un profesor nativo para que le ayude con su acento.",
              },
            ],
          },
          {
            id: "sc-1",
            icon: require("@/assets/Iconography/Attributes/15-02_Communicating Well (Written).svg"),
            comp: "Se Comunica Bien (Por Escrito)",
            wdd: "Escribe de manera profesional en múltiples formatos y con la cantidad de información precisa y relevante",
            progressMeasures: [
              {
                id: "sc-1-0",
                pm: "Rara vez necesito aclarar lo que escribí",
                pmMap: "Aclarar lo que escribo",
              },
              {
                id: "sc-1-1",
                pm: "Adapto mi estilo de redacción al destinatario",
                pmMap: "Adaptar mi estilo de redacción al destinatario",
              },
              {
                id: "sc-1-2",
                pm: "Tengo una buena comprensión de la gramática básica",
                pmMap: "Tener una buena comprensión de la gramática básica",
              },
              {
                id: "sc-1-3",
                pm: "Siempre corrijo o edito lo que escribí antes de enviarlo",
                pmMap: "Corregir o editar lo que escribí antes de enviarlo",
              },
              {
                id: "sc-1-4",
                pm: "Puedo exponer mi argumento con pocas palabras",
                pmMap: "Exponer mi argumento con pocas palabras",
              },
            ],
            developmentActions: [
              {
                id: "sc-1:1-a",
                da: " Siempre relea y edite lo que escribió. Es fácil cometer errores cuando escribe algo rápidamente y una simple revisión los detectará.",
              },
              {
                id: "sc-1:1-b",
                da: " Deje que otra persona revise su redacción — un/a colega o asistente puede revisar la información importante que está enviando a otras personas. Es sorprendente cuántos errores puede encontrar otra persona. Trate de reducir la cantidad de errores que comete.",
              },
              {
                id: "sc-1:1-c",
                da: " No suponga que la gente sabe de lo que usted está hablando, especialmente si su estilo de redacción es bastante conciso. Asegúrese de que la gente tenga el contexto adecuado para comprender su mensaje.",
              },
              {
                id: "sc-1:1-d",
                da: " Si tiene tendencia a escribir como habla, puede estar usando jerga que no todo el mundo entienda. Las conversaciones y la comunicación escrita son métodos muy diferentes de expresión y no deben confundirse en un entorno profesional.",
              },
              {
                id: "sc-1:2-a",
                da: " Organice sus pensamientos minuciosamente antes de empezar a escribir.Explique sus argumentos y asegúrese de que estén presentados en una secuencia lógica. Revíselos con un/a colega para ver si tienen sentido. Si no es naturalmente bueno/a redactando, use sus demás fortalezas para organizar sus pensamientos de antemano. Por ejemplo, si tiene inclinación visual, pruebe software tal como MindJet Manager para planificar y organizar sus ideas, o crear su propio dibujo o ilustración. Si es una persona verbal, exprese sus pensamientos en voz alta o haga una grabación de sus propuestas, y luego póngalas por escrito.",
              },
              {
                id: "sc-1:2-b",
                da: " No brinde detalles innecesarios que confundirán o distraerán a la gente de su mensaje escrito. ¿Qué información de apoyo tiene que saber el/la lector/a? Si el/la destinatario/a no está familiarizado/a con el tema, brinde contexto suficiente para aclarar su comunicación. Preferentemente, agregue documentos adjuntos o brinde material de referencia que la persona pueda consultar. Su mensaje básico debe brindar los puntos destacados o un resumen histórico breve únicamente.",
              },
              {
                id: "sc-1:2-c",
                da: " Preste atención al formato, especialmente cuando necesita comunicar varios puntos.Un buen formato facilita mucho al/la lector/a seguir sus pensamientos. Por ejemplo, separe puntos diferentes con párrafos o títulos o espaciamiento adecuados, en lugar de que toda la información fluya junta. Destaque en negrita puntos importantes sobre los cuales quiere llamar la atención. Aunque pueda parecer algo seco o excesivamente formal, use numeración o viñetas para ordenar su redacción.",
              },
              {
                id: "sc-1:2-d",
                da: " Una gramática deficiente puede hacer que el correo electrónico más simple sea difícil de entender. Asegúrese de comprender los principios básicos de la puntuación. Use el corrector de su software, pero no confíe en eso solamente. Relea su trabajo. Eats, Shoots and Leaves de Lynn Truss es un libro entretenido e informativo acerca de los peligros de una gramática deficiente.",
              },
              {
                id: "sc-1:2-e",
                da: " Limite las exposiciones repetitivas o puntos que confundan a sus lectores/as y debiliten su atención. No debería estar repitiendo su argumento varias veces, excepto una vez en su resumen. Relea lo que escribió y borre frases innecesarias — elimine el “ruido” de su redacción. Esto suena simple, pero no se hace con la frecuencia suficiente.",
              },
              {
                id: "sc-1:2-f",
                da: " Pregunte a los demás si tienen dificultad en leer su trabajo y comprender su mensaje,y exactamente qué los confunde. Use la retroalimentación para mejorar sus habilidades de redacción.",
              },
              {
                id: "sc-1:3-a",
                da: " Considere la personalidad del/de la lector/a. Escriba para el/la lector/a, no para usted. ¿Es el/la lector/a sociable o reservado/a, analítico/a o lleno/a de humor? Diseñe su mensaje con la personalidad del/de la interlocutor/a en mente.",
              },
              {
                id: "sc-1:3-b",
                da: " ¿Cómo de bien conoce al/a la lector/a? A menos que conozca a la persona relativamente bien, use comunicación más formal. Asegúrese de que su estilo de redacción sea adecuado tanto para el mensaje como para el/la lector/a.",
              },
              {
                id: "sc-1:3-c",
                da: " Aprenda del estilo de redacción de otras personas. Por ejemplo, si responden con mensajes de una línea, debe escribir brevemente también.",
              },
              {
                id: "sc-1:3-d",
                da: " Tenga en cuenta las diferencias culturales cuando escriba. La gente de los países latinos, por ejemplo, tiende a esperar menos formalidad en su comunicación que las personas de oriente. Si se comunica regularmente con un grupo cultural determinado,merece la pena hacer algo de investigación e informarse acerca de sus sensibilidades y normas. Pregúntele a un consultor, lea acerca de la cultura, pregunte a las personas que hayan tenido experiencia con ese grupo.",
              },
              {
                id: "sc-1:3-e",
                da: " Considere el nivel de comprensión del/de la lector/a acerca del tema. Si la persona no es experta, evite lenguaje técnico y use analogías o explicaciones con las cuales pueda relacionarse.",
              },
              {
                id: "sc-1:3-f",
                da: " Asegúrese de que su vocabulario sea adecuado para sus lectores/as. El uso de lenguaje ceremonioso con la audiencia equivocada puede resultar irritante y molesto y puede percibírsele como arrogante.",
              },
              {
                id: "sc-1:3-g",
                da: " Sea consciente de la posición y estado del/de la lector/a en relación con usted. La alta dirección tiene que leer grandes volúmenes de información, por lo tanto respete su tiempo redactando en la forma más breve y clara posible. Concéntrese en destilar su información hasta los puntos críticos.",
              },
              {
                id: "sc-1:4-a",
                da: " Puede estar inspirado/a para escribir cuando se siente emotivo/a. Ponga sus pensamientos en palabras, pero no distribuya el mensaje o documento hasta que se esté sintiendo menos afectado/a. Dese tiempo para leerlo nuevamente en un estado menos emotivo y use la oportunidad para editar el contenido y tono del mensaje. Si es posible, deje pasar un día o dos, luego revise sus pensamientos y redacción..",
              },
              {
                id: "sc-1:4-b",
                da: " Muestre lo que escribió a un/a colega de confianza o dos y obtenga su perspectiva acerca de si es inadecuado.",
              },
              {
                id: "sc-1:4-c",
                da: " Trate de identificar sus así llamados botones rojos. La consciencia de sí mismo/a puede ayudarle a reconocer cuando reacciona con demasiada sensibilidad y darle la oportunidad de modificar su mensaje. Mantenga un registro de los tipos de comentarios,situaciones o personas que le ponen nervioso/a y aprenda de ello.",
              },
              {
                id: "sc-1:4-d",
                da: " Si debe responder inmediatamente, respire profundamente y trate de calmarse.Mientras escribe, recuerde que el propósito de la comunicación es transmitir su argumento.Hágalo de forma objetiva y trate de comprender el punto de vista del/de la destinatario/a.Puede requerir una gran cantidad de paciencia, sea consciente de ello.",
              },
              {
                id: "sc-1:4-e",
                da: " Si es sensible acerca de un tema y desea comunicar sus sentimientos, preferentemente organice una reunión personal. A menudo escribir no es un medio fácil a través del cual expresar sus emociones de forma calmada y clara.",
              },
              {
                id: "sc-1:5-a",
                da: " Lea lo más posible. Aumente la cantidad de tiempo que dedica a leer — es la única manera de exponerse a diferentes estilos de expresión y mejorar su vocabulario. Trate de leer diversos tipos de literatura, por ejemplo, ficción,revistas comerciales, poesía, informes gubernamentales. Tome nota del vocabulario,metáforas y analogías que puede incorporar en su comunicación.",
              },
              {
                id: "sc-1:5-b",
                da: " Practique la redacción. Como cualquier habilidad, necesita una aplicación repetida para mejorar. Lleve un diario en casa para entrar en el hábito de expresar sus pensamientos por escrito, o tome un curso de redacción creativa para desplegar su imaginación y capacidades.",
              },
              {
                id: "sc-1:5-c",
                da: " Inmediatamente consulte el diccionario cuando encuentre palabras que no conoce.Memorícelas e incorpórelas en su comunicación escrita de ahora en adelante. Un buen diccionario es una herramienta esencial en todas las oficinas, independientemente de su posición.",
              },
              {
                id: "sc-1:5-d",
                da: " Mantenga un diccionario de sinónimos cerca que le ayude a identificar palabras alternativas para usar. Existen muchos diccionarios de sinónimos en Internet disponibles,pero como regla no son tan completos como sus versiones impresas.",
              },
              {
                id: "sc-1:5-e",
                da: " Si no está redactando en su primer idioma, pídale a un/a nativo/a que le ayude con elecciones de frases y palabras y cómo traducir lo que quiere decir.",
              },
            ],
          },
          {
            id: "sc-2",
            icon: require("@/assets/Iconography/Attributes/15-01_Informing Others.svg"),
            comp: "Informa A Otras Personas",
            wdd: "Mantiene a las personas informadas con datos relevantes y oportunos",
            progressMeasures: [
              {
                id: "sc-2-0",
                pm: "Doy retroalimentación a los demás con suficiente tiempo para que emprendan acciones si es necesario",
                pmMap:
                  "Dar retroalimentación a los demás con suficiente tiempo para que emprendan acciones si es necesario",
              },
              {
                id: "sc-2-1",
                pm: "Considero a mi audiencia antes de decidir cómo informarles",
                pmMap:
                  "Tener en cuenta a mi audiencia antes de decidir cómo informarles",
              },
              {
                id: "sc-2-2",
                pm: "Estoy dispuesto/a a brindar información que no será bien recibida",
                pmMap:
                  "Estar dispuesto/a a brindar información que no será bien recibida",
              },
              {
                id: "sc-2-3",
                pm: "Incluso cuando estoy disgustado/a o en desacuerdo con alguien, comparto la información libremente",
                pmMap:
                  "Compartir la información libremente, incluso cuando estoy disgustado/a o en desacuerdo con alguien",
              },
              {
                id: "sc-2-4",
                pm: "Me aseguro de que mi supervisor o gerente esté informado/a acerca del estado de mi trabajo",
                pmMap:
                  "Informar a las personas pertinentes acerca de lo que ocurre en la organización para mentenerlos informados/as y motivados/as",
              },
            ],
            developmentActions: [
              {
                id: "sc-2:1-a",
                da: " Obtenga perspectiva. Pida a un colega de confianza que pueda tratar la situación de forma más objetiva que le dé su opinión acerca de su gravedad.Las circunstancias pueden no ser tan graves como parecen.",
              },
              {
                id: "sc-2:1-b",
                da: " Reconozca sus errores, pero concéntrese en la solución. Si la gente está disgustada por la información, bríndeles la oportunidad de expresarse sin tratar de defender su posición. Usted ha aceptado los errores y es poco productivo enredarse en defenderlos en este punto.",
              },
              {
                id: "sc-2:1-c",
                da: " No empeore la situación endulzando la realidad. Sea sincero/a con la información que brinda. Tratar de que el panorama luzca mejor para disminuir una respuesta negativa,significa que no se tomarán las medidas adecuadas, lo que puede crear mayores problemas en el futuro.",
              },
              {
                id: "sc-2:1-d",
                da: " Aprenda a confrontar a la gente. Empiece trabajando en sus habilidades de manejo de conflictos. Investigue el tema o contrate a un coach.",
              },
              {
                id: "sc-2:1-e",
                da: " Elija la forma más adecuada de comunicación para asegurarse de que la información sea recibida de la mejor manera posible. ¿Es adecuado informar a la gente por medio de correo electrónico, por ejemplo? Podría ser demasiado impersonal para cierta información.",
              },
              {
                id: "sc-2:1-f",
                da: " Hable inmediatamente. Cada día que deje pasar generará más estrés para usted,porque se tornará cada vez más difícil explicar por qué no compartió la información antes.",
              },
              {
                id: "sc-2:2-a",
                da: " Acuerde cuándo y cómo mantendrá informada a la gente relevante. Puede ser en reuniones de personal, a través de correos electrónicos o con un informe de situación. La clave es establecer un sistema que le obligue aconsiderar el brindar información a los demás, como la prioridad que merece ser.",
              },
              {
                id: "sc-2:2-b",
                da: " Programe una cantidad de tiempo realista para compartir información y transmitir conocimientos. Debido a agendas ajustadas, la tentación es limitar el tiempo que se dedica a reuniones informativas. Pero la gente necesita saber que compartir información es una prioridad para usted, no una molestia.",
              },
              {
                id: "sc-2:2-c",
                da: " Por cuestiones de tiempo puede ser que esté resumiendo demasiado. Asegúrese de brindar suficiente contexto y antecedentes para que la información sea fácil de digerir.",
              },
              {
                id: "sc-2:3-a",
                da: " Durante las reuniones, escuche el tipo de información que la gente puede necesitar para hacer su trabajo y si tiene dicho material, compártalo con llos/as.",
              },
              {
                id: "sc-2:3-b",
                da: " Establezca “revisiones de aprendizaje” informales y regulares, durante las cuales la gente se reúna para compartir lo que aprendieron.",
              },
              {
                id: "sc-2:3-c",
                da: " Cree programas de mentores y recompense a la gente que transmite sus conocimientos a los demás.",
              },
              {
                id: "sc-2:3-d",
                da: " Desarrollar a otras personas es altamente valorado en una organización. Agregue esta habilidad a su plan de desarrollo y contrate a un coach para que le ayude.",
              },
              {
                id: "sc-2:3-e",
                da: " Si retiene información debido a fuertes sentimientos negativos hacia una persona o una cuestión sin resolver con él/ella, trate de resolverlo mediante una conversación. Una persona que ambos respetan puede ayudar a mediar en el conflicto de forma profesional.",
              },
              {
                id: "sc-2:3-f",
                da: " Tenga en cuenta, cuándo el favoritismo determina con quién comparte la información y la clase de información que revela. Haga una lista de la gente a quien, por lo general,retiene información y converse sus razones con un coach.",
              },
              {
                id: "sc-2:3-g",
                da: " Puede ser el/la único/a que no confía en alguna persona. Hable con un colega o mentor acerca de sus motivos. Es importante para obtener perspectiva y, a veces,simplemente para obtener un cuadro de situación más realista.",
              },
              {
                id: "sc-2:3-h",
                da: " Pregúntese si su motivo principal para retener información es la ganancia personal.De ser así, deje de hacerlo.",
              },
              {
                id: "sc-2:4-a",
                da: " Como regla general, suponga que la gente quiere saberlo todo. Es mejor moderar lo que dice que ser visto/a como alguien indiferente o que carece de cualidades de atención al cliente.",
              },
              {
                id: "sc-2:4-b",
                da: " Si piensa que puede incomodar a la gente, pídales que aclaren cuánta información necesitan.",
              },
              {
                id: "sc-2:4-c",
                da: " Copiar a las personas relevantes en los correos electrónicos es una forma rápida y simple de mantenerlos/as informados/as sin trabajo extra por su parte. Pueden elegir ignorar o leer la correspondencia. Hágalo de forma habitual.",
              },
              {
                id: "sc-2:4-d",
                da: " Sea consciente de la información que la gente simplemente tiene que saber y comuníquela. Tenga especial cuidado en informar a los demás acerca de cuestiones y asuntos controvertidos que afectan negativamente a un cliente.",
              },
              {
                id: "sc-2:4-e",
                da: " ¿Qué tan informados están sus clientes internos y externos? Establezca un sistema para asegurarse de comunicar la información importante acerca de nuevos productos, o cambios en los procedimientos y fechas de entrega, de forma oportuna. Mitigue cualquier riesgo enviando un mensaje a los clientes indicando, que son importantes para usted y que los cambios están bajo control.",
              },
              {
                id: "sc-2:4-f",
                da: " No asuma que su responsabilidad termina una vez que ha informado a la gente. Cree recordatorios y haga seguimiento de los mismos, con la mayor frecuencia posible.",
              },
              {
                id: "sc-2:4-g",
                da: " Asegúrese de tener alguna otra persona en el equipo que esté lo suficientemente informado/a como para comprender el estado de sus proyectos y poder ocuparse de ellos cuando usted no esté disponible.",
              },
              {
                id: "sc-2:4-h",
                da: " No se vea tentado a terminar un proyecto completamente antes de conversarlo con su superior. Envíe actualizaciones constantes o divida el proyecto en hitos más pequeños acerca de los cuales pueda informar. Acuerde de antemano cuáles serán esos hitos.",
              },
              {
                id: "sc-2:5-a",
                da: " Piense acerca de los conocimientos que posee que puedan ser valiosos para otros grupos y compártalos con ellos.",
              },
              {
                id: "sc-2:5-b",
                da: " Comunique la utilidad de compartir información entre los equipos y encuentre maneras de recompensarlo y alentarlo.",
              },
              {
                id: "sc-2:5-c",
                da: " Cree oportunidades de interacción entre las diferentes funciones para derribar silos estructurales.",
              },
              {
                id: "sc-2:5-d",
                da: " Interésese por conocer mejor a la gente de diferentes divisiones. Facilitará el intercambio de información.",
              },
              {
                id: "sc-2:5-e",
                da: " Comprenda la política de la compañía: quién supuestamente posee qué información, a quién debería incluir en la correspondencia y así sucesivamente. Le permitirá acceder a información sin cruzar fronteras políticas.",
              },
            ],
          },
        ],
      },
      pf: {
        characteristic: "Resuelve problemas",
        wdd: "Busca métodos para mejorar o reorganizar los procesos continuamente. Toma ideas nuevas de otras personas y las transforma de conceptos iniciales a resultados finales a través del proceso de innovación. Resuelve problemas difíciles utilizando una combinación de intuición y pensamiento analítico. Capta rápidamente el funcionamiento de las tecnologías y encuentra oportunidades para integrarlas en su trabajo.",
        icon: require("@/assets/Iconography/Characteristics/13_Practical Fixer.svg"),
        competencies: [
          {
            id: "pf-0",
            icon: require("@/assets/Iconography/Attributes/13-04_Improving Processes.svg"),
            comp: "Mejora Los Procesos",
            wdd: "Busca métodos para mejorar o reorganizar los procesos continuamente",
            progressMeasures: [
              {
                id: "pf-0-0",
                pm: "Identifico, analizo y mejoro los procesos clave de la organización",
                pmMap:
                  "Identificar, analizar y mejorar los procesos clave de la organización",
              },
              {
                id: "pf-0-1",
                pm: "Continuamente busco maneras de aumentar la producción, la eficiencia y la efectividad de los procesos",
                pmMap:
                  "Biuscar constantemente maneras de aumentar la producción, la eficiencia y la efectividad de los procesos",
              },
              {
                id: "pf-0-2",
                pm: "Identifico las debilidades que pueden dificultar que los procesos cumplan su propósito",
                pmMap:
                  "Identificar las debilidades que pueden dificultar que los procesos cumplan su propósito",
              },
              {
                id: "pf-0-3",
                pm: "Documento y reflexiono sobre las lecciones aprendidas",
                pmMap: 'Documentar y reflejar en "lecciones aprendidas"',
              },
            ],
            developmentActions: [
              {
                id: "pf-0:1-a",
                da: " Investigue. Estudie prácticas y procesos de gestión de calidad en Internet y familiarícese con los diversos modelos y metodologías. Busque modelos y prácticas comunes, y encuentre estudios de casos que expliquen todo el proceso desde la identificación inicial del problema hasta la implementación de la solución, resultados logrados y desafíos enfrentados.",
              },
              {
                id: "pf-0:1-b",
                da: " Elija una metodología adecuada. La estrategia Six Sigma, por ejemplo, es un proceso complejo, intenso, orientado a los detalles que requiere una adecuada capacitación para ser implementada eficazmente. También brinda un mejor rendimiento en un entorno de muchas transacciones en el cual pequeños cambios pueden tener grandes consecuencias. Hay muchos otros enfoques que son menos intensivos o más fáciles de usar, que pueden adaptarse mejor a un entorno orientado a los servicios o a diferentes grados de experiencia.",
              },
              {
                id: "pf-0:1-c",
                da: " Busque a un/a experto/a en la compañía. Se beneficiará de su experiencia sin tener que cometer errores.",
              },
              {
                id: "pf-0:1-d",
                da: " Considere contratar un/a consultor/a externo/a en gestión de calidad. Hable con él/ella acerca de los proyectos que implementó para asegurarse de que su experiencia coincide con sus necesidades. Si el costo es un problema, considere contratar a un/a consultor/a que le ayude a implementar un pequeño proyecto y a aplicar sus principios de forma independiente a un proyecto de mayor escala.",
              },
              {
                id: "pf-0:1-e",
                da: " Asegúrese de obtener opiniones de los empleados y clientes cuando mejora procesos.La gente en las trincheras y aquellos/as que usan el producto están más cerca del problema y en la mejor posición para darle una retroalimentación valiosa.",
              },
              {
                id: "pf-0:1-f",
                da: " Observe a sus competidores y otras industrias o negocios que operen en condiciones similares. Hay mucho para aprender acerca de lo que hacen los demás para mejorar sus procesos. Por ejemplo, si su negocio distribuye productos a través de un canal en lugar de directamente al consumidor, busque negocios relacionados en industrias que no sean competidoras, que sean reconocidos como líderes y hable con ellos. La mayoría de las compañías están felices de compartir sus éxitos y experiencias, especialmente si usted no es un competidor.",
              },
              {
                id: "pf-0:1-g",
                da: " Asista a talleres o seminarios que le expongan a formas diferentes de pensar en el área de gestión de procesos.",
              },
              {
                id: "pf-0:1-h",
                da: " Cuando mejore procesos, mantenga al consumidor en mente. Internamente, el proceso podría ser altamente eficiente pero, ¿cumple con las necesidades del cliente?",
              },
              {
                id: "pf-0:2-a",
                da: " Concentre su atención en la diferencia significativa entre un buen producto o servicio y uno excelente. Piense acerca de los casos en que recibió un excelente servicio o estuvo totalmente satisfecho con un producto que compró. Luego considere los casos en que recibió un servicio deficiente o compró un producto inferior. Use estas reflexiones para identificar un proceso en su organización que funciona bien pero que podría beneficiarse si se mejoran algunas de sus partes. Escriba sus pensamientos acerca de cómo estos cambios podrían tener un impacto positivo en los clientes tanto internos como externos.",
              },
              {
                id: "pf-0:2-b",
                da: " Identifique áreas potenciales de mejora dentro de su organización. Después organice una reunión de intercambio de ideas e invite a gente de todas las áreas o funciones relevantes para que participen. Documente los elementos potencialmente beneficiosos identificados. Determine las acciones que deberían tomarse a continuación y quién será responsable de ellas.",
              },
              {
                id: "pf-0:2-c",
                da: " Manténgase al corriente de las tendencias del mercado acerca de la mejora de procesos, por ejemplo, mejores prácticas, Six Sigma, etc.",
              },
              {
                id: "pf-0:2-d",
                da: " Expóngase lo más posible a lo que sucede en su industria. Asista a exposiciones,conferencias y seminarios por Internet que cubran temas de avanzada tecnología y destaquen productos o servicios innovadores.",
              },
              {
                id: "pf-0:2-e",
                da: " Manténgase al corriente de tendencias emergentes globalmente y en su región. Lea publicaciones de la industria, revistas y diarios líderes y cualquier otra literatura del tema.Baje transmisiones por Internet o inscríbase para recibir boletines y alertas electrónicas acerca del mercado, las tendencias de la industria, los avances tecnológicos y científicos y las noticias de último momento.",
              },
              {
                id: "pf-0:2-f",
                da: " Desarrolle un escepticismo sano acerca de sus procesos. Pregúntese por qué hace las cosas en la forma en que se hacen. Cuestione la información que le presentan.",
              },
              {
                id: "pf-0:3-a",
                da: " Comprenda el proceso de cambio. Ha sido estudiado extensamente y es mucho más predecible de lo que piensa. Aprenda a comprender algunos modelos de cambio, las fases de cambio y cómo la gente responde a ellos,cómo manejar la resistencia y cómo obtener compromiso y respaldo para lo nuevo y diferente.",
              },
              {
                id: "pf-0:3-b",
                da: " Considere la alternativa al cambio. Proyecte las consecuencias de cambiar versus no cambiar.",
              },
              {
                id: "pf-0:3-c",
                da: " La gente evita el cambio debido al dolor inicial, por lo tanto concéntrese en el resultado final y foméntelo.",
              },
              {
                id: "pf-0:3-d",
                da: " Identifique personas que se vean energizadas por el cambio. La apertura a lo nuevo es un rasgo de personalidad fundamental y siempre encontrará personas dispuestas a defender la causa. Es probable que sean apasionados/as y entusiastas acerca del cambio, lo que puede ser contagioso. Asegúrese de que obtengan los recursos y el respaldo que necesitan para ser agentes de cambio y úselos para liderar equipos de proyectos.",
              },
              {
                id: "pf-0:3-e",
                da: " Evite la complacencia, es decir, no formular preguntas difíciles. Establezca un proceso formal por el cual específicamente considere lo que ha hecho que mejore el negocio de alguna manera y haga esto al menos dos veces por año. ¿Qué importancia tuvo esa mejora, qué beneficios tuvo, qué habría pasado si no se hubiera hecho el cambio? Tal proceso creará una oportunidad para que usted celebre su éxito y reflexione sobre las oportunidades perdidas, lo que motivará y alentará más esfuerzos de mejora de procesos en el futuro.",
              },
              {
                id: "pf-0:3-f",
                da: " Aliente a los empleados a participar en la mejora del diseño de trabajo y en los procesos para asegurarse de que obtiene opiniones diversas. Organice sesiones regulares de retroalimentación e intercambio de ideas con su equipo así como también con colegas en otras funciones para fortalecer sus iniciativas de mejora.",
              },
              {
                id: "pf-0:3-g",
                da: " Otorgue autoridad a otras personas para diseñar sus propios procesos de trabajo.Aliente a su equipo a investigar las mejores prácticas de los líderes de la industria y dentro de otras áreas de la organización. Esta práctica aumenta el respaldo del proceso por parte de los empleados y sube la moral.",
              },
              {
                id: "pf-0:3-h",
                da: " Tenga cuidado de no establecer una cultura de “sí señor”. Pregunte a un colega de confianza si la gente se siente así acerca de dar su opinión. Asegúrese de que la gente sepa que todas las ideas son valiosas, incluso si son contrarias a las suyas.",
              },
              {
                id: "pf-0:4-a",
                da: " Manténgase al corriente de lo que sus clientes internos y externos esperan ahora, y anticipe sus necesidades futuras antes de que ellos mismos sepan cuáles son. Tendrá que conducir un análisis de mercado que incluya los cambios en el segmento demográfico, la competencia y la tecnología del cliente.Establezca varios procesos para obtener retroalimentación del cliente acerca de características, valor, precio, calidad, conveniencia, etc. de forma regular.",
              },
              {
                id: "pf-0:4-b",
                da: " Siempre diseñe sus procesos con sus clientes en mente, incluyendo el diseño de productos, los materiales empleados, la fabricación, los canales de distribución, así como también el servicio y el apoyo al cliente.",
              },
              {
                id: "pf-0:4-c",
                da: " Intercambie ideas acerca de maneras de mejorar la satisfacción del cliente con su equipo. Póngase en el lugar de sus clientes. ¿Qué les complacería? ¿Qué les desagradaría?Use las respuestas para buscar maneras de mejorar sus procesos y crear mayor apoyo al cliente.",
              },
              {
                id: "pf-0:4-d",
                da: " Experimente sus propios servicios y productos. No hay mejor manera de identificar oportunidades de mejora que obtener experiencia de primera mano de los productos o servicios que vende. Un fabricante multinacional de pañales para adultos hizo que los ejecutivos de la compañía los usaran por un día. Esto cambió fundamentalmente la forma en que pensaban acerca de sus clientes y sus productos.",
              },
              {
                id: "pf-0:4-e",
                da: " Trate a sus proveedores como clientes. Son un aspecto clave de su negocio y mejorar los procesos para beneficiar a ambas partes mejorará su resultado final.",
              },
            ],
          },
          {
            id: "pf-1",
            icon: require("@/assets/Iconography/Attributes/13-03_Managing  Ideas.svg"),
            comp: "Gestiona Las Ideas De Otras Personas",
            wdd: "Toma ideas nuevas de otras personas y las transforma de conceptos iniciales a resultados finales a través del proceso de innovación",
            progressMeasures: [
              {
                id: "pf-1-0",
                pm: "Aliento a la gente a compartir nuevas ideas",
                pmMap: "Alientar a la gente a compartir nuevas ideas",
              },
              {
                id: "pf-1-1",
                pm: "Valoro y apoyo la creatividad",
                pmMap: "Valorar y apoyar la creatividad",
              },
              {
                id: "pf-1-2",
                pm: "Escucho las ideas de todos/as, incluso si son diferentes a las mías",
                pmMap:
                  "Escuchar las ideas de todos/as, incluso si son diferentes a las mías",
              },
              {
                id: "pf-1-3",
                pm: "Creo que las ideas innovadoras requieren un plan si han de ejecutarse",
                pmMap:
                  "Asegurar que se cree un plan para ejecutar las ideas innovadoras",
              },
            ],
            developmentActions: [
              {
                id: "pf-1:1-a",
                da: " Estimule la creatividad alentando siempre a los/as empleados/as a ofrecer cualquier pensamiento sobre un nuevo enfoque, producto o servicio que pueda implementarse ahora y en el futuro.",
              },
              {
                id: "pf-1:1-b",
                da: " Asegúrese de que su equipo incluya algunas personas altamente creativas — tienden a obligar a los demás a pensar en nuevas ideas también.",
              },
              {
                id: "pf-1:1-c",
                da: " Inicie una campaña de ideas para involucrar a todos/as en generarlas. Presente un problema de negocios a los empleados y aliéntelos a participar en encontrar soluciones.Fije un período durante el cual puedan aportar sus sugerencias, luego seleccione las mejores ideas y envíelas a los expertos para su evaluación. Las ideas ganadoras serán usadas y sus creadores/as recibirán el reconocimiento.",
              },
              {
                id: "pf-1:1-d",
                da: " No se concentre en obtener una idea perfecta. Aliente a la gente a generar más de una solución y evaluar el aporte en su variedad. Por lo general, se combina un rango de ideas para encontrar el mejor enfoque y lograr el más alto nivel de innovación.",
              },
              {
                id: "pf-1:1-e",
                da: " Esté disponible para escuchar a la gente que quiere compartir ideas innovadoras con usted. Si nunca está disponible, pueden pensar que no está interesado/a y dejarán de tratar de llamar su atención. Si no es un momento conveniente, programe otro horario en que la persona pueda conversar con usted.",
              },
              {
                id: "pf-1:1-f",
                da: " Cuando se necesiten soluciones innovadoras para una cuestión en particular, cree una fuerza de tareas de innovación con pensadores/as creativos/as de diferentes disciplinas.",
              },
              {
                id: "pf-1:1-g",
                da: " Deje que un consultor facilite un taller de creatividad en el cual los/as empleados/as aprendan a explorar formas diferentes de pensar. Pida a un representante de recursos humanos que investigue algunas opciones para usted.",
              },
              {
                id: "pf-1:1-h",
                da: " Mantenga el lugar de trabajo alegre y flexible. Pregunte a sus empleados si el entorno fomenta la creatividad. Si no, ¿qué sugieren? ¿Reacomodar el espacio de oficinas, agregar colores a la pared, más flexibilidad en los horarios, códigos de vestimenta? Descubra las cosas que sus empleados realmente creen que importan y marcan una diferencia.",
              },
              {
                id: "pf-1:1-i",
                da: " Los clientes son una gran fuente de ideas innovadoras. Use encuestas, grupos de enfoque especiales o incluso llamadas informales o correos electrónicos para solicitar nuevas ideas.",
              },
              {
                id: "pf-1:2-a",
                da: " No deje que una idea quede sin considerar demasiado tiempo. Perderá impulso, energía e incluso el interés de las personas involucradas. Cree un equipo o fuerza de tareas para explorar la factibilidad de una idea e informar al respecto dentro de un plazo razonable.",
              },
              {
                id: "pf-1:2-b",
                da: " Si decide avanzar con ella, sea minucioso/a en su planeamiento de procesos. El plan no debería ser diferente al de los otros proyectos que tenga, con metas e hitos identificados.",
              },
              {
                id: "pf-1:2-c",
                da: " Asegúrese de poder asignar suficientes recursos para cumplir con el plan. Puede ser una gran idea, pero una dirección nueva a menudo significa tomar recursos de otros lados.Su tiempo es un recurso que tendrá que ser redireccionado también.",
              },
              {
                id: "pf-1:2-d",
                da: " Asegúrese de haber abordado la política interna y contar con la aprobación que necesita de las autoridades relevantes. Muchas grandes ideas no se implementan porque no tienen el respaldo de las personas relevantes.",
              },
              {
                id: "pf-1:2-e",
                da: " Si aprueba la implementación de una idea nueva, asegúrese de observar el proceso más cercanamente que cualquier otro. Por su naturaleza, las nuevas ideas encuentran obstáculos a medida que se implementan.",
              },
              {
                id: "pf-1:2-f",
                da: " Tenga un plan de gestión de cambio preparado. Las ideas nuevas pueden tener un impacto en los roles de la gente y en la forma en que han estado haciendo negocios.Comunicar la necesidad de cambio y aplacar los temores de la gente aumentará la probabilidad de una implementación exitosa.",
              },
              {
                id: "pf-1:2-g",
                da: " Si una idea ha sido desechada, infórmele a la gente el motivo. Comprenderán una falta de recursos o exigencias encontradas, pero estarán menos inclinados/as a comprender por qué una buena idea no tiene respaldo.",
              },
              {
                id: "pf-1:3-a",
                da: " Si tiene una idea nueva, pida retroalimentación para mejorar lo que originó, no para obtener aprobación o consentimiento.",
              },
              {
                id: "pf-1:3-b",
                da: " Adopte un mayor rol de mentor o maestro y aliente a otras personas a que le traigan sus ideas, luego use su experiencia para colaborar con sus aportes.",
              },
              {
                id: "pf-1:3-c",
                da: " Asuma que cada idea que se le presenta podría potencialmente tener un impacto positivo en el negocio.",
              },
              {
                id: "pf-1:3-d",
                da: " Sea positivo/a, muéstrese interesado/a y realmente escuche cuando le presenten una idea. Responda con preguntas que exploren la idea adecuadamente, por ejemplo, “Eso suena interesante. ¿Puede decirme más?”, “¿Cómo imagina que su idea beneficiará a los demás?”, “¿Cómo se ajusta su idea a nuestra visión estratégica?”, “¿Cuál sería el próximo paso?”",
              },
              {
                id: "pf-1:3-e",
                da: " Brinde al/a la originador/a de la idea la oportunidad de pensar en voz alta y el tiempo suficiente para explicar su idea. Cuánto más tiempo escuche, más probabilidades tendrá de ver los rangos de posibilidad y visualizar maneras de integrarla en las formas o procesos existentes.",
              },
              {
                id: "pf-1:3-f",
                da: " No asuma que un/a empleado/a subalterno/a tiene menos para aportar — su experiencia o intuición particular puede arrojar luz sobre un problema. Agradezca y activamente busque nuevas perspectivas. Incluso las personas que no están familiarizados/as con su negocio pueden tener perspectivas valiosas para ofrecer.",
              },
              {
                id: "pf-1:4-a",
                da: " La innovación puede tomar la forma de pequeños cambios y a menudo lo hace. Empiece con ideas que sean menos exigentes en cuanto a recursos",
              },
              {
                id: "pf-1:4-b",
                da: " Considere los procesos de negocios que pueden mejorarse a través de un enfoque nuevo.",
              },
              {
                id: "pf-1:4-c",
                da: " Identifique las formas en que la colaboración y las asociaciones, tanto internas como externas, le permitirán combinar recursos para empujar una iniciativa innovadora hacia adelante.",
              },
              {
                id: "pf-1:4-d",
                da: " No tiene que reinventar la rueda para ser innovador/a. Dé una mirada a las ideas que han implementado sus competidores y concéntrese en simplemente mejorarlas o brindar opciones más creativas.",
              },
              {
                id: "pf-1:4-e",
                da: " Dedique suficiente tiempo a fases de intercambio de ideas y de planificación para abordar detalles y seleccionar soluciones adecuadas de antemano. Esto es crítico para maximizar la posibilidad de éxito y asegurarse de que no se desperdicien recursos.",
              },
              {
                id: "pf-1:5-a",
                da: " Trate a los fracasos y errores como experiencias que le enseñan lecciones invalorables. No se sienta desalentado/a si su inversión en tiempo y recursos no genera éxito la primera vez. Si considera los experimentos como oportunidades de aprendizaje, su tiempo y esfuerzo están bien invertidos.",
              },
              {
                id: "pf-1:5-b",
                da: " Concéntrese en la visión global en lugar de en el costo a corto plazo. Comprenda los beneficios que generará una idea nueva exitosa. Es difícil discutir con números bien investigados.",
              },
              {
                id: "pf-1:5-c",
                da: " Obtenga respaldo de alguien más en la compañía que sea más experto/a en la toma de riesgos. Puede darle una perspectiva nueva.",
              },
              {
                id: "pf-1:5-d",
                da: " Enumere las desventajas de hacer negocios en la forma acostumbrada. ¿Cuáles son los problemas con el proceso, producto o servicio tal cual es ahora? Nada es perfecto y a veces estamos simplemente más cómodos/as con patrones establecidos que con enfoques nuevos.",
              },
            ],
          },
          {
            id: "pf-2",
            icon: require("@/assets/Iconography/Attributes/13-02_Analytical Problem Solving.svg"),
            comp: "Resuelve Problemas",
            wdd: "Resuelve problemas difíciles utilizando una combinación de intuición y pensamiento analítico",
            progressMeasures: [
              {
                id: "pf-2-0",
                pm: "Estoy abierto/a a opiniones o retroalimentación de los demás cuando trato de resolver un problema",
                pmMap:
                  "Contemplar diferentes soluciones para un problema antes de tomar acción",
              },
              {
                id: "pf-2-1",
                pm: "Puedo identificar problemas o desafíos que otros no ven",
                pmMap: "Identificar problemas o desafíos que otros no ven",
              },
              {
                id: "pf-2-2",
                pm: "Comprendo la naturaleza de un problema rápidamente, incluso con poca información",
                pmMap:
                  "Comprender la naturaleza de un problema rápidamente, incluso teniendo poca información",
              },
              {
                id: "pf-2-3",
                pm: "Uso la lógica y confío en mi intuición cuando soluciono problemas",
                pmMap:
                  "Usar la lógica y la intuición cuando soluciono problemas",
              },
            ],
            developmentActions: [
              {
                id: "pf-2:1-a",
                da: " Pregunte a sus colegas acerca de sus propias técnicas de resolución de problemas, así como también a la gente que no se dedica a su disciplina. El departamento de marketing,por ejemplo, puede tener formas instructivas de abordar una sesión de intercambio de ideas que usted puede aprovechar en su campo también.",
              },
              {
                id: "pf-2:1-b",
                da: " Deje que otras personas en su equipo tomen la delantera. Observe sus formas de abordar un problema. ¿Qué métodos podría adoptar? ¿Qué no está funcionando para ellos?",
              },
              {
                id: "pf-2:1-c",
                da: " Contacte con su departamento de recursos humanos acerca de cursos disponibles en su compañía para ampliar sus técnicas de resolución de problemas.",
              },
              {
                id: "pf-2:1-d",
                da: " Defina los factores que hacen que esta situación o problema sea diferente de uno similar que usted haya tenido. Sólo porque parecen similares no significa que la solución es la misma.",
              },
              {
                id: "pf-2:1-e",
                da: " Considere los recursos disponibles para abordar el problema. Puede tener una solución perfecta o una que fue exitosa previamente, pero su tiempo o recursos actualmente pueden ser insuficientes para emplearla nuevamente. Una solución alternativa sería un mejor enfoque.",
              },
              {
                id: "pf-2:1-f",
                da: " Asegúrese de incluir gente altamente creativa en su equipo. Son efectivos/as para introducir posibilidades novedosas.",
              },
              {
                id: "pf-2:1-g",
                da: " No suponga que conoce la respuesta porque tuvo una experiencia similar en el pasado. Es tan importante ser consciente de lo que no sabe como hacer uso de lo que sí sabe. Sea consciente de hacer generalizaciones sobre la base de experiencias anteriores.",
              },
              {
                id: "pf-2:1-h",
                da: " Cuando transmita información como hechos, asegúrese de que sean efectivamente hechos y no opinión. Encuentre expertos con los cuales pueda conversar sobre el problema para verificar sus supuestos.",
              },
              {
                id: "pf-2:1-i",
                da: " Asegúrese de tener tiempo suficiente para considerar y analizar los supuestos existentes acerca de una cuestión. Una premisa incorrecta desviará la resolución del problema en la dirección equivocada desde el principio.",
              },
              {
                id: "pf-2:2-a",
                da: " Ensure you have ample time to consider and analyze the existing assumptions about an issue. An incorrect premise will set your problem solving efforts off in the wrong direction from the start.",
              },
              {
                id: "pf-2:2-b",
                da: " Asegúrese de definir el problema de forma adecuada. Diferencie entre el problema y sus síntomas.",
              },
              {
                id: "pf-2:2-c",
                da: " Considere el proceso como parte del problema y las restricciones sobre el mismo y trabaje para eliminarlas.",
              },
              {
                id: "pf-2:2-d",
                da: " Reconozca cuando un enfoque de equipo sea mejor que hacerlo solo/a. Puede llevar más tiempo de esta manera, pero podría ser un enfoque inteligente que produce mejores resultados.",
              },
              {
                id: "pf-2:2-e",
                da: " No se apresure con problemas con consecuencias importantes o que podrían tener un gran impacto en su negocio. Programe tiempo suficiente para considerar estos problemas y hágalo cuando y donde tenga las menores distracciones.",
              },
              {
                id: "pf-2:2-f",
                da: " Divida el problema en componentes y delegue las tareas en consecuencia. De esta forma, puede concentrar su atención en las partes donde su opinión es más valiosa.",
              },
              {
                id: "pf-2:2-g",
                da: " La gente piensa y trabaja a diferentes velocidades. Algunos querrán o necesitarán más tiempo que otros para considerar las posibilidades y encontrar soluciones. Respete y apoye el tiempo que necesitan las personas para contribuir al proceso.",
              },
              {
                id: "pf-2:3-a",
                da: " Fije una fecha límite específica para tomar una decisión. Darse una fecha tope le ayudará a evitar demoras prolongadas para tomar una decisión.Comprométase con esa fecha fijando un día para conversar su decisión con sus superiores. Si está trabajando con un equipo, fije un día en el cual todos revisarán la información que han reunido y empezarán a abordar el problema.",
              },
              {
                id: "pf-2:3-b",
                da: " Programe reuniones ocasionales con su supervisor para conversar sobre la información que ha recolectado y si la misma se concentra en sus prioridades.",
              },
              {
                id: "pf-2:3-c",
                da: " ¿Tiende a pensar demasiado y complicar las cosas? Use a sus colegas como cajas de resonancia para obtener perspectiva. Busque oportunidades para combinar o abreviar procesos.",
              },
              {
                id: "pf-2:3-d",
                da: " Después de completar un proyecto, dedique tiempo a considerar la información que fue importante — e irrelevante. ¿Podría haber concentrado su tiempo y energía en una mejor dirección? Una reflexión como ésta es importante para procesar la efectividad de sus técnicas de resolución de problemas.",
              },
              {
                id: "pf-2:3-e",
                da: " Póngase en contacto con su intuición y aprenda a confiar en ella. Olvide su intelecto y lógica en algún punto y pregúntese qué le dice su intuición. Practique trabajando en temas con información limitada y pocas consecuencias y luego pase a decisiones más importantes.",
              },
              {
                id: "pf-2:4-a",
                da: " En una escala de 1 a 10, califique el nivel de dedicación y sensibilidad con el cual ha tratado el problema. Es difícil mantener la mente abierta cuando uno/a se siente emotivo/a acerca de un tema. Si su calificación es alta, diga a sus colegas que el tema le interesa profundamente y pregunte si piensan que usted está reaccionando de forma exagerada a sus sugerencias. Simplemente ser consciente de su nivel de inversión emocional le ayudará a manejar sus reacciones.",
              },
              {
                id: "pf-2:4-b",
                da: " Identifique sus botones rojos — todos tenemos temas o comentarios que tocan nuestros puntos más sensibles. Considere cuidadosamente por qué está tan sensible. Hable con un mentor o coach para obtener una perspectiva realista acerca de sus pensamientos y una guía de cómo abordar algunos de estos sentimientos.",
              },
              {
                id: "pf-2:4-c",
                da: " Manténgase sereno/a cuando sus puntos sensibles son tocados durante una conversación. No responda inmediatamente. En cambio, cuente hasta 10, luego formule una pregunta que intente aclarar el tema. Dar a la otra persona una oportunidad de explicar y tal vez reformular lo que dijeron le dará tiempo para considerar el comentario y sentirse más sereno/a.",
              },
              {
                id: "pf-2:4-d",
                da: " Sea honesto/a acerca de sus motivos. ¿Está abordando el problema de forma ética o está actuando en interés propio?",
              },
              {
                id: "pf-2:4-e",
                da: " Deje que cada miembro del equipo, incluyendo usted, contemple un problema de forma individual antes de reunirse para compartir ideas. Eso permitirá el pensamiento independiente e impedirá que la mentalidad de acumulación compulsiva invada su proceso de resolución de problemas.",
              },
              {
                id: "pf-2:4-f",
                da: " Si sabe que es extremadamente sensible o que no puede mantenerse objetivo/a,retírese. Pida a otra persona que maneje el problema y que le informe qué sucedió.Alternativamente, elija sólo los elementos que puede manejar objetivamente. Compartir el peso de una cuestión puede darle la distancia necesaria para abordar un problema conmayor imparcialidad.",
              },
            ] /* here the stop */,
          },
          {
            id: "pf-3",
            icon: require("@/assets/Iconography/Attributes/13-01_Being Technology Savvy.svg"),
            comp: "Experto/a En Tecnología",
            wdd: "Capta rápidamente el funcionamiento de las tecnologías y encuentra oportunidades para integrarlas en su trabajo",
            progressMeasures: [
              {
                id: "pf-3-0",
                pm: "Comprendo la importancia de la tecnología en todos los negocios",
                pmMap:
                  "Comprender la importancia de la tecnología en todos los procesos del negocio",
              },
              {
                id: "pf-3-1",
                pm: "Encuentro maneras de integrar la tecnología en los procesos existentes",
                pmMap:
                  "Encontrar maneras de integrar la tecnología en los procesos existentes",
              },
              {
                id: "pf-3-2",
                pm: "Me mantengo al corriente de las nuevas tecnologías que podrían beneficiar mi negocio",
                pmMap:
                  "Mantenerme al corriente de las nuevas tecnologías que podrían ayudarme a hacer mejor lo que hago",
              },
              {
                id: "pf-3-3",
                pm: "Veo a la tecnología como una forma de mejorar la productividad",
                pmMap:
                  "Ver la tecnología como una forma de mejorar la productividad",
              },
            ],
            developmentActions: [
              {
                id: "pf-3:1-a",
                da: " Antes de adoptar una nueva tecnología, haga una investigación profunda de la herramienta. Pregunte a alguien que la haya probado y la aplique conéxito. Le ayudará a obtener confianza acerca de sus beneficios.",
              },
              {
                id: "pf-3:1-b",
                da: " Pregunte a colegas que sean tecnológicamente sabios acerca de su experiencia conuna tecnología así como sus pros y contras.",
              },
              {
                id: "pf-3:1-c",
                da: " Continúe obteniendo conocimientos y confianza en diferentes áreas tecnológicas y aprovéchelos. Las pequeñas victorias le ayudan a obtener la confianza necesaria y, amedida que lo hace, su temor se reduce y eventualmente desaparece",
              },
              {
                id: "pf-3:1-d",
                da: " No se abrume con todas las características disponibles. La tecnología comonavegación por Internet tiende a abrir muchas posibilidades tangenciales. Concéntrese en los aspectos que le ayudarán a lograr lo que quiere. Es la mejor manera de que elaprendizaje resulte pragmático y poco complicado.",
              },
              {
                id: "pf-3:1-e",
                da: " Pídale a alguien que conozca la tecnología bien que demuestre cómo se usa. Use recursos del departamento técnico si están disponibles.",
              },
              {
                id: "pf-3:1-f",
                da: " Divida la información acerca de la tecnología en pequeñas partes — un concepto importante para aprender cualquier disciplina nueva. Por ejemplo, es imposible aprender un idioma nuevo de repente, pero si aprende progresivamente, palabra por palabra y frase por frase, gradualmente obtendrá una comprensión completa del idioma. Con la tecnología es lo mismo. Piense en la tecnología como simplemente otro tema para dominar.",
              },
              {
                id: "pf-3:1-g",
                da: " Póngase la meta de capacitarse en usar uno o dos pequeños artículos de tecnología,por ejemplo, un organizador electrónico, un nuevo teléfono celular o software para organizar su agenda. Aprenda cómo usar una nueva característica cada semana.",
              },
              {
                id: "pf-3:2-a",
                da: " Evalúe el impacto del cambio tecnológico en los empleados. La lista de verificación debe considerar qué posiciones es probable que se beneficien,quién estaría en desventaja con el cambio, qué compensación habrá para ellos/as y si hay un presupuesto para dicha compensación.",
              },
              {
                id: "pf-3:2-b",
                da: " Tendrá que desarrollar una estrategia para comunicar el cambio a los empleados.Debería incluir cómo funcionará la tecnología, por qué se está adoptando y cómo se brindará capacitación y soporte.",
              },
              {
                id: "pf-3:2-c",
                da: " Identifique a la gente que desempeñará roles críticos si el cambio tecnológico esaceptado. Asegúrese de involucrarlos/as en el proceso de cambio.",
              },
              {
                id: "pf-3:2-d",
                da: " Sea paciente. Recuerde, la gente se adapta a la tecnología a un ritmo diferente y la ansiedad entre los empleados causará resistencia a su aceptación y uso productivo.",
              },
              {
                id: "pf-3:2-e",
                da: " Compense de forma justa a aquellos/as empleados/as que han estado en desventaja.Los/as promotores/as del cambio tecnológico a menudo aducen que todos ganan con la implementación de nueva tecnología. Pero, en realidad, se producen pérdidas que van desde el descenso en la categoría hasta el despido. Preste atención a las necesidades emocionales y financieras de aquellas personas que pierden sus trabajos o cuya posición desciende debido al cambio tecnológico. Es una inversión crítica en la organización y envía el mensaje correcto a los/as demás empleados/as.",
              },
              {
                id: "pf-3:3-a",
                da: " Asegúrese de tener los/as defensores/as adecuados/as para abogar por latecnología y crear aceptación antes de su implementación. Los/as gerentes a nivel ejecutivo son los/as patrocinadores/as más efectivos/as.",
              },
              {
                id: "pf-3:3-b",
                da: " Desarrolle una estrategia de comunicación clara. Debería incluir cómo funcionará la tecnología, por qué se está adoptando y cómo se brindará capacitación y soporte.Determine si la comunicación debería ser formal, como un anuncio del CEO, o informal,como una conversación en reuniones de la dirección. Considere opciones deposicionamiento de marca que vinculan la identidad de la compañía con la tecnología.",
              },
              {
                id: "pf-3:3-c",
                da: " Prepare el presupuesto e invierta los recursos adecuados en capacitación de calidad.Generar capacidad entre los usuarios es crítico para la exitosa aplicación de la tecnología También considere cursos de repaso y capacitación periódicos.",
              },
              {
                id: "pf-3:3-d",
                da: " Cuidadosamente investigue proveedores de software que puedan ayudarle a diseñar una variedad de aplicaciones en una unidad cohesiva, ayudándole así a alinear más estrechamente los sistemas y procesos.",
              },
              {
                id: "pf-3:3-e",
                da: " Si necesita hacer crecer su negocio, podría considerar una aplicación — SAP — quepermite acceso a los datos, procesos de negocios y proveedores en tiempo real.",
              },
              {
                id: "pf-3:4-a",
                da: " Considere los cambios positivos que ha experimentado en su vida y que fueron producidos por los avances tecnológicos. Estamos rodeados de ejemplos de cómo la tecnología ha beneficiado a la humanidad: calefacción y refrigeración controlada termostáticamente, contestadores telefónicos, líneas de montaje automatizadas, conocimiento del universo, avances médicos y mucho más.",
              },
              {
                id: "pf-3:4-b",
                da: " Reflexione sobre los resultados positivos que experimentó con el uso de la tecnología, como ahorro de tiempo, creación de nuevas oportunidades de negocios, la capacidad de mantenerse en contacto con amigos y familiares.",
              },
              {
                id: "pf-3:4-c",
                da: " Haga una lista de las tecnologías que aprecia más y sin las cuales no podría vivir. Nos quejamos de la tecnología cuando no funciona, pero su estilo de vida se vería altamente alterado sin ella. ¿Realmente querría volver a no tener teléfonos celulares o correo electrónico, sin automatización, avances médicos deficientes, etc.?",
              },
              {
                id: "pf-3:4-d",
                da: " Si no puede librarse de su actitud adversa hacia la tecnología y su posición exige quelo haga, considere si debería conseguir otro trabajo.",
              },
              {
                id: "pf-3:5-a",
                da: " Haga una lista de cómo se beneficiaría la organización si todos los empleados fueran capaces de utilizar la tecnología existente en toda su extensión.",
              },
              {
                id: "pf-3:5-b",
                da: " Enumere cómo su falta de apoyo al cambio tecnológico le perjudicaría. Luego imagine que hizo el cambio y perjudicaría pasaron cinco años. ¿Qué beneficios puede obtener personalmente de la nueva tecnología?",
              },
              {
                id: "pf-3:5-c",
                da: " Si no puede encontrar el obvio valor agregado de la nueva tecnología, haga la inversión necesaria para obtener información clara acerca del rendimiento sobre la inversión que puede esperar.",
              },
              {
                id: "pf-3:5-d",
                da: " Trate de automatizar un proceso y familiarizarse con esa herramienta. Una vez que los beneficios están claros y usted se siente más cómodo/a con la tecnología, explore sus otras características disponibles en las cuales tal vez pueda invertir más.",
              },
            ],
          },
        ],
      },
      ccr: {
        icon: require("@/assets/Iconography/Characteristics/04_Considerate Carer.svg"),
        wdd: "Es una persona amigable y accesible. Demuestra un sentimiento genuino de preocupación e interés por la gente. Escucha con la intención genuina de entender los pensamientos y sentimientos de las personas",
        characteristic: "Se preocupa por los demás",
        competencies: [
          {
            id: "ccr-0",
            icon: require("@/assets/Iconography/Attributes/04-02_Demonstrating Empathy.svg"),
            comp: "Empático/a",
            wdd: "Demuestra un sentimiento genuino de preocupación e interés por la gente",
            progressMeasures: [
              {
                id: "ccr-0-0",
                pm: "Comprendo que las personas experimentan las situaciones de forma diferente",
                pmMap:
                  "Comprender que las personas viven las situaciones de forma diferente",
              },
              {
                id: "ccr-0-1",
                pm: "Me importan los sentimientos de la gente",
                pmMap: "Importarme los sentimientos de la gente",
              },
              {
                id: "ccr-0-2",
                pm: "Estoy disponible cuando alguien necesita hablar",
                pmMap: "Estar disponible para quien necesite hablar",
              },
              {
                id: "ccr-0-3",
                pm: "Puedo imaginarme cómo alguien podría sentirse en ciertas circunstancias",
                pmMap:
                  "Imaginarme cómo alguien podría sentirse en ciertas circunstancias",
              },
              {
                id: "ccr-0-4",
                pm: "Creo que preocuparme acerca de los sentimientos de los demás me convierte en un/a mejor gerente",
                pmMap:
                  "Creer que preocuparme acerca de los sentimientos de los demás me convierte en un/a mejor gerente",
              },
            ],
            developmentActions: [
              {
                id: ":1-a",
                da: " ¿Conoce bien a sus colegas? ¿O a la gente que trabaja para usted? ¿Son la mayoría de ellos/as extraños/as a los/as que no les da ni la hora del día? Programe tiempo en el almuerzo o tome breves intervalos durante el día para interactuar y enterarse de las vidas de los colegas.",
              },
              {
                id: ":1-b",
                da: " Esté disponible para escuchar, pero fije límites de tiempo razonables. Dígale a la otra persona que aunque sólo tiene un poco de tiempo, realmente quiere saber qué le preocupa.",
              },
              {
                id: ":1-c",
                da: " veces es realmente imposible encontrar tiempo para hablar durante un día especialmente ocupado. Sugiera reunirse con la persona fuera de horas o durante el almuerzo.",
              },
              {
                id: ":1-d",
                da: " Si sinceramente siente que alguien está monopolizando su tiempo, diplomáticamente señale que no puede darle a la persona el tiempo adecuado que merece y sugiera que hablecon alguien que ayude a los empleados.",
              },
              {
                id: ":2-a",
                da: " Cree un ambiente en el cual la gente se vea alentada a hablar de sus sentimientos. Marque el ejemplo siendo sincero/a. Siempre pregúntele a lagente cómo se sienten acerca de situaciones o tareas.",
              },
              {
                id: ":2-b",
                da: " ¿Qué tan bueno/a es interpretando a la gente? Alguien puede estar disgustado/a pero reacio/a a decirlo. Si presta especial atención y usa su intuición, estará en condiciones de percibir cuándo alguien está luchando con sus emociones. Si cree que alguien está disgustado/a, no lo ignore — pregúntele a la persona al respecto, si es conveniente.",
              },
              {
                id: ":2-c",
                da: " Si tiene poco tiempo, dígale a la persona que aunque sólo puede dedicarle un momento, realmente quiere enterarse de su problema.",
              },
              {
                id: ":2-d",
                da: " Use expresiones que transmitan su comprensión y empatía, tales como “Siento que esté pasando por algo así” o “Comprendo por qué se siente así”.",
              },
              {
                id: ":2-e",
                da: " Pregúntese cómo se sentiría si la situación fuera a la inversa. ¿Cómo querría que alguien le respondiera?",
              },
              {
                id: ":3-a",
                da: " No es necesario brindar respuestas o soluciones cuando la gente comparte sus sentimientos con usted. Puede dar consejo si se lo piden o, si no tiene una opinión formada, puede admitir que no puede hacer comentarios aunque ciertamente comprende por qué la persona se siente de esa manera.",
              },
              {
                id: ":3-b",
                da: " Practique habilidades de escucha efectivas. Esté disponible cuando alguien necesita hablar. Reformule lo que la persona dijo de modo que sepa que usted escuchó. Trate de comprender los disparadores que llevaron a la persona a su estado emocional actual",
              },
              {
                id: ":3-c",
                da: " Siéntase más cómodo/a abriéndose usted en alguna medida a un colega de confianza.Lo peor que puede pasar es que la persona elegida no muestre ningún interés. Evite ser este tipo de persona.",
              },
              {
                id: ":4-a",
                da: " Considere prejuicios o estereotipos ocultos que puede albergar y que podrían impedirle apreciar a la gente de un grupo determinado. No puede seleccionar y elegir a sus colegas o clientes, por lo tanto la empatía selectiva no es productiva.",
              },
              {
                id: ":4-b",
                da: " No trate de estar de acuerdo o en desacuerdo con la persona, simplemente sea abierto/a a lo que se dice. Imagine a la persona como un/a amigo/a cercano/a o miembro de la familia que comparte una experiencia con usted. ¿Qué tan sensible se mostraría?",
              },
              {
                id: ":4-c",
                da: " Pase tiempo en compañía de personas con las cuales tiene dificultades para relacionarse. Pídales que le expliquen su experiencia. Se sorprenderá de enterarse de las cosas que otras personas tienen que aguantar, y que tal vez usted no tiene que enfrentar",
              },
            ],
          },
          {
            id: "ccr-1",
            icon: require("@/assets/Iconography/Attributes/04-01_Listening well.svg"),
            comp: "Capaz De Escuchar",
            wdd: "Escucha con la intención genuina de entender los pensamientos y sentimientos de las personas",
            progressMeasures: [
              {
                id: "ccr-1-0",
                pm: "Creo que, en ocasiones, otras personas sabrán más que yo",
                pmMap:
                  "Creer que, en ocasiones, otras personas sabrán más que yo",
              },
              {
                id: "ccr-1-1",
                pm: "Dejo terminar de hablar a la gente antes de sugeriruna solución o curso de acción",
                pmMap:
                  "Dejar terminar de hablar a la gente antes de sugeriruna solución o curso de acción",
              },
              {
                id: "ccr-1-2",
                pm: "Puedo comprender lo que la gente está tratando de decir incluso si les resulta difícil expresarse",
                pmMap:
                  "Comprender lo que la gente está tratando de decir incluso si les resulta difícil expresarse",
              },
              {
                id: "ccr-1-3",
                pm: "Muestro interés independientemente de lo que la gente esté hablando",
                pmMap:
                  "Mostrar interés independientemente de lo que la gente esté hablando",
              },
              {
                id: "ccr-1-4",
                pm: "No me distraigo fácilmente cuando la gente me está hablando",
                pmMap:
                  "No distraerme fácilmente cuando la gente me está hablando",
              },
            ],
            developmentActions: [
              {
                id: "ccr-1:1-a",
                da: " Priorice cuidadosamente cuánto tiempo puede dedicar a los demás y a quién puede dedicarle ese tiempo.",
              },
              {
                id: "ccr-1:1-b",
                da: " Si el tiempo es realmente una limitación, trate de designar o seleccionar una persona clave que represente los intereses del grupo.",
              },
              {
                id: "ccr-1:1-c",
                da: " Pida a la gente de antemano que resuma lo que necesitan decirle en unos pocos puntos clave. Aclare cuáles son sus restricciones de tiempo y cuánto tiempo tiene disponible antes de tener que retirarse.",
              },
              {
                id: "ccr-1:1-d",
                da: " En lo posible, use la hora del almuerzo o el tiempo de viaje para ponerse al día con los demás.",
              },
              {
                id: "ccr-1:1-e",
                da: " Maneje el tiempo que pone a disposición de los demás. Si el tema requiere una hora completa de conversación pero sólo le ha asignado veinte minutos, es probable que seponga impaciente y deje de escuchar con atención a medida que el tiempo se termina.",
              },
              {
                id: "ccr-1:2-a",
                da: " Demuestre interés y escuche, incluso si está familiarizado/a con el tema o tiene una solución para el mismo. Puede haber una perspectiva nueva de la cual puede beneficiarse o datos adicionales que no fueron considerados.Incluso si no surge nada nuevo de la conversación, mostrarse atento/a alienta a la gente a participar y los motiva a resolver los problemas.",
              },
              {
                id: "ccr-1:2-b",
                da: " Permanezca callado/a a propósito y no interrumpa a los demás para dar sus opiniones antes de que hayan tenido suficiente tiempo para expresarse. Las interrupciones son muy frustrantes para la persona que está tratando de hablar y significa que usted se está concentrando en lo que tiene que decir en lugar de lo que está escuchando. Sea consciente de cuán a menudo interrumpe a la gente habitualmente.",
              },
              {
                id: "ccr-1:2-c",
                da: " En algunas situaciones, estar atento/a requiere alejarse de la situación y permitir que lo que se dijo sea asimilado. Si es conveniente, tómese tiempo antes de hacer comentarios a la gente, pero asegúrese de volver a abordar el tema con ellos más tarde.",
              },
              {
                id: "ccr-1:2-d",
                da: " Sea consciente del comportamiento despectivo que indica que está aburrido/a o desinteresado/a, por ejemplo, mirando a su alrededor mientras alguien le está hablando,mirando su reloj, repasando trabajo en su escritorio, evitando el contacto visual, etc.",
              },
              {
                id: "ccr-1:2-e",
                da: " Interrumpa lo que está haciendo y demuéstrele a la persona que está dispuesto/a a escuchar y pensar acerca de lo que tiene que decir. Si realmente no es el mejor momento para hacerlo, programe un horario para reunirse pronto.",
              },
              {
                id: "ccr-1:2-f",
                da: " Elija actuar como mentor para alguien. Es una de las mejores maneras de compartir sus conocimientos y experiencia y, al mismo tiempo, practicar mostrarse atento/a conalguien a un nivel profesional distinto del suyo.",
              },
              {
                id: "ccr-1:3-a",
                da: " La meditación es una de las formas más efectivas de sosegar la mente.Las diversas técnicas de meditación incluyen cánticos o ejercicios para controlar la respiración. Intente meditar como un ejercicio tranquilizante para hacer fuera del trabajo habitualmente.",
              },
              {
                id: "ccr-1:3-b",
                da: " Es mejor estar 100% presente durante 15 minutos que apenas presente durante una hora. Durante una conversación, sea consciente de cuántos pensamientos irrelevantes le vienen a la mente. Refrene sus pensamientos de acuerdo con la situación determinada.",
              },
              {
                id: "ccr-1:3-c",
                da: " Mantenga su mente concentrada y atenta reformulando o resumiendo lo que la persona dijo. Pregunte a la persona si usted comprendió correctamente. Use lenguaje y gestos que demuestren preocupación y comprensión durante la conversación, por ejemplo,asienta a menudo y use frases tales como “ya veo”, “entiendo” y “eso tiene sentido”.",
              },
              {
                id: "ccr-1:3-d",
                da: " Si está preocupado/a por una fecha límite apremiante, considere pedirle a la persona que espere un día o dos hasta que pueda escucharla sin distracciones. Programe ese horario en su calendario y esté absolutamente seguro/a de cumplirlo.",
              },
              {
                id: "ccr-1:3-e",
                da: " Dése tiempo para reacomodar su mente antes de empezar una conversación nueva.Puede encontrarse ya participando en otra reunión y aún pensando en la anterior. Dé un corto paseo, si es posible, o tome una bebida. Dedique unos minutos a conectarse a nivel personal con la nueva persona.",
              },
              {
                id: "ccr-1:3-f",
                da: " Reduzca la cantidad de distracciones que compiten por su atención. Cuando se disponga a escuchar a alguien, desconecte el teléfono. Siempre puede recibir los mensajes después. No se siente frente a la computadora y continúe usándola cuando alguien le está hablando.",
              },
              {
                id: "ccr-1:4-a",
                da: " Cuando alguien no está explicándose bien o se está tomando demasiado tiempo y usted descubre que se está poniendo impaciente, actúe como facilitador en lugar de dispersarse, frustrarse o interrumpir. Ayude a la persona a expresarse haciendo preguntas simples o reformulando lo que está tratando de decir. Guíele diplomáticamente a través de la conversación. Si enseña a una persona a expresarse de forma efectiva, no tiene que trabajar tan arduamente para darse cuenta qué está tratando de decir.",
              },
              {
                id: "ccr-1:4-b",
                da: " Póngase en el lugar de la otra persona. Imagine qué puede estar sintiendo. Tal vez la persona está nerviosa o es tímida. Puede requerirse algo más de paciencia, dependiendo de las circunstancias.",
              },
              {
                id: "ccr-1:4-c",
                da: " Enseñe a las personas que lo rodean cómo le gusta que le den información o qué tipo de comunicación prefiere. No suponga que la gente puede interpretarlo bien.",
              },
              {
                id: "ccr-1:4-d",
                da: " ¿Se muestra usted atento/a con algunas personas pero no con otras? Sin saberlo,puede estar discriminando a cierta gente. Identifique con quién tiende a estar menos atento/a — ¿gente más joven, mujeres, minorías? Esfuércese por ser justo/a cuando escucha. Escriba una lista de la gente con la cual no se muestra atento/a. Trate de identificar patrones o temas comunes entre ellos.",
              },
              {
                id: "ccr-1:4-e",
                da: " Si siente una antipatía determinada por alguien o está disgustado/a, lleve a la persona a un lado y converse sus diferencias profesionalmente. Si quiere dar ejemplo a los demás,muestre que las diferencias pueden resolverse y demuestre que todos en la organización serán escuchados.",
              },
            ],
          },
          {
            id: "ccr-2",
            icon: require("@/assets/Iconography/Attributes/04-01_Listening well.svg"),
            comp: "Ser accesible",
            wdd: "",
            progressMeasures: [
              {
                id: "ccr-2-0",
                pm: "Disfruto hablando o escuchando a los demas ",
                pmMap: "Disfruta hablando o escuchando a los demás ",
              },
              {
                id: "ccr-2-1",
                pm: "Puedo construir una buena relación, incluso con extraños.",
                pmMap: "Construir una buena relación, incluso con extraños ",
              },
              {
                id: "ccr-2-2",
                pm: "Parezco amigable incluso si estoy de mal humor o estresado",
                pmMap:
                  "Parecer amigable incluso si estoy de mal humor o estresado",
              },
              {
                id: "ccr-2-3",
                pm: "Permito que la gente se exprese sin interrupciones",
                pmMap:
                  "Permitir que las personas se expresen sin interrupciones",
              },
              {
                id: "ccr-2-4",
                pm: "Mantengo el juicio o la crítica de los demás al mínimo.",
                pmMap: "Mantenga al mínimo el juicio o la crítica de los demás",
              },
            ],
            developmentActions: [
              {
                id: "ccr-2:1-a",
                da: "Sea consciente de actuar de forma frenética o desorganizada en sus tareas diarias. Si constantemente se queja de todas las reuniones que tiene y del trabajo que no puede hacer, envía una señal de que no debe ser molestado. ",
              },
              {
                id: "ccr-2:1-b",
                da: "Sea realista con su horario. ¿Estás haciendo overbooking? Identifique las actividades que sería bueno hacer frente a las que son críticas. Algunas personas disfrutan de la emoción de un ritmo frenético, pero tomar atajos te agota y te vuelve inaccesible. ",
              },
              {
                id: "ccr-2:1-c",
                da: "Tómese uno o dos descansos al día para hablar con las personas, no con sus tareas.",
              },
              {
                id: "ccr-2:1-d",
                da: "Recuerda el humor. Use su sentido del humor para hacer a la ligera sus demandas imposibles y anime a otros a compartir sus problemas. ",
              },
              {
                id: "ccr-2:1-e",
                da: "Mejora tu compostura. Permanecer calmado y atento, incluso bajo presión, envía el mensaje de que está disponible cuando la gente lo necesita. Es un gran ejemplo para demostrar que eres accesible, incluso en situaciones estresantes cuando las personas pueden necesitar más de ti. ",
              },
              {
                id: "ccr-2:1-f",
                da: "¿Son compatibles sus valores y su comportamiento? Si valora ser amigable y accesible, considere si está priorizando en consecuencia. ",
              },
              {
                id: "ccr-2:1-g",
                da: "¿Qué indica tu lenguaje corporal? Por ejemplo, si sus ojos se mueven rápidamente cuando alguien le habla, envía un mensaje de que no está interesado o tiene mejores cosas que hacer. Sea consciente de estar inquieto o mirar su reloj. 8. Delegue con eficacia, especialmente si está en un puesto de dirección. Es posible que esté atascado en tareas que podrían delegarse en lugar de centrarse en su papel más importante: proporcionar dirección y visión para los demás. ",
              },
              {
                id: "ccr-2:2-a",
                da: "Encuentre un equilibrio entre la interacción con los demás y el tiempo a solas. Dado que dedicar tiempo a los demás no le resultará natural, programe & ldquo; descansos de personas & rdquo; durante el día en el que te pongas disponible para simplemente charlar. ",
              },
              {
                id: "ccr-2:2-b",
                da: "Intente permanecer en el presente y participar mentalmente durante las conversaciones con las personas. Repite lo que la persona te ha dicho y muestra interés haciendo preguntas y proporcionando comentarios. ",
              },
              {
                id: "ccr-2:2-c",
                da: "Las personas no pueden saber instintivamente qué información necesita o si lo están molestando con problemas que podrían manejar ellos mismos. Explique la información que necesita y cuándo sería un buen momento para que se acerquen a usted con problemas. ",
              },
              {
                id: "ccr-2:2-d",
                da: "Sea consciente de las señales que puede estar enviando y que mantienen a raya a las personas. Evite fruncir el ceño todo el tiempo; hacer contacto visual directo y sonreír. ",
              },
              {
                id: "ccr-2:2-e",
                da: "Pregúntese cuándo fue la última vez que preguntó por el bienestar de alguien. Si no puede recordar, ha pasado demasiado tiempo. ",
              },
              {
                id: "ccr-2:2-f",
                da: "Tienes amigos en el trabajo? Cultiva amistades y date un merecido descanso pasando tiempo con estos colegas. ",
              },
              {
                id: "ccr-2:2-g",
                da: "Reconocer y celebrar abiertamente a los demás y rsquo; hitos personales como cumpleaños y aniversarios. Asegúrese de asistir a tales eventos, aunque solo sea por unos minutos. ",
              },
              {
                id: "ccr-2:2-h",
                da: "Trate de alegrarse y abordar su mundo con menos seriedad. Puede que tengas muchas cosas en mente, pero puedes compartirlas con otros con algo de humor. Les permite a los demás saber que, aunque esté ocupado, está dispuesto a hacer tiempo para reírse de sí mismo y compartir sus preocupaciones. Cuando sea posible, comparta historias divertidas sobre cosas que le hayan sucedido.",
              },
              {
                id: "ccr-2:2-i",
                da: "Prueba la terapia de la risa, que afirma tener efectos beneficiosos del uso de emociones positivas asociadas con la risa. Los beneficios de la risa están bien documentados, sin embargo, un estudio mostró que los niños en edad preescolar se ríen hasta 400 veces al día, mientras que los adultos solo ríen 17 veces al día en promedio. La investigación ha demostrado que reír puede ayudar a reducir la presión arterial y las hormonas del estrés, desencadenar endorfinas, el analgésico natural del cuerpo, estimular la función inmunológica al elevar los niveles de células T que combaten infecciones, aumentar la flexión muscular y producir una sensación general de bienestar. Aproveche todos estos beneficios inyectando algo de risa en su jornada laboral. ",
              },
              {
                id: "ccr-2:2-j",
                da: "Lo más probable es que si usted es demasiado serio en el trabajo, sea demasiado serio en casa. Haga más cosas que le ayuden a relajarse en su vida personal. Mira más comedias, juega con tus hijos, haz más cosas que te hagan reír, aléjate del estrés diario tomando descansos frecuentes. ",
              },
              {
                id: "ccr-2:2-k",
                da: "Pase tiempo con personas que tengan una actitud positiva. Modelamos gran parte de nuestro comportamiento en el de nuestros compañeros y las personas con quienes pasamos el tiempo. ",
              },
              {
                id: "ccr-2:2-l",
                da: "Fomente una cultura del humor en el lugar de trabajo alentando a las personas con una disposición alegre a compartir su humor con todos.",
              },
              {
                id: "ccr-2:2-m",
                da: "Sonríe tan a menudo como puedas. Los estudios demuestran que los efectos positivos de la sonrisa se producen tanto si la sonrisa es falsa como real. ",
              },
              {
                id: "ccr-2:2-n",
                da: "La meditación trae quietud a la mente. Intente incorporar tiempo de meditación en su rutina diaria con prácticas como la atención plena, un método que se centra en la conciencia del aquí y ahora. Hay muchos talleres y libros disponibles para ayudarlo a comenzar. ",
              },
              {
                id: "ccr-2:3-a",
                da: "Mantenga una política de puertas abiertas para todos en todo momento. Si no es un buen momento para conversar, programe otra cita y asista. ",
              },
              {
                id: "ccr-2:3-b",
                da: "Mantente en contacto con las personas para comprobar cómo están, y no solo cuando necesites un favor.",
              },
              {
                id: "ccr-2:3-c",
                da: "Programe un horario fijo en la oficina durante la semana en el que estará disponible para que cualquiera pueda venir a hablar con usted. Asegúrese de haber despejado su horario y de poder ofrecer toda su atención.",
              },
              {
                id: "ccr-2:3-d",
                da: "Practique la gestión caminando. Comprométase a pasar una cantidad de tiempo dedicada con los empleados en el piso o en varias oficinas todos los días, en esencia, recorriendo la organización para encontrar oportunidades para hacer comentarios positivos y recibir comentarios o retroalimentación. Este enfoque permite el acceso directo a usted y promueve el intercambio de ideas. Asegúrese de hacerlo de manera auténtica, en otras palabras, sea usted mismo y hágalo a su manera única. ",
              },
              {
                id: "ccr-2:3-e",
                da: "Encuentre formas de ayudar a los demás. Ofrézcase como voluntario sin que se lo pidan. No ayudes a otros solo porque te han ayudado a ti. ",
              },
              {
                id: "ccr-2:4-a",
                da: "Maximice sus oportunidades de interactuar con las personas uno a uno. Programe un horario fijo durante la semana en el que esté disponible para que cualquiera venga y hable con usted. Pasa por las oficinas de la gente para hablar uno a uno al menos una vez a la semana. ",
              },
              {
                id: "ccr-2:4-b",
                da: "Utilice el humor para romper el hielo y crear vínculos con los demás.",
              },
              {
                id: "ccr-2:4-c",
                da: "Tienes amigos en el trabajo? Solo una o dos relaciones cercanas pueden ayudarte a salir de tu caparazón, especialmente si tus amigos son más extrovertidos que tú. ",
              },
              {
                id: "ccr-2:4-d",
                da: "Asiste a algunas actividades sociales relacionadas con el trabajo. Les da a las personas una oportunidad menos formal de conocerte y te da la oportunidad de cultivar amistades. ",
              },
              {
                id: "ccr-2:4-e",
                da: "Sea consciente de las señales que puede estar enviando y que mantienen a raya a las personas. Haz contacto visual directo, sonríe tanto como puedas, descruza los brazos. ",
              },
              {
                id: "ccr-2:4-f",
                da: "Muestre interés en los demás y rsquo; vidas y pídales que le cuenten sobre ellos mismos. A la mayoría de las personas les gusta hablar de sus vidas, lo que elimina la presión de hablar contigo. ",
              },
              {
                id: "ccr-2:5-a",
                da: "Deje que la gente termine de expresarse antes de interrumpir con una opinión o solución.",
              },
              {
                id: "ccr-2:5-b",
                da: 'Responde siempre con un comentario u observación positiva, por ejemplo, "es bueno que estés pensando en esto", o "sé que parece una tarea imposible, pero tengo confianza en ti, ¿cómo puedo ayudarte?" , o & ldquo; Siempre hay personas desafiantes con las que debes trabajar. ¿Hay otros miembros del equipo con los que se lleva bien? & Rdquo; ',
              },
              {
                id: "ccr-2:5-c",
                da: "Pase tiempo con personas positivas y optimistas. Al igual que la negatividad, el optimismo es contagioso. ",
              },
              {
                id: "ccr-2:5-d",
                da: "Lleve un diario sobre las cosas positivas de su vida. Pequeño o grande, aumentar su conciencia sobre estas cosas diariamente puede impulsarlo a pensar de manera más positiva. ",
              },
              {
                id: "ccr-2:5-e",
                da: "Trate de reconocer y limitar lo siguiente: culpar, defender, juzgar, obstaculizar, excluir y no perdonar.",
              },
              {
                id: "ccr-2:5-f",
                da: "Pregunte a sus compañeros, amigos y familiares si creen que usted es negativo en general. A veces no somos conscientes de lo negativos que somos o del impacto que esto tiene en los demás.  ",
              },
              {
                id: "ccr-2:5-g",
                da: "Contrata a un entrenador o terapeuta para que identifique las áreas de tu vida que podrías estar descuidando o que te dejan insatisfecho.",
              },
            ],
          },
        ],
      },
      cp: {
        characteristic: "Es calmado/a bajo presión",
        wdd: "Sabe conciliar la vida familiar, personal y la laboral. Mantiene la calma en situaciones de estrés. Reconoce la contribución de los demás, es humilde acerca de sus fortalezas y modesto/a sobre sus logros. Es paciente con los demás y sabe cuándo debe ir más despacio para que todo el mundo entienda.",
        icon: require("@/assets/Iconography/Characteristics/02_Calming Presence.svg"),
        competencies: [
          {
            id: "cp-0",
            icon: require("@/assets/Iconography/Attributes/02-04_Balancing my personal.svg"),
            comp: "Concilia La Vida Personal Y laboral",
            wdd: "Sabe conciliar la vida familiar, personal y la laboral",
            progressMeasures: [
              {
                id: "cp-0-0",
                pm: "Participo en un pasatiempo o actividad fuera del trabajo que me ayuda a relajarme y recargarme",
                pmMap:
                  "Participar en actividades o tener pasatiempos fuera del trabajo que me ayuden a relajarme y recargarme",
              },
              {
                id: "cp-0-1",
                pm: "Cuando estoy fuera de la oficina no me estreso acerca del trabajo",
                pmMap:
                  "No estresarme por trabajo cuando estoy fuera de la oficina",
              },
              {
                id: "cp-0-2",
                pm: "Mi meta es hacer mi trabajo lo mejor que puedo, no ser perfecto/a",
                pmMap:
                  "Intentar hacer mi trabajo lo mejor que puedo, no ser perfecto/a",
              },
              {
                id: "cp-0-3",
                pm: "Ocasionalmente estoy dispuesto/a a dedicar tiempo personal para cumplir con un objetivo de trabajo",
                pmMap:
                  "Estoy dispuesto/a a dedicar parte de mi tiempo personal a cumplir con un objetivo de trabajo",
              },
            ],
            developmentActions: [
              {
                id: "cp-0:1-a",
                da: " Ponga un reloj con alarma para marcar la hora en que debe dejar la oficina y comprométase a hacerlo cuando suene. Pida a un colega o asistente que se comunique con usted para asegurarse de que se ha marchado.",
              },
              {
                id: "cp-0:1-b",
                da: " No lleve su computadora cuando esté viajando con su familia por placer. Si tiene qu mantenerse conectado/a, acuerde con su familia un horario fijo durante el cual revisará y responderá el correo electrónico.",
              },
              {
                id: "cp-0:1-c",
                da: " Use su tiempo de vacaciones, pase lo que pase. Programe sus vacaciones al comienzo del año. Inevitablemente, siempre surgirá algo, por lo tanto ignórelo y siga adelante con sus planes.",
              },
              {
                id: "cp-0:1-d",
                da: " Hable con su familia acerca de su cronograma y asegúrese de que llega a un compromiso aceptable acerca del mismo. Puede estar suponiendo que su cronograma no ha afectado a nadie porque nadie lo ha mencionado.",
              },
              {
                id: "cp-0:1-e",
                da: " Encuentre otros intereses y actividades que lo hagan feliz y que pueda compartir con su familia o amigos. Recuerde, el trabajo no es lo único que posiblemente pueda brindarle las emociones que busca.",
              },
              {
                id: "cp-0:2-a",
                da: " Diversifique sus intereses y aplique en ellos el mismo entusiasmo que muestra en su trabajo. Por ejemplo, participe en actividades de voluntariado.Si es una persona orientada a los detalles o un gran planificador, puede ayudar a organizar un importante evento de recolección de fondos. Dedíquese a pasatiempos en los cuales pensó que podría ser bueno pero que nunca emprendió.",
              },
              {
                id: "cp-0:2-b",
                da: " Participe en actividades que liberen estrés tales como ejercicio o meditación.",
              },
              {
                id: "cp-0:2-c",
                da: " Nunca subestime la importancia de un grupo de amigos que lo apoyan. Puede haberse cerrado a relaciones estrechas si ha estado sumergido en su trabajo. Reconéctese con viejos amigos o dedique tiempo a conocer gente nueva con la cual disfrute compartir tiempo.",
              },
              {
                id: "cp-0:2-d",
                da: " Si sabe que ha estado evitando problemas personales durante un largo tiempo buscando escape en el trabajo, procure conseguir asesoramiento profesional.",
              },
              {
                id: "cp-0:3-a",
                da: " Priorice su carga de trabajo. Algunas cosas son simplemente más importantes que otras, por lo tanto invierta su tiempo con inteligencia y realice las tareas importantes primero. Sentirá menos presión si las cosas que no ha logrado hacer tienen menos importancia. Identifique y escriba las actividades o tareas que toman la mayor parte de su tiempo. Se sorprenderá de cuánto tiempo se emplea en hacer seguimiento de cosas que no son importantes. ¿Puede su asistente ayudarle con esas tareas?",
              },
              {
                id: "cp-0:3-b",
                da: " Si siente que está constantemente atrasado/a y que no puede realizar su trabajo en el tiempo asignado, ¿será que usted (o su jefe) está fijando expectativas no realistas? Controle su progreso periódicamente. Su jefe puede agregar recursos para ayudarle o puede colaborar para evaluar si usted está fijando expectativas poco realistas para sí mismo/a.",
              },
              {
                id: "cp-0:3-c",
                da: " Cuando se sienta abrumado/a, hable con un colega en quien confíe. Conversar las cosas con un colega le brindará un cuadro de la situación más realista y un muy necesario descanso a su preocupación. Otras personas por lo general son buenas para brindarnos una mejor perspectiva sobre lo que realmente debe hacerse.",
              },
              {
                id: "cp-0:3-d",
                da: " ¿Es usted un perfeccionista? No todas las tareas requieren igual atención o dedicación. ¿A que tareas puede prestarle menos atención, porque no tendrán mucho impacto en sus objetivos más importantes? Siempre evalúe la cantidad de energía y tiempo que dedica a sus tareas y verifique si es realmente necesario.",
              },
              {
                id: "cp-0:3-e",
                da: " Considere tomar cursos de gestión del tiempo que estén disponibles en la compañía o en otros sitios.",
              },
              {
                id: "cp-0:4-a",
                da: " ¿Está pidiendo más trabajo del que puede manejar, está abarcando demasiado? Ser ambicioso/a es una característica positiva, pero ser excesivamente ambicioso/a puede dañar su desempeño y su salud. Compare su carga de trabajo con la de los demás, para obtener una visión realista de cuánto debiera abarcar.",
              },
              {
                id: "cp-0:4-b",
                da: " Lleve la cuenta de las horas que trabaja. Esto le proporcionará una perspectiva realista del tiempo que está invirtiendo fuera de su casa.",
              },
              {
                id: "cp-0:4-c",
                da: " Hable con la gente adecuada si tiene preocupaciones acerca de cumplir con sus expectativas. Probablemente sea más duro/a con sí mismo/a que los demás. En ocasiones,todas las personas necesitan recibir reafirmación acerca de que están bien encaminadas y cumpliendo o superando las expectativas.",
              },
              {
                id: "cp-0:4-d",
                da: " Diga que no al trabajo que no puede manejar. No acepte más trabajo solo porque piensa que no va a quedar bien si dice que no. Quedará peor cuando no pueda hacer el trabajo. Es correcto ser honesto/a acerca de la carga de trabajo propia. No le va a costar su carrera si claramente tiene demasiado trabajo. Converse acerca de sus responsabilidades con la persona que revisa su trabajo.",
              },
              {
                id: "cp-0:4-e",
                da: " Escriba todo lo que desea lograr personalmente, en su vida privada, así como también las cosas que le gustaría lograr profesionalmente para cuando se retire. Mire la lista una vez por semana para recordar las cosas que constituyen su vida e intereses fuera del trabajo y para las cuales necesita dedicar tiempo.",
              },
              {
                id: "cp-0:4-f",
                da: " Encuentre un mentor que haya equilibrado una carrera exitosa con las prioridades personales. ¿Cómo hizo para lograr ambas cosas?",
              },
              {
                id: "cp-0:5-a",
                da: " Sea crítico acerca de lo que realmente requiere su atención y cuánto trabajo es necesario para lograr el objetivo de la tarea. Fije fechas límite para las tareas.",
              },
              {
                id: "cp-0:5-b",
                da: " Deje las tareas que otras personas puedan hacer y deléguelas. No aprenderá a confiar en la gente hasta que delegue y les brinde la oportunidad de probarse a sí mismos/as.",
              },
              {
                id: "cp-0:5-c",
                da: " Observe las expectativas realistas que otras personas fijan para su trabajo.",
              },
              {
                id: "cp-0:5-d",
                da: " Aproveche los recursos dentro y fuera de la compañía que están a su disposición para desempeñar su trabajo de forma más eficiente. Considere hacer uso de terceros para lleva a cabo el trabajo, si esa es una opción.",
              },
              {
                id: "cp-0:6-a",
                da: " Contrate un coach personal, si es posible, para obtener aclaración acerca de sus prioridades y metas personales.",
              },
              {
                id: "cp-0:6-b",
                da: " Evalúe cuánto de lo que está haciendo implica ocuparse de los/as demás.Sea esto ayudar a sus colegas con sus proyectos o hacer favores a sus amigos, ¿en qué parte del cuadro entran sus intereses y necesidades?",
              },
              {
                id: "cp-0:6-c",
                da: " Siéntase cómodo/a diciendo que no amablemente. No explique por qué, simplemente exprese que tiene otros compromisos. Practique rechazar pequeños compromisos con gente con la que se siente cómodo/a y más adelante intente con la gente a la cual le resulta más difícil decir que no.",
              },
              {
                id: "cp-0:7-a",
                da: " Intente mantener una visión global. Todos los meses, dé un paso atrás y revise cuánto tiempo dedicó a su trabajo versus a su vida personal. Si está empezando a notar que un área de su vida está absorbiendo demasiado tiempo, propóngase concentrarse más en la otra. Puede hacer esto cada dos meses, pero no deje pasar demasiado tiempo sin evaluar sus compromisos.",
              },
              {
                id: "cp-0:7-b",
                da: " Cuando empiece a sentirse exhausto/a por demasiado trabajo o demasiadas exigencias personales, sumérjase en el mundo opuesto.",
              },
              {
                id: "cp-0:7-c",
                da: " Hable con personas que conoce que son exitosas en su trabajo. Pregúnteles cómo equilibran sus exigencias laborales y personales. Se sorprenderá de encontrar que muchas de estas personas, efectivamente, organizan los compromisos de su vida sin comprometer su trabajo y viceversa.",
              },
              {
                id: "cp-0:7-d",
                da: " Sea claro/a acerca de las cosas que le importan más y que mantienen su vida personal y laboral feliz y saludable. Asegúrese de cumplir estos compromisos y prescinda de los menos importantes. Por ejemplo, decida no ir a tomar unos tragos para hacer contactos profesionales si es el cumpleaños de su hijo. Puede decidir no asistir a un compromiso para cenar con amigos porque la cena con el máximo directivo de la compañía fue reprogramada para la misma noche. Respete lo que es realmente importante y use el buen criterio.",
              },
            ],
          },
          {
            id: "cp-1",
            icon: require("@/assets/Iconography/Attributes/02-03_Being composed.svg"),
            comp: "Calmado/a",
            wdd: "Mantiene la calma en situaciones de estrés",
            progressMeasures: [
              {
                id: "cp-1-0",
                pm: "No me tomo en forma personal cuando alguien está disgustado",
                pmMap:
                  "Cuando alguien está disgustado, no tomarlo de forma personal ",
              },
              {
                id: "cp-1-1",
                pm: "Me mantengo calmado/a y tranquilo/a incluso cuando estoy con mucho estrés",
                pmMap:
                  "Mantenerme calmado/a y tranquilo/a incluso bajo mucho estrés",
              },
              {
                id: "cp-1-2",
                pm: "La gente acude a mí cuando hay una crisis",
                pmMap:
                  "Tranquilizar a la gente si acuden a mí cuando hay una crisis",
              },
              {
                id: "cp-1-3",
                pm: "Nunca tengo rabietas ni me pongo excesivamente emotivo/a en público",
                pmMap:
                  "Nunca tener rabietas ni ponerme excesivamente emotivo/a en público",
              },
            ],
            developmentActions: [
              {
                id: "cp-1:1-a",
                da: " Trate de pensar más con su cabeza que con su corazón. Si siente que sus emociones están brotando, imagine cómo abordaría la situación una persona emocionalmente imparcial.",
              },
              {
                id: "cp-1:1-b",
                da: " Si se siente abrumado/a por sus emociones, amablemente pida tomarse un breve descanso para poner sus ideas en orden. Salga de la sala o llame nuevamente por teléfono en unos pocos minutos. Es mejor hacer esto que derrumbarse delante de otras personas.",
              },
              {
                id: "cp-1:1-c",
                da: " Si es posible, tómese un día libre para adquirir perspectiva y dejar que sus emociones se asienten. Es increíble como nuestra perspectiva puede cambiar cuando nos alejamos de la situación por un momento.",
              },
              {
                id: "cp-1:1-d",
                da: " Concéntrese en controlar su respiración inhalando profundamente. Es una forma muy eficaz de calmarse.",
              },
              {
                id: "cp-1:1-e",
                da: " Considere cuidadosamente con quién está hablando en una situación determinada. No todas las personas se expresan a través de las emociones o se sienten cómodas con gente que es muy expresiva emocionalmente. En lugar de generar compasión o respaldo, puede disgustar a la gente.",
              },
              {
                id: "cp-1:1-f",
                da: " Asegúrese de tener válvulas de escape para sus sentimientos fuera del trabajo. Los amigos de confianza, los miembros de la familia, un coach o asesor pueden brindarle una válvula de escape productiva para sus emociones.",
              },
              {
                id: "cp-1:2-a",
                da: " Cuando sienta que está perdiendo la calma, trate de hacer ejercicios de respiración profunda, una forma muy eficaz de disminuir la respuesta de adrenalina del organismo al estrés. Hay muchas técnicas de respiración quepuede practicar diariamente.",
              },
              {
                id: "cp-1:2-b",
                da: " La investigación ha demostrado que el estrés puede afectar negativamente la claridad de pensamiento. A veces es necesario salir. Tome un pequeño descanso para aclarar su mente. Salga a caminar o vaya a almorzar, lo que sea necesario para dejar la situación atrás. Esto no cambiará la situación pero le dará la oportunidad de poner sus ideas en orden.",
              },
              {
                id: "cp-1:2-c",
                da: " Tome medidas. Escriba los pasos que deben tomarse para resolver el problema.Concéntrese en los elementos prioritarios.",
              },
              {
                id: "cp-1:2-d",
                da: " Pida ayuda antes de quemar un fusible. En situaciones de estrés a menudo nos olvidamos de que hay otros recursos disponibles. No suponga que tiene que hacerlo todo solo/a. Obtenga la ayuda de otras personas. Solamente hablar con alguien acerca del estrés que está experimentando puede generar mucha catarsis.",
              },
              {
                id: "cp-1:2-e",
                da: " Modele su comportamiento imitando a un colega o persona respetada que sea capaz de mantenerse calmo/a en situaciones de presión. Pregúnteles cómo logran hacerlo.",
              },
              {
                id: "cp-1:2-f",
                da: " Use una herramienta como la evaluación de personalidad de Birkman. La información que brinda genera intuición sobre sus necesidades subyacentes y su comportamiento en situación de estrés, en base a 11 componentes conductuales. Simplemente ser consciente de estas reacciones le permite adoptar mejores actitudes y un comportamiento más productivo. Un consultor certificado puede ayudarle a interpretar los resultados.",
              },
              {
                id: "cp-1:3-a",
                da: " Permítase unos minutos antes de hablar para considerar las consecuencias de su reacción. Puede sentir que ha igualado el marcador o que ha aportado justicia a la situación, pero una vez que ha dicho palabras dolientes o injustas el daño no puede desdecirse, sólo perdonarse.",
              },
              {
                id: "cp-1:3-b",
                da: " Discúlpese por el exabrupto inmediatamente. Esto es difícil de hacer estando enojado/a, pero si reconoce que su comportamiento fue inadecuado y asume la responsabilidad por ello la gente por lo general está dispuesta a continuar relacionándose con usted.",
              },
              {
                id: "cp-1:3-c",
                da: " Considere sus actitudes y expectativas acerca de los demás y de las situaciones. Si son inadecuadas o poco realistas, se está prestando a una frustración emocional y posiblemente, a un conflicto.",
              },
              {
                id: "cp-1:3-d",
                da: " Incluso cuando le resulta difícil respetar a la otra persona, porque le provoca,necesitará desconectarse de sus comentarios y hacer una valoración más aséptica de la persona. A menos que lo haga, nunca podrá volver a obtener un comportamiento colaborador de parte de ella.",
              },
              {
                id: "cp-1:3-e",
                da: ' Cuando le provoquen, primero trate de ponerse en el lugar de la otra persona.Independientemente de que la acusación o situación sea justa o no, trate de comprender las razones o motivos detrás de los comentarios. Use comentarios tales como "Comprendo por qué te sientes de esa manera" para apaciguar la situación y calmarse ambos.',
              },
              {
                id: "cp-1:3-f",
                da: " Adopte alguna técnica de relajación diaria para manejar su tensión y frustración. Haga ejercicio, medite, practique yoga o encuentre un pasatiempo que le traiga paz.",
              },
              {
                id: "cp-1:3-g",
                da: " Comparta sus pensamientos y converse sus preocupaciones con un colega o amigo/a de confianza. Esto tiene grandes ventajas terapéuticas.",
              },
              {
                id: "cp-1:3-h",
                da: " Identifique los detonantes particulares que lo hacen ponerse a la defensiva o dar una respuesta con enojo. Sepa que deberá mantenerse especialmente paciente cuando se vea expuesto a esas situaciones, personas o temas.",
              },
              {
                id: "cp-1:3-i",
                da: " Intente un curso de manejo de la ira si es consciente de que su comportamiento está afectando de forma negativa sus relaciones en el trabajo o en su vida personal.",
              },
              {
                id: "cp-1:4-a",
                da: " Respete a las personas a las cuales se está dirigiendo. Puede ser importante para usted ser expresivo/a y tremendamente honesto/a en casa o con un colega de trabajo, pero muy probablemente querrá editar lo que dice cuando habla con clientes o un superior.",
              },
              {
                id: "cp-1:4-b",
                da: " Antes de hablar, pregúntese de qué manera la otra persona querría escuchar lo que tiene que decir. Algunas personas necesitan que los demás sean directos y claros; otras,requieren más preocupación por sus sentimientos y un estilo de expresión más diplomático.",
              },
              {
                id: "cp-1:4-c",
                da: " Defienda lo que cree con una conversación bien considerada, evidencia para respaldar su punto de vista y no a través de la emoción.",
              },
            ],
          },
          {
            id: "cp-2",
            icon: require("@/assets/Iconography/Attributes/02-02_Acting with modesty.svg"),
            comp: "Modesto/a",
            wdd: "Reconoce la contribución de los demás, es humilde acerca de sus fortalezas y modesto/a sobre sus logros",
            progressMeasures: [
              {
                id: "cp-2-0",
                pm: "Comparto el mérito de un esfuerzo conjunto con mis colaboradores",
                pmMap:
                  "Compartir el mérito de un esfuerzo conjunto con mis colaboradores",
              },
              {
                id: "cp-2-1",
                pm: "Aliento a otras personas a recibir el reconocimiento si es importante para ellos",
                pmMap:
                  "Alentar a otras personas a recibir el reconocimiento, si es importante para ellos",
              },
              {
                id: "cp-2-2",
                pm: "Puedo sentirme bien acerca de mis logros sin que los demás los reconozcan",
                pmMap:
                  "Sentirme bien acerca de mis logros sin que los demás los reconozcan",
              },
              {
                id: "cp-2-3",
                pm: "No exagero mis logros",
                pmMap: "No exagerar mis logros",
              },
            ],
            developmentActions: [
              {
                id: "cp-2:1-a",
                da: " Independientemente del tamaño de sus aportes, propóngase agradecer a la gente con la cual trabajó en un proyecto (durante y después de lafinalización). Haga esto formalmente en un correo electrónico o reunión grupal.",
              },
              {
                id: "cp-2:1-b",
                da: " Cuando el aporte de otra persona ha mejorado el trabajo realizado por usted,comuníqueselo. Admita abiertamente que su trabajo sería más difícil sin su ayuda.",
              },
              {
                id: "cp-2:1-c",
                da: " Regularmente reconozca los esfuerzos de la persona que le reporta directamente a usted. Haga que esto sea una parte habitual de su gestión en reuniones y en la oficina.",
              },
              {
                id: "cp-2:1-d",
                da: " Los elogios hacen que los empleados y colegas se sientan apreciados/as y es una manera fácil de que la gente se sienta valorada. El elogio no tiene que estar relacionado con su trabajo específicamente. Puede ser una simple afirmación del comportamiento agradable de alguien, por ejemplo, comunicarle que usted reconoce una cualidad especial en él/ella.",
              },
              {
                id: "cp-2:1-e",
                da: " Concéntrese en “nosotros” y no en “mí”. Aborde cada proyecto como un esfuerzo de equipo que no podría lograrse sin el aporte de mucha gente. Rara vez una sola persona está involucrada en una tarea. Promueva los esfuerzos del equipo haciendo circular mensajes de correo electrónico y memos que recapitulen el desempeño de su equipo.Reenvíe los elogios de los clientes a su supervisor.",
              },
              {
                id: "cp-2:2-a",
                da: " No se olvide de la gente que le apoyó durante su ascenso a la cima. Haga públicos sus nombres y aliente a otras personas a hacer lo mismo. Le permite ser modesto/a acerca del rol que desempeñó a la vez que ganar el respeto del personal que le apoyó.",
              },
              {
                id: "cp-2:2-b",
                da: " Aliente a la gente a tratarle de la misma manera en que lo hacían antes de volverse exitoso/a. Muestre a los ex colegas así como también a su familia y amigos que las relaciones que comparten continúan siendo importantes.",
              },
              {
                id: "cp-2:2-c",
                da: " Sea auténtico/a. Usted no cambió simplemente porque su posición o nivel de autoridad son diferentes. Mantenga las amistades que tenía antes de volverse exitoso/a.",
              },
              {
                id: "cp-2:2-d",
                da: " Resista el impulso de ser ostentoso/a, alardear o vivir por encima de sus posibilidades. Niéguese a obtener posesiones o participar en actividades que sólo tienen el propósito de llamar la atención hacia usted.",
              },
              {
                id: "cp-2:2-e",
                da: " Acepte los elogios de otras personas cortésmente. Muestre gratitud genuina por la admiración de su éxito, pero cambie de tema cuando la gente hable demasiado de sus logros. Gire la conversación hacia los logros y cualidades de los demás.",
              },
              {
                id: "cp-2:3-a",
                da: " Pida a la gente relevante que es importante para usted que le brinde retroalimentación constante acerca de su trabajo. Algunos de nosotros requerimos más reafirmación y reconocimiento que otros. No suponga que sus colegas o superiores conocen o pueden leer sus necesidades.",
              },
              {
                id: "cp-2:3-b",
                da: " Trabaje en el auto-elogio. La gente no siempre estará disponible para reconocer su trabajo arduo, por lo tanto asegúrese de tener un sistema de recompensa privado que se apoye en lo que piensa de sí mismo/a, no en lo que los demás piensan de usted.",
              },
              {
                id: "cp-2:3-c",
                da: " Sea humilde acerca de sus fortalezas y logros. Saboree sus éxitos en privado y siga avanzando a partir de ellos. En lugar de alardear acerca de un trabajo bien hecho, use los conocimientos obtenidos de su éxito y siga adelante.",
              },
              {
                id: "cp-2:3-d",
                da: " Encuentre un lugar equilibrado del cual extraer su sensación de logro. Enumere las cosas de las que está orgulloso/a además de sus logros en el trabajo. Puede ser un/a excelente padre/madre, amigo/a o muy habilidoso/a en un pasatiempo, por ejemplo. No es sólo el trabajo lo que define sus logros —busque reconocimiento en otras áreas de su vida también.",
              },
              {
                id: "cp-2:3-e",
                da: " Asegúrese de no exagerar sus logros y su éxito para obtener mayores elogios o atención. Sea sincero/a y auténtico/a, o parecerá falso/a y su logro real se perderá en el ruido.",
              },
              {
                id: "cp-2:3-f",
                da: " Desarrolle una reputación de esforzarse calladamente en lograr el éxito en lugar de perseguir elogios.",
              },
              {
                id: "cp-2:3-g",
                da: " Asegúrese de no estar dedicando más tiempo a alardear que a hacer su trabajo. Los colegas y clientes rápidamente se sentirán frustrados/as y resentidos/as.",
              },
              {
                id: "cp-2:3-h",
                da: " Una persona modesta cree en el trabajo arduo sin esperar recompensa. No espere reconocimiento por su trabajo. Tiene más probabilidades de ser elogiado/a una vez que sus colegas vean que usted es modesto/a acerca de sus logros.",
              },
              {
                id: "cp-2:3-i",
                da: " No haga supuestos acerca de normas culturales en su entorno de trabajo.Identifíquelas correctamente y actúe en consecuencia.",
              },
            ],
          },
          {
            id: "cp-3",
            icon: require("@/assets/Iconography/Attributes/02-01_Being patient.svg"),
            comp: "Paciente",
            wdd: "Es paciente con los demás y sabe cuándo debe ir más despacio para que todo el mundo entienda",
            progressMeasures: [
              {
                id: "cp-3-0",
                pm: "Soy paciente cuando a los demás les lleva más tiempo que a mí captar un concepto",
                pmMap:
                  "Ser paciente cuando a los demás les lleva más tiempo que a mí captar un concepto",
              },
              {
                id: "cp-3-1",
                pm: "Puedo ajustar mis expectativas cuando las cosas no resultan como lo planeado",
                pmMap:
                  "Ajustar mis expectativas cuando las cosas no avanzan como estaba planificado",
              },
              {
                id: "cp-3-2",
                pm: "Hago las cosas bien, incluso si lleva más tiempo de esa manera",
                pmMap:
                  "Hacer las cosas bien, aunque lleve más tiempo de esa manera",
              },
              {
                id: "cp-3-3",
                pm: "Puedo dominar mi impulso de actuar cuando la oportunidad no es correcta",
                pmMap:
                  "Contener mi impulso de actuar cuando no es el momento adecuado para hacerlo",
              },
            ],
            developmentActions: [
              {
                id: "cp-3:1-a",
                da: " Enfréntese a la realidad. ¿Sobreestimó lo que una persona o incluso usted puede hacer? ¿Qué puede esperar razonablemente que una persona sepa y esté en condiciones de producir en base a su experiencia? ¿Es esta persona elrecurso correcto a emplear en este proyecto dado su conjunto de habilidades? De no ser así, realmente puede estar fuera de su control si no pueden tener éxito.",
              },
              {
                id: "cp-3:1-b",
                da: " Sea claro/a acerca de sus expectativas y al brindar dirección. No deje nada abierto a una interpretación errónea. La gente a menudo escucha información de forma selectiva y dos personas pueden interpretar la misma conversación de forma totalmente diferente.Haga una nota de sus expectativas y revíselas con el equipo para asegurarse de que todos estén de acuerdo. Agregue detalles como líneas de tiempo, hitos, objetivos, etc.",
              },
              {
                id: "cp-3:1-c",
                da: " Aliente firmemente a la gente a expresar sus objeciones por adelantado, si es que tienen alguna. A menudo, a los gerentes no se les cuestiona sus metas poco realistas, lo que lleva a desilusión o frustración cuando éstas no se alcanzan.",
              },
              {
                id: "cp-3:1-d",
                da: " Controle habitualmente cuán alto fijó el estándar. ¿Está esperando que nunca se cometan errores? ¿Son sus fechas límite poco realistas o sus horizontes temporales innecesariamente cortos? ¿Es excesivamente competitivo/a con sus colegas? ¿Están los miembros del equipo poco motivados/as? ¿Está permitiendo que los subordinados tengan tiempo para aprender? ¿Están continuamente tratando de irse a otros departamentos? ¿Están obligados a trabajar hasta tarde y durante los fines de semana regularmente? Pregunte si no sabe, porque estos son todos indicios de que sus expectativas podrían ser poco realistas.",
              },
              {
                id: "cp-3:1-e",
                da: " Busque señales de que la gente necesita tiempo para recargarse y permítales tomarse ese descanso. Puede retrasar el proceso a corto plazo, pero a largo plazo evitará que los buenos talentos muestren agotamiento.",
              },
              {
                id: "cp-3:1-f",
                da: " ¿Se pone impaciente cuando compara el desempeño de diferentes personas? ¡No lo haga! Las personas no son iguales y se desempeñarán diferente en contextos diferentes.Ponerse impaciente con alguien porque les falta algo en comparación con otros es injusto y poco productivo. Más bien trate de explotar, en un sentido positivo, las fortalezas de la gente y desarrollar sus debilidades para que se conviertan en fortalezas. Lo último requiere paciencia pero dará sus frutos tanto para usted como para su colega a largo plazo.",
              },
              {
                id: "cp-3:2-a",
                da: " Trate de aislar exactamente qué rasgo de esa persona provoca su impaciencia. ¿Tiene un impacto en el trabajo de la persona? Puede ser algo intrascendente como el tono de voz, el comportamiento, la forma en que se viste, un hábito irritante. Si éste es el caso, trate de pasar por alto o aceptar sus idiosincrasias, especialmente si no tienen relevancia para su trabajo.",
              },
              {
                id: "cp-3:2-b",
                da: " Si su impaciencia se deriva de algo que afecta su trabajo, tal como un abuso de confianza o estilos de trabajo irreconciliables, inicie una conversación honesta con la persona. Estas conversaciones no son fáciles, pero ignorar sus inquietudes no las hará desaparecer. Es probable que interfieran en su desempeño y nivel de comodidad en el trabajo. Asegúrese de aclarar que está teniendo la conversación porque quiere mejorar su relación de trabajo. Haga lo que pueda para comprender la posición de la otra persona. Si es necesario, pida a un mediador del departamento de recursos humanos que facilite la conversación, especialmente si el tema tiene una carga emocional.",
              },
              {
                id: "cp-3:2-c",
                da: " Busque los rasgos positivos en la gente — todos/as tienen algunos. ¿Qué talentos aporta una persona a la mesa? Antes de interactuar con alguien que es difícil, prepárese teniendo presente esos talentos.",
              },
              {
                id: "cp-3:2-d",
                da: " Trate de comprender la motivación detrás de los actos de la gente o la manera determinada en que han actuado en el pasado. Por ejemplo, alguien puede parecer maleducado/a pero de hecho simplemente puede no estar cómodo/a en ciertas circunstancias en general.",
              },
              {
                id: "cp-3:2-e",
                da: " ¿Está siendo irrespetuoso/a? Una falta de paciencia genera falta de respeto. Asegúrese de no tratar a alguien que le desagrade de forma diferente a otras personas, por ejemplo,interrumpiendo innecesariamente, levantando la voz o descartando su opinión de forma grosera.",
              },
              {
                id: "cp-3:3-a",
                da: " ¡Relájese! Trate de aliviar el estrés con técnicas de relajación tales como respiración profunda y automotivación. Hay muchos libros disponibles para aprender acerca de técnicas de relajación.",
              },
              {
                id: "cp-3:3-b",
                da: " Haga uso de su humor. Las circunstancias estresantes a menudo son divertidas después del hecho, pero no en el momento. Trate de encontrar el humor allí y reírse —alivia el estrés.",
              },
              {
                id: "cp-3:3-c",
                da: " Reconozca cuando esté perdiendo la paciencia y pida a un colega de confianza con influencia tranquilizadora que le ayude a reconcentrarse.",
              },
              {
                id: "cp-3:3-d",
                da: " Concentre su energía en soluciones al problema en lugar de permitir que aumenten las frustraciones e impaciencia.",
              },
              {
                id: "cp-3:3-e",
                da: " No siempre se pueden aplicar soluciones rápidas. Relájese y deje fluir las cosas, si es necesario.",
              },
              {
                id: "cp-3:3-f",
                da: " Trate de ser flexible y espontáneo/a. Sea en el trabajo o en su vida privada, siga la corriente cuando hay un cambio de planes. Cuanto más cómodo/a esté con el cambio de planes a último momento, más paciencia desarrollará para cuando las cosas estén fuera de su control.",
              },
              {
                id: "cp-3:4-a",
                da: " Delegue lo que pueda, incluso si puede hacerlo más rápido usted mismo/a.Cree una lista detallada de tareas o proyectos que otras personas puedan hacer y comprométase a dejarlas que lo hagan.",
              },
              {
                id: "cp-3:4-b",
                da: " Cuando delegue, permita que la gente tenga suficiente espacio y tiempo para trabajar en los problemas, tareas o respuestas antes de intervenir, incluso si tenía la respuesta antes.Les dará la oportunidad de considerar el problema y, potencialmente, podrían ofrecer un camino que usted no había considerado.",
              },
              {
                id: "cp-3:4-c",
                da: " Si es un/a experto/a en su campo, use todas las oportunidades de ser maestro/a o mentor/a. Identifique a aquellas personas que tienen dificultades y entrénelas cuando sea posible. Cuando su impaciencia crezca, pregúntese lo que haría un buen maestro.",
              },
              {
                id: "cp-3:4-d",
                da: " En lugar de ocuparse de todos los detalles, asuma nuevas responsabilidades que mejorarán su capacidad de monitorear procesos y mantener a las otras personas en la senda.",
              },
              {
                id: "cp-3:4-e",
                da: " No suponga que su experiencia en hacer algo es la única o mejor manera de abordar una tarea. A otra persona puede llevarle más tiempo pero en cambio obtener resultados más precisos o tomar un enfoque más creativo. Aliente formas innovadoras de pensar y nuevas metodologías.",
              },
              {
                id: "cp-3:5-a",
                da: " Calcule el riesgo. ¿Cuáles son las consecuencias de tomar la acción equivocada demasiado rápido? Si tendrá consecuencias serias e irreparables, permítase más tiempo para considerar sus opciones y obtener opiniones de los demás.",
              },
              {
                id: "cp-3:5-b",
                da: " Si siente la necesidad de actuar, hágalo separando el problema en partes más pequeñas y tomando decisiones en una menor escala. Satisfará su necesidad de acción pero lo hará de una forma manejable.",
              },
              {
                id: "cp-3:5-c",
                da: " Arme un equipo para tomar la decisión — no la tome por su cuenta. Asegúrese de que el equipo esté bien representado con una combinación de gente con estilos variados,incluyendo pensadores analíticos. Asegúrese de que la atmósfera permita una discusión abierta y que una persona no tenga todo el poder en la toma de decisiones. Trate de lograr consenso.",
              },
              {
                id: "cp-3:6-a",
                da: " Lea acerca de grandes líderes que provocaron cambios con perseverancia y paciencia.",
              },
              {
                id: "cp-3:6-b",
                da: " Respalde a las personas que piden más tiempo para considerar una propuesta o decisión.",
              },
              {
                id: "cp-3:6-c",
                da: " Elija sus batallas: no todas las situaciones requieren acción inmediata, por lo tanto practique la paciencia cuando la urgencia es únicamente autoimpuesta.",
              },
            ],
          },
        ],
      },
      rc: {
        characteristic: "Es responsable y ético/a",
        wdd: "Actúa según los valores que prevalecen en la organización. Trata a las personas justamente, independientemente de su raza, diferencias culturales o estilo personal. Se hace responsable de todas las áreas que están a su cargo incluso de aquellas que son más controversiales y difíciles. Se puede confiar en él/ella. Se puede contar con él/ella para cumplir promesas y mantener confidencias",
        icon: require("@/assets/Iconography/Characteristics/14_Responsible Citizen.svg"),
        competencies: [
          {
            id: "rc-0",
            icon: require("@/assets/Iconography/Attributes/14-04_Acting Ethically.svg"),
            comp: "Ético/a",
            wdd: "Actúa según los valores que prevalecen en la organización",
            progressMeasures: [
              {
                id: "rc-0-0",
                pm: "Mis acciones en el trabajo reflejan los valores de la organización",
                pmMap:
                  "Procurar que mis acciones en el trabajo reflejen los valores de la organización ",
              },
              {
                id: "rc-0-1",
                pm: "Reparo el daño si me comporté de forma inadecuada",
                pmMap:
                  "Reparar el daño si me he comportado de forma inadecuada",
              },
              {
                id: "rc-0-2",
                pm: "Pienso en los valores de la compañía cuando me encuentro ante una decisión ambigua",
                pmMap:
                  "Ante una decisión ambigua, actuar en línea con los valores predominantes del contexto",
              },
              {
                id: "rc-0-3",
                pm: "Mis valores se mantienen uniformes independientemente de la situación",
                pmMap:
                  "Ser consecuente con mis valores, independientemente de la situación",
              },
            ],
            developmentActions: [
              {
                id: "rc-0:1-a",
                da: " Familiarícese con los valores de la compañía.",
              },
              {
                id: "rc-0:1-b",
                da: " Inicie una conversación entre sus colegas y compañeros de equipo para examinar cómo su grupo está acatando los valores de la compañía.",
              },
              {
                id: "rc-0:1-c",
                da: " Intente el siguiente ejercicio: haga una lista escrita de los valores de la compañía.Luego, para cada valor, enumere las cosas que hace para promoverlo y las cosas que hace que lo contradicen. Escriba qué puede hacer de forma diferente para salvar las deficiencias.",
              },
              {
                id: "rc-0:1-d",
                da: " Deje que los valores de la compañía le guíen durante la toma de decisiones difíciles y ambiguas.",
              },
              {
                id: "rc-0:2-a",
                da: " Piense acerca de alguien cuyas acciones son consideradas poco éticas.Escriba qué hace esa persona para que usted considere que su comportamiento es poco ético. ¿Tomaría las mismas decisiones que esa persona tomó en las mismas circunstancias?",
              },
              {
                id: "rc-0:2-b",
                da: " Cuando se enfrente a una decisión difícil, piense acerca de alguien que es respetado/a por su comportamiento ético. ¿Qué haría esa persona si estuviera en su lugar? Pregúntele,si es posible.",
              },
              {
                id: "rc-0:2-c",
                da: " Pregúntese antes de actuar: “Incluso si todas las personas involucradas no obtienen lo que desean, ¿serán su dignidad y derechos respetados con mi decisión?”",
              },
              {
                id: "rc-0:2-d",
                da: " Reflexione sobre cualquier decisión ambigua posteriormente. ¿Cuál fue el resultado para todas las personas involucradas? Si tuviera que hacerlo nuevamente, ¿qué haría diferente?",
              },
              {
                id: "rc-0:2-e",
                da: " Haga la “prueba de la publicidad”: Si tuviera que explicar su decisión en la televisión nacional, ¿se sentiría cómodo/a haciéndolo?",
              },
              {
                id: "rc-0:3-a",
                da: " Sopese las consecuencias de su comportamiento. ¿Justifica arriesgar su posición?",
              },
              {
                id: "rc-0:3-b",
                da: " ¿Hay alguna situación de trabajo en la cual sus valores son poco realistas?¿Tendrá dificultad en aceptar la cultura de una organización similar?",
              },
              {
                id: "rc-0:3-c",
                da: " ¿Puede reconocer que hay algunos valores que no son lo suficientemente importantes como para arriesgar su posición?",
              },
              {
                id: "rc-0:3-d",
                da: " Si no puede atenerse a los valores de nadie más, incluyendo aquellos de su compañía,entonces tal vez debería considerar trabajar de forma independiente. Si lo hace, tenga en cuenta que de todas maneras deberá tener en consideración los valores de su cliente.",
              },
              {
                id: "rc-0:4-a",
                da: " Hable con un colega que respete o su superior acerca de cómo podría conciliar las diferencias.",
              },
              {
                id: "rc-0:4-b",
                da: " Tenga en cuenta que su trabajo no necesariamente estará en concordancia con todos sus valores. También puede satisfacer sus valores personales a través de su vida fuera del trabajo. Participe en actividades que promuevan los valores que no puede abordar a través del trabajo.",
              },
              {
                id: "rc-0:4-c",
                da: " Considere si son realmente los valores de la organización los que le generan un problema, o por el contrario se trata del comportamiento de determinadas personas o de su equipo. Si es necesario o posible, encuentre una nueva posición.",
              },
              {
                id: "rc-0:4-d",
                da: " Si no puede conciliar sus valores con los de la compañía, debe considerar trasladarse a otra organización.",
              },
              {
                id: "rc-0:5-a",
                da: " No suponga que todos son conscientes de la situación o se sienten diferentes al respecto. Si su superior no es receptivo, identifique quién en la cadena de mando estará abierto/a a sus preocupaciones para poder tener un/a interlocutor/a alternativo/a.",
              },
              {
                id: "rc-0:5-b",
                da: " Recolecte la mayor cantidad de documentación posible para respaldar su posición y proporcionar evidencia.",
              },
              {
                id: "rc-0:5-c",
                da: " Hay seguridad en los números. ¿Es usted la única persona que tiene objeciones?Identifique a otras personas que hayan planteado preocupaciones y presenten sus objeciones en forma colectiva.",
              },
              {
                id: "rc-0:5-d",
                da: " Conozca sus derechos legales. Existen leyes para proteger a los denunciantes. Hable con un representante de recursos humanos en confianza acerca de sus preocupaciones y avíseles si la cuestión tiene grandes implicaciones y no puede resolverse a su nivel.",
              },
              {
                id: "rc-0:5-e",
                da: " Si el comportamiento poco ético es dominante en la cultura de su industria u organización, usted estará mejor si renuncia. Puede estar dejando su trabajo, pero estará dando un paso enorme hacia una carrera de la cual pueda estar orgulloso/a.",
              },
            ],
          },
          {
            id: "rc-1",
            icon: require("@/assets/Iconography/Attributes/14-03_Acting Fairly.svg"),
            comp: "Justo/a",
            wdd: "Trata a las personas justamente, independientemente de su raza, diferencias culturales o estilo personal",
            progressMeasures: [
              {
                id: "rc-1-0",
                pm: "Brindo a todas las personas las oportunidades adecuadas",
                pmMap: "Brindar oportunidades adecuadas a todas las personas",
              },
              {
                id: "rc-1-1",
                pm: "Considero si estoy siendo justo/a antes de actuar",
                pmMap: "Actuar de manera justa con los demás",
              },
              {
                id: "rc-1-2",
                pm: "No permito que mis sentimientos acerca de alguien dicten cómo me comporto con ellos/as",
                pmMap:
                  "No permitir que mis sentimientos acerca de alguien dicten cómo me comporto con él/ella",
              },
              {
                id: "rc-1-3",
                pm: "Me siento cómodo/a con la gente que es diferente a mí",
                pmMap: "Sentirme cómodo/a con la gente que es diferente a mí",
              },
            ],
            developmentActions: [
              {
                id: "rc-1:1-a",
                da: " El comportamiento sutil tiene el mismo efecto que la acción abierta.Examine de cerca si se reconoce mostrando algunas de estas conductas de forma regular: dirigir la mayoría de sus preguntas a una persona determinada,ser menos atento/a con ciertas personas y hacerles callar más a menudo, ponerse más a disposición de algunas personas que de otras, ser más crítico/a o negativo/a acerca de las ideas de una persona determinada, invitar a algunas personas a almorzar y no a otras y dar elogio o reconocimiento desigual. Si responde afirmativamente a algunos de los comentarios precedentes, debería tratar de actuar de forma más justa.",
              },
              {
                id: "rc-1:1-b",
                da: " Reparta las tareas de forma justa para evitar mostrar que tiene favoritos/as. Dar a una o dos personas los proyectos más deseados todo el tiempo reduce su capacidad de desarrollar los talentos de su equipo y le niega a la gente la oportunidad de demostrar su valía. Considere formas creativas de atraer a una persona que no está teniendo un buen desempeño, en lugar de alienarla. Por ejemplo, reúna una persona con elevado desempeño con otra con menor desempeño en una tarea de equipo.",
              },
              {
                id: "rc-1:1-c",
                da: " Asegúrese de no comparar empleados/as, de forma pública o privada, o constantemente usar a una persona como ejemplo de excelencia. Puede fomentar unapérdida de respeto o resentimiento hacia la persona entre los miembros del equipo.",
              },
              {
                id: "rc-1:1-d",
                da: " En conversaciones y reuniones, aliente la opinión de todos/as y brinde a todos/as la oportunidad de ser escuchados/as.",
              },
              {
                id: "rc-1:1-e",
                da: " Sea consciente de no usar lenguaje corporal adverso cuando la persona le está hablando, como poner los ojos en blanco, tener los brazos cruzados o no sonreír cuando corresponde.",
              },
              {
                id: "rc-1:1-f",
                da: " Si siente resentimiento hacia una persona determinada, hable con él/ella en privado.Los sentimientos negativos que no son abordados se tornarán conflictivos y pueden llevar a un comportamiento pasivo-agresivo.",
              },
              {
                id: "rc-1:1-g",
                da: " Deje que un mediador facilite la conversación si las cuestiones no pueden resolverse entre ustedes.",
              },
              {
                id: "rc-1:2-a",
                da: " Identifique las diferencias inevitables que tendrán un impacto negativo en la gente y tómelas en cuenta cuando interactúa con ellos/as. Por ejemplo, si alguien acaba de incorporarse a su equipo, necesitará tiempo para formar relaciones y puede requerirle más esfuerzo que a los miembros que han trabajado juntos por algún tiempo.",
              },
              {
                id: "rc-1:2-b",
                da: " Algunas diferencias son temporales, por ejemplo, las habilidades técnicas pueden adquirirse. Pero si un miembro del equipo toma más del tiempo razonable para adquirir estas habilidades y usted continúa compensando por él/ella, será considerado/a injusto/a por los demás.",
              },
              {
                id: "rc-1:2-c",
                da: " No a todas las personas les desagrada ser tratados/as injustamente, especialmente a la persona que se beneficia. Y no todos/as arman un escándalo cuando hay injusticia en juego, pero todos/as reaccionan a ella. La gente puede apartarse, ser menos colaboradores/as o incluso sabotear a los demás. Sea consciente de cómo percibe la gente su entorno.",
              },
              {
                id: "rc-1:2-d",
                da: " Haga uso de la táctica conocida como “manto de ignorancia”, una filosofía que primero elimina todas las características de la gente involucrada. Luego le pide que tome una decisión acerca de ellas basada en una característica, siempre que esté preparado/a para ser colocado/a en esa situación y asumir esa característica. Por ejemplo, hay 10 personas en un bote salvavidas y usted tiene que decidir a quién tirar por la borda. Si decide tirar por la borda a la persona de más edad, debe estar preparado/a para estar expuesto/a ser usted la persona de más edad.",
              },
              {
                id: "rc-1:3-a",
                da: " Es vital ser consciente de cualquier prejuicio que pueda tener hacia un/os grupo/s en particular. Puede parecer obvio, pero muchas personas no reconocen sus prejuicios. Obtenga retroalimentación de otras personas,también. Piense acerca de los grupos que le hacen sentirse más incómodo/a. Una vez que sea honesto/a consigo mismo/a, puede empezar a abordar sus problemas.",
              },
              {
                id: "rc-1:3-b",
                da: " Dedique tiempo a conocer mejor a algunas personas de los grupos que son diferentes a usted. Trabajar estrechamente con la gente en un proyecto o pasar momentos sociales con ellos/as podría cambiar sus supuestos.",
              },
              {
                id: "rc-1:3-c",
                da: " Examine su comportamiento cuando esté con gente de los grupos contra los cuales tiene prejuicios. ¿Evita formularles preguntas? ¿Limita usted el tiempo y la atención que les brinda? ¿Es usted menos accesible, más crítico/a o interactúa socialmente poco o nada con gente de diferentes culturas?",
              },
              {
                id: "rc-1:4-a",
                da: " Colóquese en un estereotipo. ¿En qué grupo le colocaría otra gente?Enumere los estereotipos que enfrentará en base a cómo puede ser categorizado/a. ¿Describen de forma precisa quién es usted y cómo se desempeña?",
              },
              {
                id: "rc-1:4-b",
                da: " Aprenda a vincular cosas que le gustan con la diversidad. Por ejemplo, aumente su exposición a grupos diversos a través de pasatiempos que disfrute. Si le gusta leer, lea acerca de otras religiones; si disfruta viajar, visite países extranjeros con culturas poco conocidas; si disfruta comer, recorra los restaurantes étnicos en su ciudad.",
              },
              {
                id: "rc-1:4-c",
                da: " Asista a un curso de concientización de diversidad a través de su compañía, si lo hubiera disponible.",
              },
              {
                id: "rc-1:4-d",
                da: " En el trabajo, maximice su exposición a gente talentosa de grupos diversos. Invite a personas de otros grupos a sus reuniones o a trabajar en sus proyectos. Busque a una persona bien respetada en la compañía que caiga en un grupo contra el cual pueda sentir un prejuicio y pídale consejo u opinión experta.",
              },
              {
                id: "rc-1:4-e",
                da: " Enumere las cosas que pueda tener en común con la persona que le hace sentirse incómodo/a. Desafíese a definir al menos 10 aspectos, grandes o pequeños.",
              },
              {
                id: "rc-1:5-a",
                da: " Dé crédito a los demás por su arduo trabajo y promueva los logros de todo el grupo cuando sea posible, incluso si fue usted mismo/a quien desempeñó la mayor parte del trabajo. Fomentar el trabajo en equipo es lo mismo que fomentarse a sí mismo, pero agrega una pequeña dosis de humildad.",
              },
              {
                id: "rc-1:5-b",
                da: " No retenga información que otras personas necesitan para hacer sus trabajos. No solamente es injusto, sino que crea un entorno de trabajo ineficiente.",
              },
              {
                id: "rc-1:5-c",
                da: " Considere qué pueden perder las otras personas debido a sus comentarios o decisiones. ¿Querría estar en su lugar?",
              },
              {
                id: "rc-1:6-a",
                da: " Asista a diversos eventos culturales tales como películas y exposiciones en su ciudad.",
              },
              {
                id: "rc-1:6-b",
                da: " Aproveche posiciones internacionales cuando sea posible.",
              },
              {
                id: "rc-1:6-c",
                da: " No tiene que cruzar océanos para estar expuesto/a a grupos diversos. Solicite posiciones que impliquen equipos globales.",
              },
              {
                id: "rc-1:6-d",
                da: " Actúe como mentor con personas de su compañía de diversos orígenes culturales o de sexo o raza diferente, o busque un mentor que provenga de un origen diferente al suyo",
              },
              {
                id: "rc-1:6-e",
                da: " Observe a la gente. ¿Qué diferencias basadas en el grupo a que pertenecen ve en su comportamiento?",
              },
            ],
          },
          {
            id: "rc-2",
            icon: require("@/assets/Iconography/Attributes/14-02_Taking Accountability.svg"),
            comp: "Toma Responsabilidad",
            wdd: "Se hace responsable de todas las áreas que están a su cargo incluso de aquellas que son más controversiales y difíciles",
            progressMeasures: [
              {
                id: "rc-2-0",
                pm: "Admito cuando cometo un error, sin que me pregunten",
                pmMap: "Admitir mis errores antes de ser cuestionado",
              },
              {
                id: "rc-2-1",
                pm: "No pongo excusas por un mal desempeño",
                pmMap: "No poner excusas ante un mal desempeño",
              },
              {
                id: "rc-2-2",
                pm: "Cumplo mis promesas",
                pmMap: "Cumplir mis promesas",
              },
              {
                id: "rc-2-3",
                pm: "No culpo a factores externos de mis circunstancias o problemas",
                pmMap:
                  "No culpar a factores externos de mis circunstancias o problemas",
              },
            ],
            developmentActions: [
              {
                id: "rc-2:1-a",
                da: " Sea enérgico/a y asuma el control. Pida lo que necesita para hacer su trabajo en lugar de asumir que todo sucederá automáticamente. Cuanto más proactivo/a sea, es menos probable que tenga motivos para culpar a los demás. Cuando sea necesario, enfréntese a las situaciones y a la gente con un estilo enérgico que sea directo y sincero, sin ser amenazador o excesivamente agresivo. Pida lo que necesite para hacer su trabajo de forma efectiva, como información, ayuda y respaldo.Además, no tema decir que no.",
              },
              {
                id: "rc-2:1-b",
                da: " Haga una lista de los obstáculos externos a los que podría enfrentarse durante la tarea que tiene por delante y planee cómo abordarlos.",
              },
              {
                id: "rc-2:1-c",
                da: " Diferencie entre excusas y explicaciones y asegúrese de usar las últimas. Una explicación aclara la situación sin culpa o justificación. Su meta debería ser señalar maneras de mejorar en el futuro, nada más.",
              },
              {
                id: "rc-2:1-d",
                da: " Concentre su atención en producir resultados. Cree soluciones para los obstáculos, no excusas para evitarlos. Aborde los obstáculos inesperados creativamente.",
              },
              {
                id: "rc-2:1-e",
                da: " Evite acusar a alguien cuando las cosas se ponen difíciles. ¿Qué se ganará realmente dedicando tiempo y energía a encontrar que alguien o algo es culpable? Reagrúpense,como debería hacer un equipo, y concéntrense nuevamente en las soluciones al problema.Cree dos columnas: en una indique las formas en las que las demás personas pueden mejorar en el futuro para no repetir los mismos errores, y en la otra columna indique cómo usted puede hacer lo mismo.",
              },
              {
                id: "rc-2:1-f",
                da: ' No se concentre en el origen del problema. No importa dónde se originó un problema,o si lo creó o heredó. La pregunta crucial para hacerse es: “¿Qué puedo hacer al respecto?"',
              },
              {
                id: "rc-2:1-g",
                da: " Sea consciente del lenguaje que usa. Si se escucha expresando algo como “Nadie me dijo”, “Sólo estoy cumpliendo órdenes” o “El error no podría haberse evitado”, asegúrese de cuestionar la honestidad y validez de estos comentarios.",
              },
              {
                id: "rc-2:2-a",
                da: " Si es excesivamente sensible a la crítica, pida retroalimentación cuando haya desarrollado bien una función. Es más fácil aceptar la crítica constructiva cuando usted se siente bien con sus logros. Esto le preparará para ser más abierto/a a la retroalimentación cuando no se haya desempeñado tan bien Recuerde que siempre, siempre, hay espacio para la mejora.",
              },
              {
                id: "rc-2:2-b",
                da: " Comprenda la razón por la cual se le considera responsable. No es un castigo o amonestación a usted como persona. Se le considera responsable porque mejoró sus habilidades o porque la gente confiaba en usted. Si reconoce sus debilidades, creará oportunidades para aprender acerca de la gestión de procesos, la resolución de problemas y la toma de decisiones de calidad.",
              },
              {
                id: "rc-2:2-c",
                da: " Un poco de humildad puede llevarle muy lejos. Admita su error y asegure a su jefe o compañeros/as de trabajo que aprenderá de sus errores. La gente se siente más inclinada a mostrar solidaridad con su situación cuando usted demuestra humildad genuina.",
              },
              {
                id: "rc-2:2-d",
                da: " Ponerse a la defensiva, enojarse o sentirse inseguro/a puede ser su primera reacción,pero no mejorará la situación. Por el contrario, podría alejarle de los demás y hacerle más difícil aceptar sugerencias constructivas. Sea consciente de su reacción emocional y dese tiempo para calmarse antes de responder.",
              },
              {
                id: "rc-2:2-e",
                da: " No responsabilizarse por sus errores desvía la responsabilidad hacia otra persona.Considere el impacto en sus colegas o miembros del equipo si usted es deshonesto/a acerca del papel que desempeñó.",
              },
              {
                id: "rc-2:2-f",
                da: " No pase las decisiones difíciles a otras personas porque no quiera tomarlas. Si es necesario, obtenga opiniones para tomar la mejor decisión, pero luego tómela y siga adelante.",
              },
              {
                id: "rc-2:3-a",
                da: " Cuestione si su comportamiento y opinión están contribuyendo positivamente a los objetivos de la organización. De no ser así, asuma la responsabilidad de hacer mejoras. Por ejemplo, examine cuánto tiempo dedica a cuestiones personales o a hablar con los colegas acerca de temas no relacionados con el trabajo.",
              },
              {
                id: "rc-2:3-b",
                da: " Examine los procedimientos y controles vigentes para asegurar la responsabilidad. Si la organización carece de tales medidas, establezca un grupo de trabajo para abordar los estándares mínimos que necesitan definirse, cumplirse y monitorearse.",
              },
              {
                id: "rc-2:3-c",
                da: " Establezca una cultura de responsabilidad dentro de su grupo demostrando humildad y admitiendo sus errores. Asuma la responsabilidad de las malas decisiones y, para demostrar que ha considerado el asunto, informe a los demás de cómo actuará diferente la próxima vez. Asegúrese de que haya consecuencias por una falta de responsabilidad, pero que éstas sean justas y administradas de forma equitativa.",
              },
              {
                id: "rc-2:4-a",
                da: " Una vez que llegó a un acuerdo con alguien, asegúrese de respetarlo. No importa si es algo pequeño, tal como un documento que prometió leer conatención, o algo importante, como una fusión con la que estuvo de acuerdo.Asegúrese de que se pueda confiar en su palabra o la gente perderá el respeto por usted.",
              },
              {
                id: "rc-2:4-b",
                da: " Si no puede cumplir con los plazos comprometidos, sea proactivo/a y avise a los demás por adelantado. No espere a que ellos/as le pregunten qué está pasando — es injusto y desmoralizante.",
              },
              {
                id: "rc-2:4-c",
                da: " No haga esperar a las personas por su respuesta a los pedidos que realizaron. Esto envía un mensaje de que sus necesidades no son tan importantes para usted.",
              },
              {
                id: "rc-2:4-d",
                da: " Es razonable que su carga de trabajo esté demasiado completa. Sea realista acerca de lo que puede y no puede hacer. No haga promesas que no puede cumplir. Es mejor ser honesto/a desde el principio acerca de cuándo podrá desarrollar las tareas.",
              },
              {
                id: "rc-2:5-a",
                da: " Cuando se produce un error, hable con su superior inmediatamente. Sea honesto/a acerca de lo que sucedió y exprese su preocupación por las consecuencias potenciales. Puede sentirse aliviado/a de escuchar que no son tan malas como pensaba, y si no, al menos sabrá donde está parado/a.",
              },
              {
                id: "rc-2:5-b",
                da: " Ofrezca soluciones o las opciones disponibles para abordar o corregir el error. Esto demuestra una voluntad de aprender y salir adelante.",
              },
              {
                id: "rc-2:5-c",
                da: " Si la cultura de la compañía es tal que los errores son imperdonables, tal vez quiera considerar trabajar en otro lugar. Es difícil, si no absolutamente imposible, desarrollarse y aprender cuando no hay espacio para errores.",
              },
            ],
          },
          {
            id: "rc-3",
            icon: require("@/assets/Iconography/Attributes/14-01_Being Trustworthy.svg"),
            comp: "Digno/a De Confianza",
            wdd: "Se puede confiar en él/ella. Se puede contar con él/ella para cumplir promesas y mantener confidencias",
            progressMeasures: [
              {
                id: "rc-3-0",
                pm: "Se puede contar conmigo en cuanto a que voy hacer lo que me comprometí",
                pmMap:
                  "Se puede contar conmigo para hacer aquello con lo que me comprometí",
              },
              {
                id: "rc-3-1",
                pm: "Soy honesto/a con la gente acerca de mis intenciones",
                pmMap: "Ser honesto/a con la gente sobre mis intenciones",
              },
              {
                id: "rc-3-2",
                pm: "Soy coherente sobre cómo actúo con diferentes personas",
                pmMap: "Ser coherente en cómo actúo con diferentes personas",
              },
              {
                id: "rc-3-3",
                pm: "Soy rápido/a para admitir cuando las cosas son mi culpa",
                pmMap:
                  "Ser rápido/a en admitirlo, cuando algo ha sucedidio por culpa mía",
              },
            ],
            developmentActions: [
              {
                id: "rc-3:1-a",
                da: " Escriba los motivos por los cuales los intereses de la otra parte deberían considerarse. ¿Sus acciones justifican los beneficios a corto plazo? ¿Cuáles son los beneficios a largo plazo de un enfoque mutuamente beneficioso?",
              },
              {
                id: "rc-3:1-b",
                da: " Considere formas creativas de lograr el mismo resultado a través de medios más justos.",
              },
              {
                id: "rc-3:1-c",
                da: " Pregúntese si haría lo mismo por alguien que personalmente le importa. Los mismos estándares deberían ser aplicables en un entorno profesional.",
              },
              {
                id: "rc-3:1-d",
                da: " ¿Sus acciones son para el mejor beneficio de la organización?",
              },
              {
                id: "rc-3:1-e",
                da: " ¿Qué ramificaciones políticas negativas podrían tener sus acciones?",
              },
              {
                id: "rc-3:2-a",
                da: " Si tiene un problema con alguien, resuélvalo hablando directamente con esa persona.",
              },
              {
                id: "rc-3:2-b",
                da: " No trate de calificar la información que recibió. No depende de usted decidir si realmente la misma debe mantenerse confidencial. Si le pidieron que mantenga la confidencialidad, hágalo.",
              },
              {
                id: "rc-3:2-c",
                da: " Resista la tentación de compartir información confidencial como una forma de vincularse con los demás. Sólo perdería porque estaría comprometiendo su relación con la persona que confió en usted. Trate de vincularse con los demás por cosas positivas que tienen en común, tales como pasatiempos y experiencias de trabajo.",
              },
              {
                id: "rc-3:3-a",
                da: " En lugar de suponer lo que la gente quiere escuchar, concéntrese en lo que realmente necesita escuchar. Use esto como guía al decidir qué información quiere retener.",
              },
              {
                id: "rc-3:3-b",
                da: " La honestidad se combina bien con una dosis de diplomacia. En el lugar de trabajo,es importante ser capaz de manejar conversaciones sensibles, especialmente porque las partes a menudo tienen mucho en juego. Prepare sus habilidades diplomáticas para tener más éxito en comunicar información difícil.",
              },
              {
                id: "rc-3:3-c",
                da: " ¿Tiene menos probabilidades de ser escrupuloso con ciertas personas? Por ejemplo,¿tiene dudas de ser completamente honesto/a con su superior, un/a cliente/a determinado/a o un/a colega cercano/a? Identificar estas personas le brindará indicios sobre sus motivos.Pídale a un coach que le ayude a mejorar su sinceridad y franqueza con estas personas.",
              },
              {
                id: "rc-3:4-a",
                da: " Sea realista y honesto/a acerca de lo que puede hacer y cuánto puede comprometerse. Explique su situación o compromisos a las personas involucradas y bríndeles otras opciones si no quiere hacer una promesa de cumplimiento. Tal vez puede asumir un compromiso más pequeño que pueda cumplir y que servirá como su aporte.",
              },
              {
                id: "rc-3:4-b",
                da: " Sea organizado/a y conozca su carga de trabajo. En ocasiones la gente se compromete demasiado porque ignoran su verdadera carga de trabajo. Mantenga un calendario preciso con cronogramas para otros proyectos en curso y revíselo cuidadosamente antes de comprometerse. Comparta su calendario con los demás para que sean conscientes de su carga de trabajo y justifique por qué no puede comprometerse en este momento.",
              },
              {
                id: "rc-3:4-c",
                da: " Comprométase, pero con la condición de que se eliminen los obstáculos en su camino. Por ejemplo, tal vez otro proyecto puede moverse o se puede designar un colega para que le ayude.",
              },
              {
                id: "rc-3:4-d",
                da: " Aprenda a decir que no. Realmente está bien hacerlo. Siempre y cuando pueda aportar razones, tiene derecho a decir que no.",
              },
              {
                id: "rc-3:4-e",
                da: " Asegúrese de comprender totalmente el alcance de un proyecto y los recursos disponibles antes de comprometerse a una fecha límite.",
              },
              {
                id: "rc-3:5-a",
                da: " Promueva su aporte únicamente si participó en la mayoría del trabajo.",
              },
              {
                id: "rc-3:5-b",
                da: " Si sólo participó tangencialmente, elogie los logros de los demás sin incluirse en los honores.",
              },
              {
                id: "rc-3:5-c",
                da: " Admita sus errores. Será percibido/a como honesto/a y abierto/a a la mejora.",
              },
              {
                id: "rc-3:5-d",
                da: " Cuando acepte el mérito por el trabajo realizado, asegúrese de incluir los esfuerzos de su equipo y todas las personas involucradas. El éxito de pocos proyectos está basado en el aporte de una sola persona.",
              },
              {
                id: "rc-3:5-e",
                da: " ¿Está su información basada en hechos y verdades, o en su interpretación de la verdad? Tenga cuidado cuando camina sobre esa línea fina. ¿Está en condiciones de respaldar sus afirmaciones con evidencia?",
              },
            ],
          },
        ],
      },
    },
  },
};
